import React from 'react';
export const BsPlusLg = ({ customClass, id = '', gtmTagVariable = '' }) => {
  return (
    <i
      className={`flaticon-plus-positive-add-mathematical-symbol ${customClass} ${gtmTagVariable}`}
    />
  );
};

export const AiOutlineUserAdd = ({ customClass }) => {
  return <i className={`flaticon-add-user ${customClass}`} />;
};

export const BsShieldLockFill = ({ customClass }) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 16 16"
      className={customClass}
    >
      <path
        fillRule="evenodd"
        d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm0 5a1.5 1.5 0 0 1 .5 2.915l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99A1.5 1.5 0 0 1 8 5z"
      ></path>
    </svg>
  );
};
export const BsShieldLock = ({ customClass }) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 16 16"
      className={customClass}
    >
      <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z"></path>
      <path d="M9.5 6.5a1.5 1.5 0 0 1-1 1.415l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99a1.5 1.5 0 1 1 2-1.415z"></path>
    </svg>
  );
};
export const AiOutlineHeart = ({ customClass, id = '', gtmTagVariable = '' }) => {
  return <i className={`flaticon-heart ${customClass} gtm_cl_like_unlike`} />;
};
export const AiFillHeart = ({ customClass, id = '', gtmTagVariable = '' }) => {
  return <i className={`flaticon-heart-1 ${customClass} gtm_cl_like_unlike`} />;
};
export const IoBookmarkOutline = ({ customClass, id = '', gtmTagVariable = '' }) => {
  return <i className={`flaticon-save-instagram ${customClass} gtm_cl_vault_save_unsave`} />;
};
export const IoBookmark = ({ customClass, id = '', gtmTagVariable = '' }) => {
  return <i className={`flaticon-bookmark ${customClass} gtm_cl_vault_save_unsave`} />;
};
export const IoChatbubblesOutline = ({ customClass, id = '', gtmTagVariable = '' }) => {
  return <i className={`flaticon-bubble-chat ${customClass} gtm_cl_drag_to_comment_section`} />;
};
export const BsFillCameraFill = ({ customClass, gtmTagVariable = '', onClick = null }) => {
  return <i className={`flaticon-camera ${customClass} ${gtmTagVariable}`} onClick={onClick} />;
};
export const FiCamera = ({ customClass }) => {
  return (
    <i className={`flaticon-camera-1 ${customClass}`}></i>
    // <svg
    //   stroke="currentColor"
    //   fill="none"
    //   stroke-width="2"
    //   viewBox="0 0 24 24"
    //   className={customClass}
    // >
    //   <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
    //   <circle cx="12" cy="13" r="4"></circle>
    // </svg>
  );
};

export const IoDocumentTextSharp = ({ customClass, style = {} }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    className={customClass}
    style={style}
  >
    <path d="M272 41.69V188a4 4 0 004 4h146.31a2 2 0 001.42-3.41L275.41 40.27a2 2 0 00-3.41 1.42z"></path>
    <path d="M248 224a8 8 0 01-8-8V32H92a12 12 0 00-12 12v424a12 12 0 0012 12h328a12 12 0 0012-12V224zm104 160H160v-32h192zm0-80H160v-32h192z"></path>
  </svg>
);
export const BsImage = ({ customClass, style = {} }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 16 16"
    className={customClass}
    style={style}
  >
    <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"></path>
    <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z"></path>
  </svg>
);
export const FiDownload = ({ customClass, gtmTagVariable = '' }) => (
  <i className={`flaticon-download ${customClass} gtm_cl_download_file_icon`} />
);
export const FaFilePdf = ({ customClass, style = {} }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 384 512"
    className={customClass}
    style={style}
  >
    <path d="M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"></path>
  </svg>
);
export const MdOutlineArrowRightAlt = ({ customClass, id = '', gtmTagVariable = '' }) => (
  <i className={`flaticon-next ${customClass} ${gtmTagVariable}`} />
);
export const HiArrowNarrowLeft = ({ customClass, gtmTagVariable = '' }) => (
  <i className={`flaticon-back ${customClass} ${gtmTagVariable}`} />
);
export const RiPlayCircleFill = ({ customClass }) => (
  <i className={`flaticon-play ${customClass}`}></i>
);
export const CgArrowLongRight = ({ customClass, gtmTagVariable = '' }) => (
  <i className={`flaticon-next ${customClass} ${gtmTagVariable}`}></i>
);
export const MdVerified = ({ customClass }) => (
  <i className={`flaticon-correct ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  //   className={customClass}
  // >
  //   <path fill="none" d="M0 0h24v24H0z"></path>
  //   <path d="M23 12l-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82L8.6 22.5l3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69L23 12zm-12.91 4.72l-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35z"></path>
  // </svg>
);

export const CgArrowLongLeft = ({ customClass }) => (
  <i className={`flaticon-back ${customClass}`}></i>
  // <svg
  //   className={customClass}
  //   stroke="currentColor"
  //   fill="none"
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  // >
  //   <path
  //     d="M1.02698 11.9929L5.26242 16.2426L6.67902 14.8308L4.85766 13.0033L22.9731 13.0012L22.9728 11.0012L4.85309 11.0033L6.6886 9.17398L5.27677 7.75739L1.02698 11.9929Z"
  //     fill="currentColor"
  //   ></path>
  // </svg>
);
export const RiSearchLine = ({ customClass, gtmTagVariable = '' }) => (
  <i className={`flaticon-loupe ${customClass} ${gtmTagVariable} `} />
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  //   className={`${customClass} ${gtmTagVariable}`}
  // >
  //   <g>
  //     <path className={gtmTagVariable} fill="none" d="M0 0h24v24H0z"></path>
  //     <path
  //       className={gtmTagVariable}
  //       d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z"
  //     ></path>
  //   </g>
  // </svg>
);
export const GrClose = ({ customClass, click, id, gtmTagVariable = '' }) => (
  <i className={`flaticon-close ${customClass} ${gtmTagVariable}`} onClick={click} id={id}></i>
  // <svg
  //   id={id}
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  //   className={`${customClass} ${gtmTagVariable}`}
  //   onClick={click}
  // >
  //   <path
  //     className={gtmTagVariable}
  //     fill="none"
  //     // stroke="#000"
  //     strokeWidth="2"
  //     d="M3,3 L21,21 M3,21 L21,3"
  //   ></path>
  // </svg>
);
export const BsBookmark = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 16 16"
    className={customClass}
  >
    <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z"></path>
  </svg>
);
export const IoPaperPlane = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    className={customClass}
  >
    <path d="M473 39.05a24 24 0 00-25.5-5.46L47.47 185h-.08a24 24 0 001 45.16l.41.13 137.3 58.63a16 16 0 0015.54-3.59L422 80a7.07 7.07 0 0110 10L226.66 310.26a16 16 0 00-3.59 15.54l58.65 137.38c.06.2.12.38.19.57 3.2 9.27 11.3 15.81 21.09 16.25h1a24.63 24.63 0 0023-15.46L478.39 64.62A24 24 0 00473 39.05z"></path>
  </svg>
);
export const MdOutlinePoll = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    className={customClass}
  >
    <path fill="none" d="M0 0h24v24H0V0z"></path>
    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"></path>
  </svg>
);

export const FaFilter = ({ customClass, gtmTagVariable = '' }) => (
  <i className={`flaticon-filters ${customClass} gtm_cl_filter_icon`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 512 512"
  //   className={`${customClass} gtm_cl_filter_icon`}
  // >
  //   <path
  //     className="gtm_cl_filter_icon"
  //     d="M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
  //   ></path>
  // </svg>
);
export const AiTwotoneCheckSquare = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 1024 1024"
    className={customClass}
  >
    <path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"></path>
    <path d="M184 840h656V184H184v656zm130-367.8h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H688c6.5 0 10.3 7.4 6.5 12.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L307.5 484.9c-3.8-5.3 0-12.7 6.5-12.7z"></path>
    <path d="M432.2 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7h-46.9c-10.3 0-19.9 5-25.9 13.3L458 584.3l-71.2-98.8c-6-8.4-15.7-13.3-25.9-13.3H314c-6.5 0-10.3 7.4-6.5 12.7l124.7 172.8z"></path>
  </svg>
);
export const GrAttachment = ({ customClass, gtmTagVariable = '' }) => (
  <i className={`flaticon-attach-paperclip-symbol ${customClass} ${gtmTagVariable}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  //   className={`${customClass} ${gtmTagVariable}`}
  // >
  //   <path
  //     className={gtmTagVariable}
  //     fill="none"
  //     stroke="#000"
  //     strokeWidth="2"
  //     d="M22,12 C22,12 19.0000009,15.0000004 13.0000004,21.0000004 C6.99999996,27.0000004 -2.00000007,18.0000004 3.99999994,12.0000004 C9.99999996,6.00000037 9,7.00000011 13,3.00000008 C17,-0.999999955 23,4.99999994 19,9.00000005 C15,13.0000002 12.0000004,16.0000007 9.99999995,18.0000004 C7.99999952,20 5,17 6.99999995,15.0000004 C8.99999991,13.0000007 16,6 16,6"
  //   ></path>
  // </svg>
);
export const MdCancel = ({ customClass, click }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    className={customClass}
    onClick={click}
  >
    <path fill="none" d="M0 0h24v24H0z"></path>
    <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path>
  </svg>
);

export const MdLocationPin = ({ customClass }) => (
  <i className={`flaticon-pin ${customClass}`}></i>
  // <svg
  //   className={customClass}
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  // >
  //   <path fill="none" d="M0 0h24v24H0z"></path>
  //   <path d="M12 2C8.13 2 5 5.13 5 9c0 1.74.5 3.37 1.41 4.84.95 1.54 2.2 2.86 3.16 4.4.47.75.81 1.45 1.17 2.26.26.55.47 1.5 1.26 1.5s1-.95 1.25-1.5c.37-.81.7-1.51 1.17-2.26.96-1.53 2.21-2.85 3.16-4.4C18.5 12.37 19 10.74 19 9c0-3.87-3.13-7-7-7zm0 9.75a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"></path>
  // </svg>
);

export const IoIosArrowRoundForward = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    className={customClass}
  >
    <path d="M295.6 163.7c-5.1 5-5.1 13.3-.1 18.4l60.8 60.9H124.9c-7.1 0-12.9 5.8-12.9 13s5.8 13 12.9 13h231.3l-60.8 60.9c-5 5.1-4.9 13.3.1 18.4 5.1 5 13.2 5 18.3-.1l82.4-83c1.1-1.2 2-2.5 2.7-4.1.7-1.6 1-3.3 1-5 0-3.4-1.3-6.6-3.7-9.1l-82.4-83c-4.9-5.2-13.1-5.3-18.2-.3z"></path>
  </svg>
);
export const MdKeyboardArrowRight = ({ customClass, id = '', gtmTagVariable = '' }) => (
  <i className={`flaticon-chevron ${customClass} ${gtmTagVariable}`} id={id}></i>
  // <svg
  //   className={`${customClass} ${gtmTagVariable}`}
  //   id={id}
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  // >
  //   <path className={gtmTagVariable} fill="none" d="M0 0h24v24H0V0z"></path>
  //   <path
  //     className={gtmTagVariable}
  //     d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
  //   ></path>
  // </svg>
);
export const MdKeyboardArrowLeft = ({ customClass }) => (
  <i className={`flaticon-left-chevron ${customClass}`}></i>
  // <svg
  //   className={customClass}
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  // >
  //   <path fill="none" d="M0 0h24v24H0V0z"></path>
  //   <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path>
  // </svg>
);

export const TiVideo = ({ customClass }) => (
  <i className={`flaticon-video-camera ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   version="1.2"
  //   baseProfile="tiny"
  //   viewBox="0 0 24 24"
  //   className={customClass}
  // >
  //   <path d="M22.525 7.149c-.16-.099-.342-.149-.525-.149-.153 0-.306.035-.447.105l-2.553 1.277v-.382c0-1.654-1.346-3-3-3h-11c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3v-.382l2.553 1.276c.141.071.294.106.447.106.183 0 .365-.05.525-.149.295-.183.475-.504.475-.851v-8c0-.347-.18-.668-.475-.851zm-15.525 6.351c-.829 0-1.5-.671-1.5-1.5s.671-1.5 1.5-1.5 1.5.671 1.5 1.5-.671 1.5-1.5 1.5z"></path>
  // </svg>
);

export const GoCalender = ({ customClass }) => (
  <i className={`flaticon-calendar ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 14 16"
  //   className={customClass}
  // >
  //   <path
  //     fillRule="evenodd"
  //     d="M13 2h-1v1.5c0 .28-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5V2H6v1.5c0 .28-.22.5-.5.5h-2c-.28 0-.5-.22-.5-.5V2H2c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h11c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm0 12H2V5h11v9zM5 3H4V1h1v2zm6 0h-1V1h1v2zM6 7H5V6h1v1zm2 0H7V6h1v1zm2 0H9V6h1v1zm2 0h-1V6h1v1zM4 9H3V8h1v1zm2 0H5V8h1v1zm2 0H7V8h1v1zm2 0H9V8h1v1zm2 0h-1V8h1v1zm-8 2H3v-1h1v1zm2 0H5v-1h1v1zm2 0H7v-1h1v1zm2 0H9v-1h1v1zm2 0h-1v-1h1v1zm-8 2H3v-1h1v1zm2 0H5v-1h1v1zm2 0H7v-1h1v1zm2 0H9v-1h1v1z"
  //   ></path>
  // </svg>
);

export const BsPlayCircleFill = ({ customClass }) => (
  <i className={`flaticon-play ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 16 16"
  //   className={customClass}
  // >
  //   <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"></path>
  // </svg>
);

export const IoVideocam = ({ customClass }) => (
  <i className={`flaticon-video-camera ${customClass}`}></i>
);
export const BsUpload = ({ customClass, gtmTagVariable = '' }) => (
  <i className={`flaticon-upload ${customClass} ${gtmTagVariable}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   className={`${customClass} ${gtmTagVariable}`}
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  // >
  //   <path className={gtmTagVariable} d="M11 15h2V9h3l-4-5-4 5h3z"></path>
  //   <path
  //     className={gtmTagVariable}
  //     d="M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z"
  //   ></path>
  // </svg>
);
export const RiDeleteBin6Line = ({ customClass, click, gtmTagVariable = '' }) => (
  <i className={`flaticon-delete ${customClass} ${gtmTagVariable}`} onClick={click}></i>
  // <svg
  //   stroke="currentColor"
  //   className={`${customClass} ${gtmTagVariable}`}
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  //   onClick={click}
  // >
  //   <g>
  //     <path className={gtmTagVariable} fill="none" d="M0 0h24v24H0z"></path>
  //     <path
  //       className={gtmTagVariable}
  //       d="M7 4V2h10v2h5v2h-2v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6H2V4h5zM6 6v14h12V6H6zm3 3h2v8H9V9zm4 0h2v8h-2V9z"
  //     ></path>
  //   </g>
  // </svg>
);
export const GrEdit = ({ customClass, click, id = '', gtmTagVariable = '' }) => (
  <i className={`flaticon-pen ${customClass} ${gtmTagVariable}`} id={id} onClick={click}></i>
  // <svg
  //   id={id}
  //   stroke="currentColor"
  //   fill="currentColor"
  //   className={`${customClass} ${gtmTagVariable}`}
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  //   onClick={click}
  // >
  //   <path
  //     fill="none"
  //     strokeWidth="2"
  //     className={gtmTagVariable}
  //     d="M14,4 L20,10 L14,4 Z M22.2942268,5.29422684 C22.6840146,5.68401459 22.6812861,6.3187139 22.2864907,6.71350932 L9,20 L2,22 L4,15 L17.2864907,1.71350932 C17.680551,1.319449 18.3127724,1.31277239 18.7057732,1.70577316 L22.2942268,5.29422684 Z M3,19 L5,21 M7,17 L15,9"
  //   ></path>
  // </svg>
);

export const RiCloseLine = ({ customClass, gtmTagVariable = '' }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    className={`${customClass} ${gtmTagVariable}`}
  >
    <g>
      <path className={gtmTagVariable} fill="none" d="M0 0h24v24H0z"></path>
      <path
        className={gtmTagVariable}
        d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
      ></path>
    </g>
  </svg>
);

export const IoIosArrowUp = ({ customClass }) => (
  <i className={`flaticon-up-arrow ${customClass}`}></i>
  // <svg
  //   className={customClass}
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 512 512"
  // >
  //   <path d="M256 217.9L383 345c9.4 9.4 24.6 9.4 33.9 0 9.4-9.4 9.3-24.6 0-34L273 167c-9.1-9.1-23.7-9.3-33.1-.7L95 310.9c-4.7 4.7-7 10.9-7 17s2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l127.1-127z"></path>
  // </svg>
);
export const IoIosArrowDown = ({ customClass }) => (
  <i className={`flaticon-down-arrow ${customClass}`}></i>
  // <svg
  //   className={customClass}
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 512 512"
  // >
  //   <path d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"></path>
  // </svg>
);

export const GrView = ({ customClass }) => (
  <i className={`flaticon-show ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  //   className={customClass}
  // >
  //   <path
  //     fill="none"
  //     stroke="currentColor"
  //     strokeWidth="2"
  //     d="M12,21 C7,21 1,16 1,12 C1,8 7,3 12,3 C17,3 23,8 23,12 C23,16 17,21 12,21 Z M12,7 C9.23875,7 7,9.23875 7,12 C7,14.76125 9.23875,17 12,17 C14.76125,17 17,14.76125 17,12 C17,9.23875 14.76125,7 12,7 L12,7 Z"
  //   ></path>
  // </svg>
);
export const RiUserFollowFill = ({ customClass }) => (
  <svg className={customClass} strokeWidth="0" viewBox="0 0 24 24">
    <g>
      <path fill="none" d="M0 0h24v24H0z"></path>
      <path d="M13 14.062V22H4a8 8 0 0 1 9-7.938zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm5.793 6.914l3.535-3.535 1.415 1.414-4.95 4.95-3.536-3.536 1.415-1.414 2.12 2.121z"></path>
    </g>
  </svg>
);
export const BsFillGrid3X3GapFill = ({ customClass, click }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 16 16"
    className={customClass}
    onClick={click}
  >
    <path d="M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2zM1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zM1 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2z"></path>
  </svg>
);
export const BsFillGridFill = ({ customClass, click }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 16 16"
    className={customClass}
    onClick={click}
  >
    <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z"></path>
  </svg>
);
export const BiSupport = ({ customClass, click }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    className={customClass}
    onClick={click}
  >
    <path d="M12 2C6.486 2 2 6.486 2 12v4.143C2 17.167 2.897 18 4 18h1a1 1 0 0 0 1-1v-5.143a1 1 0 0 0-1-1h-.908C4.648 6.987 7.978 4 12 4s7.352 2.987 7.908 6.857H19a1 1 0 0 0-1 1V18c0 1.103-.897 2-2 2h-2v-1h-4v3h6c2.206 0 4-1.794 4-4 1.103 0 2-.833 2-1.857V12c0-5.514-4.486-10-10-10z"></path>
  </svg>
);

export const AiOutlineLike = ({ customClass }) => (
  <i className={`flaticon-like ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 1024 1024"
  //   className={customClass}
  // >
  //   <path
  //     className={`${customClass}_svgPath`}
  //     d="M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0 1 42.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z"
  //   ></path>
  // </svg>
);
export const AiFillLike = ({ customClass }) => (
  <i className={`flaticon-like-1 ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 1024 1024"
  //   className={customClass}
  // >
  //   <path
  //     className={`${customClass}_svgPath`}
  //     d="M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z"
  //   ></path>
  // </svg>
);
export const RiBarChart2Line = ({ customClass }) => (
  <i className={`flaticon-bar-chart ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  //   className={customClass}
  // >
  //   <g>
  //     <path fill="none" d="M0 0h24v24H0z"></path>
  //     <path d="M2 13h6v8H2v-8zm14-5h6v13h-6V8zM9 3h6v18H9V3zM4 15v4h2v-4H4zm7-10v14h2V5h-2zm7 5v9h2v-9h-2z"></path>
  //   </g>
  // </svg>
);

export const FiShare2 = ({ customClass }) => {
  return <i className={`flaticon-share-arrow ${customClass}`} />;
};

export const HiOutlineBookmark = ({ customClass, id = '', gtmTagVariable = '' }) => (
  <i className={`flaticon-save-instagram ${customClass} ${gtmTagVariable}`} id={id}></i>
  // <svg
  //   id={id}
  //   className={`${customClass} ${gtmTagVariable}`}
  //   stroke="currentColor"
  //   fill="none"
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  // >
  //   <path
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //     strokeWidth="2"
  //     className={gtmTagVariable}
  //     d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
  //   ></path>
  // </svg>
);

export const AiOutlineQuestionCircle = ({ customClass, id = '', gtmTagVariable = '' }) => (
  <i className={`flaticon-question ${customClass} ${gtmTagVariable}`} id={id}></i>
  // <svg
  //   id={id}
  //   className={`${customClass} ${gtmTagVariable}`}
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 1024 1024"
  // >
  //   <path
  //     className={gtmTagVariable}
  //     d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
  //   ></path>
  //   <path
  //     className={gtmTagVariable}
  //     d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
  //   ></path>
  // </svg>
);
export const AiOutlineLogout = ({ customClass, id = '', gtmTagVariable = '' }) => (
  <i className={`flaticon-logout ${customClass} ${gtmTagVariable}`} id={id}></i>
  // <svg
  //   id={id}
  //   className={`${customClass} ${gtmTagVariable}`}
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 1024 1024"
  // >
  //   <path
  //     className={gtmTagVariable}
  //     d="M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 0 1-112.7 75.9A352.8 352.8 0 0 1 512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 0 1-112.7-75.9 353.28 353.28 0 0 1-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z"
  //   ></path>
  // </svg>
);
export const ImTrophy = ({ customClass }) => (
  <i className={`flaticon-trophy ${customClass}`}></i>
  // <svg
  //   className={customClass}
  //   stroke="currentColor"
  //   fill="currentColor"
  //   stroke-width="0"
  //   version="1.1"
  //   viewBox="0 0 16 16"
  // >
  //   <path d="M13 3v-2h-10v2h-3v2c0 1.657 1.343 3 3 3 0.314 0 0.616-0.048 0.9-0.138 0.721 1.031 1.822 1.778 3.1 2.037v3.1h-1c-1.105 0-2 0.895-2 2h8c0-1.105-0.895-2-2-2h-1v-3.1c1.278-0.259 2.378-1.006 3.1-2.037 0.284 0.089 0.587 0.138 0.9 0.138 1.657 0 3-1.343 3-3v-2h-3zM3 6.813c-0.999 0-1.813-0.813-1.813-1.813v-1h1.813v1c0 0.628 0.116 1.229 0.327 1.782-0.106 0.019-0.216 0.030-0.327 0.030zM14.813 5c0 0.999-0.813 1.813-1.813 1.813-0.112 0-0.221-0.011-0.327-0.030 0.211-0.554 0.327-1.154 0.327-1.782v-1h1.813v1z"></path>
  // </svg>
);
export const IoTrophyOutline = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    className={customClass}
  >
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
      d="M176 464h160m-80 0V336m128-112c0-50.64-.08-134.63-.12-160a16 16 0 00-16-16l-223.79.26a16 16 0 00-16 15.95c0 30.58-.13 129.17-.13 159.79 0 64.28 83 112 128 112S384 288.28 384 224z"
    ></path>
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
      d="M128 96H48v16c0 55.22 33.55 112 80 112M384 96h80v16c0 55.22-33.55 112-80 112"
    ></path>
  </svg>
);

export const FaCertificate = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    className={customClass}
  >
    <path d="M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"></path>
  </svg>
);

export const AiFillClockCircle = ({ customClass }) => (
  <i className={`flaticon-clock-1 ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 1024 1024"
  //   className={customClass}
  // >
  //   <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm176.5 585.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z"></path>
  // </svg>
);

export const BiLock = ({ customClass }) => (
  <i className={`flaticon-lock-symbol ${customClass}`}></i>
);

export const BsPlay = ({ customClass }) => (
  <i className={`flaticon-play-2 ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 16 16"
  //   className={customClass}
  // >
  //   <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z"></path>
  // </svg>
);
export const IoLayersOutline = ({ customClass }) => (
  <i className={`flaticon-layers ${customClass}`}></i>
  // <svg
  //   className={customClass}
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 512 512"
  // >
  //   <path
  //     fill="none"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //     strokeWidth="32"
  //     d="M434.8 137.65l-149.36-68.1c-16.19-7.4-42.69-7.4-58.88 0L77.3 137.65c-17.6 8-17.6 21.09 0 29.09l148 67.5c16.89 7.7 44.69 7.7 61.58 0l148-67.5c17.52-8 17.52-21.1-.08-29.09zM160 308.52l-82.7 37.11c-17.6 8-17.6 21.1 0 29.1l148 67.5c16.89 7.69 44.69 7.69 61.58 0l148-67.5c17.6-8 17.6-21.1 0-29.1l-79.94-38.47"
  //   ></path>
  //   <path
  //     fill="none"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //     strokeWidth="32"
  //     d="M160 204.48l-82.8 37.16c-17.6 8-17.6 21.1 0 29.1l148 67.49c16.89 7.7 44.69 7.7 61.58 0l148-67.49c17.7-8 17.7-21.1.1-29.1L352 204.48"
  //   ></path>
  // </svg>
);

export const CertificateIcon = ({ customClass }) => (
  <i className={`flaticon-badge ${customClass}`}></i>
);

export const VscPieChart = ({ customClass }) => (
  <i className={`flaticon-pie-graph ${customClass}`}></i>
  // <svg
  //   className={customClass}
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 16 16"
  // >
  //   <path
  //     fillRule="evenodd"
  //     clipRule="evenodd"
  //     d="M10 6H13.9C13.5023 4.04087 11.9591 2.4977 10 2.10002V6ZM10 1.08296C12.5125 1.50448 14.4955 3.4875 14.917 6C14.9716 6.32521 15 6.65929 15 7H9V1C9.34071 1 9.67479 1.0284 10 1.08296ZM7 8.00003L8 9.00003H12.9C12.4367 11.2823 10.4189 13 8 13C5.23858 13 3 10.7614 3 8C3 5.58104 4.71776 3.56329 7 3.10002V8.00003ZM8 14C10.973 14 13.4409 11.8377 13.917 9.00003C13.9716 8.67482 14 8.34074 14 8.00003H8V2C7.65929 2 7.32521 2.0284 7 2.08296C4.16229 2.55904 2 5.027 2 8C2 11.3137 4.68629 14 8 14Z"
  //   ></path>
  // </svg>
);

export const CertificateBigIcon = ({ customClass }) => (
  <i className={`flaticon-certificate-1 ${customClass}`}></i>
);

export const CertificateFillIcon = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512.000000 512.000000"
    className={customClass}
  >
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">
      <path d="M2010 5109 c-25 -5 -78 -25 -119 -45 -100 -49 -173 -125 -231 -238 -74 -145 -150 -199 -310 -223 -221 -32 -377 -164 -435 -367 -14 -49 -16 -78 -10 -155 22 -268 12 -303 -120 -441 -98 -102 -137 -175 -156 -289 -9 -54 -9 -88 0 -142 19 -114 58 -187 156 -289 132 -138 142 -173 120 -441 -6 -77 -4 -106 10 -155 26 -90 71 -168 134 -228 81 -77 163 -115 292 -137 174 -29 244 -78 319 -225 58 -114 131 -189 233 -239 152 -75 296 -72 466 10 163 79 235 79 403 -1 171 -81 314 -84 466 -9 101 50 174 126 232 239 75 147 145 196 319 225 223 38 368 162 426 365 14 49 16 78 10 155 -22 268 -12 303 120 441 98 102 137 175 156 289 9 54 9 88 0 142 -19 114 -58 187 -156 289 -132 138 -142 173 -120 441 6 77 4 106 -10 155 -58 203 -214 334 -436 367 -159 24 -235 79 -309 223 -58 113 -131 189 -232 239 -152 75 -295 72 -466 -9 -168 -80 -236 -80 -402 -1 -132 62 -229 77 -350 54z m739 -565 c552 -81 994 -523 1075 -1075 30 -200 13 -394 -49 -584 -65 -200 -160 -352 -314 -506 -154 -154 -306 -249 -506 -314 -752 -247 -1545 248 -1661 1035 -57 393 78 802 358 1077 95 93 120 114 203 170 157 105 378 186 565 206 88 9 232 6 329 -9z" />
      <path d="M2380 4385 c-276 -44 -542 -204 -711 -427 -496 -659 -143 -1598 666 -1774 176 -38 394 -26 574 33 631 205 948 934 665 1532 -115 244 -281 413 -519 531 -218 108 -439 142 -675 105z m234 -414 c10 -9 56 -92 102 -185 46 -94 87 -173 91 -177 5 -5 100 -21 213 -38 227 -33 240 -39 240 -108 0 -33 -12 -48 -151 -182 l-151 -146 32 -185 c41 -238 41 -246 6 -276 -15 -13 -36 -24 -48 -24 -11 0 -101 43 -199 95 -98 52 -183 95 -188 95 -6 0 -91 -43 -189 -95 -99 -52 -189 -95 -200 -95 -12 0 -33 11 -48 24 -35 30 -35 38 6 276 l32 185 -151 146 c-139 134 -151 149 -151 182 0 69 13 75 240 108 112 16 208 33 212 37 4 4 48 89 97 189 75 151 95 183 118 191 32 12 60 6 87 -17z" />
      <path d="M2490 3601 c-37 -75 -72 -134 -84 -140 -12 -6 -81 -20 -154 -30 -74 -11 -136 -22 -138 -24 -3 -2 39 -44 91 -92 132 -121 130 -117 105 -267 -12 -68 -24 -134 -27 -147 -6 -22 4 -19 122 42 71 37 140 67 156 67 16 0 84 -29 155 -67 118 -61 127 -65 121 -42 -3 13 -15 79 -27 147 -25 150 -27 146 105 266 52 49 94 91 91 93 -2 3 -64 13 -138 24 -73 11 -142 24 -154 30 -12 6 -47 64 -84 140 -36 71 -67 129 -70 129 -3 0 -34 -58 -70 -129z" />
      <path d="M811 1175 c-248 -654 -262 -697 -251 -726 14 -33 37 -49 72 -49 13 1 165 52 338 114 173 63 318 111 321 107 4 -3 78 -136 164 -296 86 -160 166 -298 177 -307 26 -23 70 -23 96 -1 14 12 103 233 253 628 127 336 234 617 236 626 4 14 -5 15 -70 11 -101 -6 -221 19 -327 70 -114 54 -237 176 -293 288 -59 121 -89 143 -213 161 -43 6 -107 22 -143 35 -36 14 -73 27 -81 30 -12 3 -74 -150 -279 -691z" />
      <path d="M4010 1860 c-30 -19 -136 -50 -208 -60 -112 -16 -157 -45 -195 -130 -108 -241 -375 -404 -634 -388 -65 4 -74 3 -70 -11 2 -9 109 -290 236 -626 150 -395 239 -616 253 -628 26 -22 70 -22 96 1 11 9 91 147 177 307 86 160 160 293 164 297 3 3 148 -45 321 -108 173 -62 325 -113 338 -114 34 0 58 16 71 49 12 27 5 49 -81 278 -353 934 -434 1143 -443 1143 -5 0 -17 -5 -25 -10z" />
    </g>
  </svg>
);

export const AiFillStar = ({ customClass }) => (
  <i className={`flaticon-star-1 ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 1024 1024"
  //   className={customClass}
  // >
  //   <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"></path>
  // </svg>
);

export const AiOutlineStar = ({ customClass }) => (
  <i className={`flaticon-star ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 1024 1024"
  //   className={customClass}
  // >
  //   <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"></path>
  // </svg>
);
export const HiCheckCircle = ({ customClass }) => (
  <svg
    className={customClass}
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 20 20"
  >
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export const ImFilePdf = ({ customClass, onClick = () => {} }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    version="1.1"
    viewBox="0 0 16 16"
    className={customClass}
    onClick={onClick}
  >
    <path d="M13.156 9.211c-0.213-0.21-0.686-0.321-1.406-0.331-0.487-0.005-1.073 0.038-1.69 0.124-0.276-0.159-0.561-0.333-0.784-0.542-0.601-0.561-1.103-1.34-1.415-2.197 0.020-0.080 0.038-0.15 0.054-0.222 0 0 0.339-1.923 0.249-2.573-0.012-0.089-0.020-0.115-0.044-0.184l-0.029-0.076c-0.092-0.212-0.273-0.437-0.556-0.425l-0.171-0.005c-0.316 0-0.573 0.161-0.64 0.403-0.205 0.757 0.007 1.889 0.39 3.355l-0.098 0.239c-0.275 0.67-0.619 1.345-0.923 1.94l-0.040 0.077c-0.32 0.626-0.61 1.157-0.873 1.607l-0.271 0.144c-0.020 0.010-0.485 0.257-0.594 0.323-0.926 0.553-1.539 1.18-1.641 1.678-0.032 0.159-0.008 0.362 0.156 0.456l0.263 0.132c0.114 0.057 0.234 0.086 0.357 0.086 0.659 0 1.425-0.821 2.48-2.662 1.218-0.396 2.604-0.726 3.819-0.908 0.926 0.521 2.065 0.883 2.783 0.883 0.128 0 0.238-0.012 0.327-0.036 0.138-0.037 0.254-0.115 0.325-0.222 0.139-0.21 0.168-0.499 0.13-0.795-0.011-0.088-0.081-0.196-0.157-0.271zM3.307 12.72c0.12-0.329 0.596-0.979 1.3-1.556 0.044-0.036 0.153-0.138 0.253-0.233-0.736 1.174-1.229 1.642-1.553 1.788zM7.476 3.12c0.212 0 0.333 0.534 0.343 1.035s-0.107 0.853-0.252 1.113c-0.12-0.385-0.179-0.992-0.179-1.389 0 0-0.009-0.759 0.088-0.759v0zM6.232 9.961c0.148-0.264 0.301-0.543 0.458-0.839 0.383-0.724 0.624-1.29 0.804-1.755 0.358 0.651 0.804 1.205 1.328 1.649 0.065 0.055 0.135 0.111 0.207 0.166-1.066 0.211-1.987 0.467-2.798 0.779v0zM12.952 9.901c-0.065 0.041-0.251 0.064-0.37 0.064-0.386 0-0.864-0.176-1.533-0.464 0.257-0.019 0.493-0.029 0.705-0.029 0.387 0 0.502-0.002 0.88 0.095s0.383 0.293 0.318 0.333v0z"></path>
    <path d="M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"></path>
  </svg>
);

export const StackModules = ({ customClass }) => (
  <i className={`flaticon-layers ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   version="1.1"
  //   viewBox="0 0 16 16"
  //   className={customClass}
  // >
  //   <path d="M16 5l-8-4-8 4 8 4 8-4zM8 2.328l5.345 2.672-5.345 2.672-5.345-2.672 5.345-2.672zM14.398 7.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199zM14.398 10.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199z"></path>
  // </svg>
);

export const ClockCircleOutline = ({ customClass }) => (
  <i className={`flaticon-clock ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 1024 1024"
  //   className={customClass}
  // >
  //   <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
  //   <path d="M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"></path>
  // </svg>
);

export const SessionStethosCope = ({ customClass }) => (
  <i className={`flaticon-stethoscope ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  //   className={customClass}
  // >
  //   <g>
  //     <path fill="none" d="M0 0H24V24H0z"></path>
  //     <path d="M8 3v2H6v4c0 2.21 1.79 4 4 4s4-1.79 4-4V5h-2V3h3c.552 0 1 .448 1 1v5c0 2.973-2.162 5.44-5 5.917V16.5c0 1.933 1.567 3.5 3.5 3.5 1.497 0 2.775-.94 3.275-2.263C16.728 17.27 16 16.22 16 15c0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.371-.92 2.527-2.176 2.885C19.21 20.252 17.059 22 14.5 22 11.462 22 9 19.538 9 16.5v-1.583C6.162 14.441 4 11.973 4 9V4c0-.552.448-1 1-1h3zm11 11c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1z"></path>
  //   </g>
  // </svg>
);

export const SessionAttachMent = ({ customClass }) => (
  <i className={`flaticon-attach-paperclip-symbol ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  //   className={customClass}
  // >
  //   <path
  //     fill="none"
  //     stroke="#fff"
  //     strokeWidth="2"
  //     d="M22,12 C22,12 19.0000009,15.0000004 13.0000004,21.0000004 C6.99999996,27.0000004 -2.00000007,18.0000004 3.99999994,12.0000004 C9.99999996,6.00000037 9,7.00000011 13,3.00000008 C17,-0.999999955 23,4.99999994 19,9.00000005 C15,13.0000002 12.0000004,16.0000007 9.99999995,18.0000004 C7.99999952,20 5,17 6.99999995,15.0000004 C8.99999991,13.0000007 16,6 16,6"
  //   ></path>
  // </svg>
);

export const SessionAvailableIcon = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    className={customClass}
    viewBox="0 0 512.000000 512.000000"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M2679 4311 c-23 -19 -24 -25 -27 -185 l-3 -166 75 0 76 0 0 115 0
  115 815 0 815 0 0 -495 0 -495 -585 0 -585 0 0 -70 0 -69 129 -3 130 -3 -100
  -120 c-63 -76 -99 -128 -99 -143 0 -31 43 -72 75 -72 30 0 28 -2 188 188 l128
  152 409 0 c397 0 411 1 430 20 20 20 20 33 20 614 l0 595 -26 20 c-27 21 -31
  21 -934 21 -879 0 -909 -1 -931 -19z"
      />
      <path
        d="M3210 3773 c-22 -20 -33 -40 -37 -70 -5 -39 -2 -46 30 -78 29 -29 42
  -35 77 -35 58 0 100 41 100 100 0 52 -13 76 -50 95 -45 23 -85 19 -120 -12z"
      />
      <path
        d="M3603 3780 c-41 -25 -58 -79 -39 -125 30 -70 111 -87 168 -36 28 25
  33 36 33 76 0 40 -5 51 -33 76 -39 35 -82 38 -129 9z"
      />
      <path
        d="M3974 3766 c-38 -38 -44 -77 -19 -126 19 -37 43 -50 90 -50 47 0 71
  13 90 50 25 49 19 88 -19 126 -26 26 -42 34 -71 34 -29 0 -45 -8 -71 -34z"
      />
      <path
        d="M2383 3765 c-86 -19 -176 -69 -228 -127 -80 -89 -111 -218 -102 -418
  3 -69 13 -161 22 -205 36 -171 119 -331 227 -431 175 -165 369 -158 543 21
  133 136 205 318 225 570 28 342 -69 522 -314 585 -94 24 -275 26 -373 5z m367
  -149 c111 -41 165 -114 177 -239 3 -37 3 -67 -1 -67 -17 0 -107 53 -156 91
  -69 54 -100 56 -145 7 -41 -46 -96 -74 -182 -94 -75 -17 -91 -27 -104 -62 -12
  -31 13 -80 45 -88 50 -12 199 37 292 96 20 12 27 10 71 -18 27 -17 79 -45 116
  -62 52 -24 67 -35 63 -48 -2 -9 -7 -38 -11 -65 -16 -122 -90 -278 -169 -361
  -126 -131 -246 -129 -371 5 -68 74 -126 191 -156 314 -32 133 -33 366 -1 447
  49 123 154 170 367 164 78 -3 136 -10 165 -20z"
      />
      <path
        d="M1013 3611 c-104 -36 -173 -103 -207 -204 -14 -43 -16 -146 -16 -987
  l0 -940 70 0 70 0 2 943 3 943 25 37 c13 20 43 46 65 59 40 23 44 23 433 26
  l392 3 0 69 0 70 -392 0 c-352 -1 -398 -3 -445 -19z"
      />
      <path d="M4190 2175 l0 -695 70 0 70 0 0 695 0 695 -70 0 -70 0 0 -695z" />
      <path
        d="M2030 2381 c-63 -20 -139 -50 -169 -67 -79 -42 -153 -114 -192 -186
  l-34 -63 -3 -292 -3 -293 70 0 71 0 0 263 c0 254 1 263 24 313 39 84 122 141
  276 188 69 21 87 24 95 13 126 -168 354 -439 372 -443 49 -13 68 5 238 217 94
  117 175 219 180 226 9 12 25 10 95 -13 159 -50 236 -103 276 -189 23 -48 24
  -59 24 -312 l0 -263 71 0 70 0 -3 293 -3 292 -33 61 c-66 121 -167 192 -361
  254 -138 44 -173 48 -198 22 -10 -10 -87 -104 -172 -210 -85 -106 -158 -192
  -161 -192 -4 0 -78 89 -165 198 -87 108 -165 203 -173 210 -25 19 -69 13 -192
  -27z"
      />
      <path
        d="M443 1270 c-12 -5 -29 -20 -38 -34 -20 -31 -10 -75 45 -193 47 -101
  120 -182 199 -220 l56 -28 1855 0 1855 0 56 28 c103 50 186 161 239 317 26 76
  16 112 -32 129 -39 14 -4202 14 -4235 1z m4107 -151 c0 -21 -52 -99 -90 -133
  -21 -19 -56 -39 -77 -45 -53 -15 -3593 -15 -3646 0 -61 17 -139 97 -161 167
  l-7 22 1990 0 c1410 0 1991 -3 1991 -11z"
      />
    </g>
  </svg>
);

export const QnASection = ({ customClass }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="150.000000pt"
    height="150.000000pt"
    viewBox="0 0 150.000000 150.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,150.000000) scale(0.100000,-0.100000)"
      fill="#50a8da"
      stroke="none"
    >
      <path
        d="M413 1305 c-116 -31 -204 -95 -255 -183 -30 -52 -33 -64 -33 -137 0
    -89 17 -133 78 -201 29 -33 33 -47 42 -128 7 -67 14 -92 25 -94 8 -1 47 18 85
    43 69 46 70 46 136 40 209 -19 419 95 465 253 53 181 -64 350 -283 407 -71 19
    -191 18 -260 0z m307 -67 c88 -40 133 -79 168 -145 41 -77 43 -137 7 -209 -46
    -93 -127 -149 -260 -180 -66 -16 -85 -16 -147 -6 -58 10 -74 10 -87 -1 -9 -7
    -35 -25 -58 -40 l-41 -26 -8 67 c-6 59 -11 72 -44 108 -59 64 -74 100 -75 174
    0 107 58 190 171 246 78 38 107 44 219 40 81 -3 110 -8 155 -28z"
      />
      <path
        d="M494 1141 c-56 -25 -87 -71 -92 -137 -9 -104 59 -184 155 -184 27 0
    42 -6 51 -20 13 -21 47 -27 57 -10 4 6 0 21 -8 33 -13 19 -11 25 13 59 15 21
    31 54 34 73 15 78 -41 175 -112 195 -48 13 -50 13 -98 -9z m119 -62 c39 -30
    52 -87 31 -138 -17 -43 -31 -51 -40 -26 -9 22 -54 20 -54 -3 0 -10 5 -23 12
    -30 9 -9 6 -12 -16 -12 -19 0 -40 12 -62 34 -28 28 -34 42 -34 76 0 47 13 77
    44 102 29 24 87 23 119 -3z"
      />
      <path
        d="M1027 928 c-8 -23 4 -33 63 -52 74 -24 111 -48 163 -106 93 -103 86
    -240 -17 -339 -26 -25 -36 -44 -36 -65 0 -17 -3 -47 -6 -68 l-6 -36 -55 35
    c-54 35 -55 35 -137 28 -184 -16 -349 64 -405 195 -21 49 -46 65 -57 35 -19
    -50 85 -182 181 -229 81 -39 185 -59 272 -52 l72 7 71 -46 c40 -25 79 -45 88
    -43 13 2 19 22 27 93 9 80 13 94 41 123 58 62 79 118 79 207 0 70 -4 86 -29
    129 -41 70 -95 120 -170 156 -81 38 -131 48 -139 28z"
      />
      <path
        d="M932 747 c-6 -7 -31 -56 -55 -108 -24 -52 -54 -114 -65 -138 -16 -33
    -19 -48 -11 -58 18 -20 28 -16 50 22 l21 35 78 0 78 0 21 -36 c24 -41 47 -40
    45 2 -2 33 -123 286 -140 291 -6 2 -16 -2 -22 -10z m47 -136 c11 -27 21 -52
    21 -55 0 -3 -25 -6 -55 -6 l-55 0 27 55 c15 30 30 55 34 55 4 0 16 -22 28 -49z"
      />
    </g>
  </svg>
);

export const SpqRight = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 16 16"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z"></path>
    <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"></path>
  </svg>
);

export const SpqWrong = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="none"
      strokeMiterlimit="10"
      strokeWidth="32"
      d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
    ></path>
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
      d="M320 320L192 192m0 128l128-128"
    ></path>
  </svg>
);

export const AiOutlinePlusCircle = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 1024 1024"
    className={customClass}
  >
    <path d="M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"></path>
    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>
  </svg>
);

export const BiMenuAltRight = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    className={customClass}
  >
    <path d="M4 6h16v2H4zm4 5h12v2H8zm5 5h7v2h-7z"></path>
  </svg>
);
export const FaRegUser = ({ customClass }) => (
  <i className={`flaticon-user-1 ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 448 512"
  //   className={customClass}
  // >
  //   <path d="M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"></path>
  // </svg>
);
export const BsEmojiSmileFill = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 16 16"
    className={customClass}
  >
    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zM4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z"></path>
  </svg>
);
export const HiMenuAlt2 = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 20 20"
    className={customClass}
  >
    <path
      fillRule="evenodd"
      d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1z"
      clipRule="evenodd"
    ></path>
  </svg>
);
export const BiMapPin = ({ customClass, id = '', gtmTagVariable = '' }) => (
  <svg
    id={id}
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    className={`${customClass} ${gtmTagVariable}`}
  >
    <path
      className={gtmTagVariable}
      d="m12 17 1-2V9.858c1.721-.447 3-2 3-3.858 0-2.206-1.794-4-4-4S8 3.794 8 6c0 1.858 1.279 3.411 3 3.858V15l1 2zM10 6c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2z"
    ></path>
    <path
      className={gtmTagVariable}
      d="m16.267 10.563-.533 1.928C18.325 13.207 20 14.584 20 16c0 1.892-3.285 4-8 4s-8-2.108-8-4c0-1.416 1.675-2.793 4.267-3.51l-.533-1.928C4.197 11.54 2 13.623 2 16c0 3.364 4.393 6 10 6s10-2.636 10-6c0-2.377-2.197-4.46-5.733-5.437z"
    ></path>
  </svg>
);

export const HiOutlineDotsVertical = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="none"
    strokeWidth="0"
    viewBox="0 0 24 24"
    className={customClass}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
    ></path>
  </svg>
);
export const CertificateSharePageIcon = () => (
  <>
    <svg
      id="Layer_1"
      data-name="Layer 1"
      className="trainingCertificateShape"
      viewBox="0 0 351.08 2981.81"
    >
      <path
        className="cls-1"
        d="M3467.51,3947h-328V965.24h172.76s292,500.06,128.63,1096.48c-109.29,398.92-259.3,811.17-194,1297C3283.64,3632.45,3467.51,3947,3467.51,3947Z"
        transform="translate(-3139.52 -965.24)"
      />
    </svg>
    <svg
      id="Layer_1"
      className="trainingCertificateShapeMbl"
      data-name="Layer 1"
      viewBox="0 0 2981.81 351.08"
    >
      <path
        className="cls-1"
        d="M4806,2303.68v328H1824.15V2458.92s500.06-292.05,1096.49-128.64c398.92,109.29,811.16,259.31,1297,194C4491.36,2487.55,4806,2303.68,4806,2303.68Z"
        transform="translate(-1824.15 -2280.6)"
      />
    </svg>
  </>
);

export const IoInformationCircle = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    className={customClass}
  >
    <path d="M256 56C145.72 56 56 145.72 56 256s89.72 200 200 200 200-89.72 200-200S366.28 56 256 56zm0 82a26 26 0 11-26 26 26 26 0 0126-26zm48 226h-88a16 16 0 010-32h28v-88h-16a16 16 0 010-32h32a16 16 0 0116 16v104h28a16 16 0 010 32z"></path>
  </svg>
);

export const IoInformationCircleOutline = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    className={customClass}
  >
    <path
      fill="none"
      strokeMiterlimit="10"
      strokeWidth="32"
      d="M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z"
    ></path>
    <path
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
      d="M220 220h32v116"
    ></path>
    <path
      fill="none"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="32"
      d="M208 340h88"
    ></path>
    <path d="M248 130a26 26 0 1026 26 26 26 0 00-26-26z"></path>
  </svg>
);

export const GiTeacher = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    className={customClass}
  >
    <path d="M120.998 40.998v37.943C136.22 89.471 146 109.278 146 131.001c0 13.71-3.901 26.65-10.598 36.985 3.465 1.35 7.106 2.85 10.15 4.172l122.352-22.783 5.918 54.842-111.748 23.219c-.862 16.261-2.45 32.262-5.289 51.566h336.217V40.998zM96 88.998c-16.595 0-32.002 17.747-32.002 42.004 0 24.257 15.407 42.002 32.002 42.002 16.595 0 32.002-17.745 32.002-42.002S112.595 88.998 96 88.998zm156.096 81.629l-108.592 20.22c-14.24-5.602-4.956-3.035-21.469-8.517-7.476 5.469-16.33 8.672-26.035 8.672-8.6 0-16.53-2.523-23.428-6.9-8.59 3.564-17.655 8.09-25.736 12.654-12.992 7.338-23.722 13.211-27.838 16.033v130.213h20.004V232h17.996v263.002h30.004V326h17.996v169.002h26.004v-171.84l.154-.824c9.514-50.64 12.588-77.384 13.461-109.656l109.56-22.766zm-98.153 126.375c-.952 5.682-1.991 11.64-3.146 17.996H478v-17.996zM208 344.998c-16.595 0-32.002 17.747-32.002 42.004 0 18.198 8.67 32.73 20.01 38.855 3.599-1.662 7.482-2.706 11.68-2.851 4.633-.16 8.98.767 13.052 2.42 10.968-6.352 19.262-20.63 19.262-38.424 0-24.257-15.407-42.004-32.002-42.004zm112 0c-16.595 0-32.002 17.747-32.002 42.004 0 18.198 8.67 32.73 20.01 38.855 3.599-1.662 7.482-2.706 11.68-2.851 4.633-.16 8.98.767 13.052 2.42 10.968-6.352 19.262-20.63 19.262-38.424 0-24.257-15.407-42.004-32.002-42.004zm112 0c-16.595 0-32.002 17.747-32.002 42.004 0 18.198 8.67 32.73 20.01 38.855 3.599-1.662 7.482-2.706 11.68-2.851 4.633-.16 8.98.767 13.052 2.42 10.968-6.352 19.262-20.63 19.262-38.424 0-24.257-15.407-42.004-32.002-42.004zm-223.688 95.996c-3.844.133-8.907 2.93-14.3 8.785-5.394 5.855-10.696 14.25-15.125 22.76-4.226 8.12-7.609 16.16-10.06 22.463h85.339c-3.04-6.436-7.138-14.549-12.133-22.711-5.298-8.658-11.511-17.138-17.668-22.957-6.157-5.819-11.8-8.487-16.053-8.34zm112 0c-3.844.133-8.907 2.93-14.3 8.785-5.394 5.855-10.696 14.25-15.125 22.76-4.226 8.12-7.609 16.16-10.06 22.463h85.339c-3.04-6.436-7.138-14.549-12.133-22.711-5.298-8.658-11.511-17.138-17.668-22.957-6.157-5.819-11.8-8.487-16.052-8.34zm112 0c-3.844.133-8.907 2.93-14.3 8.785-5.394 5.855-10.696 14.25-15.125 22.76-4.226 8.12-7.609 16.16-10.06 22.463h85.339c-3.04-6.436-7.138-14.549-12.133-22.711-5.298-8.658-11.511-17.138-17.668-22.957-6.157-5.819-11.8-8.487-16.052-8.34z"></path>
  </svg>
);
export const RiReservedFill = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    className={customClass}
  >
    <g>
      <path fill="none" d="M0 0h24v24H0z"></path>
      <path d="M13 15v4h3v2H8v-2h3v-4H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-7zM8 8v2h8V8H8z"></path>
    </g>
  </svg>
);
export const RecentLogo = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 16 16"
    className={customClass}
  >
    <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"></path>
  </svg>
);
export const MdOutlineFeaturedVideo = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    className={customClass}
  >
    <path fill="none" d="M0 0h24v24H0V0z"></path>
    <path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM4 6h9v7H4z"></path>
  </svg>
);
export const MdOutlineTravelExplore = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    className={customClass}
  >
    <path fill="none" d="M0 0h24v24H0z"></path>
    <path d="M19.3 16.9c.4-.7.7-1.5.7-2.4 0-2.5-2-4.5-4.5-4.5S11 12 11 14.5s2 4.5 4.5 4.5c.9 0 1.7-.3 2.4-.7l3.2 3.2 1.4-1.4-3.2-3.2zm-3.8.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5zM12 20v2C6.48 22 2 17.52 2 12S6.48 2 12 2c4.84 0 8.87 3.44 9.8 8h-2.07A8 8 0 0015 4.59V5c0 1.1-.9 2-2 2h-2v2c0 .55-.45 1-1 1H8v2h2v3H9l-4.79-4.79C4.08 10.79 4 11.38 4 12c0 4.41 3.59 8 8 8z"></path>
  </svg>
);
export const BiShare = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    className={customClass}
  >
    <path d="M11 7.05V4a1 1 0 0 0-1-1 1 1 0 0 0-.7.29l-7 7a1 1 0 0 0 0 1.42l7 7A1 1 0 0 0 11 18v-3.1h.85a10.89 10.89 0 0 1 8.36 3.72 1 1 0 0 0 1.11.35A1 1 0 0 0 22 18c0-9.12-8.08-10.68-11-10.95zm.85 5.83a14.74 14.74 0 0 0-2 .13A1 1 0 0 0 9 14v1.59L4.42 11 9 6.41V8a1 1 0 0 0 1 1c.91 0 8.11.2 9.67 6.43a13.07 13.07 0 0 0-7.82-2.55z"></path>
  </svg>
);
export const VscDebugDisconnect = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 16 16"
    className={customClass}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.617 3.844a2.87 2.87 0 0 0-.451-.868l1.354-1.36L13.904 1l-1.36 1.354a2.877 2.877 0 0 0-.868-.452 3.073 3.073 0 0 0-2.14.075 3.03 3.03 0 0 0-.991.664L7 4.192l4.327 4.328 1.552-1.545c.287-.287.508-.618.663-.992a3.074 3.074 0 0 0 .075-2.14zm-.889 1.804a2.15 2.15 0 0 1-.471.705l-.93.93-3.09-3.09.93-.93a2.15 2.15 0 0 1 .704-.472 2.134 2.134 0 0 1 1.689.007c.264.114.494.271.69.472.2.195.358.426.472.69a2.134 2.134 0 0 1 .007 1.688zm-4.824 4.994l1.484-1.545-.616-.622-1.49 1.551-1.86-1.859 1.491-1.552L6.291 6 4.808 7.545l-.616-.615-1.551 1.545a3 3 0 0 0-.663.998 3.023 3.023 0 0 0-.233 1.169c0 .332.05.656.15.97.105.31.258.597.459.862L1 13.834l.615.615 1.36-1.353c.265.2.552.353.862.458.314.1.638.15.97.15.406 0 .796-.077 1.17-.232.378-.155.71-.376.998-.663l1.545-1.552-.616-.615zm-2.262 2.023a2.16 2.16 0 0 1-.834.164c-.301 0-.586-.057-.855-.17a2.278 2.278 0 0 1-.697-.466 2.28 2.28 0 0 1-.465-.697 2.167 2.167 0 0 1-.17-.854 2.16 2.16 0 0 1 .642-1.545l.93-.93 3.09 3.09-.93.93a2.22 2.22 0 0 1-.711.478z"
    ></path>
  </svg>
);
export const BiLike = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
    className={customClass}
  >
    <path d="M20 8h-5.612l1.123-3.367c.202-.608.1-1.282-.275-1.802S14.253 2 13.612 2H12c-.297 0-.578.132-.769.36L6.531 8H4c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h13.307a2.01 2.01 0 0 0 1.873-1.298l2.757-7.351A1 1 0 0 0 22 12v-2c0-1.103-.897-2-2-2zM4 10h2v9H4v-9zm16 1.819L17.307 19H8V9.362L12.468 4h1.146l-1.562 4.683A.998.998 0 0 0 13 10h7v1.819z"></path>
  </svg>
);
export const AiOutlineComment = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    t="1569682881658"
    viewBox="0 0 1024 1024"
    className={customClass}
  >
    <defs></defs>
    <path d="M573 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40zM293 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z"></path>
    <path d="M894 345c-48.1-66-115.3-110.1-189-130v0.1c-17.1-19-36.4-36.5-58-52.1-163.7-119-393.5-82.7-513 81-96.3 133-92.2 311.9 6 439l0.8 132.6c0 3.2 0.5 6.4 1.5 9.4 5.3 16.9 23.3 26.2 40.1 20.9L309 806c33.5 11.9 68.1 18.7 102.5 20.6l-0.5 0.4c89.1 64.9 205.9 84.4 313 49l127.1 41.4c3.2 1 6.5 1.6 9.9 1.6 17.7 0 32-14.3 32-32V753c88.1-119.6 90.4-284.9 1-408zM323 735l-12-5-99 31-1-104-8-9c-84.6-103.2-90.2-251.9-11-361 96.4-132.2 281.2-161.4 413-66 132.2 96.1 161.5 280.6 66 412-80.1 109.9-223.5 150.5-348 102z m505-17l-8 10 1 104-98-33-12 5c-56 20.8-115.7 22.5-171 7l-0.2-0.1C613.7 788.2 680.7 742.2 729 676c76.4-105.3 88.8-237.6 44.4-350.4l0.6 0.4c23 16.5 44.1 37.1 62 62 72.6 99.6 68.5 235.2-8 330z"></path>
    <path d="M433 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z"></path>
  </svg>
);

export const HelpFormIcon = ({ customClass }) => (
  <svg
    className={customClass}
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 44.000000 62.000000"
  >
    <g transform="translate(0.000000,62.000000) scale(0.100000,-0.100000)" stroke="none">
      <path d="M125 597 c-45 -18 -70 -38 -94 -77 -47 -78 -14 -208 102 -402 84 -139 90 -139 174 0 116 194 149 324 102 402 -39 64 -92 88 -189 88 -36 0 -79 -5 -95 -11z m178 -23 c122 -41 135 -148 41 -337 -41 -82 -116 -207 -124 -207 -9 0 -87 131 -129 218 -52 108 -68 179 -53 230 28 92 149 136 265 96z" />
      <path d="M154 473 c-33 -35 -15 -53 19 -19 30 30 53 33 85 10 32 -22 27 -51 -18 -100 -25 -27 -40 -53 -40 -69 0 -35 19 -32 26 5 4 16 17 36 31 45 52 35 60 120 13 145 -36 20 -89 12 -116 -17z" />
      <path d="M200 230 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0 -10 -4 -10 -10z" />
    </g>
  </svg>
);
export const GrHistory = ({ customClass, gtmTagVariable = '' }) => (
  <i className={`flaticon-clock ${customClass} ${gtmTagVariable}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   strokeWidth="0"
  //   viewBox="0 0 24 24"
  //   className={`${customClass} ${gtmTagVariable}`}
  // >
  //   <path
  //     className={gtmTagVariable}
  //     fill="none"
  //     stroke="#000"
  //     strokeWidth="2"
  //     d="M1,12 C1,18.075 5.925,23 12,23 C18.075,23 23,18.075 23,12 C23,5.925 18.075,1 12,1 C7.563,1 4,4 2,7.5 M1,1 L1,8 L8,8 M16,17 L12,13 L12,6"
  //   ></path>
  // </svg>
);

export const CtaDoctorIcon = ({ customClass }) => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    enableBackground="new 0 0 512 512"
    className={customClass}
  >
    <circle fill="#ECF0F1" cx="256" cy="256" r="256" />
    <circle fill="#FAD24D" cx="256" cy="256" r="256" />
    <path
      fill="#F0BA7D"
      d="M228.546,238.629l-6.957,34.955l-23.307,8.016l13.793,217.594l88.682-0.503l4.142-221.201  l-14.885-4.683l-7.586-35.659L228.546,238.629L228.546,238.629z"
    />
    <path
      fill="#21D0C3"
      d="M192.992,342.31c38.801,18.812,78.715,22.761,120.732,1.065l-1.432,162.402  C294.176,509.84,275.341,512,256,512c-22.256,0-43.846-2.844-64.432-8.182L192.992,342.31z"
    />
    <path
      fill="#EEF3F7"
      d="M297.499,275.471l67.592,18.434c17.527,5.411,33.188,15.775,33.689,34.4l3.707,137.649  c-15.404,10.768-32.048,19.876-49.674,27.085l-4.314-76.125l-11.837,82.104C311.304,507.439,284.186,512,256.001,512  c-0.736,0-1.466-0.022-2.201-0.028l-0.028-69.787L297.499,275.471z"
    />
    <g>
      <path
        fill="#FFFFFF"
        d="M296.855,274.993l8.907,3.593l30.383,45.612l-35.613-0.573l22.074,11.812l-68.833,106.749   L296.855,274.993L296.855,274.993z"
      />
      <path
        fill="#FFFFFF"
        d="M218.424,274.774l-67.907,17.239c-17.622,5.103-33.46,15.188-34.291,33.801l-6.262,140.453   c15.269,10.625,31.75,19.624,49.193,26.762l5.78-77.732l10.575,83.779c24.647,8.163,50.956,12.666,78.287,12.897l-0.028-69.787   L218.424,274.774L218.424,274.774z"
      />
    </g>
    <path
      fill="#EEF3F7"
      d="M219.076,274.306l-10.62,4.068l-29.53,44.437l35.619,0.057l-22.28,11.42l61.508,107.897  L219.076,274.306L219.076,274.306z"
    />
    <path
      fill="#FED298"
      d="M182.578,154.801c-1.135,11.456,1.159,36.892,15.056,35.924c0,0,20.002,58.295,58.511,64.896  c33.246-6.075,53.47-58.873,55.005-63.896c4.579,1.564,17.396-19.756,7.571-37.198c-2.818-5.002-10.795-0.952-10.795-0.952  l-0.614-14.565c-52.536,5.102-85.296-45.711-85.296-45.711c-20.027,21.785-24.845,34.219-26.987,61.314c0,0-3.761-2.335-7.936-2.424  C185.835,152.161,184.221,153.257,182.578,154.801L182.578,154.801z"
    />
    <path
      fill="#666666"
      d="M221.588,273.584l6.805-34.175c-19.713-19.409-29.992-48.684-29.992-48.684  c-13.432,1.498-18.826-35.521-9.789-36.814c4.133-0.592,6.9,0.703,6.9,0.703c2.035-28.608,7.545-37.307,26.503-61.314  c0,0,33.118,55.72,85.613,50.617l0.751,12.014c2.482-2.44,7.019-4.733,10.799,1.484c6.15,10.115-1.895,33.103-9.343,34.506  c-1.055,3.544-9.344,29.695-26.901,47.615l7.079,33.273c19.699,6.379,38.692,11.306,57.757,16.375  c-9.685-59.038-15.235-122.924-26.799-177.458c-11.098-52.331-71.765-66.967-106.652-43.726c0,0-30.082,12.121-35.574,52.32  c-5.49,40.197-3.389,44.071-3.389,44.071l-9.693,123.779C183.636,283.607,204.447,279.478,221.588,273.584L221.588,273.584z"
    />
    <path
      fill="#FEFEFE"
      d="M348.527,418.914c-9.989-1.725-16.69-11.222-14.966-21.212c1.725-9.988,11.223-16.692,21.212-14.968  c9.991,1.725,16.691,11.225,14.967,21.216C368.015,413.939,358.517,420.639,348.527,418.914z"
    />
    <path
      fill="#0F7986"
      d="M348.709,417.86c-9.408-1.625-15.719-10.566-14.094-19.975c1.625-9.409,10.568-15.721,19.978-14.096  c9.409,1.626,15.718,10.571,14.094,19.979C367.06,413.177,358.119,419.485,348.709,417.86z"
    />
    <path
      fill="#EBECEC"
      d="M350.022,410.253c-5.203-0.898-8.697-5.851-7.798-11.054c0.898-5.207,5.849-8.696,11.052-7.798  c5.207,0.899,8.698,5.846,7.799,11.053C360.178,407.658,355.229,411.151,350.022,410.253L350.022,410.253z"
    />
    <path
      fill="#FEFEFE"
      d="M351.147,392.425l4.204,0.725l2.26-13.09l-4.202-0.725L351.147,392.425L351.147,392.425z"
    />
    <path
      fill="#21D0C3"
      d="M210.372,422.546l7.877-1.563c3.346-0.665,6.119-2.636,7.886-5.279  c1.765-2.643,2.532-5.957,1.866-9.304l-9.262-46.668c-3.496-17.61-17.273-26.591-33.016-28.581  c-6.033-0.764-12.357-0.486-18.483,0.729c-6.131,1.212-12.075,3.37-17.356,6.378c-13.754,7.833-23.024,21.378-19.522,39.017  l9.262,46.669c0.665,3.346,2.639,6.117,5.28,7.885l0.006-0.002c2.644,1.769,5.954,2.532,9.299,1.868l7.872-1.563l-0.644-3.245  l-7.874,1.563c-2.454,0.487-4.886-0.074-6.822-1.367l0.001-0.001c-1.938-1.299-3.386-3.331-3.874-5.781l-9.262-46.669  c-3.177-16.005,5.317-28.341,17.902-35.504c4.973-2.834,10.583-4.868,16.373-6.017c5.789-1.147,11.752-1.406,17.434-0.689  c14.408,1.821,27.009,9.982,30.178,25.956l9.265,46.669c0.486,2.452-0.078,4.881-1.372,6.822c-1.297,1.936-3.331,3.384-5.783,3.869  l-7.876,1.563L210.372,422.546L210.372,422.546z"
    />
    <path
      fill="#4D4D4D"
      d="M221.235,366.648l-1.415-7.129c-3.602-18.157-17.777-27.41-33.963-29.458  c-6.148-0.775-12.589-0.499-18.83,0.741c-6.243,1.236-12.3,3.436-17.682,6.498c-14.146,8.057-23.673,22.003-20.065,40.19  l1.417,7.129l5.405-1.075l-1.415-7.128c-3.067-15.458,5.168-27.392,17.362-34.337c4.874-2.774,10.369-4.766,16.047-5.892  c5.676-1.127,11.521-1.38,17.088-0.677c13.962,1.764,26.167,9.652,29.231,25.081l1.414,7.129L221.235,366.648L221.235,366.648z"
    />
    <g>
      <path
        fill="#076673"
        d="M155.836,434.082l4.213-0.837c1.057,1.187,2.694,1.797,4.362,1.466   c2.507-0.497,4.136-2.932,3.638-5.441c-0.496-2.504-2.931-4.134-5.438-3.635c-1.671,0.331-2.95,1.522-3.472,3.021l-4.212,0.835   L155.836,434.082z"
      />
      <path
        fill="#076673"
        d="M213.72,422.593l-4.21,0.837c-0.523,1.498-1.802,2.689-3.471,3.02   c-2.506,0.496-4.94-1.132-5.438-3.64c-0.496-2.504,1.132-4.94,3.637-5.437c1.669-0.331,3.308,0.281,4.361,1.466l4.212-0.837   L213.72,422.593L213.72,422.593z"
      />
    </g>
    <path
      fill="#666666"
      d="M169.59,330.379l-1.607-8.097l-3.195,0.636l-3.19,0.632l1.625,8.176  c1.217-0.356,2.449-0.657,3.693-0.903C167.802,330.646,168.694,330.499,169.59,330.379z"
    />
    <g>
      <path
        fill="#0F7986"
        d="M162.697,429.577c0.76-0.151,1.251-0.89,1.1-1.645c-0.15-0.759-0.885-1.253-1.645-1.102   c-0.76,0.151-1.251,0.887-1.101,1.646C161.202,429.233,161.938,429.728,162.697,429.577L162.697,429.577z"
      />
      <path
        fill="#0F7986"
        d="M204.351,421.295c0.757-0.15,1.249-0.887,1.098-1.643c-0.151-0.76-0.885-1.253-1.645-1.103   c-0.76,0.151-1.251,0.887-1.1,1.648C202.853,420.952,203.59,421.445,204.351,421.295z"
      />
    </g>
    <path
      fill="#FEFEFE"
      d="M349.511,410.164c-4.923-0.85-8.224-5.531-7.375-10.455c0.85-4.921,5.528-8.223,10.452-7.374  c4.922,0.85,8.225,5.529,7.376,10.451C359.114,407.711,354.433,411.014,349.511,410.164z"
    />
    <g>
      <path
        fill="#4D4D4D"
        d="M208.563,278.563c-0.142,0.001-49.862,0.414-41.463,43.912l-4.623,0.884   c-9.468-49.038,45.874-49.49,46.032-49.492L208.563,278.563L208.563,278.563z"
      />
      <path
        fill="#4D4D4D"
        d="M307.775,274.091c8.111,0.218,23.794,2.429,35.861,17.111   c11.811,14.367,20.091,40.752,13.899,89.128l-4.661-0.59c5.993-46.823-1.751-72.031-12.866-85.554   c-10.86-13.211-25.019-15.202-32.344-15.399L307.775,274.091L307.775,274.091z"
      />
    </g>
  </svg>
);

export const CtaArticleIcon = ({ customClass }) => (
  <svg
    id="Layer_1"
    enableBackground="new 0 0 135 135"
    viewBox="0 0 135 135"
    xmlSpace="preserve"
    className={customClass}
  >
    <g id="_x33_6">
      <g>
        <g>
          <g>
            <g>
              <path
                d="m131.5 67.4999619c0 35.3471832-28.6586304 63.9943924-63.9943237 63.9943924-35.3470421-.0000001-64.0056763-28.6472092-64.0056763-63.9943924 0-35.3471069 28.6586342-63.9943237 64.0056763-63.9943237 35.3356933.0000009 63.9943237 28.6472167 63.9943237 63.9943237z"
                fill="#9ee6ff"
              />
            </g>
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m13.6016273 101.9698105c11.3662987 17.7547226 31.2451134 29.5245438 53.8951988 29.5245438 22.6535034 0 42.5332947-11.7700653 53.9015503-29.5245438z"
                  fill="#c68142"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m33.2457237 104.8721008v16.6886978c-1.8798561-1.1899033-3.6797047-2.4698334-5.4195576-3.8497314v-12.8389664c0-1.4998779 1.2098656-2.7098083 2.7097492-2.7098083 1.5064164 0 2.7098084 1.2037353 2.7098084 2.7098083z"
                  fill="#af6223"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m104.7601547 111.7115326v7.8093872c-1.7398605 1.2599106-3.5497742 2.4198532-5.4196243 3.4897232v-11.2991104c0-1.4998779 1.2099915-2.7097473 2.7098694-2.7097473 1.5062256 0 2.7097549 1.2037201 2.7097549 2.7097473z"
                  fill="#af6223"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m88.6713257 116.4111786v11.4790802c-1.7698822.6299591-3.5796814 1.1799011-5.4195023 1.6298828v-13.108963c0-1.4998779 1.2098694-2.7098083 2.7097473-2.7098083 1.5064774-.0000001 2.709755 1.2037353 2.709755 2.7098083z"
                  fill="#af6223"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m39.0927963 101.9698105v9.1709137c0 1.4715729 1.1959534 2.7097549 2.7097511 2.7097549 1.4998817 0 2.7097473-1.2098694 2.7097473-2.7097549v-9.1709137z"
                  fill="#af6223"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m113.9892807 101.9698105v9.4916916c1.9500427-2.0598984 3.7697296-4.2496643 5.4195023-6.5595474v-2.9321442z"
                  fill="#af6223"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m56.9538307 106.1619797v24.458107c-1.8398209-.3000183-3.6496162-.6799316-5.4194984-1.1399231l-.010006-23.3181839c0-1.4998779 1.2098656-2.7098083 2.7097473-2.7098083 1.5316658-.0000001 2.7197571 1.2693557 2.7197571 2.7098083z"
                  fill="#af6223"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m89.7411804 101.9698105v3.5912781c0 1.4636002 1.1807404 2.7097473 2.7097473 2.7097473 1.4901199 0 2.7097473-1.2198792 2.7097473-2.7097473v-3.5912781z"
                  fill="#af6223"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m68.8629303 101.9698105v29.500145c1.8299332-.0300293 3.6398544-.1499023 5.4194946-.3400726v-29.1600723h-5.4194946z"
                  fill="#af6223"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d="m104.0848999 22.7638149v73.1326904c0 3.3541946-2.7191086 6.0733032-6.0733032 6.0733032h-61.0231972c-3.3541908 0-6.0733013-2.7191086-6.0733013-6.0733032v-73.1326904c0-3.3541927 2.7191105-6.0733032 6.0733013-6.0733032h61.0231972c3.3541946 0 6.0733032 2.7191105 6.0733032 6.0733032z"
                      fill="#ffbc50"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d="m104.081543 94.7603073v1.1336823c0 3.3504333-2.7228622 6.0733032-6.0733032 6.0733032h-61.0164834c-3.3504333 0-6.0733013-2.7228699-6.0733013-6.0733032v-73.1326962c0-3.3504372 2.7127323-6.0733032 6.0733013-6.0733032h1.1336784v12.116272c.0000001 36.4296856 29.5264207 65.9560451 65.9561082 65.9560451z"
                      fill="#ffb32c"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d="m38.000824 88.810936v-58.9616509c0-3.3541927 2.7191124-6.0733032 6.0733032-6.0733032h46.8516235c3.3541946 0 6.0733032 2.7191105 6.0733032 6.0733032v58.9616509c0 3.3541946-2.7191086 6.0733032-6.0733032 6.0733032h-46.8516235c-3.3541908 0-6.0733032-2.7191086-6.0733032-6.0733032z"
                      fill="#fff"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <g>
                    <g>
                      <path
                        d="m79.748642 13.4028416-2.0002289-.3264112c-1.5054092-.2526474-2.6844788-1.3472815-3.1792374-2.7896595-1.0106506-2.9266486-3.8004379-5.0426669-7.0639038-5.0426669h-.0105438c-3.2740021 0-6.0532532 2.1160183-7.0639076 5.0426669-.4842186 1.442378-1.6738205 2.5370121-3.1686935 2.7896595l-2.0107689.3264112c-4.2952003.7160482-7.4428825 4.4214573-7.4428825 8.7694092v1.3683567c0 1.1628246.9426537 2.1054802 2.1054802 2.1054802h35.1720886c1.1628265 0 2.105484-.9426556 2.105484-2.1054802v-1.3683567c-.0000001-4.3479519-3.1582261-8.053361-7.4428864-8.7694092zm-12.2433701 1.6317987c-1.3264694 0-2.4002838-1.0632782-2.4002838-2.3897409 0-1.3053875 1.0738144-2.3792038 2.4002838-2.3792038 1.3053818 0 2.3792038 1.0738163 2.3792038 2.3792038 0 1.3264627-1.073822 2.3897409-2.3792038 2.3897409z"
                        fill="#24272b"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <g>
                  <g>
                    <g>
                      <path
                        d="m87.1599121 21.4562016h-33.0560074c-1.1580505 0-2.1054802-.9473629-2.1054802-2.1054802.0638962-.8416996-.2850456-2.7849064.8632545-5.1899376-3.0214233 1.4423771-5.0532036 4.5162964-5.0532036 8.011467v1.3683567c0 1.1581173.9474907 2.1054802 2.1054802 2.1054802h35.1720886c1.1579895 0 2.105484-.9473629 2.105484-2.1054802-.0070952-1.2393418.0189439-1.5036049-.0316161-2.0844059z"
                        fill="#13181e"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g opacity=".3">
                <g>
                  <g>
                    <g>
                      <g>
                        <g>
                          <path
                            d="m81.6323471 18.2416821c-.1743088-.1480198-.3593369-.2843552-.5550766-.4090042-.3486252-.2210579-.4518509-.6826477-.2298203-1.0322495.2220306-.3486271.6826477-.4508781 1.0322495-.2298222.2522202.159708.4917755.3369427.7186813.5278111.3155136.2668266.3544693.73913.0886154 1.0546474-.2674026.3149033-.7382888.3547936-1.0546493.0886174z"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g>
                  <g>
                    <g>
                      <g>
                        <g>
                          <path
                            d="m79.1461868 17.0935478c-1.2266159-.3003311-3.4110184-.1554604-5.6247864-1.9826975-.3184433-.2619572-.3632355-.7332869-.1003036-1.0527.2609863-.3194122.7342606-.3651819 1.0526962-.1003027 1.8364868 1.5130234 3.5467834 1.3348503 4.9139023 1.6593895.4070511.0662193.6836166.4508781.6174011.8589096-.0678939.4128208-.4575271.6842995-.8589096.6174011z"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g>
              <g opacity=".3">
                <g>
                  <g>
                    <g>
                      <g>
                        <g>
                          <path
                            d="m101.8306046 81.0580521.0000076 14.7303772c0 .7950134-.6443558 1.4393539-1.4393921 1.4393539s-1.4393921-.6443405-1.4393921-1.4393539v-14.7303772c0-.7950134.6443481-1.4393539 1.4393845-1.4393539.7950439-.0000001 1.4393921.6443328 1.4393921 1.4393539z"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g>
              <g opacity=".3">
                <g>
                  <g>
                    <g>
                      <g>
                        <g>
                          <path
                            d="m36.3566856 30.6138363.0000038 16.5664768c0 .8941154-.7246666 1.6187668-1.6188049 1.6187706-.8941383 0-1.6188049-.7246513-1.6188049-1.6187668l-.0000076-16.5664787c0-.8941174.7246704-1.6187687 1.6188087-1.6187687s1.6188049.7246513 1.6188049 1.6187668z"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m93.1764526 59.1110535c0 .6683846-.5453568 1.2137413-1.2137451 1.2137413h-48.925415c-.668602 0-1.2137451-.5453568-1.2137451-1.2137413 0-.6771889.5451431-1.222332 1.2137451-1.222332h48.925415c.6683884 0 1.2137451.5451431 1.2137451 1.222332z"
                    fill="#e5f5f9"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m93.1764526 65.3025436c0 .6683807-.5453568 1.2137375-1.2137451 1.2137375h-48.925415c-.668602 0-1.2137451-.5453568-1.2137451-1.2137375 0-.6771927.5451431-1.2223282 1.2137451-1.2223282h48.925415c.6683884.0000001 1.2137451.5451356 1.2137451 1.2223282z"
                    fill="#e5f5f9"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m90.1764526 71.4940338c0 .6683807-.5453568 1.2137375-1.2137451 1.2137375h-45.925415c-.668602 0-1.2137451-.5453568-1.2137451-1.2137375 0-.6771927.5451431-1.2223358 1.2137451-1.2223358h45.925415c.6683884 0 1.2137451.5451431 1.2137451 1.2223358z"
                    fill="#e5f5f9"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m88.1764526 77.685524c0 .6683807-.5453568 1.2137375-1.2137451 1.2137375h-43.925415c-.668602 0-1.2137451-.5453568-1.2137451-1.2137375 0-.6771927.5451431-1.2223358 1.2137451-1.2223358h43.925415c.6683884 0 1.2137451.5451431 1.2137451 1.2223358z"
                    fill="#e5f5f9"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m93.1764526 83.8770142c0 .6683807-.5453568 1.2137375-1.2137451 1.2137375h-48.925415c-.668602 0-1.2137451-.5453568-1.2137451-1.2137375 0-.6771927.5451431-1.2223358 1.2137451-1.2223358h48.925415c.6683884-.0000001 1.2137451.5451431 1.2137451 1.2223358z"
                    fill="#e5f5f9"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m48.8100586 60.3231125h-5.7700195c-.6699219 0-1.2199707-.539917-1.2199707-1.2099609 0-.6800537.5500488-1.2200928 1.2199707-1.2200928h5.7700195c-.6699219 0-1.2099609.5400391-1.2099609 1.2200928 0 .6700439.540039 1.2099609 1.2099609 1.2099609z"
                    fill="#d3e6ed"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m48.8100586 66.513176h-5.7700195c-.6699219 0-1.2199707-.5400391-1.2199707-1.2099609 0-.6800537.5500488-1.2200928 1.2199707-1.2200928h5.7700195c-.6699219 0-1.2099609.5400391-1.2099609 1.2200928 0 .6699218.540039 1.2099609 1.2099609 1.2099609z"
                    fill="#d3e6ed"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m48.8100586 72.7031174h-5.7700195c-.6699219 0-1.2199707-.5400391-1.2199707-1.2099609 0-.6799316.5500488-1.2199707 1.2199707-1.2199707h5.7700195c-.6699219 0-1.2099609.5400391-1.2099609 1.2199707 0 .6699218.540039 1.2099609 1.2099609 1.2099609z"
                    fill="#d3e6ed"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m48.8100586 78.9030685h-5.7700195c-.6699219 0-1.2199707-.5499268-1.2199707-1.2199707 0-.6699219.5500488-1.2199707 1.2199707-1.2199707h5.7700195c-.6699219 0-1.2099609.5500488-1.2099609 1.2199707 0 .670044.540039 1.2199707 1.2099609 1.2199707z"
                    fill="#d3e6ed"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m48.8100586 85.093132h-5.7700195c-.6699219 0-1.2199707-.5499878-1.2199707-1.2199707 0-.6700439.5500488-1.2200928 1.2199707-1.2200928h5.7700195c-.6699219 0-1.2099609.5500488-1.2099609 1.2200928 0 .6699829.540039 1.2199707 1.2099609 1.2199707z"
                    fill="#d3e6ed"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m75.9023819 46.4598732c-.6258469 1.0918999-2.0121841 1.4442673-3.0739975.8281441l-3.0343704-1.7490501v3.4980202c0 1.2456093-1.0070343 2.2526474-2.2524872 2.2526474-1.2456055 0-2.2526474-1.0070381-2.2526474-2.2526474v-3.4980202l-3.0342865 1.7490501c-1.0799026.6227264-2.451355.2516785-3.0740776-.8281441-.6308861-1.0874138-.2524605-2.450901.8215103-3.0740776l3.0343704-1.7490501-3.0343704-1.7556801c-1.0798225-.6228065-1.4442368-1.994175-.8215103-3.0740776.6227226-1.0798225 1.994175-1.4508705 3.0740776-.8281441l3.0342865 1.7490463v-3.4980164c0-1.2456131 1.0070419-2.2526474 2.2526474-2.2526474 1.2528458 0 2.2524872 1.0143967 2.2524872 2.2526474v3.4980164l3.0343704-1.7490463c1.0798264-.6227264 2.4512711-.2516785 3.0739975.8281441.6228104 1.0799026.2583923 2.4512711-.8215103 3.0740776l-3.0342865 1.7556801 3.0342865 1.7490501c1.0799026.6228065 1.4443207 1.9940948.8215103 3.0740776z"
                  fill="#fc545d"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m62.0877953 47.3738708c-1.0404739.499836-2.3184624.1065102-2.9084015-.9175606-.6201134-1.0610924-.2656021-2.4378853.8192558-3.072216l3.0395126-1.745018-3.0395126-1.761322c-1.0731735-.6226463-1.4418983-1.9908409-.8192558-3.072216.5899391-1.0240707 1.8597298-1.4091949 2.9001999-.909462-1.5874062.74506-1.7681274 3.0509567-.1638107 3.981678l3.0394096 1.761322-3.0394096 1.745018c-1.6095467.9409447-1.4233361 3.2409897.1720123 3.9897766z"
                  fill="#f14448"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m37.9837151 61.0390701v32.5821304c0 4.6061249-3.7346497 8.3486099-8.3408279 8.3486099-4.6077404 0-8.348711-3.7328949-8.348711-8.3486099v-32.5821304z"
                    fill="#e5f5f9"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m40.031414 53.3836937v6.0224915c0 .9018173-.7310638 1.632885-1.6328812 1.632885h-17.5191726c-.9018154 0-1.6328831-.7310677-1.6328831-1.632885v-6.0224915c0-.9018173.7310677-1.6328812 1.6328831-1.6328812h17.5191727c.9018173 0 1.6328811.7310639 1.6328811 1.6328812z"
                    fill="#24272b"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d="m23.0352688 53.8994789v4.9838562c0 .383358-.312336.6957397-.6957359.6957397-.3762932 0-.6886292-.3123817-.6886292-.6957397v-4.9838562c0-.3833542.312336-.6886711.6886292-.6886711.3833999 0 .6957359.3053169.6957359.6886711z"
                      fill="#13181e"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d="m26.6831989 53.8994789v4.9838562c0 .383358-.312336.6957397-.6957359.6957397-.3762932 0-.6886292-.3123817-.6886292-.6957397v-4.9838562c0-.3833542.312336-.6886711.6886292-.6886711.3834 0 .6957359.3053169.6957359.6886711z"
                      fill="#13181e"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d="m30.3311291 53.8994789v4.9838562c0 .383358-.312336.6957397-.6957359.6957397-.3762932 0-.6886292-.3123817-.6886292-.6957397v-4.9838562c0-.3833542.312336-.6886711.6886292-.6886711.3833999 0 .6957359.3053169.6957359.6886711z"
                      fill="#13181e"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d="m33.9790611 53.8994789v4.9838562c0 .383358-.312336.6957397-.6957359.6957397-.376297 0-.688633-.3123817-.688633-.6957397v-4.9838562c0-.3833542.312336-.6886711.688633-.6886711.3834 0 .6957359.3053169.6957359.6886711z"
                      fill="#13181e"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d="m37.6269913 53.8994789v4.9838562c0 .383358-.312336.6957397-.6957359.6957397-.376297 0-.688633-.3123817-.688633-.6957397v-4.9838562c0-.3833542.312336-.6886711.688633-.6886711.3833999 0 .6957359.3053169.6957359.6886711z"
                      fill="#13181e"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m24.1339054 71.4517899v22.1695709c0 3.0584946 2.4743843 5.5086975 5.5090389 5.5086975 3.0332298 0 5.5010643-2.4713058 5.5010643-5.5086975v-22.1695709z"
                  fill="#fc545d"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m30.7276268 99.0268402c-3.3733826.6887131-6.5954552-1.9075699-6.5954552-5.4027023v-22.1727829h2.1795921v22.1727829c.0000001 2.7114486 1.928011 4.9018097 4.4158631 5.4027023z"
                  fill="#f14448"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m32.291317 74.4667969c0 .4472656-.3620796.8164597-.8094387.8164597-.4542904 0-.8163719-.369194-.8163719-.8164597 0-.4472733.3620815-.8164597.8163719-.8164597.4473591 0 .8094387.3691864.8094387.8164597z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m32.9542503 93.5259476c0 .4472733-.3620796.8164597-.8094368.8164597-.4542923 0-.8163738-.3691864-.8163738-.8164597 0-.4472656.3620815-.816452.8163738-.816452.4473572-.0000001.8094368.3691863.8094368.816452z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m27.8533974 85.2784576c0 .4472733-.3620815.8164597-.8094387.8164597-.4542923 0-.8163719-.3691864-.8163719-.8164597s.3620796-.8164597.8163719-.8164597c.4473571.0000001.8094387.3691865.8094387.8164597z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m33.7671585 87.9369888c0 .4472733-.3620834.8164597-.8094406.8164597-.4542923 0-.8163719-.3691864-.8163719-.8164597s.3620796-.8164597.8163719-.8164597c.4473572.0000001.8094406.3691865.8094406.8164597z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m27.8502388 91.8345413c0 .562912-.4556942 1.0275497-1.018713 1.0275497-.5717449 0-1.0274372-.4646378-1.0274372-1.0275497 0-.5629044.4556923-1.0275421 1.0274372-1.0275421.5630188 0 1.018713.4646378 1.018713 1.0275421z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m28.2428055 78.8738098c0 .4472733-.3620815.8164597-.8094387.8164597-.4542923 0-.8163738-.3691864-.8163738-.8164597s.3620815-.8164597.8163738-.8164597c.4473572.0000001.8094387.3691865.8094387.8164597z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m32.5917244 81.5931473c0 .6125641-.4958878 1.1181793-1.1085644 1.1181793-.6221733 0-1.1180611-.5056152-1.1180611-1.1181793 0-.6125565.4958878-1.1181793 1.1180611-1.1181793.6126766 0 1.1085644.5056228 1.1085644 1.1181793z"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d="m110.9902802 52.9280739c-.1603088-.531765.1409912-1.0930023.6727448-1.253334.7574768-.2282257 1.379837-.8052826 1.6648941-1.5436325l4.7269592-12.2435684c.2996521-.7761459-.0879211-1.6512604-.8640213-1.9509048l-2.8735046-1.1094284c-.5181656-.200058-.7760849-.7824059-.5760193-1.300602s.7823944-.7761383 1.30056-.5760803l2.8735046 1.1094284c1.8108368.6991425 2.7152176 2.7411766 2.0160599 4.5521126l-4.7269592 12.2435684c-.5144043 1.3323708-1.5937195 2.3331795-2.9608917 2.7453423-.5298158.1592367-1.0921174-.1384584-1.2533265-.6729013z"
                      fill="#24272b"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m91.3494263 80.1579971-1.1204224 2.8870621c-.384491.9907608.4358902 1.7453537.3795471 1.645195.7777863.7204056 2.0369797.4298401 2.4205551-.5585403l1.1204224-2.8870621z"
                    fill="#24272b"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m96.8377075 78.8492279-.7770767 2.0127563c-.2997894.7764893-1.174408 1.1638947-1.9508438.8641205l-3.0494308-1.1773529c-.7764359-.2997742-1.1638107-1.1744156-.8640289-1.9509048l.7770844-2.0127563c.1572418.1442795.3435745.2620316.5546875.3435364l4.667984 1.8022537c.2111205.0815124.4282378.1195373.6416243.1183471z"
                    fill="#43a1ff"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m95.7974014 81.2994614c-.4033813.4723358-1.0753784.6630173-1.6876144.4266434l-3.0494308-1.1773529c-.7764359-.2997742-1.1638107-1.1744156-.8640289-1.9509048l.7770844-2.0127563c.1572418.1442795.3435745.2620316.5546875.3435364l.2580338.0996246-.4030457 1.0439453c-.2997589.7764359.0875931 1.6511383.8640213 1.9509125 3.0807112 1.1599501 3.1086577 1.2705076 3.5502928 1.2763518z"
                    fill="#2c8cff"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m107.9485016 53.2573128-9.4495544 24.4758339c-.3501358.9069061-1.3691254 1.3582611-2.2759781 1.0081406l-4.6702271-1.8031235c-.9068527-.3501282-1.3581619-1.3691483-1.0080261-2.2760544l9.4495544-24.4758339z"
                    fill="#fc545d"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m102.1703568 54.1038284c-.6477509-.2500877-1.3756027.0723114-1.6256943.7201004l-7.175705 18.5861893c-.3505096.9078751.1025696 1.9264755 1.0080261 2.276062l4.2738953 1.6501007-.1530533.396431c-.3501358.9069061-1.3691254 1.3582687-2.2759781 1.0081406l-4.6679916-1.8022537c-.9068527-.3501282-1.3581619-1.3691559-1.0080261-2.2760544l9.449852-24.4766006 7.9519958 3.0701714-1.0342789 2.6789474z"
                    fill="#f14448"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <ellipse
                    cx="113.691"
                    cy="26.739"
                    fill="#fc545d"
                    rx="3.365"
                    ry="3.364"
                    transform="matrix(.428 -.904 .904 .428 40.833 118.021)"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m117.1763229 32.650219-7.6680908 19.8615646c-.3501358.9069023-1.369133 1.3582611-2.2759857 1.0081367l-6.8025818-2.6264c-.9068527-.3501244-1.3581696-1.3691521-1.0080338-2.2760544l7.6680984-19.8615665c1.0754089-2.7854919 4.2051697-4.1718082 6.9905014-3.0964222l.0000076.0000038c2.7853319 1.0753842 4.1714937 4.2052441 3.0960847 6.990738z"
                    fill="#43a1ff"
                  />
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m109.8644714 51.5890579-.3559494.9219589c-.3504868.9078178-1.368187 1.3586273-2.2759781 1.0081406l-6.8025894-2.6264c-.9077911-.3504906-1.3585129-1.3682404-1.0080261-2.2760582l7.6675034-19.8600311c.795166-2.0596085 2.7119064-3.3520145 4.7798386-3.4512424-1.4225311 1.403204-.7790604 1.1661816-8.8911972 21.7380047-.3496017.9055214.100235 1.9255676 1.0080261 2.2760544z"
                    fill="#2c8cff"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g opacity=".3">
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d="m108.3856964 47.5581017c-.5710144-.2210312-.8544235-.8624001-.6333923-1.4334145l.5754547-1.48666c.2210312-.5710182.8623962-.8544235 1.4334106-.6333923.5710144.2210274.8544235.8624001.6333923 1.4334145l-.5754547 1.48666c-.2210235.5710143-.8623962.8544196-1.4334106.6333923z"
                      fill="#fff"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d="m110.2744827 42.6785126c-.5710144-.2210274-.8544159-.8624001-.6333923-1.4334145l3.0970078-8.000946c.2210236-.5710182.8623962-.8544235 1.4334106-.6333923.5710144.2210274.8544235.8623962.6333923 1.4334145l-3.0970001 8.000946c-.2210312.5710143-.8624039.8544235-1.4334183.6333923z"
                      fill="#fff"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const CtaQuizIcon = ({ customClass }) => (
  <svg
    enableBackground="new 0 0 512 512"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    className={customClass}
  >
    <g id="_x32_5_quiz">
      <g>
        <path
          d="m359.554 325.893v130.667c0 28.613-23.138 51.752-51.752 51.752h-234.707c-28.614 0-51.752-23.138-51.752-51.752v-327.902c0-28.56 23.138-51.752 51.752-51.752h119.447c-16.964 25.392-27.003 55.617-27.325 87.827-.483 49.174 21.044 93.464 55.187 123.581 1.772 1.557 2.899 3.704 3.006 6.119l4.402 70.703c.483 7.085 8.536 10.844 14.226 6.657l58.086-42.572c1.825-1.396 4.08-1.933 6.388-1.611 18.858 2.304 36.594 1.571 53.042-1.717z"
          fill="#cce0f1"
        />
        <path
          d="m132.358 148.965v32.306c0 6.017-4.905 10.921-10.921 10.921h-32.255c-6.017 0-10.921-4.904-10.921-10.921v-32.306c0-6.016 4.904-10.92 10.921-10.92h32.256c6.016 0 10.92 4.904 10.92 10.92z"
          fill="#d81a60"
        />
        <path
          d="m132.358 243.448v32.306c0 6.017-4.905 10.921-10.921 10.921h-32.255c-6.017 0-10.921-4.904-10.921-10.921v-32.306c0-6.016 4.904-10.92 10.921-10.92h32.256c6.016 0 10.92 4.904 10.92 10.92z"
          fill="#faa629"
        />
        <path
          d="m132.358 337.931v32.306c0 6.017-4.905 10.921-10.921 10.921h-32.255c-6.017 0-10.921-4.904-10.921-10.921v-32.306c0-6.016 4.904-10.92 10.921-10.92h32.256c6.016-.001 10.92 4.903 10.92 10.92z"
          fill="#fff"
        />
        <path
          d="m132.358 432.413v32.306c0 6.017-4.905 10.921-10.921 10.921h-32.255c-6.017 0-10.921-4.904-10.921-10.921v-32.306c0-6.016 4.904-10.92 10.921-10.92h32.256c6.016 0 10.92 4.904 10.92 10.92z"
          fill="#3eb655"
        />
        <path
          d="m359.554 325.893v16.374c-17.062 3.036-34.427 3.603-52.288 1.664l-55.67 40.854c-15.818 11.716-38.545 1.152-39.833-18.574l-4.188-67.75c-37.686-34.411-58.945-82.995-58.408-133.888.268-31.619 9.288-61.629 24.695-87.666h18.682c-16.964 25.392-27.003 55.617-27.325 87.827-.483 49.174 21.044 93.464 55.187 123.581 1.772 1.557 2.899 3.704 3.006 6.119l4.402 70.703c.483 7.085 8.536 10.844 14.226 6.657l58.086-42.572c1.825-1.396 4.08-1.933 6.388-1.611 18.856 2.303 36.592 1.57 53.04-1.718z"
          opacity=".1"
        />
        <path
          d="m490.656 166.277c0 96.42-84.137 173.975-184.116 161.334-2.335-.322-4.589.242-6.441 1.61l-58.044 42.588c-5.716 4.186-13.766.403-14.25-6.683l-4.348-70.683c-.161-2.415-1.287-4.588-3.058-6.119-34.135-30.109-55.631-74.387-55.147-123.576.806-85.095 69.396-156.664 154.41-160.851 93.629-4.67 170.994 69.878 170.994 162.38z"
          fill="#d81a60"
        />
        <path
          d="m327.904 233.119c-7.977 0-14.442-6.465-14.442-14.442v-34.446c0-13.054 8.913-24.605 21.2-27.465 13.285-3.091 22.667-14.806 22.813-28.486.165-15.856-13.639-29.872-29.538-29.896-.011 0-.028 0-.039 0-16.275 0-29.476 13.223-29.476 29.577 0 7.977-6.465 14.442-14.442 14.442s-14.442-6.465-14.442-14.442c0-31.878 25.729-58.461 58.359-58.461h.085c31.9.047 58.719 27.182 58.376 59.087-.282 26.641-18.317 49.514-44.008 56.032l-.006 34.057c.002 7.978-6.463 14.443-14.44 14.443z"
          fill="#fff"
        />
        <path
          d="m317.767 275.616c-5.835-5.714-5.547-15.317 0-20.391 5.314-5.373 15.023-5.373 20.393 0 .637.635 1.269 1.385 1.788 2.194 3.679 5.262 3.236 13.276-1.788 18.196-5.639 5.646-14.919 5.597-20.393.001z"
          fill="#fff"
        />
        <g>
          <path
            d="m201.317 339.984h-23.487c-2.967 0-5.368-2.404-5.368-5.368 0-2.965 2.401-5.368 5.368-5.368h23.487c2.967 0 5.368 2.404 5.368 5.368s-2.401 5.368-5.368 5.368z"
            fill="#fff"
          />
        </g>
        <g>
          <path
            d="m209.878 378.923h-32.048c-2.967 0-5.368-2.404-5.368-5.368s2.401-5.368 5.368-5.368h32.048c2.967 0 5.368 2.404 5.368 5.368s-2.401 5.368-5.368 5.368z"
            fill="#fff"
          />
        </g>
        <g>
          <path
            d="m302.635 434.466h-124.805c-2.967 0-5.368-2.404-5.368-5.368 0-2.965 2.401-5.368 5.368-5.368h124.805c2.967 0 5.368 2.404 5.368 5.368s-2.401 5.368-5.368 5.368z"
            fill="#fff"
          />
        </g>
        <g>
          <path
            d="m281.837 473.405h-104.007c-2.967 0-5.368-2.404-5.368-5.368s2.401-5.368 5.368-5.368h104.008c2.967 0 5.368 2.404 5.368 5.368s-2.401 5.368-5.369 5.368z"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const CtaSessionIcon = ({ customClass }) => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    width="100%"
    viewBox="0 0 918 554"
    enableBackground="new 0 0 918 554"
    xmlSpace="preserve"
    className={customClass}
  >
    <path
      fill="#E1F5FD"
      opacity="1.000000"
      stroke="none"
      d=" M227.023926,190.227005   C230.007996,186.341385 232.983963,182.449509 235.977539,178.571243   C247.207520,164.022614 258.215454,149.295227 269.731842,134.976852   C285.757782,115.051765 305.611633,100.045624 329.604492,90.934250   C340.686127,86.725975 351.952393,82.941872 363.309021,79.547791   C368.475525,78.003708 374.041565,77.522827 379.466156,77.168335   C394.669647,76.174820 409.820282,76.024139 424.948212,78.904106   C442.386749,82.223946 459.023651,87.547859 474.014496,97.125076   C481.381104,101.831383 488.845001,106.766212 495.042206,112.844231   C508.622650,126.163414 521.443359,140.258774 534.512512,154.095535   C535.859924,155.522079 536.789978,157.342804 537.511841,159.405426   C523.817322,159.871765 510.524628,159.913315 497.183228,159.568146   C497.223328,158.155945 497.312225,157.130447 497.557556,156.179123   C497.713989,156.253296 497.987213,156.040527 498.434326,156.130035   C500.797333,156.219528 502.713226,156.219528 505.080536,156.219528   C505.080536,152.194595 504.888824,148.885010 505.134247,145.608170   C505.381500,142.306763 504.142548,141.256500 500.883118,141.298157   C488.397308,141.457718 475.908173,141.352188 463.421661,141.479492   C462.146790,141.492477 460.881073,142.403992 459.418396,143.264328   C459.365631,147.537766 458.757904,151.715622 460.023071,155.216690   C460.511627,156.568634 465.250366,156.384705 468.029053,157.284195   C467.937469,158.432083 467.869598,159.196289 467.347107,159.918381   C423.778839,159.875412 380.665222,159.876633 337.551575,159.871964   C329.015503,159.871048 328.058624,160.805908 328.053223,169.258606   C328.022766,216.866043 327.992401,264.473480 327.604736,312.053284   C319.649261,307.302734 311.874054,302.838013 304.502808,297.784119   C297.148315,292.741669 292.739410,285.543640 290.245392,276.878479   C286.815552,264.961731 283.558502,252.888077 278.759521,241.500214   C273.015289,227.869232 263.885742,217.386230 247.121246,217.560822   C251.174438,204.321854 247.070679,196.085205 234.638199,192.202942   C232.138199,191.422256 229.563950,190.879471 227.023926,190.227005  z"
    />
    <path
      fill="#E1F5FE"
      opacity="1.000000"
      stroke="none"
      d=" M547.995422,404.403076   C547.670166,414.614380 547.344849,424.825714 546.664307,435.516602   C533.551575,443.804840 524.909180,454.183777 527.037781,470.124542   C528.057861,477.763916 530.592834,485.201050 532.441711,492.729767   C524.811035,492.819855 517.180359,492.980286 509.549622,492.987671   C478.010468,493.018311 446.471222,493.002655 414.500000,492.532166   C413.676910,484.759308 413.738708,477.399567 412.801453,470.169281   C410.792664,454.672821 405.083191,441.273102 390.132446,433.637939   C387.496490,432.291779 385.223572,430.234772 382.618286,428.183777   C381.971344,420.251129 381.489136,412.640686 381.018555,404.852234   C381.030182,404.674225 381.035614,404.317444 381.497223,404.252136   C405.222748,404.173187 428.486725,404.173035 451.750610,404.142456   C479.830292,404.105530 507.910004,404.042786 535.983398,404.079285   C535.977051,404.167328 535.949341,404.341705 536.056580,404.464172   C536.163818,404.586609 536.614807,404.660797 536.614807,404.660797   C536.614807,404.660797 536.972290,404.357269 537.425903,404.277466   C541.251465,404.266144 544.623413,404.334625 547.995422,404.403076  z"
    />
    <path
      fill="#7FA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M692.018188,492.935608   C687.924561,492.935608 683.830872,492.935608 679.321045,492.935608   C678.594604,475.434540 677.883850,458.312500 677.518066,440.638245   C686.878418,435.615234 692.034058,428.038086 693.812378,418.479309   C695.684387,408.416626 696.713257,398.192902 697.973694,388.022583   C698.532593,383.512573 698.755127,378.960846 699.121399,374.535492   C693.179138,373.242859 688.017334,372.120026 682.597900,370.766602   C680.511169,366.457611 678.189575,362.518402 676.986694,358.263000   C675.688232,353.669403 672.283691,349.207397 675.196655,344.217743   C677.596436,351.022339 679.713562,357.603668 681.678406,363.711853   C683.471863,362.459656 685.243835,361.222412 687.004211,360.337341   C685.769287,362.580444 684.545959,364.471405 682.771790,367.213806   C688.388428,366.394592 693.063538,365.078857 697.702576,365.195831   C703.559387,365.343506 705.927612,361.600342 709.170227,357.453857   C701.646729,356.480286 694.706116,350.932617 687.976562,357.652069   C691.260132,353.946533 692.848877,350.364960 689.561523,346.066803   C689.411926,345.871185 689.579163,345.433228 689.883545,345.371216   C690.679321,345.093781 691.728638,344.387787 691.620972,344.037506   C689.827515,338.203613 687.889282,332.414276 686.094482,326.447052   C686.412842,326.085175 686.658325,325.990051 687.251709,326.167419   C690.066406,333.424988 692.571472,340.508881 695.245972,348.072052   C697.551575,345.658478 699.782043,343.323517 702.132568,341.344116   C700.481628,344.449310 698.710693,347.198975 696.774658,350.016663   C696.568665,350.206879 696.527832,350.329010 696.487061,350.451172   C696.682861,350.328705 696.878723,350.206268 697.515808,350.134125   C702.700500,349.615906 707.432617,348.904205 712.191162,348.525787   C715.758728,348.242065 719.788696,349.405396 722.852539,348.116852   C728.247681,345.847870 733.062134,342.197876 738.464294,339.056091   C753.745483,331.108063 766.457764,321.558014 770.584656,303.598358   C772.225952,296.455872 776.176575,289.769775 779.560242,283.122498   C783.072632,276.222321 788.098999,270.547577 794.885071,266.474091   C803.051697,261.571869 811.544250,263.444000 820.061279,264.755066   C824.168762,266.221344 827.207153,268.662689 827.754272,273.979004   C825.887207,278.566956 824.570740,282.767822 822.248230,286.308868   C816.515564,295.049438 810.385803,303.533478 804.297180,312.035858   C796.023438,323.589691 793.225525,336.266327 795.751648,350.258484   C798.671509,366.431488 792.180603,377.750244 779.897949,383.842834   C774.430908,386.554749 769.165161,389.973785 764.476013,393.874817   C758.941956,398.478699 754.130859,403.951569 749.001465,409.022156   C748.996643,408.996552 749.047668,409.006989 748.772034,409.060852   C748.346619,409.806213 748.196838,410.497742 747.873596,411.472290   C745.180908,413.625671 742.488037,415.304047 740.172302,417.399323   C729.671204,426.900879 720.668457,437.689301 712.893066,449.527496   C711.969116,450.934174 710.384888,451.907074 709.107117,452.692566   C710.409729,447.851959 711.607117,443.365906 713.032593,438.953583   C718.539490,421.907745 723.438477,404.598541 733.706726,389.545776   C735.029480,387.606689 736.471741,385.749176 737.858643,383.853882   C737.529785,383.563568 737.200928,383.273254 736.872070,382.982971   C735.764648,384.017487 734.427490,384.895508 733.595215,386.117462   C731.543091,389.130310 729.250793,392.108582 727.891541,395.441864   C722.203430,409.390076 716.564758,423.369965 711.423584,437.525482   C708.154907,446.525391 705.792419,455.854492 703.010315,465.018188   C702.997070,465.000366 703.041077,465.006500 702.806396,465.140381   C702.707458,465.840057 702.843140,466.405823 702.854614,467.307312   C701.628784,469.839233 700.384460,471.976746 699.453125,474.242920   C696.904358,480.444855 694.487366,486.700958 692.018188,492.935608  M750.481140,370.836609   C750.747864,370.633820 750.936890,370.374451 751.353943,369.914429   C751.395447,369.801910 751.437012,369.689362 751.478516,369.576813   C751.297363,369.700104 751.116211,369.823364 750.499023,370.165436   C750.220337,370.361359 750.033630,370.622925 749.508606,371.168549   C749.239136,371.366760 749.054443,371.625458 748.346558,371.991577   C747.761536,372.461761 747.176453,372.931946 746.591431,373.402130   C746.959412,373.777313 747.327454,374.152527 747.695496,374.527710   C748.147095,373.698730 748.598755,372.869781 749.478088,371.820465   C749.745422,371.623535 749.934631,371.368652 750.481140,370.836609  M756.279114,364.013641   C755.261230,364.984192 754.243347,365.954712 753.225403,366.925262   C753.552917,367.191803 753.880432,367.458344 754.207886,367.724884   C755.156616,366.497833 756.105347,365.270782 757.342529,363.898987   C757.211670,363.912445 757.080811,363.925903 756.279114,364.013641  M791.997375,300.502075   C786.844177,310.302460 781.635559,320.074249 776.555176,329.912231   C772.477295,337.809021 768.649536,345.836090 764.498169,353.692963   C763.435669,355.703796 761.567993,357.289154 760.070251,359.070007   C760.390869,359.365173 760.711548,359.660339 761.032166,359.955505   C762.081116,359.068024 763.439209,358.372406 764.128601,357.261688   C768.397583,350.383575 774.087158,343.881866 776.334473,336.366852   C780.170532,323.538910 786.482727,312.326294 793.779724,301.430969   C796.391479,297.531250 799.143250,293.725342 801.831116,289.876617   C801.349121,289.514954 800.867065,289.153290 800.385071,288.791626   C797.736938,292.505280 795.088806,296.218903 791.997375,300.502075  M712.799927,350.548157   C710.489014,350.734894 708.166199,350.831604 705.870728,351.134949   C703.781677,351.411041 701.722229,351.911591 698.439819,352.547699   C710.428650,356.981812 714.375671,356.366913 718.160522,350.057037   C716.558716,350.146149 715.080750,350.228363 712.799927,350.548157  M693.938354,367.321930   C691.263123,367.850555 688.587830,368.379211 685.042419,369.079803   C698.227905,373.430511 699.468506,373.262878 701.136414,367.192352   C698.988586,367.192352 696.882263,367.192352 693.938354,367.321930  M803.283691,286.429810   C802.989075,286.649292 802.694519,286.868744 802.399963,287.088226   C802.576111,287.273956 802.752258,287.459717 802.928345,287.645416   C803.162354,287.361145 803.396301,287.076904 803.283691,286.429810  M738.880249,381.743896   C739.169312,381.470612 739.464111,381.202606 739.733215,380.910889   C739.749207,380.893555 739.559082,380.686035 739.464905,380.567017   C739.160950,380.854126 738.856995,381.141266 738.880249,381.743896  M745.470459,375.611359   C745.470459,375.611359 745.568481,375.439911 745.568481,375.439911   C745.568481,375.439911 745.373169,375.464386 745.470459,375.611359  M759.371521,361.471436   C759.371521,361.471436 759.539978,361.566711 759.539978,361.566711   C759.539978,361.566711 759.515198,361.374512 759.371521,361.471436  M741.371338,379.470367   C741.371338,379.470367 741.541992,379.566437 741.541992,379.566437   C741.541992,379.566437 741.516541,379.372253 741.371338,379.470367  M743.367065,377.470215   C743.367065,377.470215 743.540527,377.566895 743.540527,377.566895   C743.540527,377.566895 743.513977,377.370300 743.367065,377.470215  z"
    />
    <path
      fill="#DFF4FD"
      opacity="1.000000"
      stroke="none"
      d=" M820.002869,264.423859   C811.544250,263.444000 803.051697,261.571869 794.885071,266.474091   C788.098999,270.547577 783.072632,276.222321 779.560242,283.122498   C776.176575,289.769775 772.225952,296.455872 770.584656,303.598358   C766.457764,321.558014 753.745483,331.108063 738.345581,338.940430   C737.882324,338.894836 737.642578,338.665924 737.717834,338.287720   C738.695923,334.840973 737.545776,332.926941 734.395935,332.659454   C731.284241,332.395264 728.116821,332.264954 725.013855,332.535156   C719.817749,332.987579 714.653320,333.804932 708.794434,334.556030   C711.390686,330.531494 713.764343,327.155396 715.803406,323.588013   C717.238281,321.077728 719.011658,320.930054 721.616516,321.335968   C726.682129,322.125366 731.836487,322.910858 736.927307,322.765045   C740.049255,322.675690 743.307922,321.193085 746.125000,319.644531   C747.261536,319.019806 747.974426,316.455750 747.738403,314.953644   C747.602905,314.091461 745.206055,313.109833 743.779053,313.028534   C741.156006,312.879028 738.450806,313.115906 735.863525,313.620605   C730.726379,314.622620 725.646118,315.915863 719.776917,317.264679   C721.906982,311.364380 723.738708,306.290619 725.664246,300.956848   C729.088867,301.543579 732.313965,302.259583 735.578308,302.619934   C741.552490,303.279388 747.674805,303.932007 753.011902,300.429718   C754.504944,299.449890 755.038879,297.008575 756.012817,295.237671   C754.524292,294.472504 753.074890,293.173859 751.538513,293.061279   C748.930542,292.870148 746.216003,293.179108 743.638733,293.719421   C737.890381,294.924561 732.199097,296.402161 725.142944,298.089600   C727.955139,292.614288 730.184448,288.273895 732.391418,283.976868   C733.760071,284.276093 734.390686,284.501221 735.032715,284.541016   C742.585754,285.009460 750.148560,285.861023 757.690918,285.710876   C761.060120,285.643799 765.358582,283.395355 764.563354,279.305786   C763.774231,275.247742 759.502136,276.079102 756.203125,276.740570   C749.657654,278.052979 743.118408,279.396240 735.561462,280.933197   C738.601135,277.262390 740.999329,274.366333 743.733948,271.333374   C745.625366,271.036591 747.180237,270.743317 748.735352,270.741760   C753.483582,270.737000 758.231873,270.844543 763.335083,270.893066   C765.076172,269.247101 766.462280,267.616516 767.848389,265.985901   C765.829834,265.326447 763.833862,264.223816 761.786987,264.119324   C759.205750,263.987549 756.582886,264.670380 754.019775,264.663147   C755.843567,262.720337 757.625671,261.116180 759.732300,259.416779   C762.176697,257.676910 764.296509,256.032318 766.753052,254.317230   C769.475647,252.011185 772.262756,250.065720 774.142822,247.464630   C776.361389,244.395370 774.696045,241.508362 771.004272,242.176392   C767.939819,242.730942 764.281494,244.134186 762.423645,246.414200   C757.747559,252.153046 753.940430,258.599945 749.442444,264.845093   C748.339050,264.425781 746.975159,263.988556 746.913879,263.412720   C746.475586,259.293549 746.610962,255.096069 745.950012,251.023102   C745.395447,247.605850 744.010437,244.323334 742.994019,240.993530   C742.994934,241.005890 743.019775,241.007599 742.991699,240.647995   C740.487183,237.531769 738.339355,239.475204 737.601135,241.468994   C736.571045,244.250824 735.821045,247.651703 736.475586,250.428360   C737.629456,255.323776 740.047546,259.908966 741.703491,264.704407   C742.359253,266.603699 742.393188,268.717682 742.396667,270.851318   C739.309448,273.897369 736.535767,276.825928 733.621460,279.902954   C732.697693,271.570435 732.061218,264.003387 730.874268,256.523712   C730.608032,254.845810 728.416260,253.473450 727.110962,251.960434   C725.613953,253.503693 722.810120,255.089417 722.858643,256.582428   C723.020874,261.573578 722.835999,267.377869 725.279419,271.326569   C730.403870,279.607819 730.582520,286.882416 724.902283,294.534698   C724.739807,294.753571 724.489380,294.907196 724.014099,295.324982   C722.641785,290.406311 721.611084,285.537537 719.878418,280.932922   C718.803101,278.075317 716.663269,275.618286 714.999634,272.991760   C714.997925,273.002014 715.018250,272.998352 715.052307,272.610962   C711.570923,270.332764 708.744141,271.717590 709.215515,276.018158   C709.695618,280.397400 711.863220,284.591644 712.956055,289.005676   C710.914185,288.417877 709.208252,287.691376 706.886292,286.702515   C706.500244,287.376282 705.750122,288.685486 704.769043,290.160919   C704.099121,290.693542 703.660217,291.059906 703.077026,291.084290   C702.852356,289.671661 702.992615,288.517273 702.627319,287.554749   C702.284363,286.651306 701.407043,285.950684 700.776733,285.122803   C700.788696,285.084747 700.842590,285.143555 700.919189,284.794647   C701.662598,282.647247 702.474182,280.774261 699.024841,280.696259   C696.213257,275.571594 693.562439,270.762970 690.986450,265.914520   C686.374817,257.234589 685.889343,248.489105 690.690430,239.688553   C693.559265,234.429901 696.809143,229.332153 699.158020,223.849457   C701.741150,217.819763 703.487122,211.431396 705.597778,205.199295   C718.574280,205.738327 731.181030,208.248016 743.499695,212.300934   C768.432251,220.503860 790.617004,233.312073 809.286621,251.881470   C813.107666,255.682007 816.405457,260.008575 820.002869,264.423859  z"
    />
    <path
      fill="#4A7BB1"
      opacity="1.000000"
      stroke="none"
      d=" M705.385010,204.914291   C703.487122,211.431396 701.741150,217.819763 699.158020,223.849457   C696.809143,229.332153 693.559265,234.429901 690.690430,239.688553   C685.889343,248.489105 686.374817,257.234589 690.986450,265.914520   C693.562439,270.762970 696.213257,275.571594 699.061951,281.021667   C699.809875,282.811249 700.326233,283.977417 700.842590,285.143555   C700.842590,285.143555 700.788696,285.084747 700.784119,285.576508   C700.123047,293.014954 699.466492,299.961609 698.603882,307.125732   C698.231628,308.121216 698.065430,308.899261 697.639648,309.904480   C696.478271,311.714874 695.576538,313.298065 694.475952,315.079895   C693.828430,316.084625 693.379700,316.890778 692.656311,317.904633   C690.568481,320.739471 688.755249,323.366577 686.942017,325.993713   C686.658325,325.990051 686.412842,326.085175 685.753235,326.559113   C684.049316,328.534271 682.797791,330.229401 681.380310,332.101624   C681.019958,332.558472 680.934753,332.868317 680.616394,333.191345   C678.487427,336.781128 676.700684,340.387787 674.913940,343.994476   C672.283691,349.207397 675.688232,353.669403 676.986694,358.263000   C678.189575,362.518402 680.511169,366.457611 682.674988,371.132568   C684.584290,379.081238 686.158813,386.433380 687.286499,393.854736   C679.131836,393.875153 671.424011,393.826385 663.859131,393.449341   C667.495911,389.680817 667.938110,385.999451 664.922302,381.857788   C664.966980,381.674316 664.965942,381.296661 665.424072,381.221619   C669.091125,381.146606 672.299927,381.146606 675.518188,381.146606   C675.518188,376.035461 675.518188,371.714020 675.518188,367.236267   C673.354004,367.136017 671.565308,367.053162 669.687866,366.710754   C669.304504,365.984741 669.009827,365.518341 668.685669,364.645386   C668.716919,359.924408 668.777771,355.610016 668.962646,350.998627   C661.384338,350.427002 653.682068,350.152313 646.160522,349.505920   C646.620667,347.364349 647.096191,345.599670 647.143433,343.823608   C647.301270,337.884125 647.305969,331.940552 647.614441,326.104492   C649.075439,324.423523 650.934082,322.787842 651.396362,320.823578   C653.437866,312.148254 659.581665,308.300781 667.375305,305.653473   C672.042603,304.068115 676.363220,301.462097 680.839600,299.314789   C680.603516,298.810181 680.367371,298.305573 680.131226,297.800934   C672.397644,301.245544 664.664062,304.690125 656.683838,308.244598   C657.123413,296.041962 657.814819,284.469391 657.870911,272.893677   C657.916077,263.566864 660.410034,255.221100 665.627075,247.578537   C668.750366,243.003052 671.786072,238.367783 674.861145,233.759399   C673.214844,233.835739 672.113220,234.462646 671.471802,235.403351   C668.383423,239.932556 665.359802,244.508759 662.424377,249.138748   C657.654663,256.661713 655.790039,264.887634 655.859436,273.810303   C655.934387,283.444733 655.497986,293.096588 654.912476,302.718231   C654.483521,309.768005 652.397705,316.396423 647.683838,321.734894   C647.357788,319.579865 647.199219,317.763428 647.198242,315.946899   C647.182251,285.228210 647.192566,254.509491 647.169861,223.790802   C647.168396,221.808655 646.946045,219.826691 646.903564,217.617783   C646.980713,217.390930 647.275757,217.013306 647.275757,217.013306   C648.569580,216.152725 649.909058,215.353043 651.149719,214.421692   C659.074646,208.472763 666.586304,201.852005 675.007324,196.721939   C682.249817,192.309830 690.608887,192.450256 698.516296,196.102142   C702.117371,197.765213 705.026794,200.171265 705.385010,204.914291  z"
    />
    <path
      fill="#5D8FC6"
      opacity="1.000000"
      stroke="none"
      d=" M692.480347,492.989258   C694.487366,486.700958 696.904358,480.444855 699.453125,474.242920   C700.384460,471.976746 701.628784,469.839233 702.885742,466.980804   C703.041138,465.881226 703.041138,465.443848 703.041077,465.006500   C703.041077,465.006500 702.997070,465.000366 703.332520,464.883911   C705.480896,460.871948 707.293762,456.976471 709.106689,453.081024   C710.384888,451.907074 711.969116,450.934174 712.893066,449.527496   C720.668457,437.689301 729.671204,426.900879 740.172302,417.399323   C742.488037,415.304047 745.180908,413.625671 748.136841,411.254944   C748.731567,410.172028 748.889648,409.589508 749.047668,409.006989   C749.047668,409.006989 748.996643,408.996552 749.352905,409.188751   C756.260315,406.164917 762.573975,402.282104 769.404236,399.850128   C796.663696,390.144135 824.616760,388.570404 853.002930,393.929962   C859.527344,396.357605 866.213257,398.435944 872.512756,401.349884   C876.034180,402.978821 879.297363,405.626465 882.012207,408.453491   C890.534729,417.328339 888.102112,428.003021 876.385437,431.880096   C869.995544,433.994507 863.153687,435.073944 856.428101,435.752502   C849.336487,436.468018 842.140564,436.150360 834.072693,436.245148   C826.511658,435.942688 819.869812,435.621582 813.224243,435.427246   C797.625183,434.971100 781.932434,433.319458 766.655457,438.098663   C754.539246,441.889069 742.829407,446.523254 733.405823,455.986816   C725.584839,465.652863 717.979736,475.176331 710.658569,484.913300   C708.936890,487.203033 708.173523,490.213287 706.969238,492.892059   C702.293640,492.942352 697.618042,492.992645 692.480347,492.989258  z"
    />
    <path
      fill="#E0F4FE"
      opacity="1.000000"
      stroke="none"
      d=" M852.996460,393.504761   C824.616760,388.570404 796.663696,390.144135 769.404236,399.850128   C762.573975,402.282104 756.260315,406.164917 749.357788,409.214355   C754.130859,403.951569 758.941956,398.478699 764.476013,393.874817   C769.165161,389.973785 774.430908,386.554749 779.897949,383.842834   C792.180603,377.750244 798.671509,366.431488 795.751648,350.258484   C793.225525,336.266327 796.023438,323.589691 804.297180,312.035858   C810.385803,303.533478 816.515564,295.049438 822.248230,286.308868   C824.570740,282.767822 825.887207,278.566956 827.822266,274.336365   C831.866577,279.428345 836.271545,284.554932 839.539673,290.325409   C851.140991,310.809601 856.952454,332.908051 855.927002,356.507629   C855.396362,368.717743 853.996948,380.890137 852.996460,393.504761  z"
    />
    <path
      fill="#655A71"
      opacity="1.000000"
      stroke="none"
      d=" M497.231964,159.954865   C510.524628,159.913315 523.817322,159.871765 537.571960,159.729797   C557.606934,159.712799 577.179932,159.811096 596.752991,159.873672   C607.206360,159.907089 617.659912,159.878860 628.795288,160.260742   C630.330627,163.012955 631.923523,165.381165 631.929016,167.753052   C632.065430,226.541565 632.044312,285.330475 631.986267,344.119263   C631.984375,346.047821 631.303040,347.975739 630.479614,349.950317   C608.488281,350.075287 586.955811,350.153900 565.085083,349.996094   C564.133301,346.107178 561.600830,345.947449 558.543640,345.951477   C507.111633,346.019379 455.679413,345.968567 404.247467,346.057709   C399.979584,346.065094 395.719574,346.986115 391.441711,347.265472   C390.324585,347.338409 389.154083,346.593689 388.207977,345.954803   C389.661804,344.768250 390.915710,343.851410 392.618713,342.997498   C467.893799,343.069183 542.719788,343.077759 617.545776,343.087036   C625.272217,343.087982 626.160400,342.219421 626.161133,334.472473   C626.166077,281.810699 626.166016,229.148895 626.159607,176.487106   C626.158691,169.007401 625.059631,167.939697 617.378601,167.939377   C525.887085,167.935425 434.395538,167.936081 342.903992,167.939011   C335.332489,167.939255 334.033569,169.270294 334.033142,177.053772   C334.030365,228.049057 334.031525,279.044342 334.048523,330.039612   C334.049133,331.864990 334.228943,333.690338 334.074829,335.751801   C331.816467,335.716095 329.808533,335.444305 327.871765,334.697754   C327.949280,326.842285 327.955658,319.461609 327.962036,312.080902   C327.992401,264.473480 328.022766,216.866043 328.053223,169.258606   C328.058624,160.805908 329.015503,159.871048 337.551575,159.871964   C380.665222,159.876633 423.778839,159.875412 467.829346,159.918716   C478.254791,159.959076 487.743378,159.956970 497.231964,159.954865  z"
    />
    <path
      fill="#497BB2"
      opacity="1.000000"
      stroke="none"
      d=" M599.929749,492.862518   C584.510193,492.862518 569.090698,492.862518 552.872131,492.862518   C554.242554,471.487488 555.597961,450.348053 557.430298,428.705353   C566.984985,422.816772 571.101440,414.548553 572.278503,404.247742   C590.527954,404.257294 608.298584,404.313171 626.065674,404.810333   C626.208679,412.201782 627.055237,419.223450 626.354004,426.086975   C624.951172,439.817322 619.089905,452.223572 613.270325,464.550568   C610.822449,469.735718 608.225159,474.850342 605.535400,480.323456   C591.324402,470.097656 577.759644,460.336884 564.194824,450.576080   C563.762939,451.102051 563.331055,451.627991 562.899170,452.153961   C563.978699,452.903717 565.071472,453.635162 566.135742,454.406067   C577.430054,462.587341 588.650696,470.873077 600.054626,478.898438   C603.304077,481.185181 604.762817,483.167969 602.166443,486.901520   C600.992065,488.590302 600.649597,490.857666 599.929749,492.862518  z"
    />
    <path
      fill="#2D3559"
      opacity="1.000000"
      stroke="none"
      d=" M388.906921,492.915771   C377.911163,492.971558 366.915405,493.073181 355.919647,493.075378   C305.258026,493.085388 254.596390,493.067688 203.471649,492.582397   C203.330811,490.326508 203.653107,488.548157 204.243530,486.580017   C205.899811,485.875458 207.287994,485.360718 209.159424,484.925323   C227.241119,485.004700 244.839569,485.004700 262.973145,485.004700   C262.973145,480.772491 262.990540,477.314606 262.969330,473.856934   C262.931091,467.621918 259.459045,464.149200 253.054825,464.075806   C246.224167,463.997467 239.392212,464.032043 232.526260,463.634888   C232.441788,462.241211 232.391861,461.230042 232.786896,460.204681   C246.533005,459.374664 259.834167,458.558807 273.586609,457.802246   C280.993622,457.532990 287.949341,457.204468 295.377441,456.902496   C304.635712,456.816315 313.421631,456.703613 322.647278,456.699036   C332.047150,457.587372 341.007294,458.367645 350.104553,459.243500   C350.241699,459.339081 350.570007,459.402100 350.882080,459.605347   C360.810913,462.223969 368.215332,468.095093 375.138306,475.289948   C378.210083,478.717926 381.091522,481.871552 384.046814,485.355469   C385.716064,488.095764 387.311493,490.505768 388.906921,492.915771  z"
    />
    <path
      fill="#E0F4FE"
      opacity="1.000000"
      stroke="none"
      d=" M55.124454,388.213898   C54.086487,378.041870 52.067963,367.854187 52.229870,357.701294   C52.504063,340.507385 57.529423,324.440979 68.084877,310.540802   C71.666008,305.824921 75.858192,301.573029 80.429581,297.038605   C87.006721,299.666168 92.925430,302.364227 98.591278,305.369934   C95.110664,305.796692 91.869469,305.785980 88.663727,306.117828   C87.757523,306.211639 86.954987,307.306915 86.104912,307.942902   C86.737099,308.633972 87.369278,309.325012 88.001266,310.007080   C88.001083,309.998047 87.983269,310.002594 88.038651,310.391052   C93.098038,313.558044 97.555321,311.282257 102.412842,309.216125   C106.450951,310.966095 110.117432,312.770844 113.783913,314.575592   C113.582878,315.088562 113.381836,315.601562 113.180801,316.114532   C111.113571,315.930054 109.049690,315.662415 106.978386,315.578857   C103.017097,315.418976 99.016075,315.019318 95.104019,315.422516   C93.359886,315.602264 91.791260,317.484955 90.142990,318.594757   C91.766640,320.059113 93.225708,321.805756 95.074638,322.883698   C96.212791,323.547241 97.998215,323.482971 99.402771,323.234802   C103.458221,322.518219 107.548569,321.807495 111.477783,320.610535   C118.368927,318.511322 121.830597,320.539215 123.189827,328.011871   C121.364166,328.011871 119.554123,328.010468 117.744080,328.012207   C112.811783,328.016998 107.863083,327.781769 102.953094,328.115540   C99.806908,328.329376 99.393044,329.523163 100.770386,332.538879   C101.123116,332.987854 101.368347,333.199158 101.810898,333.701660   C110.369110,338.723694 117.708206,332.866547 125.532333,331.582397   C127.382271,334.747498 129.196899,337.852203 131.006805,341.297180   C130.999512,342.090912 130.996933,342.544403 130.995758,343.255127   C131.000961,343.683777 131.004745,343.855225 130.796570,344.027649   C130.584610,344.028595 130.160980,344.037781 129.995285,343.860168   C129.602417,343.447998 129.345169,343.253174 128.959946,342.916290   C128.566284,342.845520 128.270508,342.956512 127.508842,343.091125   C122.403137,343.092987 117.747162,342.847565 113.133049,343.181183   C111.685570,343.285828 110.350700,344.948090 108.964287,345.897400   C109.985085,347.270996 110.756058,349.024078 112.099060,349.908264   C113.366570,350.742798 115.275040,351.060364 116.832687,350.906799   C120.591362,350.536133 124.309799,349.757355 128.035385,349.499878   C128.022827,350.570160 128.019348,351.283783 127.964859,352.379852   C127.550903,354.258942 127.187965,355.755524 126.463593,357.251526   C124.055016,358.469696 122.007881,359.688477 119.960739,360.907257   C121.647423,362.313477 123.334099,363.719666 125.015259,365.485229   C125.008636,366.563354 125.007515,367.282135 124.880798,368.294922   C124.513023,369.391327 124.270844,370.193726 123.977142,371.375488   C123.621880,373.503967 123.318123,375.253082 122.958344,377.349854   C122.832870,377.921722 122.763412,378.145966 122.248924,378.316223   C98.934746,377.273376 76.497231,379.176544 55.124454,388.213898  z"
    />
    <path
      fill="#7EA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M54.884594,388.448669   C76.497231,379.176544 98.934746,377.273376 122.288490,378.576416   C122.841263,379.238861 122.909431,379.587189 122.821960,380.046265   C122.453468,380.356750 122.408409,380.588898 122.386200,381.264099   C122.068489,383.407043 121.895714,385.139374 121.509056,387.184387   C120.263664,394.001831 119.232147,400.506653 118.109016,407.335022   C118.011345,408.105316 118.005280,408.552063 117.837791,409.360168   C116.786072,415.821899 115.895775,421.922241 114.624039,428.187744   C112.439583,428.532715 110.637459,428.858002 108.833412,428.868958   C96.559029,428.943420 84.284233,428.951660 72.009575,428.981323   C66.113884,428.002655 60.205765,427.091370 54.329517,426.007294   C52.382812,425.648193 50.466118,424.972382 48.624249,424.223572   C35.053627,418.706360 32.813862,405.627686 43.944702,395.979187   C47.184841,393.170563 51.060429,391.095032 54.884594,388.448669  z"
    />
    <path
      fill="#497CB2"
      opacity="1.000000"
      stroke="none"
      d=" M131.356979,261.854980   C126.886879,257.418365 121.965492,253.343704 118.050385,248.462006   C111.877876,240.765564 113.296043,234.032028 121.113945,227.885849   C129.668091,221.160858 138.739456,220.108414 148.032623,225.569031   C154.745071,229.513199 160.934982,234.346634 167.845947,239.183441   C170.975372,241.861267 173.735092,244.017105 176.234924,246.440964   C182.548706,252.562927 188.745575,258.805481 195.035553,265.454651   C194.572586,272.047760 194.063385,278.185974 193.210907,284.278137   C191.247299,284.462799 189.626968,284.693451 187.963837,284.584045   C184.673218,280.111206 181.425415,275.978424 178.086670,271.518616   C173.403763,266.375610 168.811813,261.559631 164.219849,256.743683   C163.780258,257.183167 163.340668,257.622650 162.901077,258.062134   C165.142776,260.490387 167.384476,262.918640 169.737320,265.467285   C165.883621,266.193970 162.678787,266.798309 159.473938,267.402649   C159.482712,267.935638 159.491501,268.468658 159.500275,269.001648   C166.093765,267.690857 172.619888,266.683563 177.758163,272.590424   C180.576233,277.008575 183.322205,281.089264 185.774368,285.392029   C179.541077,287.800995 173.601608,289.987823 167.483582,291.842651   C165.466324,289.167542 164.006973,286.334686 161.723373,284.566010   C151.731628,276.827332 141.500961,269.397125 131.356979,261.854980  M159.875366,253.575607   C147.468094,244.943130 142.378906,242.410904 138.710007,242.968369   C146.259903,247.473969 153.882599,252.022995 162.625412,257.240479   C161.413177,255.474365 160.915314,254.749023 159.875366,253.575607  z"
    />
    <path
      fill="#497BB2"
      opacity="1.000000"
      stroke="none"
      d=" M634.973083,492.932068   C623.976013,492.965363 612.978882,492.998657 601.644226,492.658203   C606.561890,482.073425 612.267517,472.064301 616.958191,461.600189   C622.790100,448.589935 628.725891,435.490265 629.014648,420.758728   C629.036865,419.622467 630.220154,417.908783 631.273926,417.486267   C641.137024,413.531403 651.089661,409.799927 661.370911,405.966003   C663.103271,405.616272 664.481262,405.304321 665.859192,404.992371   C666.648987,418.685303 667.438782,432.378174 667.781006,446.559021   C660.902466,452.867188 653.896667,458.179230 648.186707,464.637085   C641.134766,472.612701 635.974121,481.915039 634.973083,492.932068  z"
    />
    <path
      fill="#242A39"
      opacity="1.000000"
      stroke="none"
      d=" M226.554886,190.275726   C229.563950,190.879471 232.138199,191.422256 234.638199,192.202942   C247.070679,196.085205 251.174438,204.321854 246.910919,217.840195   C246.078537,219.476135 245.487183,220.451874 244.757904,221.043823   C244.383301,218.378891 244.146606,216.097748 244.035233,215.024399   C239.747833,215.024399 235.832993,215.332748 231.984100,214.960022   C224.040771,214.190765 216.151688,212.836777 208.203308,212.153152   C202.904053,211.697388 202.120316,213.291733 203.700516,218.359756   C204.489349,220.889664 205.685684,224.316086 204.648499,226.221725   C198.922363,236.742752 200.997711,245.886230 208.139526,254.689865   C211.721313,259.105072 217.545059,259.347534 219.759567,254.342316   C223.114395,246.759674 232.300278,244.862381 241.120880,250.281082   C241.328018,250.408340 242.302795,249.286072 242.943848,249.196777   C243.031647,256.128448 243.095139,262.609955 243.043839,269.460999   C242.680145,270.965973 242.457779,272.107971 242.177963,273.235748   C240.486771,280.051910 238.674744,281.445953 231.710907,280.963776   C228.906311,280.769562 226.124207,280.250427 223.038483,279.648346   C215.177109,276.227478 207.609085,273.037445 199.838776,269.572754   C198.449234,267.017456 197.261993,264.736816 196.086639,262.068848   C195.706207,259.104980 195.313904,256.528412 195.164276,253.684113   C196.599304,252.343887 198.902725,251.148453 198.799911,250.219269   C198.222336,244.999390 197.956223,239.401367 195.704681,234.865067   C194.681427,232.803436 189.335754,232.887192 185.872345,231.724472   C185.409348,230.593384 185.024796,229.735596 184.640259,228.877808   C183.670425,223.358948 182.042770,217.845749 181.995117,212.318939   C181.969482,209.344131 184.590515,206.313156 186.145569,203.375366   C186.721664,202.286987 187.965012,201.507095 188.389923,200.390823   C190.664627,194.414886 195.230835,191.419159 201.280960,191.036209   C209.531204,190.514008 217.815918,190.535843 226.554886,190.275726  M239.163696,256.998108   C234.070068,252.762238 226.528000,254.928528 223.332886,262.039764   C226.856812,262.697845 230.223679,263.700134 233.630951,263.864349   C237.511246,264.051331 239.858032,262.035675 239.163696,256.998108  z"
    />
    <path
      fill="#3A323F"
      opacity="1.000000"
      stroke="none"
      d=" M630.938477,349.903961   C631.303040,347.975739 631.984375,346.047821 631.986267,344.119263   C632.044312,285.330475 632.065430,226.541565 631.929016,167.753052   C631.923523,165.381165 630.330627,163.012955 629.258057,160.356430   C632.849609,160.008163 636.661377,159.860916 640.470947,159.905655   C645.705261,159.967102 647.311401,161.525772 647.332520,166.789551   C647.393127,181.888748 647.352112,196.988358 647.243286,212.821075   C647.204102,213.727966 647.272705,213.901581 647.341309,214.075180   C647.341309,214.075180 647.197571,214.146942 646.874573,214.261978   C646.643188,215.532883 646.734802,216.688766 646.826416,217.844635   C646.946045,219.826691 647.168396,221.808655 647.169861,223.790802   C647.192566,254.509491 647.182251,285.228210 647.198242,315.946899   C647.199219,317.763428 647.357788,319.579865 647.620178,322.057373   C647.654663,323.811768 647.511963,324.905151 647.369263,325.998566   C647.305969,331.940552 647.301270,337.884125 647.143433,343.823608   C647.096191,345.599670 646.620667,347.364349 645.700806,349.564026   C640.681885,350.085052 636.303650,350.176331 631.679504,350.174438   C631.268616,350.022217 631.103577,349.963104 630.938477,349.903961  z"
    />
    <path
      fill="#DFF3FC"
      opacity="1.000000"
      stroke="none"
      d=" M131.007446,261.995789   C141.500961,269.397125 151.731628,276.827332 161.723373,284.566010   C164.006973,286.334686 165.466324,289.167542 167.236328,292.111084   C155.720352,299.228943 147.183273,308.624573 140.856033,320.007507   C138.751495,323.793732 137.598129,328.108673 136.006134,332.485901   C136.001389,333.195282 136.000412,333.600647 135.735367,334.192444   C134.233871,335.617126 132.996445,336.855438 131.480957,337.893860   C128.407623,334.297028 127.036018,330.662537 129.620773,326.249573   C131.815933,322.253479 134.324799,318.586792 135.388550,314.540222   C136.079483,311.911926 134.663681,308.729767 134.019012,305.548492   C132.775146,305.424652 131.704071,305.548096 130.311737,305.838989   C128.403152,312.331757 126.815849,318.657043 125.204109,325.079681   C124.490395,324.094116 123.780220,322.513550 122.574394,321.559204   C118.727745,318.514771 119.215813,315.217712 120.743729,311.060913   C122.143913,307.251617 122.621574,303.012878 122.930756,298.919922   C123.204605,295.294647 122.229538,291.105804 117.838287,291.258270   C113.445557,291.410797 115.009247,295.848480 115.010979,298.494507   C115.014236,303.462952 115.612846,308.431030 116.033714,314.387787   C112.162285,311.621063 109.234108,309.528412 106.742996,307.748108   C107.868500,301.671967 109.195107,296.048889 109.837364,290.348663   C110.128311,287.766479 109.971634,284.465271 106.000877,283.993103   C106.000153,284.001007 106.014877,283.991882 106.033936,283.652222   C102.414337,281.277039 102.056602,284.374390 102.028297,286.371765   C101.958031,291.330688 102.245361,296.313934 102.734833,301.253143   C102.969421,303.620392 103.062408,305.253784 99.991577,304.620331   C95.618340,299.625977 91.289635,294.973450 86.960922,290.320953   C99.465248,277.730255 115.325172,270.342072 131.007446,261.995789  z"
    />
    <path
      fill="#E1F5FD"
      opacity="1.000000"
      stroke="none"
      d=" M72.013870,429.357544   C84.284233,428.951660 96.559029,428.943420 108.833412,428.868958   C110.637459,428.858002 112.439583,428.532715 114.638092,428.434723   C115.033592,428.516571 115.057869,429.011017 115.036652,429.439514   C114.351303,434.911102 113.687172,439.954163 113.013763,445.460510   C113.001793,448.885681 113.073814,451.850067 112.975052,454.808746   C112.879585,457.668610 113.981842,459.210938 117.399170,459.003418   C118.866623,459.004181 119.933876,459.002716 121.447540,459.003723   C123.988762,459.026917 126.083565,459.047577 128.095276,459.428955   C127.060188,462.050262 125.663811,464.230164 125.236176,466.585938   C123.707970,475.004547 125.125572,483.724762 137.088608,482.427307   C138.653610,483.422272 140.107941,484.521729 141.598984,484.574036   C149.723862,484.858887 157.857803,484.885925 166.016144,485.399109   C166.486069,488.132812 166.928482,490.469055 167.370880,492.805328   C151.402039,492.869904 135.432419,493.022003 119.465408,492.881042   C117.607109,492.864624 115.224274,491.692139 113.994446,490.269226   C98.812103,472.703583 85.156075,454.019226 73.560989,433.874451   C72.836258,432.615356 72.522919,431.119446 72.013870,429.357544  z"
    />
    <path
      fill="#DFF4FD"
      opacity="1.000000"
      stroke="none"
      d=" M733.725342,455.922180   C742.829407,446.523254 754.539246,441.889069 766.655457,438.098663   C781.932434,433.319458 797.625183,434.971100 813.224243,435.427246   C819.869812,435.621582 826.511658,435.942688 833.616821,436.325928   C829.760132,443.417999 825.544312,450.456818 821.083130,457.336517   C818.583496,461.191223 815.677429,464.782410 812.610840,468.655212   C800.764526,457.149780 785.957764,453.769104 770.494080,453.241119   C756.949280,452.778625 744.341187,456.818726 733.146301,464.403687   C733.317383,461.315247 733.521362,458.618713 733.725342,455.922180  z"
    />
    <path
      fill="#D4A817"
      opacity="1.000000"
      stroke="none"
      d=" M626.069214,404.369080   C608.298584,404.313171 590.527954,404.257294 571.836243,404.172058   C566.591980,404.211151 562.268860,404.279633 557.945679,404.348145   C554.926697,404.306793 551.907715,404.265442 548.442078,404.313599   C544.623413,404.334625 541.251465,404.266144 537.171143,404.207153   C536.291687,404.258301 536.120544,404.299988 535.949341,404.341705   C535.949341,404.341705 535.977051,404.167328 535.980103,403.667664   C535.990295,400.168976 535.997375,397.169891 536.468933,394.098816   C544.243713,393.954224 551.553955,393.881653 559.334167,393.897644   C570.296753,394.005402 580.789612,394.063660 591.282166,394.035919   C615.426941,393.972076 639.571533,393.866364 663.716248,393.777649   C671.424011,393.826385 679.131836,393.875153 687.735657,393.940063   C693.544983,394.350006 693.748657,394.876495 692.333252,403.897308   C689.986084,404.050873 687.574707,404.208679 684.703125,404.288452   C681.462158,404.247498 678.681396,404.284546 675.900635,404.321594   C672.968933,404.280334 670.037231,404.239105 666.246094,404.212769   C663.299927,404.248413 661.213257,404.269104 658.744751,404.184021   C657.585571,404.133667 656.808167,404.189117 655.561890,404.206177   C646.098755,404.236481 637.104309,404.305176 627.772949,404.291565   C626.980408,404.262543 626.524780,404.315826 626.069214,404.369080  z"
    />
    <path
      fill="#9CBADB"
      opacity="1.000000"
      stroke="none"
      d=" M733.179260,464.795593   C744.341187,456.818726 756.949280,452.778625 770.494080,453.241119   C785.957764,453.769104 800.764526,457.149780 812.534790,469.015442   C813.081543,469.813293 813.303528,470.449188 813.649353,471.008514   C815.767151,474.433075 817.040100,477.990234 814.619873,481.742188   C812.251038,485.414459 808.416748,485.188538 804.739197,484.903503   C802.434143,484.724854 800.158447,484.166565 797.198364,483.502350   C788.624939,480.282532 780.886292,476.739441 772.784180,474.528748   C758.856323,470.728485 744.688049,467.444214 731.113220,475.787476   C731.773987,471.841431 732.476624,468.318512 733.179260,464.795593  z"
    />
    <path
      fill="#C1D5E9"
      opacity="1.000000"
      stroke="none"
      d=" M549.996826,81.127815   C555.383484,63.636074 566.587524,52.224953 583.993774,48.193768   C602.954895,43.802464 619.632690,49.180054 631.705322,64.544586   C653.358704,92.102486 637.935669,129.658356 607.582886,138.246429   C582.057556,145.468643 554.995178,128.824356 549.539856,104.107758   C547.862488,96.507812 547.437256,89.016716 549.996826,81.127815  M622.467834,124.010193   C632.097656,114.916786 636.948242,103.814751 635.980469,90.525764   C634.272400,67.069595 614.600830,50.593784 591.997986,52.344501   C575.270386,53.640141 562.918823,62.752411 556.518005,78.936104   C547.732178,101.150032 561.242737,127.590012 584.533264,133.010666   C598.246399,136.202271 610.915344,133.662140 622.467834,124.010193  z"
    />
    <path
      fill="#7EA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M389.378296,492.977905   C387.311493,490.505768 385.716064,488.095764 384.035339,484.886993   C383.370331,470.483063 382.686859,456.881073 382.265930,443.270996   C382.114044,438.359375 382.592316,433.428253 382.782990,428.506042   C385.223572,430.234772 387.496490,432.291779 390.132446,433.637939   C405.083191,441.273102 410.792664,454.672821 412.801453,470.169281   C413.738708,477.399567 413.676910,484.759308 414.031006,492.526733   C405.945923,493.008698 397.897797,493.024353 389.378296,492.977905  z"
    />
    <path
      fill="#E0F4FE"
      opacity="1.000000"
      stroke="none"
      d=" M731.155090,476.210602   C744.688049,467.444214 758.856323,470.728485 772.784180,474.528748   C780.886292,476.739441 788.624939,480.282532 796.769897,483.455750   C794.901672,489.327637 790.287781,492.981354 784.980530,492.985352   C764.236755,493.000916 743.492920,492.960114 722.438843,492.599609   C725.137329,486.909485 728.146240,481.560059 731.155090,476.210602  z"
    />
    <path
      fill="#7EA5D6"
      opacity="1.000000"
      stroke="none"
      d=" M635.440735,492.987366   C635.974121,481.915039 641.134766,472.612701 648.186707,464.637085   C653.896667,458.179230 660.902466,452.867188 667.691650,447.020386   C668.512390,451.729004 669.110229,456.455688 669.409912,461.201172   C670.065186,471.579834 670.569214,481.968079 671.172607,493.042633   C659.028320,493.042633 647.468384,493.042633 635.440735,492.987366  z"
    />
    <path
      fill="#497CB2"
      opacity="1.000000"
      stroke="none"
      d=" M532.862305,492.845459   C530.592834,485.201050 528.057861,477.763916 527.037781,470.124542   C524.909180,454.183777 533.551575,443.804840 546.658936,435.966949   C546.333374,454.787079 545.657776,473.636475 544.965088,492.961182   C540.789612,492.961182 537.036255,492.961182 532.862305,492.845459  z"
    />
    <path
      fill="#DDF2FB"
      opacity="1.000000"
      stroke="none"
      d=" M685.163330,404.366455   C687.574707,404.208679 689.986084,404.050873 692.333252,403.897308   C693.748657,394.876495 693.544983,394.350006 688.182495,393.870850   C686.158813,386.433380 684.584290,379.081238 682.932617,371.363129   C688.017334,372.120026 693.179138,373.242859 699.121399,374.535492   C698.755127,378.960846 698.532593,383.512573 697.973694,388.022583   C696.713257,398.192902 695.684387,408.416626 693.812378,418.479309   C692.034058,428.038086 686.878418,435.615234 677.538269,440.207214   C676.864319,435.298859 676.515137,430.269318 676.569458,424.914490   C679.703125,417.848267 682.433228,411.107361 685.163330,404.366455  z"
    />
    <path
      fill="#7EA5D6"
      opacity="1.000000"
      stroke="none"
      d=" M731.113220,475.787476   C728.146240,481.560059 725.137329,486.909485 721.958862,492.555267   C717.158752,492.908386 712.528320,492.965210 707.433594,492.957031   C708.173523,490.213287 708.936890,487.203033 710.658569,484.913300   C717.979736,475.176331 725.584839,465.652863 733.405823,455.986816   C733.521362,458.618713 733.317383,461.315247 733.146301,464.403687   C732.476624,468.318512 731.773987,471.841431 731.113220,475.787476  z"
    />
    <path
      fill="#83AFDD"
      opacity="1.000000"
      stroke="none"
      d=" M626.065674,404.810364   C626.524780,404.315826 626.980408,404.262543 627.742371,404.724213   C628.048767,408.331543 628.048767,411.423920 628.048767,415.371826   C638.435730,413.150757 647.256592,408.903076 656.587524,405.034790   C657.700806,404.892670 658.445923,404.785980 659.490234,404.733154   C660.198486,405.192596 660.607483,405.598236 661.016479,406.003845   C651.089661,409.799927 641.137024,413.531403 631.273926,417.486267   C630.220154,417.908783 629.036865,419.622467 629.014648,420.758728   C628.725891,435.490265 622.790100,448.589935 616.958191,461.600189   C612.267517,472.064301 606.561890,482.073425 601.182617,492.597839   C600.869080,492.936584 600.679504,492.961945 600.209839,492.924896   C600.649597,490.857666 600.992065,488.590302 602.166443,486.901520   C604.762817,483.167969 603.304077,481.185181 600.054626,478.898438   C588.650696,470.873077 577.430054,462.587341 566.135742,454.406067   C565.071472,453.635162 563.978699,452.903717 562.899170,452.153961   C563.331055,451.627991 563.762939,451.102051 564.194824,450.576080   C577.759644,460.336884 591.324402,470.097656 605.535400,480.323456   C608.225159,474.850342 610.822449,469.735718 613.270325,464.550568   C619.089905,452.223572 624.951172,439.817322 626.354004,426.086975   C627.055237,419.223450 626.208679,412.201782 626.065674,404.810364  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M194.921585,253.951859   C195.313904,256.528412 195.706207,259.104980 195.929291,262.378601   C195.503143,263.717010 195.246216,264.358368 194.989288,264.999695   C188.745575,258.805481 182.548706,252.562927 176.234924,246.440964   C173.735092,244.017105 170.975372,241.861267 168.162842,239.299545   C171.588058,236.588821 175.155853,234.117950 178.793839,231.755188   C180.404404,230.709198 182.157028,229.882004 184.242706,228.916656   C185.024796,229.735596 185.409348,230.593384 185.685516,232.029297   C180.098206,238.563065 184.490387,243.977707 186.647308,249.399979   C188.068283,252.972214 190.854477,254.815048 194.921585,253.951859  z"
    />
    <path
      fill="#E1EEE7"
      opacity="1.000000"
      stroke="none"
      d=" M557.961914,404.778534   C562.268860,404.279633 566.591980,404.211151 571.357422,404.218384   C571.101440,414.548553 566.984985,422.816772 557.587158,428.337372   C557.504089,420.718048 557.741089,412.963501 557.961914,404.778534  z"
    />
    <path
      fill="#39333D"
      opacity="1.000000"
      stroke="none"
      d=" M167.805252,492.907593   C166.928482,490.469055 166.486069,488.132812 166.417847,485.376953   C172.674896,484.974487 178.557770,484.991577 184.503998,485.438538   C184.709259,488.279327 185.798264,489.353119 188.363525,488.951355   C193.554047,488.138397 198.769958,487.487549 203.975403,486.769836   C203.653107,488.548157 203.330811,490.326508 203.009918,492.500916   C191.420746,492.934631 179.830185,492.972229 167.805252,492.907593  z"
    />
    <path
      fill="#497CB2"
      opacity="1.000000"
      stroke="none"
      d=" M684.703125,404.288452   C682.433228,411.107361 679.703125,417.848267 676.657593,424.560242   C676.201904,418.091644 676.061707,411.651947 675.911011,404.766907   C678.681396,404.284546 681.462158,404.247498 684.703125,404.288452  z"
    />
    <path
      fill="#8DB1D9"
      opacity="1.000000"
      stroke="none"
      d=" M86.572655,290.192566   C91.289635,294.973450 95.618340,299.625977 99.978775,304.633850   C100.010506,304.989197 99.987831,305.017395 99.701645,305.021912   C99.225029,305.038391 99.034592,305.050354 98.844147,305.062286   C92.925430,302.364227 87.006721,299.666168 80.770149,296.914978   C79.448563,294.689178 78.444832,292.516510 77.441101,290.343811   C80.355530,290.250580 83.269958,290.157379 86.572655,290.192566  M79.860031,293.419678   C84.866928,296.353088 89.873825,299.286499 94.880714,302.219910   C95.200424,301.754486 95.520134,301.289062 95.839844,300.823639   C92.235870,297.763184 88.795929,294.470337 84.948433,291.754913   C83.376183,290.645294 80.583031,289.170624 79.860031,293.419678  z"
    />
    <path
      fill="#497CB2"
      opacity="1.000000"
      stroke="none"
      d=" M661.370911,405.966064   C660.607483,405.598236 660.198486,405.192596 659.465210,404.638123   C659.140991,404.489288 659.126526,404.289795 659.126526,404.289795   C661.213257,404.269104 663.299927,404.248413 665.745239,404.272034   C666.199219,404.492065 666.187439,404.660278 665.963745,404.906738   C664.481262,405.304321 663.103271,405.616272 661.370911,405.966064  z"
    />
    <path
      fill="#242A39"
      opacity="1.000000"
      stroke="none"
      d=" M646.903564,217.617783   C646.734802,216.688766 646.643188,215.532883 646.825500,214.198395   C647.182251,214.762985 647.265076,215.506195 647.311890,216.631348   C647.275757,217.013306 646.980713,217.390930 646.903564,217.617783  z"
    />
    <path
      fill="#4A7BB1"
      opacity="1.000000"
      stroke="none"
      d=" M647.476074,213.969421   C647.272705,213.901581 647.204102,213.727966 647.220093,213.290848   C647.406738,213.306122 647.508789,213.584885 647.476074,213.969421  z"
    />
    <path
      fill="#7EA5D6"
      opacity="1.000000"
      stroke="none"
      d=" M244.895813,221.427612   C245.487183,220.451874 246.078537,219.476135 246.880219,218.221008   C263.885742,217.386230 273.015289,227.869232 278.759521,241.500214   C283.558502,252.888077 286.815552,264.961731 290.245392,276.878479   C292.739410,285.543640 297.148315,292.741669 304.502808,297.784119   C311.874054,302.838013 319.649261,307.302734 327.604736,312.053284   C327.955658,319.461609 327.949280,326.842285 327.530029,334.629181   C318.536469,330.307922 309.927582,325.630707 301.384521,320.836273   C295.180145,317.354309 289.062775,313.717285 282.940979,309.721802   C282.609467,307.191925 282.619019,304.932343 281.815247,303.013428   C277.403870,292.481750 272.806152,282.027863 268.223328,271.568787   C267.902527,270.836700 267.185486,270.278259 266.652740,269.639038   C269.767303,279.152496 273.863525,288.118988 277.541840,297.253723   C279.077728,301.067963 279.725128,305.239990 280.437775,309.153015   C272.408813,306.027252 264.718567,302.997803 256.888489,299.786255   C256.526398,299.376556 256.257965,299.239624 255.933441,299.150940   C255.923615,299.108551 255.840042,299.084320 255.866699,298.671936   C254.266449,287.393829 249.229950,278.016754 243.158630,269.091492   C243.095139,262.609955 243.031647,256.128448 242.944153,248.782959   C243.578705,239.088531 244.237259,230.258072 244.895813,221.427612  M251.914246,243.774277   C256.289032,251.719101 260.663818,259.663910 265.038605,267.608734   C265.494995,267.390411 265.951385,267.172058 266.407806,266.953735   C264.627960,263.360809 262.905060,259.738281 261.053864,256.182526   C258.759796,251.776093 256.426208,247.387146 253.975723,243.066650   C252.816437,241.022705 252.675262,241.102783 251.914246,243.774277  z"
    />
    <path
      fill="#4D4253"
      opacity="1.000000"
      stroke="none"
      d=" M468.052734,156.900528   C465.250366,156.384705 460.511627,156.568634 460.023071,155.216690   C458.757904,151.715622 459.365631,147.537766 459.913147,143.295898   C472.029846,142.972610 483.460358,142.906174 494.886597,143.095963   C496.257019,143.118713 498.736572,144.490967 498.766541,145.308670   C498.897156,148.871658 498.312256,152.460846 497.987213,156.040527   C497.987213,156.040527 497.713989,156.253296 497.061768,156.149933   C490.982056,156.033493 485.551605,155.905014 480.128113,156.045395   C476.098297,156.149734 472.077545,156.602798 468.052734,156.900528  M468.896759,145.268570   C468.584839,144.977005 468.272919,144.685425 467.960968,144.393829   C467.649719,144.868652 467.338440,145.343475 466.366455,146.191727   C466.263641,147.875137 466.160828,149.558533 466.058014,151.241943   C467.390991,151.183884 469.192322,151.654190 469.967682,150.966980   C472.146423,149.035889 471.080536,147.211365 468.896759,145.268570  z"
    />
    <path
      fill="#3A323F"
      opacity="1.000000"
      stroke="none"
      d=" M498.434326,156.130035   C498.312256,152.460846 498.897156,148.871658 498.766541,145.308670   C498.736572,144.490967 496.257019,143.118713 494.886597,143.095963   C483.460358,142.906174 472.029846,142.972610 460.105896,142.930145   C460.881073,142.403992 462.146790,141.492477 463.421661,141.479492   C475.908173,141.352188 488.397308,141.457718 500.883118,141.298157   C504.142548,141.256500 505.381500,142.306763 505.134247,145.608170   C504.888824,148.885010 505.080536,152.194595 505.080536,156.219528   C502.713226,156.219528 500.797333,156.219528 498.434326,156.130035  z"
    />
    <path
      fill="#3A323F"
      opacity="1.000000"
      stroke="none"
      d=" M468.029053,157.284195   C472.077545,156.602798 476.098297,156.149734 480.128113,156.045395   C485.551605,155.905014 490.982056,156.033493 496.905304,156.075775   C497.312225,157.130447 497.223328,158.155945 497.183228,159.568146   C487.743378,159.956970 478.254791,159.959076 468.283966,159.960846   C467.869598,159.196289 467.937469,158.432083 468.029053,157.284195  z"
    />
    <path
      fill="#EFBC30"
      opacity="1.000000"
      stroke="none"
      d=" M536.004456,394.170837   C535.997375,397.169891 535.990295,400.168976 535.986450,403.579620   C507.910004,404.042786 479.830292,404.105530 451.750610,404.142456   C428.486725,404.173035 405.222748,404.173187 381.173096,404.163147   C379.947113,404.195099 379.506866,404.250763 378.614197,404.241486   C375.431335,404.250061 372.700836,404.323578 369.512787,404.307007   C359.049194,404.260406 349.043121,404.303864 338.761841,404.283997   C338.303436,404.263733 338.120270,404.306763 337.479034,404.272797   C326.584320,404.271637 316.147644,404.347443 305.291168,404.305847   C301.384094,404.225403 297.896820,404.262360 294.007812,404.252014   C291.409546,404.204834 289.213043,404.204926 286.898621,403.820984   C286.269165,400.310211 285.757629,397.183533 285.666809,394.034485   C287.211853,393.952362 288.336151,393.892639 289.860779,393.885010   C292.769409,393.851288 295.277679,393.765442 297.977478,393.689575   C298.430756,393.715027 298.683411,393.674072 299.392975,393.667603   C310.439087,393.569916 321.019165,393.381226 331.686768,393.212738   C331.774292,393.232910 331.813324,393.408234 332.156433,393.622559   C334.979218,393.821381 337.458893,393.805878 340.407166,393.866577   C347.916534,393.889862 354.957275,393.836945 362.427094,393.861694   C364.871124,393.890167 366.886108,393.840973 369.370667,393.866028   C385.812103,393.896942 401.783936,393.853607 418.238953,393.879211   C445.835602,393.892975 472.949066,393.837799 500.521942,393.855713   C511.129120,393.888916 521.276917,393.849030 531.805298,393.857178   C533.458740,393.993744 534.731567,394.082275 536.004456,394.170837  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M369.970337,404.397095   C372.700836,404.323578 375.431335,404.250061 378.803223,404.431091   C379.965393,404.800507 380.486145,404.915375 381.006897,405.030273   C381.489136,412.640686 381.971344,420.251129 382.618286,428.183777   C382.592316,433.428253 382.114044,438.359375 382.265930,443.270996   C382.686859,456.881073 383.370331,470.483063 383.961487,484.556702   C381.091522,481.871552 378.210083,478.717926 375.157715,474.829987   C374.261230,460.218018 373.702118,446.328888 372.752167,432.466583   C372.109619,423.090576 370.916931,413.752289 369.970337,404.397095  z"
    />
    <path
      fill="#E1EEE7"
      opacity="1.000000"
      stroke="none"
      d=" M381.018555,404.852234   C380.486145,404.915375 379.965393,404.800507 379.255615,404.496033   C379.506866,404.250763 379.947113,404.195099 380.711487,404.228455   C381.035614,404.317444 381.030182,404.674225 381.018555,404.852234  z"
    />
    <path
      fill="#E1EEE7"
      opacity="1.000000"
      stroke="none"
      d=" M536.056580,404.464172   C536.120544,404.299988 536.291687,404.258301 536.717590,404.286926   C536.972290,404.357269 536.614807,404.660797 536.614807,404.660797   C536.614807,404.660797 536.163818,404.586609 536.056580,404.464172  z"
    />
    <path
      fill="#DDF2FB"
      opacity="1.000000"
      stroke="none"
      d=" M675.196655,344.217743   C676.700684,340.387787 678.487427,336.781128 680.583374,333.548157   C682.944885,338.262512 683.703247,343.610016 689.538452,345.038361   C689.551025,345.059784 689.598816,345.108154 689.598816,345.108154   C689.579163,345.433228 689.411926,345.871185 689.561523,346.066803   C692.848877,350.364960 691.260132,353.946533 687.982849,357.646698   C688.000427,357.998871 688.008606,357.985138 687.687866,358.087067   C687.241150,358.799347 687.115173,359.409698 686.994751,360.010559   C687.000244,360.001068 687.015808,359.985138 687.015808,359.985168   C685.243835,361.222412 683.471863,362.459656 681.678406,363.711853   C679.713562,357.603668 677.596436,351.022339 675.196655,344.217743  z"
    />
    <path
      fill="#DDF2FB"
      opacity="1.000000"
      stroke="none"
      d=" M687.251709,326.167419   C688.755249,323.366577 690.568481,320.739471 692.908691,318.165894   C696.802673,323.127838 700.293640,327.958862 703.443970,333.002625   C704.172485,334.169006 704.002014,336.106873 703.752380,337.607819   C703.552673,338.808655 702.605469,339.885162 701.992615,341.007416   C701.995300,340.997955 702.012512,340.988556 702.012512,340.988586   C699.782043,343.323517 697.551575,345.658478 695.245972,348.072052   C692.571472,340.508881 690.066406,333.424988 687.251709,326.167419  z"
    />
    <path
      fill="#DFF4FD"
      opacity="1.000000"
      stroke="none"
      d=" M738.001038,339.010498   C733.062134,342.197876 728.247681,345.847870 722.852539,348.116852   C719.788696,349.405396 715.758728,348.242065 712.191162,348.525787   C707.432617,348.904205 702.700500,349.615906 697.483337,350.099121   C697.009644,350.013794 696.939758,349.948639 696.939758,349.948639   C698.710693,347.198975 700.481628,344.449310 702.132568,341.344116   C702.012512,340.988556 701.995300,340.997955 702.363892,341.088135   C705.614258,338.049866 708.657715,337.915497 712.800964,339.197784   C720.987671,341.731476 729.488281,344.018341 737.642578,338.665924   C737.642578,338.665924 737.882324,338.894836 738.001038,339.010498  z"
    />
    <path
      fill="#DDF2FB"
      opacity="1.000000"
      stroke="none"
      d=" M687.994141,358.004242   C694.706116,350.932617 701.646729,356.480286 709.170227,357.453857   C705.927612,361.600342 703.559387,365.343506 697.702576,365.195831   C693.063538,365.078857 688.388428,366.394592 682.771790,367.213806   C684.545959,364.471405 685.769287,362.580444 687.004211,360.337311   C687.015808,359.985138 687.000244,360.001068 687.305420,359.895538   C687.743225,359.188385 687.875916,358.586761 688.008606,357.985138   C688.008606,357.985138 688.000427,357.998871 687.994141,358.004242  z"
    />
    <path
      fill="#A1C2E0"
      opacity="1.000000"
      stroke="none"
      d=" M709.107117,452.692566   C707.293762,456.976471 705.480896,460.871948 703.345825,464.901733   C705.792419,455.854492 708.154907,446.525391 711.423584,437.525482   C716.564758,423.369965 722.203430,409.390076 727.891541,395.441864   C729.250793,392.108582 731.543091,389.130310 733.595215,386.117462   C734.427490,384.895508 735.764648,384.017487 736.872070,382.982971   C737.200928,383.273254 737.529785,383.563568 737.858643,383.853882   C736.471741,385.749176 735.029480,387.606689 733.706726,389.545776   C723.438477,404.598541 718.539490,421.907745 713.032593,438.953583   C711.607117,443.365906 710.409729,447.851959 709.107117,452.692566  z"
    />
    <path
      fill="#A1C2E0"
      opacity="1.000000"
      stroke="none"
      d=" M792.218994,300.217285   C795.088806,296.218903 797.736938,292.505280 800.385071,288.791626   C800.867065,289.153290 801.349121,289.514954 801.831116,289.876617   C799.143250,293.725342 796.391479,297.531250 793.779724,301.430969   C786.482727,312.326294 780.170532,323.538910 776.334473,336.366852   C774.087158,343.881866 768.397583,350.383575 764.128601,357.261688   C763.439209,358.372406 762.081116,359.068024 761.032166,359.955505   C760.711548,359.660339 760.390869,359.365173 760.070251,359.070007   C761.567993,357.289154 763.435669,355.703796 764.498169,353.692963   C768.649536,345.836090 772.477295,337.809021 776.555176,329.912231   C781.635559,320.074249 786.844177,310.302460 792.218994,300.217285  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M689.883545,345.371216   C689.598816,345.108154 689.551025,345.059784 689.374817,344.711670   C686.647827,340.217194 684.097046,336.070862 681.546265,331.924500   C682.797791,330.229401 684.049316,328.534271 685.642029,326.727081   C687.889282,332.414276 689.827515,338.203613 691.620972,344.037506   C691.728638,344.387787 690.679321,345.093781 689.883545,345.371216  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M713.201416,350.429382   C715.080750,350.228363 716.558716,350.146149 718.160522,350.057037   C714.375671,356.366913 710.428650,356.981812 698.439819,352.547699   C701.722229,351.911591 703.781677,351.411041 705.870728,351.134949   C708.166199,350.831604 710.489014,350.734894 713.201416,350.429382  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M694.357117,367.257141   C696.882263,367.192352 698.988586,367.192352 701.136414,367.192352   C699.468506,373.262878 698.227905,373.430511 685.042419,369.079803   C688.587830,368.379211 691.263123,367.850555 694.357117,367.257141  z"
    />
    <path
      fill="#A1C2E0"
      opacity="1.000000"
      stroke="none"
      d=" M757.054138,364.043762   C756.105347,365.270782 755.156616,366.497833 754.207886,367.724884   C753.880432,367.458344 753.552917,367.191803 753.225403,366.925262   C754.243347,365.954712 755.261230,364.984192 756.639038,364.004150   C756.999023,363.994629 757.054138,364.043762 757.054138,364.043762  z"
    />
    <path
      fill="#A1C2E0"
      opacity="1.000000"
      stroke="none"
      d=" M749.050293,372.040771   C748.598755,372.869781 748.147095,373.698730 747.695496,374.527710   C747.327454,374.152527 746.959412,373.777313 746.591431,373.402130   C747.176453,372.931946 747.761536,372.461761 748.672974,371.993591   C748.999451,371.995575 749.050293,372.040741 749.050293,372.040771  z"
    />
    <path
      fill="#A1C2E0"
      opacity="1.000000"
      stroke="none"
      d=" M803.456970,286.611206   C803.396301,287.076904 803.162354,287.361145 802.928345,287.645447   C802.752258,287.459717 802.576111,287.273956 802.399963,287.088196   C802.694519,286.868744 802.989075,286.649292 803.456970,286.611206  z"
    />
    <path
      fill="#E0F4FE"
      opacity="1.000000"
      stroke="none"
      d=" M748.772034,409.060852   C748.889648,409.589508 748.731567,410.172028 748.310303,410.971863   C748.196838,410.497742 748.346619,409.806213 748.772034,409.060852  z"
    />
    <path
      fill="#A1C2E0"
      opacity="1.000000"
      stroke="none"
      d=" M738.716675,381.586121   C738.856995,381.141266 739.160950,380.854126 739.464905,380.567017   C739.559082,380.686035 739.749207,380.893555 739.733215,380.910889   C739.464111,381.202606 739.169312,381.470612 738.716675,381.586121  z"
    />
    <path
      fill="#A1C2E0"
      opacity="1.000000"
      stroke="none"
      d=" M702.806396,465.140381   C703.041138,465.443848 703.041138,465.881226 703.010010,466.645081   C702.843140,466.405823 702.707458,465.840057 702.806396,465.140381  z"
    />
    <path
      fill="#A1C2E0"
      opacity="1.000000"
      stroke="none"
      d=" M750.935120,369.946655   C751.116211,369.823364 751.297363,369.700104 751.478516,369.576843   C751.437012,369.689362 751.395447,369.801910 751.174316,369.956970   C750.994751,369.999512 750.935120,369.946655 750.935120,369.946655  z"
    />
    <path
      fill="#A1C2E0"
      opacity="1.000000"
      stroke="none"
      d=" M751.021484,370.028992   C750.936890,370.374451 750.747864,370.633820 750.237915,370.917908   C749.994690,370.999176 749.938843,370.950134 749.938843,370.950134   C750.033630,370.622925 750.220337,370.361359 750.717041,370.056030   C750.935120,369.946655 750.994751,369.999512 751.021484,370.028992  z"
    />
    <path
      fill="#A1C2E0"
      opacity="1.000000"
      stroke="none"
      d=" M745.421814,375.537872   C745.373169,375.464386 745.568481,375.439911 745.568481,375.439911   C745.568481,375.439911 745.470459,375.611359 745.421814,375.537872  z"
    />
    <path
      fill="#A1C2E0"
      opacity="1.000000"
      stroke="none"
      d=" M748.976929,371.970123   C749.054443,371.625458 749.239136,371.366760 749.723755,371.059326   C749.938843,370.950134 749.994690,370.999176 750.020264,371.027496   C749.934631,371.368652 749.745422,371.623535 749.264160,371.930603   C749.050293,372.040741 748.999451,371.995575 748.976929,371.970123  z"
    />
    <path
      fill="#DFF4FD"
      opacity="1.000000"
      stroke="none"
      d=" M697.042114,350.048798   C696.878723,350.206268 696.682861,350.328705 696.487061,350.451172   C696.527832,350.329010 696.568665,350.206879 696.774658,350.016663   C696.939758,349.948639 697.009644,350.013794 697.042114,350.048798  z"
    />
    <path
      fill="#A1C2E0"
      opacity="1.000000"
      stroke="none"
      d=" M759.443359,361.422974   C759.515198,361.374512 759.539978,361.566711 759.539978,361.566711   C759.539978,361.566711 759.371521,361.471436 759.443359,361.422974  z"
    />
    <path
      fill="#A1C2E0"
      opacity="1.000000"
      stroke="none"
      d=" M756.974487,363.966980   C757.080811,363.925903 757.211670,363.912445 757.198364,363.971375   C757.054138,364.043762 756.999023,363.994629 756.974487,363.966980  z"
    />
    <path
      fill="#A1C2E0"
      opacity="1.000000"
      stroke="none"
      d=" M741.443970,379.421326   C741.516541,379.372253 741.541992,379.566437 741.541992,379.566437   C741.541992,379.566437 741.371338,379.470367 741.443970,379.421326  z"
    />
    <path
      fill="#A1C2E0"
      opacity="1.000000"
      stroke="none"
      d=" M743.440552,377.420258   C743.513977,377.370300 743.540527,377.566895 743.540527,377.566895   C743.540527,377.566895 743.367065,377.470215 743.440552,377.420258  z"
    />
    <path
      fill="#7FA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M737.717834,338.287720   C729.488281,344.018341 720.987671,341.731476 712.800964,339.197784   C708.657715,337.915497 705.614258,338.049866 702.361206,341.097595   C702.605469,339.885162 703.552673,338.808655 703.752380,337.607819   C704.002014,336.106873 704.172485,334.169006 703.443970,333.002625   C700.293640,327.958862 696.802673,323.127838 693.183350,317.958191   C693.379700,316.890778 693.828430,316.084625 694.558105,315.459442   C697.682190,320.750610 700.525330,325.860840 703.368469,330.971069   C704.091614,330.620941 704.814758,330.270782 705.537903,329.920624   C702.991638,323.172852 700.445435,316.425049 697.899231,309.677277   C698.065430,308.899261 698.231628,308.121216 698.720215,307.475464   C702.052429,315.554871 705.062317,323.501984 708.352173,332.188202   C710.605896,325.959869 718.747192,321.986511 713.286377,314.019470   C713.940735,313.484985 714.717773,312.783752 714.585449,312.381958   C712.370667,305.656097 710.042236,298.967682 707.908936,292.106750   C708.078796,291.942627 708.424011,291.620209 708.738831,291.764648   C712.099121,299.540100 715.144592,307.171112 718.299194,315.075409   C719.775818,311.154419 721.477173,307.211334 722.676147,303.121002   C723.062134,301.804016 722.568665,299.760071 721.709656,298.635071   C719.105530,295.224884 716.125488,292.101837 713.291870,288.866913   C711.863220,284.591644 709.695618,280.397400 709.215515,276.018158   C708.744141,271.717590 711.570923,270.332764 714.645996,272.628906   C713.125793,274.319336 711.073120,275.646790 711.126892,276.882477   C711.434143,283.935242 715.695435,288.878021 720.045288,293.671509   C720.577026,293.426788 721.108765,293.182098 721.640503,292.937378   C719.427429,286.285431 717.214355,279.633453 715.001221,272.981476   C716.663269,275.618286 718.803101,278.075317 719.878418,280.932922   C721.611084,285.537537 722.641785,290.406311 724.014099,295.324982   C724.489380,294.907196 724.739807,294.753571 724.902283,294.534698   C730.582520,286.882416 730.403870,279.607819 725.279419,271.326569   C722.835999,267.377869 723.020874,261.573578 722.858643,256.582428   C722.810120,255.089417 725.613953,253.503693 727.110962,251.960434   C728.416260,253.473450 730.608032,254.845810 730.874268,256.523712   C732.061218,264.003387 732.697693,271.570435 733.621460,279.902954   C736.535767,276.825928 739.309448,273.897369 742.573120,271.032440   C743.174561,271.220795 743.286011,271.345520 743.397522,271.470276   C740.999329,274.366333 738.601135,277.262390 735.561462,280.933197   C743.118408,279.396240 749.657654,278.052979 756.203125,276.740570   C759.502136,276.079102 763.774231,275.247742 764.563354,279.305786   C765.358582,283.395355 761.060120,285.643799 757.690918,285.710876   C750.148560,285.861023 742.585754,285.009460 735.032715,284.541016   C734.390686,284.501221 733.760071,284.276093 732.391418,283.976868   C730.184448,288.273895 727.955139,292.614288 725.142944,298.089600   C732.199097,296.402161 737.890381,294.924561 743.638733,293.719421   C746.216003,293.179108 748.930542,292.870148 751.538513,293.061279   C753.074890,293.173859 754.524292,294.472504 756.012817,295.237671   C755.038879,297.008575 754.504944,299.449890 753.011902,300.429718   C747.674805,303.932007 741.552490,303.279388 735.578308,302.619934   C732.313965,302.259583 729.088867,301.543579 725.664246,300.956848   C723.738708,306.290619 721.906982,311.364380 719.776917,317.264679   C725.646118,315.915863 730.726379,314.622620 735.863525,313.620605   C738.450806,313.115906 741.156006,312.879028 743.779053,313.028534   C745.206055,313.109833 747.602905,314.091461 747.738403,314.953644   C747.974426,316.455750 747.261536,319.019806 746.125000,319.644531   C743.307922,321.193085 740.049255,322.675690 736.927307,322.765045   C731.836487,322.910858 726.682129,322.125366 721.616516,321.335968   C719.011658,320.930054 717.238281,321.077728 715.803406,323.588013   C713.764343,327.155396 711.390686,330.531494 708.794434,334.556030   C714.653320,333.804932 719.817749,332.987579 725.013855,332.535156   C728.116821,332.264954 731.284241,332.395264 734.395935,332.659454   C737.545776,332.926941 738.695923,334.840973 737.717834,338.287720  M746.874573,284.778351   C752.684448,284.641846 759.025635,286.007812 763.836731,278.618103   C754.064636,277.465942 746.487244,280.678925 738.771118,283.485474   C741.178101,283.878845 743.585022,284.272247 746.874573,284.778351  M729.298706,257.517365   C728.713501,256.305389 728.128357,255.093384 727.457214,253.703400   C722.250183,258.395569 724.100281,269.968262 731.390259,277.882019   C730.724243,270.697937 730.149414,264.497467 729.298706,257.517365  M725.760071,334.124573   C721.178345,334.821259 716.596619,335.517944 711.204468,336.337830   C723.218811,341.561584 733.030396,341.008057 736.160767,334.522705   C732.762451,334.366486 729.716431,334.226471 725.760071,334.124573  M730.776733,320.929443   C742.364624,321.176636 744.718689,320.324432 746.497986,314.040894   C738.149902,315.521149 730.396057,316.896027 722.642212,318.270905   C722.686401,318.747528 722.730652,319.224152 722.774841,319.700775   C725.144470,320.102722 727.514099,320.504669 730.776733,320.929443  M740.545044,301.005585   C749.909424,301.005615 752.225647,300.085815 753.945801,295.186554   C745.626892,294.208832 738.187073,296.602905 730.826050,300.007660   C733.760681,300.337677 736.695251,300.667694 740.545044,301.005585  z"
    />
    <path
      fill="#DDF2FB"
      opacity="1.000000"
      stroke="none"
      d=" M712.985901,313.992035   C718.747192,321.986511 710.605896,325.959869 708.352173,332.188202   C705.062317,323.501984 702.052429,315.554871 698.926270,307.258026   C699.466492,299.961609 700.123047,293.014954 700.772217,285.614563   C701.407043,285.950684 702.284363,286.651306 702.627319,287.554749   C702.992615,288.517273 702.852356,289.671661 702.989563,291.431885   C701.673767,299.355835 703.929138,305.750153 709.003479,309.004517   C709.002319,308.994781 708.982422,308.992126 708.890564,309.353760   C710.200378,311.149750 711.602112,312.584137 713.004517,314.008179   C713.005310,313.997833 712.985901,313.992035 712.985901,313.992035  z"
    />
    <path
      fill="#DDF2FB"
      opacity="1.000000"
      stroke="none"
      d=" M712.956055,289.005676   C716.125488,292.101837 719.105530,295.224884 721.709656,298.635071   C722.568665,299.760071 723.062134,301.804016 722.676147,303.121002   C721.477173,307.211334 719.775818,311.154419 718.299194,315.075409   C715.144592,307.171112 712.099121,299.540100 708.583801,291.459412   C707.075989,290.671417 706.037964,290.333038 705.000000,289.994690   C705.750122,288.685486 706.500244,287.376282 706.886292,286.702515   C709.208252,287.691376 710.914185,288.417877 712.956055,289.005676  z"
    />
    <path
      fill="#7FA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M762.980164,270.908386   C758.231873,270.844543 753.483582,270.737000 748.735352,270.741760   C747.180237,270.743317 745.625366,271.036591 743.733948,271.333374   C743.286011,271.345520 743.174561,271.220795 742.886658,270.914978   C742.393188,268.717682 742.359253,266.603699 741.703491,264.704407   C740.047546,259.908966 737.629456,255.323776 736.475586,250.428360   C735.821045,247.651703 736.571045,244.250824 737.601135,241.468994   C738.339355,239.475204 740.487183,237.531769 742.608887,240.730133   C740.838623,242.652161 738.372559,244.013702 738.189453,245.633286   C737.398438,252.631653 740.557495,258.549927 743.835815,264.313141   C744.289490,264.214508 744.743225,264.115875 745.196899,264.017273   C744.462280,256.338562 743.727661,248.659866 742.993103,240.981155   C744.010437,244.323334 745.395447,247.605850 745.950012,251.023102   C746.610962,255.096069 746.475586,259.293549 746.913879,263.412720   C746.975159,263.988556 748.339050,264.425781 749.497559,264.905334   C749.895142,264.883484 750.004883,265.004486 750.028503,265.301575   C750.689270,266.306213 751.326416,267.013763 751.641357,267.819855   C750.761475,268.123962 750.203735,268.329559 749.645935,268.535126   C749.665161,268.936523 749.684387,269.337921 749.703552,269.739319   C754.124573,269.739319 758.545532,269.739319 762.972595,270.031555   C762.979187,270.518646 762.979675,270.713531 762.980164,270.908386  z"
    />
    <path
      fill="#7FA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M749.840027,264.823242   C753.940430,258.599945 757.747559,252.153046 762.423645,246.414200   C764.281494,244.134186 767.939819,242.730942 771.004272,242.176392   C774.696045,241.508362 776.361389,244.395370 774.142822,247.464630   C772.262756,250.065720 769.475647,252.011185 766.590576,254.155823   C766.091309,254.064896 765.777344,253.731476 765.970764,253.465790   C768.646057,250.609055 771.127930,248.018036 774.203247,244.807449   C766.477173,243.592361 759.157043,250.114807 754.721313,260.754730   C756.261902,259.970245 757.509155,259.335144 758.918762,258.903442   C759.190002,259.241974 759.298889,259.377014 759.407776,259.512024   C757.625671,261.116180 755.843567,262.720337 754.034790,264.664490   C754.008057,265.004517 754.012268,264.973450 753.659302,264.894958   C752.826233,264.864288 752.346069,264.912140 751.555786,264.967316   C750.831970,264.984619 750.418457,264.994568 750.004883,265.004517   C750.004883,265.004486 749.895142,264.883484 749.840027,264.823242  z"
    />
    <path
      fill="#8DB1D9"
      opacity="1.000000"
      stroke="none"
      d=" M750.028503,265.301575   C750.418457,264.994568 750.831970,264.984619 751.685791,265.231995   C752.754822,265.317352 753.383545,265.145386 754.012268,264.973450   C754.012268,264.973450 754.008057,265.004517 753.993042,265.003143   C756.582886,264.670380 759.205750,263.987549 761.786987,264.119324   C763.833862,264.223816 765.829834,265.326447 767.848389,265.985901   C766.462280,267.616516 765.076172,269.247101 763.335083,270.893066   C762.979675,270.713531 762.979187,270.518646 763.206177,269.791016   C764.277039,268.490845 765.120300,267.723480 765.963562,266.956085   C765.756104,266.486023 765.548584,266.015961 765.341064,265.545898   C760.881897,266.271027 756.422668,266.996185 751.963501,267.721313   C751.326416,267.013763 750.689270,266.306213 750.028503,265.301575  z"
    />
    <path
      fill="#7FA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M704.769043,290.160950   C706.037964,290.333038 707.075989,290.671417 708.268982,291.315002   C708.424011,291.620209 708.078796,291.942627 707.557861,292.030579   C703.112915,293.193024 703.779846,296.263611 704.598511,298.797852   C705.733459,302.311127 707.505432,305.618622 709.004639,309.014252   C703.929138,305.750153 701.673767,299.355835 703.133789,291.773895   C703.660217,291.059906 704.099121,290.693542 704.769043,290.160950  z"
    />
    <path
      fill="#7FA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M766.253784,254.226288   C764.296509,256.032318 762.176697,257.676910 759.732300,259.416779   C759.298889,259.377014 759.190002,259.241974 759.134521,258.656006   C761.384399,256.713867 763.580872,255.222672 765.777344,253.731476   C765.777344,253.731476 766.091309,254.064896 766.253784,254.226288  z"
    />
    <path
      fill="#DDF2FB"
      opacity="1.000000"
      stroke="none"
      d=" M700.919189,284.794647   C700.326233,283.977417 699.809875,282.811249 699.256409,281.319702   C702.474182,280.774261 701.662598,282.647247 700.919189,284.794647  z"
    />
    <path
      fill="#E3AB3E"
      opacity="1.000000"
      stroke="none"
      d=" M669.776611,366.970337   C671.565308,367.053162 673.354004,367.136017 675.518188,367.236267   C675.518188,371.714020 675.518188,376.035461 675.518188,381.146606   C672.299927,381.146606 669.091125,381.146606 665.106934,381.131897   C663.896973,381.167694 663.462280,381.218170 662.690308,381.216248   C661.900574,381.197235 661.448303,381.230591 660.748413,381.210022   C660.336975,381.196899 660.173035,381.237701 659.544189,381.215607   C635.709229,381.166077 612.339233,381.179443 588.511597,381.115967   C583.377014,381.066010 578.699890,381.092896 573.792908,381.036835   C573.562988,380.953888 573.092285,380.822144 573.092529,380.373627   C573.016479,375.695251 572.940186,371.465393 573.336670,367.168396   C593.202332,367.052429 612.595276,367.003601 632.457153,366.977234   C645.209595,366.989899 657.493103,366.980103 669.776611,366.970337  M606.570801,376.947174   C621.647644,376.452728 636.832397,378.137360 651.874573,374.671295   C650.389038,373.557861 648.837524,373.074188 647.283203,373.065247   C635.959717,373.000031 624.635620,373.029541 613.311768,373.030762   C609.315125,373.031189 605.309204,372.887604 601.327759,373.135162   C600.224243,373.203766 599.193298,374.439850 598.129089,375.140289   C599.121277,375.740387 600.050171,376.642029 601.121094,376.866547   C602.557190,377.167603 604.103088,376.944855 606.570801,376.947174  M659.146301,375.011932   C662.842773,376.632019 666.578247,378.588745 669.851501,373.908356   C665.769287,371.108154 662.228882,372.057648 659.146301,375.011932  M588.231506,375.910522   C589.058167,375.292206 589.884827,374.673859 590.711487,374.055542   C590.582275,373.522186 590.453125,372.988861 590.323914,372.455505   C586.788086,372.780090 583.252319,373.104645 579.716492,373.429199   C579.714355,374.132355 579.712158,374.835480 579.710022,375.538635   C582.327026,375.759918 584.943970,375.981201 588.231506,375.910522  z"
    />
    <path
      fill="#493E4D"
      opacity="1.000000"
      stroke="none"
      d=" M573.092285,380.822144   C573.092285,380.822144 573.562988,380.953888 574.100952,381.305908   C579.415649,381.502869 584.192444,381.347809 588.969177,381.192749   C612.339233,381.179443 635.709229,381.166077 659.643799,381.342773   C660.208252,381.532837 660.654602,381.588104 660.654602,381.588104   C660.654602,381.588104 660.995972,381.263947 660.995972,381.263947   C661.448303,381.230591 661.900574,381.197235 662.868652,381.405884   C663.882080,381.778992 664.379883,381.910126 664.877625,382.041229   C667.938110,385.999451 667.495911,389.680817 663.859131,393.449310   C639.571533,393.866364 615.426941,393.972076 591.282166,394.035919   C580.789612,394.063660 570.296753,394.005402 559.364075,393.715942   C559.078430,393.242096 559.160400,393.012604 559.626160,392.730286   C570.375183,392.537506 580.667542,392.307220 590.960999,392.239044   C594.792725,392.213684 595.127136,389.753571 595.212280,386.919464   C595.302917,383.905945 593.799500,382.991699 590.877563,383.022430   C580.585144,383.130554 570.290405,383.016937 559.730896,382.711182   C559.951599,381.963379 560.411621,381.120728 560.928955,381.083832   C563.309265,380.914154 565.705627,380.969391 568.508972,380.978333   C570.311951,380.949249 571.702087,380.885681 573.092285,380.822144  M652.668579,390.065308   C654.792114,389.619446 658.094055,391.252777 657.988464,386.926697   C657.883179,382.609528 654.605652,384.040131 652.500610,384.071228   C638.763611,384.274017 625.029724,384.676880 611.294128,384.982452   C609.078064,385.031708 606.901001,384.747803 606.983582,388.133606   C607.069580,391.659698 609.523071,390.975952 611.560608,390.986511   C619.527710,391.027771 627.496704,391.096680 635.461914,390.967438   C640.904602,390.879150 646.342224,390.479431 652.668579,390.065308  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M668.838623,351.295593   C668.777771,355.610016 668.716919,359.924408 668.241638,364.675415   C658.052490,365.044617 648.272156,364.756195 638.505310,365.001892   C633.535156,365.126923 633.643555,361.820221 633.628296,358.804291   C633.612122,355.607178 633.433655,351.977478 638.537537,351.945770   C648.638855,351.883057 658.738342,351.529144 668.838623,351.295593  z"
    />
    <path
      fill="#83AFDD"
      opacity="1.000000"
      stroke="none"
      d=" M647.614380,326.104492   C647.511963,324.905151 647.654663,323.811768 647.861084,322.395874   C652.397705,316.396423 654.483521,309.768005 654.912476,302.718231   C655.497986,293.096588 655.934387,283.444733 655.859436,273.810303   C655.790039,264.887634 657.654663,256.661713 662.424377,249.138748   C665.359802,244.508759 668.383423,239.932556 671.471802,235.403351   C672.113220,234.462646 673.214844,233.835739 674.861145,233.759399   C671.786072,238.367783 668.750366,243.003052 665.627075,247.578537   C660.410034,255.221100 657.916077,263.566864 657.870911,272.893677   C657.814819,284.469391 657.123413,296.041962 656.683838,308.244598   C664.664062,304.690125 672.397644,301.245544 680.131226,297.800934   C680.367371,298.305573 680.603516,298.810181 680.839600,299.314789   C676.363220,301.462097 672.042603,304.068115 667.375305,305.653473   C659.581665,308.300781 653.437866,312.148254 651.396362,320.823578   C650.934082,322.787842 649.075439,324.423523 647.614380,326.104492  z"
    />
    <path
      fill="#D15947"
      opacity="1.000000"
      stroke="none"
      d=" M668.962646,350.998627   C658.738342,351.529144 648.638855,351.883057 638.537537,351.945770   C633.433655,351.977478 633.612122,355.607178 633.628296,358.804291   C633.643555,361.820221 633.535156,365.126923 638.505310,365.001892   C648.272156,364.756195 658.052490,365.044617 668.271240,365.081970   C669.009827,365.518341 669.304504,365.984741 669.687866,366.710754   C657.493103,366.980103 645.209595,366.989899 632.410339,366.595612   C629.476013,360.878906 630.335144,355.572571 631.925354,350.267639   C636.303650,350.176331 640.681885,350.085052 645.519958,349.935699   C653.682068,350.152313 661.384338,350.427002 668.962646,350.998627  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M697.639648,309.904480   C700.445435,316.425049 702.991638,323.172852 705.537903,329.920624   C704.814758,330.270782 704.091614,330.620941 703.368469,330.971069   C700.525330,325.860840 697.682190,320.750610 694.756958,315.260834   C695.576538,313.298065 696.478271,311.714874 697.639648,309.904480  z"
    />
    <path
      fill="#7FA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M681.380310,332.101624   C684.097046,336.070862 686.647827,340.217194 689.362183,344.690247   C683.703247,343.610016 682.944885,338.262512 680.925537,333.565063   C680.934753,332.868317 681.019958,332.558472 681.380310,332.101624  z"
    />
    <path
      fill="#5F524B"
      opacity="1.000000"
      stroke="none"
      d=" M664.922302,381.857788   C664.379883,381.910126 663.882080,381.778992 663.205994,381.458252   C663.462280,381.218170 663.896973,381.167694 664.648804,381.206940   C664.965942,381.296661 664.966980,381.674316 664.922302,381.857788  z"
    />
    <path
      fill="#FCFDFD"
      opacity="1.000000"
      stroke="none"
      d=" M285.246124,394.056824   C285.757629,397.183533 286.269165,400.310211 286.875305,404.229797   C287.476501,408.448975 287.966248,411.877899 288.492706,415.301178   C290.624023,429.160370 292.766632,443.017853 294.905090,456.875946   C287.949341,457.204468 280.993622,457.532990 273.578918,457.389893   C270.367218,435.691498 268.273560,414.351501 264.653778,393.273651   C261.745972,376.341705 256.989288,359.727264 253.031860,342.595947   C247.720657,326.252167 240.856964,311.158386 228.810898,298.614868   C227.798935,297.358124 226.913132,296.359222 226.409622,295.323669   C230.031891,296.723206 233.271881,298.159363 236.757904,299.816681   C237.356720,299.918488 237.709503,299.799103 238.062286,299.679718   C237.757263,299.405365 237.452255,299.131012 236.981781,298.544373   C236.259262,297.745026 235.702209,297.257935 234.567078,296.265411   C239.579803,296.547699 243.813049,296.786102 248.040771,296.993103   C248.035248,296.961700 247.971741,296.956360 247.950226,297.189453   C248.172424,297.624542 248.445496,297.772278 249.149963,297.928986   C251.647995,298.356262 253.744019,298.720276 255.840042,299.084320   C255.840042,299.084320 255.923615,299.108551 256.061005,299.344788   C256.423767,299.819824 256.700439,299.948944 257.028351,299.968353   C264.718567,302.997803 272.408813,306.027252 280.650330,309.362549   C281.769958,309.828766 282.338257,309.989105 282.906586,310.149414   C289.062775,313.717285 295.180145,317.354309 301.384521,320.836273   C309.927582,325.630707 318.536469,330.307922 327.458862,335.103943   C329.808533,335.444305 331.816467,335.716095 334.414734,335.636536   C340.620453,332.154877 346.235809,329.024597 352.193604,325.816040   C356.755920,323.161438 360.975708,320.585052 365.528870,317.962921   C370.914734,314.897247 376.027832,311.971130 380.969788,308.779968   C381.987610,308.122742 382.366943,306.476685 383.454437,305.228271   C388.519226,303.724640 393.170135,302.279114 397.870392,301.285034   C398.927490,308.961456 399.935211,316.186432 400.931732,323.668579   C400.932648,324.270386 400.944794,324.614990 400.917847,325.395660   C402.950714,332.927246 400.037262,337.785217 393.999054,341.285950   C393.304199,341.688782 392.775421,342.378082 392.169617,342.934570   C390.915710,343.851410 389.661804,344.768250 387.929443,346.055786   C386.242432,347.449127 385.033875,348.471771 383.557373,349.611145   C382.907227,350.138824 382.524994,350.549805 381.825012,351.095276   C377.001160,354.840271 372.495148,358.450775 367.688232,362.130981   C366.597382,362.828552 365.807434,363.456421 364.704468,364.201599   C361.846985,366.539703 359.302551,368.760468 356.548279,371.119690   C355.891907,371.481445 355.445404,371.704773 354.658844,371.934570   C352.883972,372.965118 351.449127,373.989227 349.733154,375.093018   C348.863617,375.675903 348.275269,376.179138 347.474792,376.792725   C346.984314,377.071167 346.755371,377.290771 346.264282,377.636139   C344.907867,378.405304 343.863098,379.100250 342.466064,379.890717   C336.629028,384.347351 331.040070,383.152740 325.285828,380.495758   C318.488647,377.357208 311.596527,374.423492 304.735138,371.424866   C298.970123,368.905426 293.190247,366.420105 287.177063,363.639557   C284.797607,362.203735 282.657990,361.048035 279.392334,359.284119   C281.472473,371.640503 283.359283,382.848663 285.246124,394.056824  M324.223480,343.138885   C323.723297,344.150696 323.223114,345.162506 322.722931,346.174316   C322.988739,346.322235 323.254517,346.470184 323.520325,346.618103   C324.244781,345.586212 324.969238,344.554321 326.014832,343.300293   C326.217773,343.130890 326.383942,342.930939 327.285736,342.201630   C327.992371,342.695312 329.184784,343.090393 329.308929,343.702271   C329.607574,345.174103 329.405640,346.747528 329.405640,348.279938   C329.795563,348.258179 330.185486,348.236389 330.575378,348.214600   C330.960571,345.195099 331.345734,342.175598 331.893738,337.879578   C329.371643,339.505249 327.588287,340.654755 325.316437,341.954132   C325.144806,342.236877 324.973145,342.519623 324.223480,343.138885  M258.388428,328.070801   C257.463806,323.566315 256.512512,319.074707 252.768768,315.468964   C254.969589,322.550873 257.022980,329.158356 259.076385,335.765869   C259.337860,335.687653 259.599335,335.609406 259.860809,335.531158   C259.466034,333.299500 259.071259,331.067810 258.388428,328.070801  z"
    />
    <path
      fill="#55BAEB"
      opacity="1.000000"
      stroke="none"
      d=" M392.618713,342.997467   C392.775421,342.378082 393.304199,341.688782 393.999054,341.285950   C400.037262,337.785217 402.950714,332.927246 401.382050,325.405579   C417.120239,325.138550 417.618744,324.630981 417.155579,309.454224   C421.300995,307.996796 425.182495,306.784668 429.066650,306.078613   C429.076385,313.072845 428.965729,319.563843 429.124908,326.048218   C429.272797,332.072754 432.219269,335.684174 437.369965,335.833893   C443.005920,335.997772 448.657074,335.638000 454.730377,335.593079   C458.728241,335.618378 462.297333,335.557037 466.278503,335.614685   C467.260986,335.717712 467.831390,335.701752 468.775635,335.710388   C470.396393,335.710236 471.643341,335.685516 473.273438,335.707825   C474.158569,335.653564 474.660614,335.552277 475.608093,335.552032   C485.600677,335.605957 495.147766,335.558838 505.168457,335.630005   C511.180695,335.684052 516.719360,335.619781 522.498413,335.620331   C523.074219,335.705597 523.404907,335.675140 524.213135,335.700195   C529.888123,335.749603 535.080750,335.692596 540.721130,335.674957   C546.735413,335.636444 552.301941,335.558563 558.256592,335.599091   C559.182434,335.710052 559.720276,335.702606 560.687256,335.712189   C563.423828,335.709198 565.731201,335.689209 568.427612,335.719330   C569.589478,335.669006 570.362305,335.568573 571.583984,335.562073   C581.033691,335.447937 590.034485,335.239929 599.496887,335.062531   C603.274292,335.096649 606.697388,335.604645 609.869202,334.930603   C612.073059,334.462311 613.931458,332.368713 615.991150,330.759216   C616.038147,330.517181 616.052002,330.024261 616.076050,329.625854   C616.121948,328.166809 616.143799,327.106171 616.411133,325.710510   C616.739136,304.499115 616.827759,283.622833 616.873474,262.746460   C616.874756,262.146118 616.419800,261.544769 616.159912,260.700745   C616.142151,260.457611 616.109131,259.971100 616.124023,259.619629   C616.129761,258.564728 616.120544,257.861298 616.198975,256.804138   C616.276001,255.967102 616.265320,255.483871 616.476685,254.655380   C616.770691,231.036057 616.914551,207.761780 616.856689,184.488022   C616.844421,179.549301 613.623291,176.941666 608.356750,176.939545   C580.251770,176.928177 552.146729,176.950928 523.696655,176.908463   C522.889221,176.892685 522.426880,176.930313 521.498291,176.949615   C493.667450,176.931580 466.302765,176.929718 438.938110,176.934937   C435.605469,176.935577 432.127014,176.675110 430.564423,181.183502   C429.893005,188.557816 429.178009,195.629044 429.151398,202.702866   C429.085419,220.243195 429.333923,237.784698 429.414001,255.555450   C429.319275,256.100281 429.353546,256.405640 429.364807,257.176392   C429.464813,264.740570 429.674713,271.829559 429.621063,279.135925   C424.896545,281.749603 420.435547,284.145935 415.035522,287.046661   C416.546967,279.753418 422.441589,275.867065 421.580994,268.735962   C419.712982,270.063568 418.415771,270.985474 417.097015,271.445099   C417.061554,242.519577 417.060974,214.056366 417.024109,185.593185   C417.015259,178.763107 415.204742,176.940598 408.522919,176.934708   C389.880219,176.918274 371.237549,176.923553 352.594849,176.942795   C345.373749,176.950241 343.922394,178.435669 343.921234,185.775177   C343.914551,228.553513 343.917297,271.331848 343.918823,314.110168   C343.919128,322.863281 343.923004,322.863281 351.851135,325.894287   C346.235809,329.024597 340.620453,332.154877 334.665161,335.400421   C334.228943,333.690338 334.049133,331.864990 334.048523,330.039612   C334.031525,279.044342 334.030365,228.049057 334.033142,177.053772   C334.033569,169.270294 335.332489,167.939255 342.903992,167.939011   C434.395538,167.936081 525.887085,167.935425 617.378601,167.939377   C625.059631,167.939697 626.158691,169.007401 626.159607,176.487106   C626.166016,229.148895 626.166077,281.810699 626.161133,334.472473   C626.160400,342.219421 625.272217,343.087982 617.545776,343.087036   C542.719788,343.077759 467.893799,343.069183 392.618713,342.997467  z"
    />
    <path
      fill="#665970"
      opacity="1.000000"
      stroke="none"
      d=" M383.825317,349.494415   C385.033875,348.471771 386.242432,347.449127 387.729553,346.325500   C389.154083,346.593689 390.324585,347.338409 391.441711,347.265472   C395.719574,346.986115 399.979584,346.065094 404.247467,346.057709   C455.679413,345.968567 507.111633,346.019379 558.543640,345.951477   C561.600830,345.947449 564.133301,346.107178 564.922668,350.194519   C564.825745,350.832092 564.553040,351.034821 563.798279,351.178650   C548.521057,351.078613 533.725952,351.037506 518.607910,351.056824   C517.854797,351.035553 517.424561,350.953766 516.951355,350.588196   C516.584839,350.009003 516.261292,349.713654 515.937805,349.418274   C515.626465,349.916626 515.315186,350.415009 514.536682,350.956482   C502.416565,350.998291 490.763641,350.996979 478.667694,351.044952   C452.343384,351.073273 426.462036,351.063782 400.580811,351.000336   C399.156799,350.996857 397.733856,350.545319 396.158142,349.990723   C395.745209,349.304443 395.502350,348.913574 395.197052,348.579773   C395.166016,348.545837 394.759491,348.855286 394.527252,349.005371   C395.084534,349.449829 395.641815,349.894226 395.813965,350.642883   C391.619019,350.952667 387.809265,350.958221 383.965454,350.595306   C383.896027,349.982697 383.860687,349.738556 383.825317,349.494415  z"
    />
    <path
      fill="#F56B59"
      opacity="1.000000"
      stroke="none"
      d=" M564.280396,351.237579   C564.553040,351.034821 564.825745,350.832092 565.260864,350.430939   C586.955811,350.153900 608.488281,350.075287 630.479614,349.950317   C631.103577,349.963104 631.268616,350.022217 631.679504,350.174469   C630.335144,355.572571 629.476013,360.878906 631.941406,366.573181   C612.595276,367.003601 593.202332,367.052429 572.905151,367.152924   C570.005615,367.277649 568.010437,367.350647 565.640625,367.303894   C560.845398,362.919586 560.580688,358.636810 564.280396,351.237579  M593.500000,353.995544   C585.897461,353.995544 578.294922,353.995544 570.837280,353.995544   C569.315674,360.875366 570.146301,362.920715 574.471252,362.947998   C588.600098,363.037170 602.730286,362.911377 616.859009,363.011169   C620.722900,363.038483 620.971069,360.834229 621.082214,357.846222   C621.200378,354.669189 619.850464,353.883545 616.940002,353.939972   C609.462463,354.085022 601.980286,353.991882 593.500000,353.995544  z"
    />
    <path
      fill="#665970"
      opacity="1.000000"
      stroke="none"
      d=" M184.440659,485.008698   C178.557770,484.991577 172.674896,484.974487 166.390320,484.979523   C157.857803,484.885925 149.723862,484.858887 141.598984,484.574036   C140.107941,484.521729 138.653610,483.422272 137.105530,481.998718   C137.308151,479.236023 137.591309,477.281311 137.866333,475.325439   C138.965515,467.508728 142.841660,464.108795 150.723679,464.059174   C154.204407,464.037262 157.685196,464.025330 161.619247,464.027466   C167.929306,464.006104 173.786087,463.966095 180.052795,464.064575   C197.828766,464.141144 215.194794,464.079224 232.560822,464.017334   C239.392212,464.032043 246.224167,463.997467 253.054825,464.075806   C259.459045,464.149200 262.931091,467.621918 262.969330,473.856934   C262.990540,477.314606 262.973145,480.772491 262.973145,485.004700   C244.839569,485.004700 227.241119,485.004700 208.850952,484.702789   C200.186356,484.603485 192.313507,484.806091 184.440659,485.008698  z"
    />
    <path
      fill="#7FA6D5"
      opacity="1.000000"
      stroke="none"
      d=" M369.512787,404.307037   C370.916931,413.752289 372.109619,423.090576 372.752167,432.466583   C373.702118,446.328888 374.261230,460.218018 374.967346,474.555664   C368.215332,468.095093 360.810913,462.223969 351.209351,459.351379   C351.395935,458.126984 351.860443,457.289490 351.695801,456.602936   C347.516357,439.174774 343.270935,421.762421 339.037079,404.347321   C349.043121,404.303864 359.049194,404.260406 369.512787,404.307037  z"
    />
    <path
      fill="#7EA5D6"
      opacity="1.000000"
      stroke="none"
      d=" M305.710999,404.423248   C316.147644,404.347443 326.584320,404.271637 337.495392,404.667267   C338.958618,409.884979 339.947388,414.631256 341.027924,419.817963   C334.741608,418.486969 329.209412,417.315643 323.677216,416.144318   C323.540497,416.563782 323.403748,416.983276 323.267029,417.402740   C324.494537,417.933258 325.676514,418.662842 326.958313,418.956177   C330.504883,419.767792 334.204956,420.068237 337.620514,421.229248   C339.504639,421.869690 341.990631,423.572754 342.405670,425.243713   C345.196014,436.478119 347.503479,447.832458 349.967438,459.147919   C341.007294,458.367645 332.047150,457.587372 322.589966,456.304260   C321.270142,445.611053 317.985504,436.206207 313.000000,426.903381   C310.562653,419.118652 308.136841,411.770966 305.710999,404.423248  z"
    />
    <path
      fill="#66AAD1"
      opacity="1.000000"
      stroke="none"
      d=" M253.053040,342.971954   C256.989288,359.727264 261.745972,376.341705 264.653778,393.273651   C268.273560,414.351501 270.367218,435.691498 273.127625,457.330627   C259.834167,458.558807 246.533005,459.374664 232.675385,459.772034   C231.112656,453.217560 230.106400,447.081543 229.117844,440.574280   C229.023056,439.469818 228.910583,438.736603 228.840576,437.658234   C228.578613,436.208466 228.274185,435.103882 227.999634,433.654724   C227.947861,432.858582 227.866226,432.407013 227.780746,431.675171   C227.562912,431.096863 227.348907,430.798767 227.193314,430.249390   C227.174057,429.665070 227.096390,429.332001 227.055283,428.663757   C227.038437,427.656921 226.985031,426.985352 227.340942,426.235474   C232.840271,425.060486 231.297318,429.504547 232.154037,431.782043   C242.757843,431.782043 253.104996,431.782043 263.827911,431.782043   C263.827911,419.179657 263.845459,406.937103 263.783386,394.694916   C263.779755,393.976135 263.133453,393.260590 262.662781,392.407837   C262.095520,392.345306 261.651642,392.418488 260.797729,392.581970   C259.280243,392.594482 258.172791,392.516632 257.049255,392.096924   C257.039978,390.836731 257.046814,389.918365 257.445557,388.998352   C261.247040,387.964661 262.542786,385.070923 260.949402,382.071960   C260.361664,380.965790 259.471283,379.894989 259.289948,378.719940   C258.497620,373.586456 260.884430,367.692108 255.519928,363.672211   C255.214890,363.443573 255.007996,362.622894 255.176636,362.293213   C257.318695,358.105804 254.676865,354.704834 253.612045,350.961853   C252.897156,348.448914 253.203568,345.645447 253.053040,342.971954  z"
    />
    <path
      fill="#4A7BB1"
      opacity="1.000000"
      stroke="none"
      d=" M313.011566,427.340363   C317.985504,436.206207 321.270142,445.611053 322.150238,456.196167   C313.421631,456.703613 304.635712,456.816315 295.377441,456.902496   C292.766632,443.017853 290.624023,429.160370 288.492706,415.301178   C287.966248,411.877899 287.476501,408.448975 286.993225,404.613831   C289.213043,404.204926 291.409546,404.204834 294.151978,404.576294   C300.802460,412.412018 306.907013,419.876190 313.011566,427.340363  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M229.100159,440.945526   C230.106400,447.081543 231.112656,453.217560 232.230423,459.786224   C232.391861,461.230042 232.441788,462.241211 232.526260,463.634857   C215.194794,464.079224 197.828766,464.141144 179.971283,463.645660   C178.349945,458.136749 177.220062,453.185272 176.040192,448.014709   C169.817825,449.680420 164.230850,451.176025 158.254089,452.672241   C156.576767,452.800110 155.289230,452.927338 154.045319,452.677368   C156.167557,451.293671 158.148926,449.888000 160.342560,449.353424   C167.746735,447.549103 175.210846,445.976746 182.686310,444.487701   C184.949005,444.036957 187.322891,444.144409 189.871338,443.981812   C189.639145,442.618286 189.400055,441.214233 189.081833,439.345459   C192.410049,438.873291 195.464569,438.277466 198.543854,438.091461   C199.617218,438.026642 201.547501,438.812134 201.685959,439.493774   C201.942566,440.757019 201.540146,443.127136 200.755493,443.452454   C198.045273,444.576172 195.052124,445.017487 191.353806,445.916168   C190.858078,450.530029 186.142883,447.899780 182.644730,448.244751   C182.149170,449.728271 181.735001,451.137878 181.211258,452.505463   C179.325729,457.428894 182.391418,461.805573 187.493317,461.666962   C198.114120,461.378357 208.737549,461.149200 219.361404,461.021912   C227.995514,460.918457 227.885468,460.997925 228.050140,452.568665   C228.125931,448.688934 228.733643,444.819580 229.100159,440.945526  z"
    />
    <path
      fill="#9CBADB"
      opacity="1.000000"
      stroke="none"
      d=" M350.104553,459.243500   C347.503479,447.832458 345.196014,436.478119 342.405670,425.243713   C341.990631,423.572754 339.504639,421.869690 337.620514,421.229248   C334.204956,420.068237 330.504883,419.767792 326.958313,418.956177   C325.676514,418.662842 324.494537,417.933258 323.267029,417.402740   C323.403748,416.983276 323.540497,416.563782 323.677216,416.144318   C329.209412,417.315643 334.741608,418.486969 341.027924,419.817963   C339.947388,414.631256 338.958618,409.884979 337.953461,404.744232   C338.120270,404.306763 338.303436,404.263733 338.761841,404.283997   C343.270935,421.762421 347.516357,439.174774 351.695801,456.602936   C351.860443,457.289490 351.395935,458.126984 350.897278,459.148132   C350.570007,459.402100 350.241699,459.339081 350.104553,459.243500  z"
    />
    <path
      fill="#E1EEE7"
      opacity="1.000000"
      stroke="none"
      d=" M184.503998,485.438538   C192.313507,484.806091 200.186356,484.603485 208.367691,484.623413   C207.287994,485.360718 205.899811,485.875458 204.243515,486.580017   C198.769958,487.487549 193.554047,488.138397 188.363525,488.951355   C185.798264,489.353119 184.709259,488.279327 184.503998,485.438538  z"
    />
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d=" M229.117859,440.574280   C228.733643,444.819580 228.125931,448.688934 228.050140,452.568665   C227.885468,460.997925 227.995514,460.918457 219.361404,461.021912   C208.737549,461.149200 198.114120,461.378357 187.493317,461.666962   C182.391418,461.805573 179.325729,457.428894 181.211258,452.505463   C181.735001,451.137878 182.149170,449.728271 182.644730,448.244751   C186.142883,447.899780 190.858078,450.530029 191.353806,445.916168   C195.052124,445.017487 198.045273,444.576172 200.755493,443.452454   C201.540146,443.127136 201.942566,440.757019 201.685959,439.493774   C201.547501,438.812134 199.617218,438.026642 198.543854,438.091461   C195.464569,438.277466 192.410049,438.873291 189.081833,439.345459   C189.400055,441.214233 189.639145,442.618286 189.871338,443.981812   C187.322891,444.144409 184.949005,444.036957 182.686310,444.487701   C175.210846,445.976746 167.746735,447.549103 160.342560,449.353424   C158.148926,449.888000 156.167557,451.293671 153.825150,452.800934   C153.243088,453.260651 152.924789,453.219666 152.192169,453.114044   C150.179016,452.862091 148.577133,452.493500 146.981903,452.520386   C141.491547,452.612946 135.971725,452.544586 130.525299,453.122833   C126.632599,453.536133 121.874908,453.352875 121.001122,459.001221   C119.933876,459.002716 118.866623,459.004181 117.355820,458.617920   C116.274498,455.084503 115.748924,451.909790 114.946838,448.806549   C114.599045,447.460938 113.681686,446.262512 113.023041,444.997253   C113.687172,439.954163 114.351303,434.911102 115.385559,429.395325   C117.628891,427.035492 120.837769,425.314148 121.096886,423.226654   C121.634254,418.897308 120.658577,414.367126 120.128052,409.940735   C120.080902,409.547333 118.739517,409.309082 117.999222,408.998779   C118.005280,408.552063 118.011345,408.105316 118.500977,407.329041   C119.979897,406.236450 121.748360,405.559052 121.843994,404.696259   C122.426636,399.439423 122.674995,394.142334 122.898346,388.852905   C122.925484,388.210236 122.134666,387.532959 121.722931,386.871735   C121.895714,385.139374 122.068489,383.407043 122.499725,381.136200   C122.888771,380.396088 122.961914,380.175354 122.977600,379.935516   C122.909431,379.587189 122.841263,379.238861 122.733521,378.630371   C122.763412,378.145966 122.832870,377.921722 123.309845,377.313477   C125.159340,376.091095 126.601318,375.252747 128.954605,373.884613   C126.661255,372.539856 125.344963,371.768005 124.028664,370.996155   C124.270844,370.193726 124.513023,369.391327 125.224678,368.241974   C131.148376,364.991241 129.628479,359.316162 130.714264,354.735901   C130.871307,354.073486 128.966522,352.922363 128.015869,351.997375   C128.019348,351.283783 128.022827,350.570160 128.230820,349.426880   C128.435333,348.997223 128.848419,348.938934 129.233002,348.899658   C130.081238,347.249115 130.544891,345.637909 131.008545,344.026672   C131.004745,343.855225 131.000961,343.683777 131.352325,343.218628   C136.369705,341.507080 137.562683,338.419739 135.999435,334.006042   C136.000412,333.600647 136.001389,333.195282 136.219940,332.413910   C136.710663,331.910675 136.991730,331.804413 137.711716,331.792725   C142.350037,331.623596 147.324127,325.802826 147.125244,321.352112   C147.231094,321.225464 147.537216,321.101898 147.948944,321.354279   C151.975388,322.503815 154.772064,322.350159 153.993820,317.177612   C154.964417,316.608368 155.749527,316.227417 157.009369,315.889038   C165.975189,316.112732 165.975189,316.112732 165.958557,310.102936   C167.048996,309.418762 167.921906,308.940857 168.978531,308.805542   C171.858231,309.347473 174.554199,309.546844 177.438370,309.760132   C177.041580,314.112518 173.789307,318.328369 179.231201,321.417297   C179.521149,325.225403 179.690750,328.611786 179.506744,332.080475   C178.818024,332.507477 178.139984,332.929321 178.197632,333.185638   C179.928314,340.879730 181.082977,348.614807 184.772278,355.899414   C188.732071,363.718079 196.237457,369.814728 196.251083,378.972473   C206.184753,380.027283 201.098328,391.489594 208.574387,394.287628   C203.665649,397.440308 202.021835,401.200684 204.057190,406.062378   C204.038727,406.045197 204.079193,406.037323 203.805801,406.117340   C202.830719,406.461151 202.129028,406.724945 201.266815,406.795898   C201.045776,406.447052 200.985260,406.291107 200.912415,405.770721   C198.582214,399.608032 196.789429,406.108612 194.065674,405.576202   C189.806030,401.395020 186.864532,405.756256 183.500214,408.263885   C178.586075,402.003296 175.140594,411.205780 170.340103,409.517670   C171.297714,405.844055 170.716385,403.109985 166.158112,402.826721   C166.054047,402.610687 166.127869,402.136780 166.530197,401.991089   C167.014008,399.197021 166.471863,396.329712 167.308472,393.946411   C168.982880,389.176605 166.704208,386.881409 163.280258,384.793701   C165.017548,383.155243 167.381104,381.931915 167.767395,380.253510   C169.158447,374.209381 170.083710,368.032257 170.711929,361.857239   C170.861649,360.385529 169.177536,358.727234 168.336884,357.154755   C167.225754,358.509796 165.597244,359.701721 165.108109,361.252930   C163.991028,364.795563 164.059769,368.815186 162.491241,372.087067   C160.397064,376.455414 160.063080,381.167542 162.616333,385.084717   C161.959793,386.067108 161.687500,386.964783 161.432541,388.180420   C161.192719,389.747528 160.935562,390.996613 160.265289,392.208618   C158.901276,394.173828 157.465317,396.091522 157.098526,398.195618   C156.288666,402.841156 156.019135,407.501099 149.775101,408.183533   C149.088165,408.258606 148.589508,410.056580 147.788162,411.304260   C146.690475,412.375092 145.808136,413.197144 144.664795,414.267365   C142.978851,418.852966 145.767197,420.075134 149.089264,420.896729   C149.065201,420.908600 149.087570,420.860687 149.105316,421.191833   C149.519012,421.814331 149.914963,422.105682 150.310898,422.397003   C150.474930,421.731079 150.638947,421.065125 150.785278,420.273132   C150.767593,420.147034 150.974258,419.998291 151.368439,419.986938   C152.348114,419.749023 153.428955,419.554657 153.446121,419.291016   C153.801041,413.839630 158.710663,414.621613 161.870117,413.030609   C163.257263,412.332092 164.620743,411.586609 166.191650,410.721252   C166.388321,410.580048 166.871109,410.617218 167.016846,410.965790   C167.949692,411.834747 169.022980,412.984802 169.479279,412.777405   C173.654434,410.879761 177.584396,410.750397 182.315186,411.429443   C189.278030,412.428864 196.551880,411.261475 203.779694,411.383179   C203.875687,412.499176 203.885239,413.249084 203.560638,414.062805   C203.661789,416.083374 204.097092,418.040100 204.653473,420.383698   C204.805008,421.847321 204.835480,422.924103 204.485565,424.103119   C204.090912,428.047333 204.076630,431.889313 204.062347,435.731262   C208.169678,435.381409 212.395065,435.474213 216.316818,434.428375   C217.594543,434.087646 218.080063,430.776245 219.146698,428.584229   C220.576691,427.920929 221.787903,427.496948 223.069611,427.426422   C224.432983,428.186218 225.725861,428.592590 227.018723,428.998962   C227.096390,429.332001 227.174057,429.665070 227.206787,430.532288   C227.369431,431.362793 227.577011,431.659119 227.784592,431.955414   C227.866226,432.407013 227.947861,432.858582 227.685242,433.699554   C227.826706,435.393768 228.312408,436.698578 228.798096,438.003418   C228.910583,438.736603 229.023056,439.469818 229.117859,440.574280  z"
    />
    <path
      fill="#8DB1D9"
      opacity="1.000000"
      stroke="none"
      d=" M100.023308,304.975708   C103.062408,305.253784 102.969421,303.620392 102.734833,301.253143   C102.245361,296.313934 101.958031,291.330688 102.028297,286.371765   C102.056602,284.374390 102.414337,281.277039 105.665573,283.744263   C100.481956,290.527161 105.064507,296.735382 105.284103,303.014435   C107.652779,296.710175 109.848320,290.417023 106.001602,283.985229   C109.971634,284.465271 110.128311,287.766479 109.837364,290.348663   C109.195107,296.048889 107.868500,301.671967 106.742996,307.748108   C109.234108,309.528412 112.162285,311.621063 116.033714,314.387787   C115.612846,308.431030 115.014236,303.462952 115.010979,298.494507   C115.009247,295.848480 113.445557,291.410797 117.838287,291.258270   C122.229538,291.105804 123.204605,295.294647 122.930756,298.919922   C122.621574,303.012878 122.143913,307.251617 120.743729,311.060913   C119.215813,315.217712 118.727745,318.514771 122.574394,321.559204   C123.780220,322.513550 124.490395,324.094116 125.204109,325.079681   C126.815849,318.657043 128.403152,312.331757 130.465698,305.982056   C130.940933,305.957611 131.241364,306.251526 131.130463,306.612976   C130.281204,313.216095 129.542847,319.457764 128.932373,325.880005   C129.060242,326.060577 129.321381,326.417847 129.321381,326.417847   C127.036018,330.662537 128.407623,334.297028 131.562943,338.216522   C131.619171,339.478333 131.315353,340.217621 131.011536,340.956909   C129.196899,337.852203 127.382271,334.747498 125.532333,331.582397   C117.708206,332.866547 110.369110,338.723694 101.943924,333.558228   C101.914825,333.082764 102.176270,332.791718 102.558746,332.902740   C109.388527,335.426849 115.109192,332.673096 120.957092,330.566406   C116.239151,329.831604 111.534065,329.184387 106.842293,329.269592   C104.946373,329.304047 103.079529,330.939087 101.055237,331.968353   C100.911034,332.090973 100.627701,332.342072 100.627701,332.342072   C99.393044,329.523163 99.806908,328.329376 102.953094,328.115540   C107.863083,327.781769 112.811783,328.016998 117.744080,328.012207   C119.554123,328.010468 121.364166,328.011871 123.189827,328.011871   C121.830597,320.539215 118.368927,318.511322 111.477783,320.610535   C107.548569,321.807495 103.458221,322.518219 99.402771,323.234802   C97.998215,323.482971 96.212791,323.547241 95.074638,322.883698   C93.225708,321.805756 91.766640,320.059113 90.142990,318.594757   C91.791260,317.484955 93.359886,315.602264 95.104019,315.422516   C99.016075,315.019318 103.017097,315.418976 106.978386,315.578857   C109.049690,315.662415 111.113571,315.930054 113.180801,316.114532   C113.381836,315.601562 113.582878,315.088562 113.783913,314.575592   C110.117432,312.770844 106.450951,310.966095 102.383041,308.861694   C101.317024,307.380463 100.652428,306.198944 99.987831,305.017395   C99.987831,305.017395 100.010506,304.989197 100.023308,304.975708  M99.343788,321.433563   C103.312981,320.682373 107.282166,319.931183 111.251358,319.179993   C104.808037,317.371521 98.485870,315.565399 92.343544,318.290375   C92.287491,318.823090 92.231438,319.355774 92.175392,319.888489   C94.307602,320.466980 96.439819,321.045441 99.343788,321.433563  M120.300789,306.452332   C122.045967,298.438141 121.507950,295.644165 117.624573,293.309235   C117.624573,299.377655 117.624573,305.326691 117.624573,311.275726   C117.965950,311.303070 118.307335,311.330414 118.648712,311.357758   C119.126709,309.982147 119.604698,308.606537 120.300789,306.452332  z"
    />
    <path
      fill="#8DB1D9"
      opacity="1.000000"
      stroke="none"
      d=" M128.848419,348.938934   C128.848419,348.938934 128.435333,348.997223 128.239899,349.070190   C124.309799,349.757355 120.591362,350.536133 116.832687,350.906799   C115.275040,351.060364 113.366570,350.742798 112.099060,349.908264   C110.756058,349.024078 109.985085,347.270996 108.964287,345.897400   C110.350700,344.948090 111.685570,343.285828 113.133049,343.181183   C117.747162,342.847565 122.403137,343.092987 127.779160,343.119476   C128.696198,343.115479 128.877014,343.106750 129.057846,343.098053   C129.345169,343.253174 129.602417,343.447998 129.973648,344.118408   C130.084991,344.724091 130.052277,344.893860 129.549683,345.080841   C123.112961,345.098083 117.146141,345.098083 111.179329,345.098083   C111.037651,345.777161 110.895981,346.456238 110.754311,347.135315   C112.499702,347.763428 114.294945,349.027863 115.980789,348.895782   C120.367126,348.552216 124.705437,347.595642 129.083252,347.229797   C129.018524,348.030334 128.933472,348.484619 128.848419,348.938934  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M127.964859,352.379852   C128.966522,352.922363 130.871307,354.073486 130.714264,354.735901   C129.628479,359.316162 131.148376,364.991241 125.350281,367.947998   C125.007515,367.282135 125.008636,366.563354 125.220566,365.258301   C124.338783,363.426727 123.246185,362.181427 122.559654,361.398956   C124.154984,359.847961 125.489998,358.550049 126.825020,357.252136   C127.187965,355.755524 127.550903,354.258942 127.964859,352.379852  z"
    />
    <path
      fill="#9CBADB"
      opacity="1.000000"
      stroke="none"
      d=" M99.701645,305.021912   C100.652428,306.198944 101.317024,307.380463 102.011414,308.916443   C97.555321,311.282257 93.098038,313.558044 88.489304,310.378845   C92.576660,309.690674 96.268738,309.403229 99.960815,309.115784   C96.795830,307.650726 93.687531,307.153229 90.600060,307.259674   C89.703247,307.290588 88.866005,309.049377 88.001450,310.016083   C87.369278,309.325012 86.737099,308.633972 86.104912,307.942902   C86.954987,307.306915 87.757523,306.211639 88.663727,306.117828   C91.869469,305.785980 95.110664,305.796692 98.591286,305.369934   C99.034592,305.050354 99.225029,305.038391 99.701645,305.021912  z"
    />
    <path
      fill="#8DB1D9"
      opacity="1.000000"
      stroke="none"
      d=" M126.463577,357.251526   C125.489998,358.550049 124.154984,359.847961 122.559654,361.398956   C123.246185,362.181427 124.338783,363.426727 125.226082,364.898956   C123.334099,363.719666 121.647423,362.313477 119.960739,360.907257   C122.007881,359.688477 124.055016,358.469696 126.463577,357.251526  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M131.006805,341.297180   C131.315353,340.217621 131.619171,339.478333 131.841019,338.416382   C132.996445,336.855438 134.233871,335.617126 135.735367,334.192444   C137.562683,338.419739 136.369705,341.507080 131.350922,342.961426   C130.996933,342.544403 130.999512,342.090912 131.006805,341.297180  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M123.977142,371.375488   C125.344963,371.768005 126.661255,372.539856 128.954605,373.884613   C126.601318,375.252747 125.159340,376.091095 123.365860,376.965820   C123.318123,375.253082 123.621880,373.503967 123.977142,371.375488  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M130.019577,345.063599   C130.052277,344.893860 130.084991,344.724091 130.139343,344.296021   C130.160980,344.037781 130.584610,344.028595 130.796585,344.027649   C130.544891,345.637909 130.081238,347.249115 129.233002,348.899658   C128.933472,348.484619 129.018524,348.030334 129.187500,346.995300   C129.520798,345.964264 129.770187,345.513947 130.019577,345.063599  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M128.959946,342.916290   C128.877014,343.106750 128.696198,343.115479 128.245056,343.095825   C128.270508,342.956512 128.566284,342.845520 128.959946,342.916290  z"
    />
    <path
      fill="#8DB1D9"
      opacity="1.000000"
      stroke="none"
      d=" M101.781799,333.226196   C101.368347,333.199158 101.123116,332.987854 100.770386,332.538879   C100.627701,332.342072 100.911034,332.090973 101.245796,332.094971   C101.823387,332.291840 102.021957,332.522766 102.176270,332.791718   C102.176270,332.791718 101.914825,333.082764 101.781799,333.226196  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M117.837799,409.360168   C118.739517,409.309082 120.080902,409.547333 120.128052,409.940735   C120.658577,414.367126 121.634254,418.897308 121.096886,423.226654   C120.837769,425.314148 117.628891,427.035492 115.406784,428.966827   C115.057869,429.011017 115.033592,428.516571 115.019539,428.269592   C115.895775,421.922241 116.786072,415.821899 117.837799,409.360168  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M121.509056,387.184387   C122.134666,387.532959 122.925484,388.210236 122.898346,388.852905   C122.674995,394.142334 122.426636,399.439423 121.843994,404.696259   C121.748360,405.559052 119.979897,406.236450 118.592590,407.005493   C119.232147,400.506653 120.263664,394.001831 121.509056,387.184387  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M122.821960,380.046265   C122.961914,380.175354 122.888771,380.396088 122.644661,380.725586   C122.408409,380.588898 122.453468,380.356750 122.821960,380.046265  z"
    />
    <path
      fill="#F49E86"
      opacity="1.000000"
      stroke="none"
      d=" M226.027328,295.360291   C226.913132,296.359222 227.798935,297.358124 228.797836,299.067047   C229.242508,304.877838 229.988831,309.992828 229.814896,315.076324   C229.502762,324.199615 223.818039,328.361115 215.192825,325.786255   C211.294067,324.622375 207.671356,322.472443 204.006577,320.606537   C201.257492,319.206848 198.641342,317.546143 195.984833,315.999939   C196.003647,315.998260 195.999222,316.036682 195.972687,315.700806   C195.608856,315.075867 195.271561,314.786804 194.702789,314.263550   C192.290344,308.596069 190.109390,303.162842 188.117310,297.458466   C191.665115,293.556305 193.665207,289.370880 193.554169,284.324158   C194.063385,278.185974 194.572586,272.047760 195.035538,265.454651   C195.246216,264.358368 195.503143,263.717010 195.917419,262.765930   C197.261993,264.736816 198.449234,267.017456 199.866364,269.933228   C202.046799,272.912506 203.554306,276.050537 206.039185,277.437256   C211.384552,280.420410 217.233078,282.501923 222.967896,285.241333   C223.392868,286.256622 223.725616,286.983124 224.004730,288.139587   C224.643188,290.833160 225.335251,293.096710 226.027328,295.360291  z"
    />
    <path
      fill="#39333D"
      opacity="1.000000"
      stroke="none"
      d=" M193.210907,284.278137   C193.665207,289.370880 191.665115,293.556305 187.747635,297.449646   C181.057678,301.295593 174.926239,304.879272 168.794800,308.462952   C167.921906,308.940857 167.048996,309.418762 165.609299,310.206970   C162.206558,312.293640 159.370605,314.070038 156.534653,315.846466   C155.749527,316.227417 154.964417,316.608368 153.660202,317.285339   C151.273132,318.754852 149.405167,319.928375 147.537216,321.101898   C147.537216,321.101898 147.231094,321.225464 146.855621,321.489563   C143.413681,325.075470 140.347198,328.397308 137.280716,331.719116   C136.991730,331.804413 136.710663,331.910675 136.223724,332.109924   C137.598129,328.108673 138.751495,323.793732 140.856033,320.007507   C147.183273,308.624573 155.720352,299.228943 167.414856,292.443115   C173.601608,289.987823 179.541077,287.800995 186.101593,285.399841   C187.150635,285.098419 187.578629,285.011292 188.006622,284.924133   C189.626968,284.693451 191.247299,284.462799 193.210907,284.278137  z"
    />
    <path
      fill="#83AFDD"
      opacity="1.000000"
      stroke="none"
      d=" M177.686066,272.252960   C172.619888,266.683563 166.093765,267.690857 159.500275,269.001648   C159.491501,268.468658 159.482712,267.935638 159.473938,267.402649   C162.678787,266.798309 165.883621,266.193970 169.737320,265.467285   C167.384476,262.918640 165.142776,260.490387 162.901077,258.062134   C163.340668,257.622650 163.780258,257.183167 164.219849,256.743683   C168.811813,261.559631 173.403763,266.375610 177.964874,271.623291   C177.934036,272.055023 177.686066,272.252960 177.686066,272.252960  z"
    />
    <path
      fill="#83AFDD"
      opacity="1.000000"
      stroke="none"
      d=" M160.146393,253.799652   C160.915314,254.749023 161.413177,255.474365 162.625412,257.240479   C153.882599,252.022995 146.259903,247.473969 138.710007,242.968369   C142.378906,242.410904 147.468094,244.943130 160.146393,253.799652  z"
    />
    <path
      fill="#83AFDD"
      opacity="1.000000"
      stroke="none"
      d=" M187.963837,284.584045   C187.578629,285.011292 187.150635,285.098419 186.395416,285.177734   C183.322205,281.089264 180.576233,277.008575 177.758163,272.590424   C177.686066,272.252960 177.934036,272.055023 178.055817,271.950348   C181.425415,275.978424 184.673218,280.111206 187.963837,284.584045  z"
    />
    <path
      fill="#F39D85"
      opacity="1.000000"
      stroke="none"
      d=" M244.757904,221.043823   C244.237259,230.258072 243.578705,239.088531 242.919830,248.332809   C242.302795,249.286072 241.328018,250.408340 241.120880,250.281082   C232.300278,244.862381 223.114395,246.759674 219.759567,254.342316   C217.545059,259.347534 211.721313,259.105072 208.139526,254.689865   C200.997711,245.886230 198.922363,236.742752 204.648499,226.221725   C205.685684,224.316086 204.489349,220.889664 203.700516,218.359756   C202.120316,213.291733 202.904053,211.697388 208.203308,212.153152   C216.151688,212.836777 224.040771,214.190765 231.984100,214.960022   C235.832993,215.332748 239.747833,215.024399 244.035233,215.024399   C244.146606,216.097748 244.383301,218.378891 244.757904,221.043823  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M224.058365,287.709625   C223.725616,286.983124 223.392868,286.256622 223.037872,284.823547   C223.121033,282.704346 223.226440,281.291779 223.331863,279.879181   C226.124207,280.250427 228.906311,280.769562 231.710907,280.963776   C238.674744,281.445953 240.486771,280.051910 242.177963,273.235748   C242.457779,272.107971 242.680145,270.965973 243.043854,269.460999   C249.229950,278.016754 254.266449,287.393829 255.866699,298.671936   C253.744019,298.720276 251.647995,298.356262 249.077759,297.736664   C248.364059,297.341003 248.153458,297.166077 247.971741,296.956360   C247.971741,296.956360 248.035248,296.961700 247.790543,296.765717   C240.909042,292.665771 234.272232,288.761780 228.856400,285.576019   C226.485367,286.630371 225.271866,287.170013 224.058365,287.709625  z"
    />
    <path
      fill="#F39D85"
      opacity="1.000000"
      stroke="none"
      d=" M195.164276,253.684113   C190.854477,254.815048 188.068283,252.972214 186.647308,249.399979   C184.490387,243.977707 180.098206,238.563065 185.763962,232.302612   C189.335754,232.887192 194.681427,232.803436 195.704681,234.865067   C197.956223,239.401367 198.222336,244.999390 198.799911,250.219269   C198.902725,251.148453 196.599304,252.343887 195.164276,253.684113  z"
    />
    <path
      fill="#F56B59"
      opacity="1.000000"
      stroke="none"
      d=" M223.038483,279.648346   C223.226440,281.291779 223.121033,282.704346 222.945618,284.534729   C217.233078,282.501923 211.384552,280.420410 206.039185,277.437256   C203.554306,276.050537 202.046799,272.912506 200.068665,270.207886   C207.609085,273.037445 215.177109,276.227478 223.038483,279.648346  z"
    />
    <path
      fill="#EE9A84"
      opacity="1.000000"
      stroke="none"
      d=" M239.275070,257.372742   C239.858032,262.035675 237.511246,264.051331 233.630951,263.864349   C230.223679,263.700134 226.856812,262.697845 223.332886,262.039764   C226.528000,254.928528 234.070068,252.762238 239.275070,257.372742  z"
    />
    <path
      fill="#8DB1D9"
      opacity="1.000000"
      stroke="none"
      d=" M134.191788,305.795776   C134.663681,308.729767 136.079483,311.911926 135.388550,314.540222   C134.324799,318.586792 131.815933,322.253479 129.620773,326.249573   C129.321381,326.417847 129.060242,326.060577 129.029633,325.552673   C131.885971,319.197693 135.693619,313.574219 133.676331,306.320068   C133.848709,306.145844 134.191788,305.795776 134.191788,305.795776  z"
    />
    <path
      fill="#8DB1D9"
      opacity="1.000000"
      stroke="none"
      d=" M130.786957,305.814575   C131.704071,305.548096 132.775146,305.424652 134.019012,305.548492   C134.191788,305.795776 133.848709,306.145844 133.416595,306.201233   C132.403458,306.254913 131.822403,306.253235 131.241364,306.251526   C131.241364,306.251526 130.940933,305.957611 130.786957,305.814575  z"
    />
    <path
      fill="#4676B1"
      opacity="1.000000"
      stroke="none"
      d=" M152.606491,453.178680   C152.924789,453.219666 153.243088,453.260651 153.781555,453.178101   C155.289230,452.927338 156.576767,452.800110 158.401367,453.072021   C159.680969,456.983734 160.423462,460.496277 161.165955,464.008850   C157.685196,464.025330 154.204407,464.037262 150.723679,464.059174   C142.841660,464.108795 138.965515,467.508728 137.866333,475.325439   C137.591309,477.281311 137.308151,479.236023 137.011810,481.619873   C125.125572,483.724762 123.707970,475.004547 125.236176,466.585938   C125.663811,464.230164 127.060188,462.050262 128.422928,459.235718   C136.757950,456.847443 144.682220,455.013062 152.606491,453.178680  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M152.192169,453.114044   C144.682220,455.013062 136.757950,456.847443 128.506012,458.875031   C126.083565,459.047577 123.988762,459.026917 121.447540,459.003723   C121.874908,453.352875 126.632599,453.536133 130.525299,453.122833   C135.971725,452.544586 141.491547,452.612946 146.981903,452.520386   C148.577133,452.493500 150.179016,452.862091 152.192169,453.114044  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M113.013763,445.460510   C113.681686,446.262512 114.599045,447.460938 114.946838,448.806549   C115.748924,451.909790 116.274498,455.084503 116.955612,458.615723   C113.981842,459.210938 112.879585,457.668610 112.975052,454.808746   C113.073814,451.850067 113.001793,448.885681 113.013763,445.460510  z"
    />
    <path
      fill="#E0F3FB"
      opacity="1.000000"
      stroke="none"
      d=" M563.798279,351.178650   C560.580688,358.636810 560.845398,362.919586 565.650391,367.690399   C566.721863,372.445740 567.408997,376.694824 568.096191,380.943909   C565.705627,380.969391 563.309265,380.914154 560.928955,381.083832   C560.411621,381.120728 559.951599,381.963379 559.730835,383.157898   C559.720947,386.839630 559.445435,389.798431 559.169922,392.757202   C559.160400,393.012604 559.078430,393.242096 558.894165,393.627380   C551.553955,393.881653 544.243713,393.954224 536.468933,394.098816   C534.731567,394.082275 533.458740,393.993744 531.804138,393.404663   C531.422424,391.310760 531.422424,389.717438 531.422424,388.074585   C526.824524,387.674408 522.670715,387.312897 518.568237,386.588074   C518.549805,385.501526 518.480042,384.778290 518.544800,383.711945   C518.586548,382.895294 518.493713,382.421753 518.508789,381.495300   C518.543640,375.381226 518.470581,369.720062 518.538330,363.665131   C518.602600,362.167969 518.526123,361.064606 518.564453,359.526367   C518.763184,356.393158 518.847046,353.694794 518.930847,350.996399   C533.725952,351.037506 548.521057,351.078613 563.798279,351.178650  z"
    />
    <path
      fill="#497BB2"
      opacity="1.000000"
      stroke="none"
      d=" M656.219299,405.070221   C647.256592,408.903076 638.435730,413.150757 628.048767,415.371826   C628.048767,411.423920 628.048767,408.331543 628.079346,404.806519   C637.104309,404.305176 646.098755,404.236481 655.584656,404.417969   C656.076172,404.668152 656.219299,405.070221 656.219299,405.070221  z"
    />
    <path
      fill="#977896"
      opacity="1.000000"
      stroke="none"
      d=" M656.587524,405.034790   C656.219299,405.070221 656.076172,404.668152 656.053467,404.456360   C656.808167,404.189117 657.585571,404.133667 658.744751,404.184021   C659.126526,404.289795 659.140991,404.489288 659.166016,404.584290   C658.445923,404.785980 657.700806,404.892670 656.587524,405.034790  z"
    />
    <path
      fill="#FDFEFE"
      opacity="1.000000"
      stroke="none"
      d=" M622.210327,124.260147   C610.915344,133.662140 598.246399,136.202271 584.533264,133.010666   C561.242737,127.590012 547.732178,101.150032 556.518005,78.936104   C562.918823,62.752411 575.270386,53.640141 591.997986,52.344501   C614.600830,50.593784 634.272400,67.069595 635.980469,90.525764   C636.948242,103.814751 632.097656,114.916786 622.210327,124.260147  M592.249268,93.440895   C593.340515,94.223610 594.531006,95.790230 595.507568,95.666687   C604.380310,94.544197 613.228088,93.199783 622.044678,91.694466   C623.040649,91.524422 623.798645,89.960617 624.666992,89.043129   C623.609436,88.620667 622.499146,87.736031 621.502869,87.849892   C614.418762,88.659500 607.329407,89.505241 600.303101,90.700142   C597.260559,91.217560 595.408813,90.712105 593.761353,87.909462   C589.555969,80.755409 585.023499,73.793846 580.635681,66.746613   C580.115967,65.911880 579.601501,65.056808 579.228760,64.151764   C578.728333,62.936798 578.368347,61.663998 577.948120,60.416016   C576.507019,61.214710 575.065979,62.013401 573.455750,62.905838   C579.934814,73.292992 585.992859,83.005127 592.249268,93.440895  z"
    />
    <path
      fill="#E1F5FD"
      opacity="1.000000"
      stroke="none"
      d=" M79.623047,293.122498   C80.583031,289.170624 83.376183,290.645294 84.948433,291.754913   C88.795929,294.470337 92.235870,297.763184 95.839844,300.823639   C95.520134,301.289062 95.200424,301.754486 94.880714,302.219910   C89.873825,299.286499 84.866928,296.353088 79.623047,293.122498  z"
    />
    <path
      fill="#9CBADB"
      opacity="1.000000"
      stroke="none"
      d=" M282.940979,309.721802   C282.338257,309.989105 281.769958,309.828766 280.989075,309.458862   C279.725128,305.239990 279.077728,301.067963 277.541840,297.253723   C273.863525,288.118988 269.767303,279.152496 266.652740,269.639038   C267.185486,270.278259 267.902527,270.836700 268.223328,271.568787   C272.806152,282.027863 277.403870,292.481750 281.815247,303.013428   C282.619019,304.932343 282.609467,307.191925 282.940979,309.721802  z"
    />
    <path
      fill="#9CBADB"
      opacity="1.000000"
      stroke="none"
      d=" M251.761948,243.465973   C252.675262,241.102783 252.816437,241.022705 253.975723,243.066650   C256.426208,247.387146 258.759796,251.776093 261.053864,256.182526   C262.905060,259.738281 264.627960,263.360809 266.407806,266.953735   C265.951385,267.172058 265.494995,267.390411 265.038605,267.608734   C260.663818,259.663910 256.289032,251.719101 251.761948,243.465973  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M256.888489,299.786255   C256.700439,299.948944 256.423767,299.819824 256.070831,299.387146   C256.257965,299.239624 256.526398,299.376556 256.888489,299.786255  z"
    />
    <path
      fill="#E1EEE7"
      opacity="1.000000"
      stroke="none"
      d=" M468.973083,145.824646   C471.080536,147.211365 472.146423,149.035889 469.967682,150.966980   C469.192322,151.654190 467.390991,151.183884 466.058014,151.241943   C466.160828,149.558533 466.263641,147.875137 467.019897,146.050674   C468.106598,145.881302 468.539856,145.852966 468.973083,145.824646  z"
    />
    <path
      fill="#3A323F"
      opacity="1.000000"
      stroke="none"
      d=" M468.934937,145.546600   C468.539856,145.852966 468.106598,145.881302 467.350281,145.863953   C467.338440,145.343475 467.649719,144.868652 467.960999,144.393829   C468.272919,144.685425 468.584839,144.977005 468.934937,145.546600  z"
    />
    <path
      fill="#E0F3FC"
      opacity="1.000000"
      stroke="none"
      d=" M383.999481,350.963776   C387.809265,350.958221 391.619019,350.952667 395.834229,350.621582   C396.239655,350.296082 396.310425,350.302368 396.310425,350.302368   C397.733856,350.545319 399.156799,350.996857 400.580811,351.000336   C426.462036,351.063782 452.343384,351.073273 478.736816,351.509338   C479.319214,363.563843 479.389526,375.203247 479.091858,387.091614   C458.503113,387.340607 438.282288,387.340607 417.755798,387.340607   C417.755798,390.169678 417.755798,391.989960 417.755798,393.810242   C401.783936,393.853607 385.812103,393.896942 369.384583,393.504395   C368.689697,391.685516 368.450500,390.302582 368.212280,388.510834   C368.160889,386.733795 368.108490,385.365509 368.088593,383.530273   C368.047668,377.366913 367.974243,371.670563 367.948547,365.584778   C367.993866,364.150635 367.991486,363.105957 367.989105,362.061279   C372.495148,358.450775 377.001160,354.840271 382.136841,351.130371   C383.177460,351.008606 383.588470,350.986206 383.999481,350.963776  z"
    />
    <path
      fill="#3A323F"
      opacity="1.000000"
      stroke="none"
      d=" M518.400879,381.948181   C518.493713,382.421753 518.586548,382.895294 518.282837,383.803192   C518.096436,385.142151 518.306702,386.046753 518.516907,386.951385   C522.670715,387.312897 526.824524,387.674408 531.422424,388.074585   C531.422424,389.717438 531.422424,391.310760 531.423584,393.356628   C521.276917,393.849030 511.129120,393.888916 500.512390,393.431274   C499.912964,391.377991 499.782471,389.822235 499.666962,388.445068   C493.076752,387.958374 487.063354,387.514282 481.025909,386.595215   C480.996338,378.995361 481.167999,371.864136 480.911865,364.748291   C480.780212,361.090088 481.855011,359.828552 485.643585,359.905945   C496.574707,360.129242 507.513702,359.970154 518.449585,359.961212   C518.526123,361.064606 518.602600,362.167969 518.206055,363.825989   C517.493469,367.793304 517.017944,371.211243 517.093994,374.616882   C517.148743,377.069153 517.938782,379.505005 518.400879,381.948181  z"
    />
    <path
      fill="#7FA6D5"
      opacity="1.000000"
      stroke="none"
      d=" M287.416931,363.919678   C293.190247,366.420105 298.970123,368.905426 304.735138,371.424866   C311.596527,374.423492 318.488647,377.357208 325.285828,380.495758   C331.040070,383.152740 336.629028,384.347351 342.518738,379.949890   C342.923645,379.913574 343.030487,380.030579 343.019531,380.358398   C343.005646,381.124146 343.002686,381.562073 342.687134,382.154907   C340.582642,385.539886 338.790710,388.769958 336.831665,392.088440   C336.776337,392.449707 336.888184,392.722534 337.320892,392.997070   C338.407379,393.262665 339.173004,393.526520 339.938599,393.790405   C337.458893,393.805878 334.979218,393.821381 332.307739,393.483948   C332.210724,393.042297 332.305511,392.953552 332.400330,392.864807   C332.133270,392.974030 331.866241,393.083282 331.599243,393.192566   C321.019165,393.381226 310.439087,393.569916 299.403107,393.245392   C298.338715,390.028442 297.419373,387.656281 293.641663,387.883484   C291.896851,386.485138 290.438873,385.230011 288.801453,383.604309   C288.220276,376.795715 287.818604,370.357697 287.416931,363.919678  z"
    />
    <path
      fill="#665970"
      opacity="1.000000"
      stroke="none"
      d=" M481.049927,387.070160   C487.063354,387.514282 493.076752,387.958374 499.666962,388.445068   C499.782471,389.822235 499.912964,391.377991 500.052979,393.358154   C472.949066,393.837799 445.835602,393.892975 418.238953,393.879211   C417.755798,391.989960 417.755798,390.169678 417.755798,387.340607   C438.282288,387.340607 458.503113,387.340607 479.361725,387.107666   C480.349670,386.939880 480.699799,387.005005 481.049927,387.070160  z"
    />
    <path
      fill="#7FA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M336.998779,392.000000   C338.790710,388.769958 340.582642,385.539886 342.873962,382.491638   C347.108948,382.944183 350.844543,383.214935 354.279388,383.463867   C354.610748,380.031799 354.805389,378.015900 355.000122,375.750000   C355.000610,375.333344 355.000916,375.166656 355.368347,375.004456   C357.823639,375.005951 359.911804,375.002991 362.000183,375.372955   C362.333588,377.163910 362.666779,378.581970 362.833221,380.329346   C361.240509,385.983093 357.352692,386.445312 352.687012,386.093353   C350.161835,385.902863 347.564697,386.666656 344.945801,386.655792   C341.438751,384.852203 340.790680,385.348175 340.698334,389.569305   C342.136871,389.378937 343.568420,389.189453 345.258698,389.284790   C346.787811,389.506927 348.061279,389.354248 349.328064,389.397491   C354.219879,389.564392 359.109528,389.793884 363.893127,390.259155   C363.523773,391.012177 363.261261,391.506104 362.780273,392.107605   C362.288635,392.413727 362.103271,392.674622 362.003632,393.194397   C362.001617,393.390961 361.998047,393.784058 361.998047,393.784058   C354.957275,393.836945 347.916534,393.889862 340.407166,393.866577   C339.173004,393.526520 338.407379,393.262665 337.320862,392.748291   C336.999908,392.497742 336.998779,392.000000 336.998779,392.000000  z"
    />
    <path
      fill="#497CB2"
      opacity="1.000000"
      stroke="none"
      d=" M287.177063,363.639557   C287.818604,370.357697 288.220276,376.795715 288.739319,384.054016   C289.057953,387.860504 289.259216,390.846710 289.460449,393.832916   C288.336151,393.892639 287.211853,393.952362 285.666809,394.034485   C283.359283,382.848663 281.472473,371.640503 279.392334,359.284119   C282.657990,361.048035 284.797607,362.203735 287.177063,363.639557  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M313.000000,426.903381   C306.907013,419.876190 300.802460,412.412018 294.553772,404.623566   C297.896820,404.262360 301.384094,404.225403 305.291168,404.305847   C308.136841,411.770966 310.562653,419.118652 313.000000,426.903381  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M289.860779,393.885010   C289.259216,390.846710 289.057953,387.860504 288.918793,384.424591   C290.438873,385.230011 291.896851,386.485138 293.812134,388.197052   C295.441620,390.329102 296.613800,392.004364 297.785980,393.679626   C295.277679,393.765442 292.769409,393.851288 289.860779,393.885010  z"
    />
    <path
      fill="#7FA6D5"
      opacity="1.000000"
      stroke="none"
      d=" M362.427094,393.861694   C361.998047,393.784058 362.001617,393.390961 362.221741,393.086609   C362.713989,392.583099 362.899628,392.322357 362.998779,392.000000   C363.261261,391.506104 363.523773,391.012177 364.231415,390.257385   C365.451447,389.664337 366.226349,389.332184 367.304199,388.986633   C367.808533,388.955383 368.009888,388.937500 368.211273,388.919617   C368.450500,390.302582 368.689697,391.685516 368.914978,393.430115   C366.886108,393.840973 364.871124,393.890167 362.427094,393.861694  z"
    />
    <path
      fill="#7EA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M297.977478,393.689575   C296.613800,392.004364 295.441620,390.329102 294.098999,388.340271   C297.419373,387.656281 298.338715,390.028442 298.937073,393.154419   C298.683411,393.674072 298.430756,393.715027 297.977478,393.689575  z"
    />
    <path
      fill="#7FA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M687.687866,358.087067   C687.875916,358.586761 687.743225,359.188385 687.299866,359.905029   C687.115173,359.409698 687.241150,358.799347 687.687866,358.087067  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M746.433289,284.721985   C743.585022,284.272247 741.178101,283.878845 738.771118,283.485474   C746.487244,280.678925 754.064636,277.465942 763.836731,278.618103   C759.025635,286.007812 752.684448,284.641846 746.433289,284.721985  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M729.436646,257.907166   C730.149414,264.497467 730.724243,270.697937 731.390259,277.882019   C724.100281,269.968262 722.250183,258.395569 727.457214,253.703400   C728.128357,255.093384 728.713501,256.305389 729.436646,257.907166  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M709.003540,309.004517   C707.505432,305.618622 705.733459,302.311127 704.598511,298.797852   C703.779846,296.263611 703.112915,293.193024 707.388062,292.194702   C710.042236,298.967682 712.370667,305.656097 714.585449,312.381958   C714.717773,312.783752 713.940735,313.484985 713.286377,314.019470   C712.985901,313.992035 713.005310,313.997833 713.010071,313.666992   C711.670654,311.888184 710.326538,310.440155 708.982422,308.992126   C708.982422,308.992126 709.002319,308.994781 709.003540,309.004517  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M726.215210,334.105499   C729.716431,334.226471 732.762451,334.366486 736.160767,334.522705   C733.030396,341.008057 723.218811,341.561584 711.204468,336.337830   C716.596619,335.517944 721.178345,334.821259 726.215210,334.105499  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M730.330200,320.918030   C727.514099,320.504669 725.144470,320.102722 722.774841,319.700775   C722.730652,319.224152 722.686401,318.747528 722.642212,318.270905   C730.396057,316.896027 738.149902,315.521149 746.497986,314.040894   C744.718689,320.324432 742.364624,321.176636 730.330200,320.918030  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M714.999573,272.991760   C717.214355,279.633453 719.427429,286.285431 721.640503,292.937378   C721.108765,293.182098 720.577026,293.426788 720.045288,293.671509   C715.695435,288.878021 711.434143,283.935242 711.126892,276.882477   C711.073120,275.646790 713.125793,274.319336 714.611938,273.016296   C715.018250,272.998352 714.997925,273.002014 714.999573,272.991760  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M740.087463,301.001648   C736.695251,300.667694 733.760681,300.337677 730.826050,300.007660   C738.187073,296.602905 745.626892,294.208832 753.945801,295.186554   C752.225647,300.085815 749.909424,301.005615 740.087463,301.001648  z"
    />
    <path
      fill="#7FA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M708.890564,309.353760   C710.326538,310.440155 711.670654,311.888184 713.009277,313.677368   C711.602112,312.584137 710.200378,311.149750 708.890564,309.353760  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M742.994019,240.993530   C743.727661,248.659866 744.462280,256.338562 745.196899,264.017273   C744.743225,264.115875 744.289490,264.214508 743.835815,264.313141   C740.557495,258.549927 737.398438,252.631653 738.189453,245.633286   C738.372559,244.013702 740.838623,242.652161 742.636963,241.089737   C743.019775,241.007599 742.994934,241.005890 742.994019,240.993530  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M751.641357,267.819855   C756.422668,266.996185 760.881897,266.271027 765.341064,265.545898   C765.548584,266.015961 765.756104,266.486023 765.963562,266.956085   C765.120300,267.723480 764.277039,268.490845 763.200073,269.498779   C758.545532,269.739319 754.124573,269.739319 749.703552,269.739319   C749.684387,269.337921 749.665161,268.936523 749.645935,268.535126   C750.203735,268.329559 750.761475,268.123962 751.641357,267.819855  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M765.970764,253.465790   C763.580872,255.222672 761.384399,256.713867 758.972168,258.452545   C757.509155,259.335144 756.261902,259.970245 754.721313,260.754730   C759.157043,250.114807 766.477173,243.592361 774.203247,244.807449   C771.127930,248.018036 768.646057,250.609055 765.970764,253.465790  z"
    />
    <path
      fill="#DFF4FD"
      opacity="1.000000"
      stroke="none"
      d=" M753.659302,264.894958   C753.383545,265.145386 752.754822,265.317352 751.996033,265.224640   C752.346069,264.912140 752.826233,264.864288 753.659302,264.894958  z"
    />
    <path
      fill="#BA7C28"
      opacity="1.000000"
      stroke="none"
      d=" M606.086304,376.947083   C604.103088,376.944855 602.557190,377.167603 601.121094,376.866547   C600.050171,376.642029 599.121277,375.740387 598.129089,375.140289   C599.193298,374.439850 600.224243,373.203766 601.327759,373.135162   C605.309204,372.887604 609.315125,373.031189 613.311768,373.030762   C624.635620,373.029541 635.959717,373.000031 647.283203,373.065247   C648.837524,373.074188 650.389038,373.557861 651.874573,374.671295   C636.832397,378.137360 621.647644,376.452728 606.086304,376.947083  z"
    />
    <path
      fill="#4A7BB1"
      opacity="1.000000"
      stroke="none"
      d=" M568.508972,380.978333   C567.408997,376.694824 566.721863,372.445740 566.024902,367.810150   C568.010437,367.350647 570.005615,367.277649 572.432373,367.220093   C572.940186,371.465393 573.016479,375.695251 573.092529,380.373627   C571.702087,380.885681 570.311951,380.949249 568.508972,380.978333  z"
    />
    <path
      fill="#BA7C28"
      opacity="1.000000"
      stroke="none"
      d=" M658.962402,374.741211   C662.228882,372.057648 665.769287,371.108154 669.851501,373.908356   C666.578247,378.588745 662.842773,376.632019 658.962402,374.741211  z"
    />
    <path
      fill="#BA7C28"
      opacity="1.000000"
      stroke="none"
      d=" M587.896240,376.056519   C584.943970,375.981201 582.327026,375.759918 579.710022,375.538635   C579.712158,374.835480 579.714355,374.132355 579.716492,373.429199   C583.252319,373.104645 586.788086,372.780090 590.323914,372.455505   C590.453125,372.988861 590.582275,373.522186 590.711487,374.055542   C589.884827,374.673859 589.058167,375.292206 587.896240,376.056519  z"
    />
    <path
      fill="#5F524B"
      opacity="1.000000"
      stroke="none"
      d=" M588.511597,381.115936   C584.192444,381.347809 579.415649,381.502869 574.330872,381.388855   C578.699890,381.092896 583.377014,381.066010 588.511597,381.115936  z"
    />
    <path
      fill="#5F524B"
      opacity="1.000000"
      stroke="none"
      d=" M660.748413,381.210022   C660.995972,381.263947 660.654602,381.588104 660.654602,381.588104   C660.654602,381.588104 660.208252,381.532837 660.108704,381.405640   C660.173035,381.237701 660.336975,381.196899 660.748413,381.210022  z"
    />
    <path
      fill="#3A323F"
      opacity="1.000000"
      stroke="none"
      d=" M652.225342,390.142151   C646.342224,390.479431 640.904602,390.879150 635.461914,390.967438   C627.496704,391.096680 619.527710,391.027771 611.560608,390.986511   C609.523071,390.975952 607.069580,391.659698 606.983582,388.133606   C606.901001,384.747803 609.078064,385.031708 611.294128,384.982452   C625.029724,384.676880 638.763611,384.274017 652.500610,384.071228   C654.605652,384.040131 657.883179,382.609528 657.988464,386.926697   C658.094055,391.252777 654.792114,389.619446 652.225342,390.142151  z"
    />
    <path
      fill="#FCFDFD"
      opacity="1.000000"
      stroke="none"
      d=" M559.626160,392.730286   C559.445435,389.798431 559.720947,386.839630 559.996521,383.434143   C570.290405,383.016937 580.585144,383.130554 590.877563,383.022430   C593.799500,382.991699 595.302917,383.905945 595.212280,386.919464   C595.127136,389.753571 594.792725,392.213684 590.960999,392.239044   C580.667542,392.307220 570.375183,392.537506 559.626160,392.730286  z"
    />
    <path
      fill="#A1E2F1"
      opacity="1.000000"
      stroke="none"
      d=" M352.193604,325.816040   C343.923004,322.863281 343.919128,322.863281 343.918823,314.110168   C343.917297,271.331848 343.914551,228.553513 343.921234,185.775177   C343.922394,178.435669 345.373749,176.950241 352.594849,176.942795   C371.237549,176.923553 389.880219,176.918274 408.522919,176.934708   C415.204742,176.940598 417.015259,178.763107 417.024109,185.593185   C417.060974,214.056366 417.061554,242.519577 416.960419,271.767273   C413.237549,276.051697 409.629700,279.551575 405.929871,282.643311   C404.374298,281.796783 402.917725,281.009216 401.445892,280.979675   C394.637421,280.843018 387.824615,280.895142 381.013641,280.932770   C379.517944,280.941040 378.023468,281.166107 376.528412,281.291351   C376.560974,281.867188 376.593536,282.443024 376.626099,283.018860   C386.433228,283.018860 396.240387,283.018860 406.031128,283.389648   C403.283508,289.451508 400.552277,295.142548 397.821014,300.833588   C393.170135,302.279114 388.519226,303.724640 382.986877,305.145264   C374.296295,305.100555 366.486786,305.026672 358.678131,305.079926   C353.486847,305.115356 351.845154,306.951447 352.089355,312.101166   C352.296600,316.470734 354.585449,318.080383 359.553925,317.666443   C361.412048,317.511627 363.313690,317.879242 365.195496,318.008667   C360.975708,320.585052 356.755920,323.161438 352.193604,325.816040  M362.443207,197.016205   C364.663757,200.260712 367.499451,200.604889 370.578552,198.462524   C373.318207,196.556320 373.785461,193.796036 372.147552,191.020905   C370.529968,188.280121 367.929718,187.182617 364.896271,188.661209   C361.608215,190.263947 360.335815,192.848953 362.443207,197.016205  M361.167938,287.072418   C362.455200,290.599335 364.720551,292.737091 368.666290,291.568176   C371.621613,290.692657 374.022491,288.446289 372.785156,285.363586   C371.919861,283.207825 369.341766,280.587097 367.262238,280.330078   C363.783173,279.900055 361.203033,282.301117 361.167938,287.072418  M372.937408,240.379349   C371.521240,238.386566 370.455383,235.860641 368.551697,234.609863   C367.485687,233.909454 364.311066,234.750916 363.380859,235.924011   C362.157196,237.467148 361.397278,240.269913 361.950989,242.064056   C362.443451,243.659668 365.334473,245.904816 366.571167,245.581909   C368.903687,244.972885 370.807861,242.723282 372.937408,240.379349  M364.866913,215.029648   C362.779114,213.735779 360.807220,211.817963 358.556763,211.400055   C357.354584,211.176788 354.761932,213.334152 354.430237,214.789383   C353.989655,216.722290 354.590546,219.441895 355.796783,221.017426   C356.674835,222.164261 359.397369,222.652435 361.048676,222.292465   C364.211670,221.602921 365.479187,219.073456 364.866913,215.029648  M353.902313,262.601440   C354.082672,266.806396 356.219910,269.553162 360.417877,268.419067   C362.320435,267.905121 364.735535,264.878479 364.741302,262.985046   C364.747192,261.065491 362.431061,258.155304 360.482727,257.434998   C357.248413,256.239288 354.922668,258.504303 353.902313,262.601440  M372.838013,259.995636   C381.401672,259.995636 389.965332,259.995636 398.528992,259.995636   C394.956146,256.182983 371.554810,256.310150 367.974030,259.369995   C369.588806,259.624115 370.765259,259.809235 372.838013,259.995636  M401.233276,188.050537   C392.893860,188.435394 384.454742,187.234116 376.185272,188.731918   C376.203857,189.257263 376.222443,189.782593 376.241028,190.307938   C386.072418,190.307938 395.903778,190.307938 405.735138,190.307938   C405.794067,189.798752 405.852966,189.289581 405.911896,188.780396   C404.658661,188.536880 403.405457,188.293381 401.233276,188.050537  M395.074951,213.996994   C396.041473,213.606476 397.008026,213.215942 398.843994,212.474121   C391.602142,209.870071 370.647217,210.723892 367.980408,213.999512   C377.118011,213.999512 385.640747,213.999512 395.074951,213.996994  M387.523071,234.050354   C383.779877,234.184784 380.036682,234.319199 376.293488,234.453629   C376.311584,235.105026 376.329681,235.756439 376.347778,236.407837   C386.074219,236.407837 395.800659,236.407837 405.527100,236.407837   C405.562866,235.724426 405.598633,235.041000 405.634369,234.357590   C399.927368,234.255219 394.220367,234.152863 387.523071,234.050354  M371.040985,261.961334   C370.217987,262.178864 369.395020,262.396362 368.572021,262.613892   C368.619751,262.893738 368.667480,263.173615 368.715210,263.453461   C376.920990,263.453461 385.126740,263.453461 393.332489,263.453461   C393.341705,262.954895 393.350891,262.456329 393.360107,261.957764   C386.217316,261.957764 379.074554,261.957764 371.040985,261.961334  M401.288696,194.421738   C399.964539,193.931290 398.651581,193.056580 397.314301,193.017654   C391.845947,192.858521 386.369873,192.926041 380.897247,192.975693   C379.429932,192.988998 377.964752,193.234299 376.498566,193.373093   C376.539154,193.871429 376.579712,194.369781 376.620270,194.868118   C384.618652,194.868118 392.617035,194.868118 401.288696,194.421738  M372.818390,215.966690   C371.390747,216.124588 369.963074,216.282486 368.535431,216.440384   C368.596008,216.738998 368.656586,217.037628 368.717194,217.336243   C376.931335,217.336243 385.145477,217.336243 393.359650,217.336243   C393.357605,216.879639 393.355591,216.423050 393.353577,215.966446   C386.818726,215.966446 380.283905,215.966446 372.818390,215.966690  M398.957794,238.955276   C391.502655,238.955276 384.047546,238.955276 376.592407,238.955276   C376.595612,239.601227 376.598785,240.247162 376.601990,240.893112   C384.548981,240.893112 392.496002,240.893112 400.443024,240.893112   C400.231476,240.256516 400.019958,239.619934 398.957794,238.955276  M378.129211,287.015900   C385.798828,286.684723 393.567352,287.785034 401.135162,285.697693   C393.495209,284.993011 385.884277,284.968994 378.275116,285.073303   C377.940430,285.077911 377.621857,286.256195 378.129211,287.015900  M396.559845,289.112030   C389.895325,289.112030 383.230804,289.112030 376.566284,289.112030   C376.585815,289.656708 376.605316,290.201385 376.624847,290.746063   C383.141876,291.031769 389.658081,291.351562 396.178223,291.508575   C396.526611,291.516968 396.908051,290.153748 396.559845,289.112030  M385.210449,268.078857   C386.644226,267.924713 388.077972,267.770538 389.511749,267.616394   C389.454102,267.241089 389.396454,266.865753 389.338776,266.490448   C382.422241,266.490448 375.505707,266.490448 368.589142,266.490448   C368.564789,267.020081 368.540436,267.549713 368.516083,268.079346   C373.771057,268.079346 379.026031,268.079346 385.210449,268.078857  M383.621033,197.002823   C381.262238,197.136337 378.903473,197.269852 376.544678,197.403366   C376.591400,197.713638 376.638123,198.023926 376.684845,198.334198   C383.568176,198.334198 390.451508,198.334198 397.334839,198.334198   C397.321838,197.890411 397.308838,197.446625 397.295837,197.002838   C393.056427,197.002838 388.816986,197.002838 383.621033,197.002823  M389.392700,220.635803   C382.493561,220.635803 375.594391,220.635803 368.695251,220.635803   C368.700958,220.907578 368.706696,221.179352 368.712402,221.451126   C375.600555,221.451126 382.488678,221.451126 389.392700,220.635803  M381.733154,245.076385   C386.866760,245.076385 392.000366,245.076385 397.133942,245.076385   C397.123413,244.603363 397.112885,244.130341 397.102356,243.657318   C390.281158,243.657318 383.459930,243.657318 376.638733,243.657318   C376.625549,244.023407 376.612366,244.389481 376.599182,244.755569   C378.002350,244.862442 379.405487,244.969315 381.733154,245.076385  z"
    />
    <path
      fill="#65ABD2"
      opacity="1.000000"
      stroke="none"
      d=" M195.966019,316.001648   C198.641342,317.546143 201.257492,319.206848 204.006577,320.606537   C207.671356,322.472443 211.294067,324.622375 215.192825,325.786255   C223.818039,328.361115 229.502762,324.199615 229.814896,315.076324   C229.988831,309.992828 229.242508,304.877838 228.923981,299.324860   C240.856964,311.158386 247.720657,326.252167 253.031860,342.595947   C253.203568,345.645447 252.897156,348.448914 253.612045,350.961853   C254.676865,354.704834 257.318695,358.105804 255.176636,362.293213   C255.007996,362.622894 255.214890,363.443573 255.519928,363.672211   C260.884430,367.692108 258.497620,373.586456 259.289948,378.719940   C259.471283,379.894989 260.361664,380.965790 260.949402,382.071960   C262.542786,385.070923 261.247040,387.964661 257.428589,388.595337   C257.218292,382.520355 254.100601,379.587250 249.024078,377.793427   C245.177856,376.434265 240.355347,376.169708 239.004639,370.571686   C238.966736,361.527191 236.574493,358.244080 228.073746,356.623535   C222.903992,355.638000 218.551712,354.039886 216.267502,348.897827   C216.013580,348.326202 215.465973,347.772552 214.912613,347.471375   C213.958939,346.952301 212.548370,346.036652 211.955002,346.377197   C211.032547,346.906708 210.235733,348.293640 210.079834,349.413757   C209.240219,355.446228 212.309540,361.224396 217.945724,362.733185   C223.388702,364.190308 226.787537,366.783569 227.402435,372.581543   C227.492996,373.435486 228.444443,374.198151 229.132690,375.315887   C231.119720,377.695465 232.590958,380.702698 234.900925,381.637726   C240.076324,383.732483 241.734390,387.438354 241.498245,392.543396   C238.139114,392.660919 235.220688,392.660919 232.327744,392.660919   C231.842743,394.806824 231.497910,396.332550 231.167252,397.795593   C227.617844,398.022095 224.348633,398.230713 220.927094,398.053833   C213.439606,373.735474 206.096817,349.804901 198.778351,325.866913   C197.778793,322.597473 196.900482,319.290985 195.966019,316.001648  z"
    />
    <path
      fill="#F49F88"
      opacity="1.000000"
      stroke="none"
      d=" M397.870392,301.285034   C400.552277,295.142548 403.283508,289.451508 406.005310,283.381866   C405.995880,283.003265 406.021851,283.051453 406.021851,283.051453   C409.629700,279.551575 413.237549,276.051697 416.981964,272.229614   C418.415771,270.985474 419.712982,270.063568 421.580994,268.735962   C422.441589,275.867065 416.546967,279.753418 415.035522,287.046661   C420.435547,284.145935 424.896545,281.749603 429.975342,279.059021   C439.832733,274.183197 439.832733,274.183197 442.676208,277.119080   C441.301361,278.281403 439.938904,279.433258 438.576447,280.585083   C443.660675,277.919434 447.726379,277.482819 449.266052,284.996796   C447.751526,286.211670 445.690125,287.865204 442.545319,290.387726   C445.770447,289.402313 447.657288,288.825775 449.544159,288.249268   C449.832977,288.716614 450.121826,289.183929 450.410645,289.651276   C444.966675,297.007294 437.632111,302.045959 429.063995,305.572540   C425.182495,306.784668 421.300995,307.996796 416.805573,309.548370   C414.582825,310.927765 412.780945,311.760986 411.402710,313.047882   C407.816864,316.396118 404.416992,319.943481 400.942932,323.411438   C399.935211,316.186432 398.927490,308.961456 397.870392,301.285034  z"
    />
    <path
      fill="#F0FCFD"
      opacity="1.000000"
      stroke="none"
      d=" M365.528870,317.962952   C363.313690,317.879242 361.412048,317.511627 359.553925,317.666443   C354.585449,318.080383 352.296600,316.470734 352.089355,312.101166   C351.845154,306.951447 353.486847,305.115356 358.678131,305.079926   C366.486786,305.026672 374.296295,305.100555 382.572998,305.203369   C382.366943,306.476685 381.987610,308.122742 380.969788,308.779968   C376.027832,311.971130 370.914734,314.897247 365.528870,317.962952  z"
    />
    <path
      fill="#405068"
      opacity="1.000000"
      stroke="none"
      d=" M224.004730,288.139587   C225.271866,287.170013 226.485367,286.630371 228.856400,285.576019   C234.272232,288.761780 240.909042,292.665771 247.796051,296.797119   C243.813049,296.786102 239.579803,296.547699 234.567078,296.265411   C235.702209,297.257935 236.259262,297.745026 236.815659,298.722839   C236.815002,299.213562 236.511856,299.595490 236.511856,299.595490   C233.271881,298.159363 230.031891,296.723206 226.409622,295.323669   C225.335251,293.096710 224.643188,290.833160 224.004730,288.139587  z"
    />
    <path
      fill="#A0E1F1"
      opacity="1.000000"
      stroke="none"
      d=" M400.931702,323.668579   C404.416992,319.943481 407.816864,316.396118 411.402710,313.047882   C412.780945,311.760986 414.582825,310.927765 416.541656,309.793671   C417.618744,324.630981 417.120239,325.138550 401.421143,324.969543   C400.944794,324.614990 400.932648,324.270386 400.931702,323.668579  z"
    />
    <path
      fill="#7FA6D5"
      opacity="1.000000"
      stroke="none"
      d=" M363.000000,380.000000   C362.666779,378.581970 362.333588,377.163910 361.998352,374.963593   C362.257202,369.829437 358.963226,371.296509 356.758118,370.981232   C359.302551,368.760468 361.846985,366.539703 364.699585,364.430695   C365.007782,364.542480 365.004883,365.001221 365.003113,365.401062   C365.000885,366.867279 365.000427,367.933655 364.668823,369.046875   C364.225128,370.395844 364.112579,371.697937 364.000000,373.418457   C363.666656,375.891266 363.333344,377.945618 363.000000,380.000000  z"
    />
    <path
      fill="#665970"
      opacity="1.000000"
      stroke="none"
      d=" M258.532471,328.453461   C259.071259,331.067810 259.466034,333.299500 259.860809,335.531158   C259.599335,335.609406 259.337860,335.687653 259.076385,335.765869   C257.022980,329.158356 254.969589,322.550873 252.768768,315.468964   C256.512512,319.074707 257.463806,323.566315 258.532471,328.453461  z"
    />
    <path
      fill="#7EA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M356.548279,371.119690   C358.963226,371.296509 362.257202,369.829437 361.998169,374.590668   C359.911804,375.002991 357.823639,375.005951 355.367859,374.620850   C354.999817,373.464569 354.999359,372.696350 354.998871,371.928101   C355.445404,371.704773 355.891907,371.481445 356.548279,371.119690  z"
    />
    <path
      fill="#665970"
      opacity="1.000000"
      stroke="none"
      d=" M325.804901,341.804260   C327.588287,340.654755 329.371643,339.505249 331.893738,337.879578   C331.345734,342.175598 330.960571,345.195099 330.575378,348.214600   C330.185486,348.236389 329.795563,348.258179 329.405640,348.279938   C329.405640,346.747528 329.607574,345.174103 329.308929,343.702271   C329.184784,343.090393 327.992371,342.695312 326.732971,342.218628   C326.055145,342.091858 325.930023,341.948059 325.804901,341.804260  z"
    />
    <path
      fill="#7FA6D5"
      opacity="1.000000"
      stroke="none"
      d=" M354.658844,371.934570   C354.999359,372.696350 354.999817,373.464569 355.000732,374.616394   C355.000916,375.166656 355.000610,375.333344 354.639038,375.712769   C352.876129,375.643463 351.474457,375.361420 350.057983,375.062988   C350.043182,375.046600 350.014313,375.013336 350.014313,375.013336   C351.449127,373.989227 352.883972,372.965118 354.658844,371.934570  z"
    />
    <path
      fill="#7FA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M365.004883,365.001221   C365.004883,365.001221 365.007782,364.542480 365.012634,364.313385   C365.807434,363.456421 366.597382,362.828552 367.688232,362.130981   C367.991486,363.105957 367.993866,364.150635 367.667419,365.457520   C366.560699,365.480225 365.782776,365.240723 365.004883,365.001221  z"
    />
    <path
      fill="#7FA6D5"
      opacity="1.000000"
      stroke="none"
      d=" M342.870972,379.854401   C343.863098,379.100250 344.907867,378.405304 346.368530,377.747375   C346.784363,377.784393 347.000000,378.000000 346.936035,378.357086   C345.591553,379.152954 344.311035,379.591766 343.030487,380.030579   C343.030487,380.030579 342.923645,379.913574 342.870972,379.854401  z"
    />
    <path
      fill="#665970"
      opacity="1.000000"
      stroke="none"
      d=" M325.693726,343.522430   C324.969238,344.554321 324.244781,345.586212 323.520325,346.618103   C323.254517,346.470184 322.988739,346.322235 322.722931,346.174316   C323.223114,345.162506 323.723297,344.150696 324.727478,343.160645   C325.385590,343.295746 325.539642,343.409088 325.693726,343.522430  z"
    />
    <path
      fill="#7FA6D5"
      opacity="1.000000"
      stroke="none"
      d=" M347.686890,376.682373   C348.275269,376.179138 348.863617,375.675903 349.733154,375.093018   C350.014313,375.013336 350.043182,375.046600 349.989685,375.372681   C349.293915,376.136414 348.651581,376.574066 347.928284,376.929810   C347.847290,376.847839 347.686890,376.682343 347.686890,376.682373  z"
    />
    <path
      fill="#655A71"
      opacity="1.000000"
      stroke="none"
      d=" M383.965454,350.595306   C383.588470,350.986206 383.177460,351.008606 382.454620,350.995911   C382.524994,350.549805 382.907227,350.138824 383.557373,349.611145   C383.860687,349.738556 383.896027,349.982697 383.965454,350.595306  z"
    />
    <path
      fill="#405068"
      opacity="1.000000"
      stroke="none"
      d=" M247.950226,297.189453   C248.153458,297.166077 248.364059,297.341003 248.675751,297.673431   C248.445496,297.772278 248.172424,297.624542 247.950226,297.189453  z"
    />
    <path
      fill="#7FA6D5"
      opacity="1.000000"
      stroke="none"
      d=" M346.680115,377.673157   C346.755371,377.290771 346.984314,377.071167 347.474792,376.792725   C347.686890,376.682343 347.847290,376.847839 347.816223,377.146118   C347.583649,377.714722 347.321960,377.899933 347.000000,378.000000   C347.000000,378.000000 346.784363,377.784393 346.680115,377.673157  z"
    />
    <path
      fill="#665970"
      opacity="1.000000"
      stroke="none"
      d=" M326.346802,342.468079   C326.383942,342.930939 326.217773,343.130890 325.854279,343.411377   C325.539642,343.409088 325.385590,343.295746 325.016479,342.992371   C324.973145,342.519623 325.144806,342.236877 325.560669,341.879181   C325.930023,341.948059 326.055145,342.091858 326.346802,342.468079  z"
    />
    <path
      fill="#405068"
      opacity="1.000000"
      stroke="none"
      d=" M236.981125,299.035095   C237.452255,299.131012 237.757263,299.405365 238.062286,299.679718   C237.709503,299.799103 237.356720,299.918488 236.757904,299.816681   C236.511856,299.595490 236.815002,299.213562 236.981125,299.035095  z"
    />
    <path
      fill="#A0E2F2"
      opacity="1.000000"
      stroke="none"
      d=" M615.944153,331.001221   C613.931458,332.368713 612.073059,334.462311 609.869202,334.930603   C606.697388,335.604645 603.274292,335.096649 599.418823,334.678223   C597.844849,330.099396 596.827637,325.931152 595.772278,321.772552   C593.633484,313.344727 588.753174,309.031921 579.811523,307.508453   C577.745361,306.508514 575.854248,305.787231 573.762512,304.695496   C572.886353,299.637085 571.287048,294.937866 575.699829,290.850983   C576.620972,289.997894 575.874634,287.344452 576.036133,285.177795   C576.706116,282.778015 577.236633,280.721191 577.830261,278.242432   C577.762146,275.417908 577.630920,273.015289 577.500427,270.625519   C569.394775,265.208801 551.365112,270.340393 552.348633,275.385284   C553.251709,276.459442 554.154419,277.532654 555.030151,278.573822   C551.276855,282.547058 552.189819,286.632904 557.431763,290.274780   C557.677002,291.365326 557.770630,292.182434 557.525696,293.006104   C556.875122,295.120819 555.869751,297.424835 556.398376,299.295349   C557.431030,302.949524 556.595032,304.839233 553.053101,306.235779   C551.423096,306.878510 550.299438,308.805542 548.782043,310.220581   C548.617920,310.290955 548.262146,310.322052 548.016174,310.006744   C545.259949,310.736908 542.749695,311.782410 539.470703,313.148071   C540.935059,314.713348 542.018921,315.871887 543.092529,317.360657   C543.027466,318.127716 542.972717,318.564514 542.528687,319.015381   C538.191956,320.848236 539.982605,323.503845 541.108521,326.390015   C541.056641,327.149841 541.009949,327.582916 540.705444,328.226379   C540.309509,329.305237 540.171326,330.173645 540.029541,331.016418   C540.025940,330.990753 540.056946,331.033569 539.664429,331.063049   C534.219971,331.728546 529.168030,332.364594 524.079468,332.533295   C524.042786,307.220245 524.042786,282.374512 524.042786,256.895447   C531.814636,256.895447 538.914734,256.895447 546.481323,256.930054   C559.966064,257.009125 572.984253,257.053589 586.018372,257.494995   C588.474976,260.893250 592.672241,260.908722 596.387573,257.795593   C598.496521,257.471313 600.249573,257.280212 602.018494,257.489319   C604.192200,262.123352 608.074463,259.027893 611.312744,259.864014   C612.747864,258.856689 613.870239,257.984192 615.273376,257.097626   C615.739929,257.108337 615.925659,257.133118 616.111328,257.157898   C616.120544,257.861298 616.129761,258.564728 615.935303,259.711578   C615.880310,260.417999 616.028992,260.680939 616.177612,260.943909   C616.419800,261.544769 616.874756,262.146118 616.873474,262.746460   C616.827759,283.622833 616.739136,304.499115 616.157043,325.788391   C615.438293,326.467529 615.219177,326.733765 614.642334,327.037628   C610.167114,328.713196 606.049500,330.351166 601.428528,332.189362   C602.033752,332.541016 603.406128,334.031219 604.501709,333.849823   C608.367065,333.209778 612.137634,331.996857 615.944153,331.001221  z"
    />
    <path
      fill="#9FE1F1"
      opacity="1.000000"
      stroke="none"
      d=" M524.041748,176.961868   C552.146729,176.950928 580.251770,176.928177 608.356750,176.939545   C613.623291,176.941666 616.844421,179.549301 616.856689,184.488022   C616.914551,207.761780 616.770691,231.036057 615.984192,254.661224   C610.271790,255.021606 605.261353,255.229263 600.284119,254.913589   C598.876831,254.824341 596.800598,253.483902 596.347595,252.238449   C594.598450,247.429916 593.381775,242.427734 592.245178,237.240631   C597.631470,227.658981 596.952087,222.313568 590.256348,214.403595   C587.928040,211.653046 586.234558,208.338547 584.429626,205.179642   C582.868164,202.446838 581.772766,199.434464 580.093872,196.784836   C576.785034,191.562729 569.389648,189.359055 562.289368,190.964294   C556.162109,192.349533 554.416443,197.112366 554.448425,202.215851   C554.503113,210.961502 555.438049,219.701645 555.752747,228.646591   C553.857727,230.813965 551.389465,232.535629 550.724060,234.789566   C548.766785,241.418869 547.525085,248.259399 545.534302,255.014023   C538.165466,255.010803 531.265442,255.010803 524.041748,255.010803   C524.041748,228.425171 524.041748,202.693527 524.041748,176.961868  z"
    />
    <path
      fill="#A0E1F1"
      opacity="1.000000"
      stroke="none"
      d=" M429.066650,306.078613   C437.632111,302.045959 444.966675,297.007294 450.410645,289.651276   C450.121826,289.183929 449.832977,288.716614 449.544159,288.249268   C447.657288,288.825775 445.770447,289.402313 442.545319,290.387726   C445.690125,287.865204 447.751526,286.211670 449.266052,284.996796   C447.726379,277.482819 443.660675,277.919434 438.576447,280.585083   C439.938904,279.433258 441.301361,278.281403 442.676208,277.119080   C439.832733,274.183197 439.832733,274.183197 430.238892,278.841675   C429.674713,271.829559 429.464813,264.740570 429.783386,257.271088   C456.536896,256.897064 482.761932,256.903473 509.452698,256.945923   C513.825134,256.981934 517.731812,256.981934 522.003174,256.981934   C522.003174,259.996094 521.996582,262.136932 522.004089,264.277710   C522.087402,288.036957 522.173035,311.796234 522.257996,335.555481   C516.719360,335.619781 511.180695,335.684052 505.228760,335.279877   C502.922729,326.831604 501.850220,318.533417 496.056793,311.701843   C496.221649,310.337921 496.028137,309.190552 496.477142,308.415344   C500.624786,301.254730 500.324249,298.329742 493.960968,293.485962   C490.180023,290.607880 487.999298,287.311890 487.112579,282.501312   C485.867889,275.748810 479.817596,272.289032 472.740173,273.344513   C464.971405,274.503143 462.400208,277.701996 462.784210,285.731079   C462.988220,289.995697 466.343964,302.377808 467.948303,306.020447   C466.755951,306.722473 465.863800,307.297455 464.623474,307.954437   C462.530701,309.471069 459.700958,310.617218 459.229736,312.390228   C457.208557,319.995056 455.881561,327.784363 454.301575,335.506439   C448.657074,335.638000 443.005920,335.997772 437.369965,335.833893   C432.219269,335.684174 429.272797,332.072754 429.124908,326.048218   C428.965729,319.563843 429.076385,313.072845 429.066650,306.078613  z"
    />
    <path
      fill="#FAFDFD"
      opacity="1.000000"
      stroke="none"
      d=" M508.986938,256.909882   C482.761932,256.903473 456.536896,256.897064 429.893280,256.795898   C429.353546,256.405640 429.319275,256.100281 429.825439,255.461517   C433.849030,255.083618 437.419006,255.029388 441.434021,255.000977   C444.253571,254.995392 446.628113,254.963989 449.328918,254.930054   C450.069214,254.286682 450.483246,253.645813 450.985870,252.612183   C451.412292,250.450165 451.799042,248.688614 452.080048,246.910370   C454.091431,234.181488 456.616943,230.901016 466.307922,228.979660   C466.873474,229.411377 467.418610,229.887985 467.329468,230.110397   C464.384766,237.458862 466.649658,244.645050 468.124573,251.801712   C468.373993,253.011993 470.013977,253.935684 471.448242,255.069412   C474.246216,255.092987 476.607452,255.038956 479.342499,254.986313   C480.518677,254.531586 481.836365,254.241760 482.045380,253.594162   C484.790710,245.086624 487.379608,236.528610 490.408997,227.986450   C496.539917,229.291763 503.089172,229.711365 505.144714,236.568359   C506.933441,242.535278 507.781708,248.784088 509.032471,255.242218   C509.008606,256.020691 508.997772,256.465271 508.986938,256.909882  z"
    />
    <path
      fill="#FAFDFD"
      opacity="1.000000"
      stroke="none"
      d=" M591.966736,237.497696   C593.381775,242.427734 594.598450,247.429916 596.347595,252.238449   C596.800598,253.483902 598.876831,254.824341 600.284119,254.913589   C605.261353,255.229263 610.271790,255.021606 615.762146,255.006470   C616.265320,255.483871 616.276001,255.967102 616.198975,256.804138   C615.925659,257.133118 615.739929,257.108337 614.875977,257.051727   C613.131836,257.043030 612.065918,257.066132 610.631348,257.209625   C607.509338,257.249725 604.755981,257.169403 602.002686,257.089111   C600.249573,257.280212 598.496521,257.471313 596.103027,257.501343   C592.309204,257.259552 589.155823,257.178802 586.002441,257.098053   C572.984253,257.053589 559.966064,257.009125 546.476379,256.617889   C546.004333,255.853165 546.003784,255.435196 546.003174,255.017242   C547.525085,248.259399 548.766785,241.418869 550.724060,234.789566   C551.389465,232.535629 553.857727,230.813965 556.131470,228.567505   C557.499451,228.053604 558.237976,227.821274 558.866333,228.001007   C558.189453,235.290466 557.360352,242.162704 557.225769,249.048508   C557.188416,250.962357 559.208679,252.916412 560.672241,254.957596   C562.393372,255.050156 563.727112,255.037140 565.431519,255.020218   C566.882874,253.756302 568.231384,252.640335 568.999756,251.212296   C573.174927,243.453186 577.206909,235.617081 581.613403,227.897888   C585.281311,231.158096 588.624023,234.327896 591.966736,237.497696  z"
    />
    <path
      fill="#A0E1F1"
      opacity="1.000000"
      stroke="none"
      d=" M430.834106,180.881592   C432.127014,176.675110 435.605469,176.935577 438.938110,176.934937   C466.302765,176.929718 493.667450,176.931580 521.507202,177.354309   C521.956787,178.854218 521.931274,179.931137 521.519287,181.105347   C520.760681,181.886398 520.065735,182.569077 520.063477,183.254013   C520.000427,202.580719 519.971985,221.907852 520.084778,241.234039   C520.092102,242.483475 521.276733,243.726028 521.943298,245.427155   C521.982483,247.683136 521.852600,249.497757 522.032166,251.281219   C522.349976,254.435806 520.905823,255.435867 518.075806,254.567474   C518.531860,251.291275 519.295837,248.365585 519.170471,245.478485   C519.084167,243.487564 517.659546,241.583542 517.034851,239.577805   C516.556763,238.042786 516.502930,236.378815 516.065247,234.827255   C515.474915,232.734558 514.121887,230.702576 514.093445,228.630859   C513.910522,215.306351 514.004883,201.978073 513.997986,188.651047   C513.994507,182.014816 513.984070,182.070786 507.329254,181.990067   C481.885895,181.681519 456.443054,181.333740 430.959045,180.970108   C430.918121,180.939606 430.834106,180.881592 430.834106,180.881592  z"
    />
    <path
      fill="#FCFDFD"
      opacity="1.000000"
      stroke="none"
      d=" M495.996460,312.091064   C501.850220,318.533417 502.922729,326.831604 504.755157,335.161560   C495.147766,335.558838 485.600677,335.605957 475.631287,335.233459   C476.736969,331.340424 478.221863,327.847351 479.802551,324.398132   C482.540649,318.423431 485.338074,312.475952 488.440186,306.651306   C491.178650,308.554047 493.587555,310.322571 495.996460,312.091064  z"
    />
    <path
      fill="#FCFDFD"
      opacity="1.000000"
      stroke="none"
      d=" M579.986572,307.787140   C588.753174,309.031921 593.633484,313.344727 595.772278,321.772552   C596.827637,325.931152 597.844849,330.099396 598.957275,334.647583   C590.034485,335.239929 581.033691,335.447937 571.554321,335.225464   C574.046021,325.792328 577.016296,316.789734 579.986572,307.787140  z"
    />
    <path
      fill="#F0FCFD"
      opacity="1.000000"
      stroke="none"
      d=" M521.905823,181.008041   C521.931274,179.931137 521.956787,178.854218 521.973389,177.372620   C522.426880,176.930313 522.889221,176.892685 523.696655,176.908463   C524.041748,202.693527 524.041748,228.425171 524.041748,255.010803   C531.265442,255.010803 538.165466,255.010803 545.534302,255.014023   C546.003784,255.435196 546.004333,255.853165 546.009888,256.583282   C538.914734,256.895447 531.814636,256.895447 524.042786,256.895447   C524.042786,282.374512 524.042786,307.220245 524.043457,332.861908   C523.939758,334.303162 523.835327,334.948486 523.730896,335.593781   C523.404907,335.675140 523.074219,335.705597 522.498413,335.620300   C522.173035,311.796234 522.087402,288.036957 522.004089,264.277710   C521.996582,262.136932 522.003174,259.996094 522.003174,256.981934   C517.731812,256.981934 513.825134,256.981934 509.452698,256.945923   C508.997772,256.465271 509.008606,256.020691 509.476990,255.275085   C512.624512,254.960876 515.314514,254.947662 518.004456,254.934448   C520.905823,255.435867 522.349976,254.435806 522.032166,251.281219   C521.852600,249.497757 521.982483,247.683136 521.976624,244.962708   C521.955505,223.031281 521.930664,202.019653 521.905823,181.008041  z"
    />
    <path
      fill="#FAFDFD"
      opacity="1.000000"
      stroke="none"
      d=" M542.917969,319.001343   C542.972717,318.564514 543.027466,318.127716 543.335938,317.146729   C545.147156,314.509094 546.704651,312.415558 548.262146,310.322052   C548.262146,310.322052 548.617920,310.290955 549.173584,310.206543   C552.154541,309.392578 554.579956,308.663025 556.968872,308.326721   C556.582581,313.573517 555.864258,318.437103 555.996338,323.277496   C556.107788,327.359222 557.206726,331.414001 557.868530,335.480713   C552.301941,335.558563 546.735413,335.636444 540.638550,335.302856   C540.091125,333.605438 540.074036,332.319519 540.056946,331.033569   C540.056946,331.033569 540.025940,330.990753 540.276428,330.795227   C540.672363,329.738434 540.817810,328.877197 540.963257,328.015961   C541.009949,327.582916 541.056641,327.149841 541.345154,326.112335   C542.030579,323.339020 542.474304,321.170197 542.917969,319.001343  z"
    />
    <path
      fill="#FAFDFD"
      opacity="1.000000"
      stroke="none"
      d=" M454.730347,335.593079   C455.881561,327.784363 457.208557,319.995056 459.229736,312.390228   C459.700958,310.617218 462.530701,309.471069 464.915192,308.234558   C465.658905,317.453644 465.762665,326.474670 465.866425,335.495697   C462.297333,335.557037 458.728241,335.618378 454.730347,335.593079  z"
    />
    <path
      fill="#405068"
      opacity="1.000000"
      stroke="none"
      d=" M568.038574,335.669220   C565.731201,335.689209 563.423828,335.709198 560.659485,335.275879   C560.730225,326.623657 561.257996,318.424744 562.100586,310.475220   C565.579529,314.232117 568.875000,312.241577 572.142639,311.374695   C570.767334,319.751312 569.402954,327.710266 568.038574,335.669220  z"
    />
    <path
      fill="#D6E4EB"
      opacity="1.000000"
      stroke="none"
      d=" M568.427612,335.719330   C569.402954,327.710266 570.767334,319.751312 572.370117,311.122589   C573.060059,308.657227 573.511597,306.861603 573.963135,305.065948   C575.854248,305.787231 577.745361,306.508514 579.811523,307.508453   C577.016296,316.789734 574.046021,325.792328 571.105408,335.131531   C570.362305,335.568573 569.589478,335.669006 568.427612,335.719330  z"
    />
    <path
      fill="#405068"
      opacity="1.000000"
      stroke="none"
      d=" M472.890320,335.660797   C471.643341,335.685516 470.396393,335.710236 468.721100,335.278442   C469.164581,327.211884 470.036377,319.601837 471.128235,312.265259   C474.174713,312.356018 477.001068,312.173340 479.756531,312.341553   C477.420532,320.348541 475.155426,328.004669 472.890320,335.660797  z"
    />
    <path
      fill="#A0E1F1"
      opacity="1.000000"
      stroke="none"
      d=" M440.989014,254.975159   C437.419006,255.029388 433.849030,255.083618 429.867584,255.231781   C429.333923,237.784698 429.085419,220.243195 429.151398,202.702866   C429.178009,195.629044 429.893005,188.557816 430.564423,181.183502   C430.834106,180.881592 430.918121,180.939606 430.959045,181.394928   C431.000000,205.559402 431.000000,229.268555 431.000000,251.663086   C435.056152,253.007996 438.022583,253.991577 440.989014,254.975159  z"
    />
    <path
      fill="#D6E4EB"
      opacity="1.000000"
      stroke="none"
      d=" M473.273438,335.707825   C475.155426,328.004669 477.420532,320.348541 479.879395,312.003418   C481.075226,308.625458 482.077271,305.936523 483.378296,303.319885   C485.155060,304.433777 486.632812,305.475433 488.110596,306.517059   C485.338074,312.475952 482.540649,318.423431 479.802551,324.398132   C478.221863,327.847351 476.736969,331.340424 475.185791,335.132385   C474.660614,335.552277 474.158569,335.653564 473.273438,335.707825  z"
    />
    <path
      fill="#D6E4EB"
      opacity="1.000000"
      stroke="none"
      d=" M561.785828,310.225830   C561.257996,318.424744 560.730225,326.623657 560.230225,335.258850   C559.720276,335.702606 559.182434,335.710052 558.256592,335.599121   C557.206726,331.414001 556.107788,327.359222 555.996338,323.277496   C555.864258,318.437103 556.582581,313.573517 557.206299,308.074341   C559.093445,307.005768 560.706665,306.582794 562.270508,306.502747   C562.075989,307.972412 561.930908,309.099121 561.785828,310.225830  z"
    />
    <path
      fill="#D6E4EB"
      opacity="1.000000"
      stroke="none"
      d=" M470.908203,311.991821   C470.036377,319.601837 469.164581,327.211884 468.347290,335.253845   C467.831390,335.701752 467.260986,335.717712 466.278503,335.614685   C465.762665,326.474670 465.658905,317.453644 465.263367,308.152527   C465.863800,307.297455 466.755951,306.722473 468.285461,306.000610   C470.236847,305.542206 471.550903,305.230713 472.795990,305.274017   C472.120789,307.749817 471.514526,309.870819 470.908203,311.991821  z"
    />
    <path
      fill="#A0E1F1"
      opacity="1.000000"
      stroke="none"
      d=" M539.664429,331.063049   C540.074036,332.319519 540.091125,333.605438 540.190857,335.263489   C535.080750,335.692596 529.888123,335.749603 524.213135,335.700195   C523.835327,334.948486 523.939758,334.303162 524.080200,333.329254   C529.168030,332.364594 534.219971,331.728546 539.664429,331.063049  z"
    />
    <path
      fill="#A0E1F1"
      opacity="1.000000"
      stroke="none"
      d=" M615.991150,330.759186   C612.137634,331.996857 608.367065,333.209778 604.501709,333.849823   C603.406128,334.031219 602.033752,332.541016 601.428528,332.189362   C606.049500,330.351166 610.167114,328.713196 614.644409,327.380219   C615.353394,328.464874 615.702698,329.244568 616.052002,330.024261   C616.052002,330.024261 616.038147,330.517181 615.991150,330.759186  z"
    />
    <path
      fill="#A1E2F1"
      opacity="1.000000"
      stroke="none"
      d=" M616.076050,329.625854   C615.702698,329.244568 615.353394,328.464874 615.002075,327.342590   C615.219177,326.733765 615.438293,326.467529 615.911560,326.123444   C616.143799,327.106171 616.121948,328.166809 616.076050,329.625854  z"
    />
    <path
      fill="#9FE1F1"
      opacity="1.000000"
      stroke="none"
      d=" M616.159912,260.700745   C616.028992,260.680939 615.880310,260.417999 615.920410,260.063049   C616.109131,259.971100 616.142151,260.457611 616.159912,260.700745  z"
    />
    <path
      fill="#221F27"
      opacity="1.000000"
      stroke="none"
      d=" M481.025909,386.595215   C480.699799,387.005005 480.349670,386.939880 479.729675,386.858704   C479.389526,375.203247 479.319214,363.563843 479.179810,351.460052   C490.763641,350.996979 502.416565,350.998291 514.868408,350.998718   C516.109680,350.955872 516.552002,350.913910 516.994385,350.871979   C517.424561,350.953766 517.854797,351.035553 518.607910,351.056854   C518.847046,353.694794 518.763184,356.393158 518.564453,359.526367   C507.513702,359.970154 496.574707,360.129242 485.643585,359.905945   C481.855011,359.828552 480.780212,361.090088 480.911865,364.748291   C481.167999,371.864136 480.996338,378.995361 481.025909,386.595215  z"
    />
    <path
      fill="#655A71"
      opacity="1.000000"
      stroke="none"
      d=" M516.951355,350.588196   C516.552002,350.913910 516.109680,350.955872 515.335571,350.955597   C515.315186,350.415009 515.626465,349.916626 515.937805,349.418274   C516.261292,349.713654 516.584839,350.009003 516.951355,350.588196  z"
    />
    <path
      fill="#655A71"
      opacity="1.000000"
      stroke="none"
      d=" M396.158142,349.990723   C396.310425,350.302368 396.239655,350.296082 396.219360,350.317383   C395.641815,349.894226 395.084534,349.449829 394.527252,349.005371   C394.759491,348.855286 395.166016,348.545837 395.197052,348.579773   C395.502350,348.913574 395.745209,349.304443 396.158142,349.990723  z"
    />
    <path
      fill="#D15947"
      opacity="1.000000"
      stroke="none"
      d=" M594.000000,353.994751   C601.980286,353.991882 609.462463,354.085022 616.940002,353.939972   C619.850464,353.883545 621.200378,354.669189 621.082214,357.846222   C620.971069,360.834229 620.722900,363.038483 616.859009,363.011169   C602.730286,362.911377 588.600098,363.037170 574.471252,362.947998   C570.146301,362.920715 569.315674,360.875366 570.837280,353.995544   C578.294922,353.995544 585.897461,353.995544 594.000000,353.994751  z"
    />
    <path
      fill="#39333D"
      opacity="1.000000"
      stroke="none"
      d=" M161.619247,464.027466   C160.423462,460.496277 159.680969,456.983734 158.791168,453.071411   C164.230850,451.176025 169.817825,449.680420 176.040192,448.014709   C177.220062,453.185272 178.349945,458.136749 179.561340,463.507172   C173.786087,463.966095 167.929306,464.006104 161.619247,464.027466  z"
    />
    <path
      fill="#F64D5A"
      opacity="1.000000"
      stroke="none"
      d=" M221.079437,398.439331   C224.348633,398.230713 227.617844,398.022095 231.167252,397.795593   C231.497910,396.332550 231.842743,394.806824 232.327744,392.660919   C235.220688,392.660919 238.139114,392.660919 241.956039,392.667816   C247.591476,392.596069 252.328415,392.517426 257.065369,392.438782   C258.172791,392.516632 259.280243,392.594482 261.051453,392.683624   C262.072205,392.644470 262.429199,392.593994 262.786194,392.543549   C263.133453,393.260590 263.779755,393.976135 263.783386,394.694916   C263.845459,406.937103 263.827911,419.179657 263.827911,431.782043   C253.104996,431.782043 242.757843,431.782043 232.154037,431.782043   C231.297318,429.504547 232.840271,425.060486 227.034821,426.150696   C225.905533,426.054321 225.491684,425.964417 225.222870,425.569031   C225.632721,424.405487 225.897507,423.547424 226.575012,422.708679   C228.548981,422.629822 230.110229,422.531647 231.714203,422.430786   C231.714203,415.217010 231.714203,408.622375 231.714203,401.701385   C230.420410,401.850006 229.321365,401.976288 227.918640,401.803833   C224.668198,401.322510 221.721436,401.139923 218.866852,400.678406   C219.665833,399.746124 220.372620,399.092712 221.079437,398.439331  z"
    />
    <path
      fill="#85B9D8"
      opacity="1.000000"
      stroke="none"
      d=" M257.049255,392.096924   C252.328415,392.517426 247.591476,392.596069 242.396729,392.550293   C241.734390,387.438354 240.076324,383.732483 234.900925,381.637726   C232.590958,380.702698 231.119720,377.695465 229.299866,374.999847   C232.555511,373.247314 235.779129,372.123657 239.002747,371.000000   C240.355347,376.169708 245.177856,376.434265 249.024078,377.793427   C254.100601,379.587250 257.218292,382.520355 257.036682,388.596985   C257.046814,389.918365 257.039978,390.836731 257.049255,392.096924  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M225.077820,425.874542   C225.491684,425.964417 225.905533,426.054321 226.625519,426.229004   C226.985031,426.985352 227.038437,427.656921 227.055283,428.663757   C225.725861,428.592590 224.432983,428.186218 223.320862,427.261658   C224.026993,426.453827 224.552399,426.164185 225.077820,425.874542  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M228.840576,437.658234   C228.312408,436.698578 227.826706,435.393768 227.655380,434.044128   C228.274185,435.103882 228.578613,436.208466 228.840576,437.658234  z"
    />
    <path
      fill="#85B9D8"
      opacity="1.000000"
      stroke="none"
      d=" M262.662781,392.407837   C262.429199,392.593994 262.072205,392.644470 261.461487,392.593262   C261.651642,392.418488 262.095520,392.345306 262.662781,392.407837  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M227.780746,431.675171   C227.577011,431.659119 227.369431,431.362793 227.148376,430.783569   C227.348907,430.798767 227.562912,431.096863 227.780746,431.675171  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M220.927078,398.053833   C220.372620,399.092712 219.665833,399.746124 218.449646,400.656647   C212.191803,399.611145 208.522308,403.888275 204.075653,406.079529   C202.021835,401.200684 203.665649,397.440308 208.574387,394.287628   C201.098328,391.489594 206.184753,380.027283 196.251083,378.972473   C196.237457,369.814728 188.732071,363.718079 184.772278,355.899414   C181.082977,348.614807 179.928314,340.879730 178.197632,333.185638   C178.139984,332.929321 178.818024,332.507477 179.690033,332.321045   C180.496017,329.337006 180.940369,326.197876 180.997803,323.051697   C181.117966,316.468262 181.034210,309.881104 181.034210,303.295441   C180.688858,303.295074 180.343521,303.294678 179.998169,303.294281   C179.702408,309.194702 179.406631,315.095093 179.110855,320.995514   C173.789307,318.328369 177.041580,314.112518 177.438370,309.760132   C174.554199,309.546844 171.858231,309.347473 168.978516,308.805542   C174.926239,304.879272 181.057678,301.295593 187.558777,297.720764   C190.109390,303.162842 192.290344,308.596069 194.715637,314.629944   C195.306381,315.499268 195.652802,315.767975 195.999222,316.036682   C195.999222,316.036682 196.003647,315.998260 195.984833,315.999939   C196.900482,319.290985 197.778793,322.597473 198.778351,325.866913   C206.096817,349.804901 213.439606,373.735474 220.927078,398.053833  M186.970261,351.563965   C188.067505,353.473663 189.164749,355.383362 190.261993,357.293030   C190.582718,357.115143 190.903442,356.937225 191.224182,356.759308   C188.673126,351.534576 186.122070,346.309845 183.571030,341.085114   C183.167862,341.269440 182.764694,341.453766 182.361526,341.638092   C183.806152,344.714294 185.250763,347.790497 186.970261,351.563965  M192.096848,361.130798   C192.568344,361.998413 193.039856,362.866028 193.511368,363.733612   C193.881927,362.482849 193.676544,361.430237 193.283218,360.453308   C193.206497,360.262756 192.399643,360.366180 192.096848,361.130798  M191.499985,358.000000   C191.366653,358.199982 191.233322,358.399994 191.100006,358.600006   C191.400009,358.566681 191.699997,358.533325 191.499985,358.000000  z"
    />
    <path
      fill="#F49F88"
      opacity="1.000000"
      stroke="none"
      d=" M204.057190,406.062378   C208.522308,403.888275 212.191803,399.611145 218.357452,400.935547   C221.721436,401.139923 224.668198,401.322510 228.064148,402.148773   C228.509567,404.197815 228.661758,405.624390 228.474289,407.004852   C227.763214,412.241119 226.942184,417.462433 226.162277,422.689362   C225.897507,423.547424 225.632721,424.405487 225.222870,425.569031   C224.552399,426.164185 224.026993,426.453827 223.250336,426.908203   C221.787903,427.496948 220.576691,427.920929 218.765182,428.619812   C214.320236,430.227875 210.475601,431.561096 206.220215,433.036713   C205.732422,429.782104 205.299194,426.891479 204.865952,424.000854   C204.835480,422.924103 204.805008,421.847321 204.733582,420.016327   C204.426666,417.507721 204.160721,415.753326 203.894791,413.998962   C203.885239,413.249084 203.875687,412.499176 203.840698,410.969879   C203.903244,408.806091 203.991211,407.421692 204.079193,406.037323   C204.079193,406.037323 204.038727,406.045197 204.057190,406.062378  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M203.805801,406.117340   C203.991211,407.421692 203.903244,408.806091 203.754272,410.603760   C196.551880,411.261475 189.278030,412.428864 182.315186,411.429443   C177.584396,410.750397 173.654434,410.879761 169.479279,412.777405   C169.022980,412.984802 167.949692,411.834747 167.177124,410.678741   C166.881851,407.709656 166.572021,405.376221 166.262177,403.042755   C170.716385,403.109985 171.297714,405.844055 170.340103,409.517670   C175.140594,411.205780 178.586075,402.003296 183.500214,408.263885   C186.864532,405.756256 189.806030,401.395020 194.065674,405.576202   C196.789429,406.108612 198.582214,399.608032 200.645126,405.842865   C200.197311,406.768005 200.004425,407.256561 199.811554,407.745117   C200.350143,407.493011 200.888748,407.240875 201.427338,406.988770   C202.129028,406.724945 202.830719,406.461151 203.805801,406.117340  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M163.000610,385.000000   C160.063080,381.167542 160.397064,376.455414 162.491241,372.087067   C164.059769,368.815186 163.991028,364.795563 165.108109,361.252930   C165.597244,359.701721 167.225754,358.509796 168.336884,357.154755   C169.177536,358.727234 170.861649,360.385529 170.711929,361.857239   C170.083710,368.032257 169.158447,374.209381 167.767395,380.253510   C167.381104,381.931915 165.017548,383.155243 163.280563,384.793701   C163.000000,385.000000 163.000610,385.000000 163.000610,385.000000  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M149.113312,420.884857   C145.767197,420.075134 142.978851,418.852966 145.055023,414.262421   C149.170517,413.308075 152.634766,412.606812 156.099014,411.905548   C156.079681,411.622192 156.060364,411.338867 156.041046,411.055511   C153.361862,411.055511 150.682693,411.055511 148.003510,411.055511   C148.589508,410.056580 149.088165,408.258606 149.775101,408.183533   C156.019135,407.501099 156.288666,402.841156 157.098526,398.195618   C157.465317,396.091522 158.901276,394.173828 160.260757,392.627869   C159.446609,399.012604 158.223892,404.941040 157.002609,410.862457   C160.394516,410.862457 163.194748,410.862457 165.994980,410.862457   C164.620743,411.586609 163.257263,412.332092 161.870117,413.030609   C158.710663,414.621613 153.801041,413.839630 153.446121,419.291016   C153.428955,419.554657 152.348114,419.749023 151.367325,419.664246   C151.167404,418.740509 151.362762,418.128113 151.738373,417.337036   C152.009247,416.834015 152.099854,416.509705 152.482391,416.028625   C152.703506,415.496735 152.632675,415.121582 152.561859,414.746429   C152.243073,415.026947 151.924286,415.307465 151.382767,415.730164   C151.058899,416.201538 150.957764,416.530670 150.583832,417.039459   C149.911774,418.441010 149.512527,419.662933 149.113312,420.884857  z"
    />
    <path
      fill="#39333D"
      opacity="1.000000"
      stroke="none"
      d=" M166.191650,410.721252   C163.194748,410.862457 160.394516,410.862457 157.002609,410.862457   C158.223892,404.941040 159.446609,399.012604 160.673859,392.664948   C160.935562,390.996613 161.192719,389.747528 161.744751,388.083893   C163.402390,392.491821 164.765137,397.314301 166.127869,402.136780   C166.127869,402.136780 166.054047,402.610687 166.158112,402.826721   C166.572021,405.376221 166.881851,407.709656 167.031403,410.330170   C166.871109,410.617218 166.388321,410.580048 166.191650,410.721252  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M204.485565,424.103119   C205.299194,426.891479 205.732422,429.782104 206.220215,433.036713   C210.475601,431.561096 214.320236,430.227875 218.546387,428.859100   C218.080063,430.776245 217.594543,434.087646 216.316818,434.428375   C212.395065,435.474213 208.169678,435.381409 204.062347,435.731262   C204.076630,431.889313 204.090912,428.047333 204.485565,424.103119  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M166.530197,401.991089   C164.765137,397.314301 163.402390,392.491821 161.727448,387.765869   C161.687500,386.964783 161.959793,386.067108 162.616333,385.084717   C163.000610,385.000000 163.000000,385.000000 162.999695,385.000000   C166.704208,386.881409 168.982880,389.176605 167.308472,393.946411   C166.471863,396.329712 167.014008,399.197021 166.530197,401.991089  z"
    />
    <path
      fill="#665970"
      opacity="1.000000"
      stroke="none"
      d=" M179.231201,321.417297   C179.406631,315.095093 179.702408,309.194702 179.998169,303.294281   C180.343521,303.294678 180.688858,303.295074 181.034210,303.295441   C181.034210,309.881104 181.117966,316.468262 180.997803,323.051697   C180.940369,326.197876 180.496017,329.337006 180.043640,332.238708   C179.690750,328.611786 179.521149,325.225403 179.231201,321.417297  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M137.711716,331.792725   C140.347198,328.397308 143.413681,325.075470 146.749771,321.616211   C147.324127,325.802826 142.350037,331.623596 137.711716,331.792725  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M157.009369,315.889038   C159.370605,314.070038 162.206558,312.293640 165.391785,310.413208   C165.975189,316.112732 165.975189,316.112732 157.009369,315.889038  z"
    />
    <path
      fill="#5F524B"
      opacity="1.000000"
      stroke="none"
      d=" M147.788177,411.304260   C150.682693,411.055511 153.361862,411.055511 156.041046,411.055511   C156.060364,411.338867 156.079681,411.622192 156.099014,411.905548   C152.634766,412.606812 149.170517,413.308075 145.316040,414.014282   C145.808136,413.197144 146.690475,412.375092 147.788177,411.304260  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M147.948944,321.354279   C149.405167,319.928375 151.273132,318.754852 153.474716,317.473602   C154.772064,322.350159 151.975388,322.503815 147.948944,321.354279  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M203.560638,414.062805   C204.160721,415.753326 204.426666,417.507721 204.612518,419.629456   C204.097092,418.040100 203.661789,416.083374 203.560638,414.062805  z"
    />
    <path
      fill="#5F524B"
      opacity="1.000000"
      stroke="none"
      d=" M151.558121,417.515747   C151.362762,418.128113 151.167404,418.740509 150.973145,419.675598   C150.974258,419.998291 150.767593,420.147034 150.502594,420.371979   C149.854263,420.684845 149.470917,420.772766 149.087570,420.860657   C149.087570,420.860687 149.065201,420.908600 149.089249,420.896729   C149.512527,419.662933 149.911774,418.441010 150.754791,417.208130   C151.198578,417.197205 151.558121,417.515747 151.558121,417.515747  z"
    />
    <path
      fill="#FBFBFB"
      opacity="1.000000"
      stroke="none"
      d=" M149.105316,421.191833   C149.470917,420.772766 149.854263,420.684845 150.520294,420.498047   C150.638947,421.065125 150.474930,421.731079 150.310898,422.397003   C149.914963,422.105682 149.519012,421.814331 149.105316,421.191833  z"
    />
    <path
      fill="#F49F88"
      opacity="1.000000"
      stroke="none"
      d=" M201.266815,406.795898   C200.888748,407.240875 200.350143,407.493011 199.811554,407.745117   C200.004425,407.256561 200.197311,406.768005 200.657471,406.207306   C200.985260,406.291107 201.045776,406.447052 201.266815,406.795898  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M102.558746,332.902740   C102.021957,332.522766 101.823387,332.291840 101.389999,331.972351   C103.079529,330.939087 104.946373,329.304047 106.842293,329.269592   C111.534065,329.184387 116.239151,329.831604 120.957092,330.566406   C115.109192,332.673096 109.388527,335.426849 102.558746,332.902740  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M106.000877,283.993103   C109.848320,290.417023 107.652779,296.710175 105.284103,303.014435   C105.064507,296.735382 100.481956,290.527161 105.646515,284.083923   C106.014877,283.991882 106.000153,284.001007 106.000877,283.993103  z"
    />
    <path
      fill="#DDF2FB"
      opacity="1.000000"
      stroke="none"
      d=" M131.130463,306.612976   C131.822403,306.253235 132.403458,306.254913 133.244232,306.375458   C135.693619,313.574219 131.885971,319.197693 128.901764,325.372101   C129.542847,319.457764 130.281204,313.216095 131.130463,306.612976  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M98.957909,321.528748   C96.439819,321.045441 94.307602,320.466980 92.175392,319.888489   C92.231438,319.355774 92.287491,318.823090 92.343544,318.290375   C98.485870,315.565399 104.808037,317.371521 111.251358,319.179993   C107.282166,319.931183 103.312981,320.682373 98.957909,321.528748  z"
    />
    <path
      fill="#DDF2FB"
      opacity="1.000000"
      stroke="none"
      d=" M120.191742,306.841614   C119.604698,308.606537 119.126709,309.982147 118.648712,311.357758   C118.307335,311.330414 117.965950,311.303070 117.624573,311.275726   C117.624573,305.326691 117.624573,299.377655 117.624573,293.309235   C121.507950,295.644165 122.045967,298.438141 120.191742,306.841614  z"
    />
    <path
      fill="#DDF2FB"
      opacity="1.000000"
      stroke="none"
      d=" M129.549683,345.080841   C129.770187,345.513947 129.520798,345.964264 129.167160,346.649109   C124.705437,347.595642 120.367126,348.552216 115.980789,348.895782   C114.294945,349.027863 112.499702,347.763428 110.754311,347.135315   C110.895981,346.456238 111.037651,345.777161 111.179329,345.098083   C117.146141,345.098083 123.112961,345.098083 129.549683,345.080841  z"
    />
    <path
      fill="#DAEFF9"
      opacity="1.000000"
      stroke="none"
      d=" M88.001266,310.007080   C88.866005,309.049377 89.703247,307.290588 90.600060,307.259674   C93.687531,307.153229 96.795830,307.650726 99.960815,309.115784   C96.268738,309.403229 92.576660,309.690674 88.433929,309.990356   C87.983269,310.002594 88.001083,309.998047 88.001266,310.007080  z"
    />
    <path
      fill="#65ABD2"
      opacity="1.000000"
      stroke="none"
      d=" M195.972687,315.700806   C195.652802,315.767975 195.306381,315.499268 194.947113,314.864166   C195.271561,314.786804 195.608856,315.075867 195.972687,315.700806  z"
    />
    <path
      fill="#221F27"
      opacity="1.000000"
      stroke="none"
      d=" M518.508789,381.495300   C517.938782,379.505005 517.148743,377.069153 517.093994,374.616882   C517.017944,371.211243 517.493469,367.793304 518.065186,364.219757   C518.470581,369.720062 518.543640,375.381226 518.508789,381.495300  z"
    />
    <path
      fill="#221F27"
      opacity="1.000000"
      stroke="none"
      d=" M518.568237,386.588074   C518.306702,386.046753 518.096436,385.142151 518.148254,384.146271   C518.480042,384.778290 518.549805,385.501526 518.568237,386.588074  z"
    />
    <path
      fill="#7A9CBF"
      opacity="1.000000"
      stroke="none"
      d=" M592.150024,93.079086   C585.992859,83.005127 579.934814,73.292992 573.455750,62.905838   C575.065979,62.013401 576.507019,61.214710 577.948120,60.416023   C578.368347,61.663998 578.728333,62.936798 579.228760,64.151764   C579.601501,65.056808 580.115967,65.911880 580.635681,66.746613   C585.023499,73.793846 589.555969,80.755409 593.761353,87.909462   C595.408813,90.712105 597.260559,91.217560 600.303101,90.700142   C607.329407,89.505241 614.418762,88.659500 621.502869,87.849892   C622.499146,87.736031 623.609436,88.620667 624.666992,89.043121   C623.798645,89.960617 623.040649,91.524422 622.044678,91.694466   C613.228088,93.199783 604.380310,94.544197 595.507568,95.666687   C594.531006,95.790230 593.340515,94.223610 592.150024,93.079086  z"
    />
    <path
      fill="#7EA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M365.003113,365.401062   C365.782776,365.240723 366.560699,365.480225 367.619720,365.846954   C367.974243,371.670563 368.047668,377.366913 367.738281,383.585083   C367.237366,385.737915 367.119293,387.368958 367.001221,389.000000   C366.226349,389.332184 365.451447,389.664337 364.338287,389.998260   C359.109528,389.793884 354.219879,389.564392 349.328064,389.397491   C348.061279,389.354248 346.787811,389.506927 345.258698,388.951477   C345.000000,387.888885 345.000000,387.444458 345.000000,387.000000   C347.564697,386.666656 350.161835,385.902863 352.687012,386.093353   C357.352692,386.445312 361.240509,385.983093 362.833221,380.329346   C363.333344,377.945618 363.666656,375.891266 364.272583,373.187103   C364.696777,371.358215 364.848389,370.179108 365.000000,369.000000   C365.000427,367.933655 365.000885,366.867279 365.003113,365.401062  z"
    />
    <path
      fill="#7FA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M367.304199,388.986633   C367.119293,387.368958 367.237366,385.737915 367.705811,384.052063   C368.108490,385.365509 368.160889,386.733795 368.212280,388.510834   C368.009888,388.937500 367.808533,388.955383 367.304199,388.986633  z"
    />
    <path
      fill="#7EA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M346.936035,378.357086   C347.321960,377.899933 347.583649,377.714722 347.897217,377.228088   C348.651581,376.574066 349.293915,376.136414 350.004517,375.389038   C351.474457,375.361420 352.876129,375.643463 354.638916,375.962769   C354.805389,378.015900 354.610748,380.031799 354.279388,383.463867   C350.844543,383.214935 347.108948,382.944183 343.186523,382.336731   C343.002686,381.562073 343.005646,381.124146 343.019531,380.358398   C344.311035,379.591766 345.591553,379.152954 346.936035,378.357086  z"
    />
    <path
      fill="#7EA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M336.831665,392.088440   C336.998779,392.000000 336.999908,392.497742 336.999939,392.746552   C336.888184,392.722534 336.776337,392.449707 336.831665,392.088440  z"
    />
    <path
      fill="#7EA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M331.686768,393.212708   C331.866241,393.083282 332.133270,392.974030 332.400330,392.864807   C332.305511,392.953552 332.210724,393.042297 331.964630,393.269653   C331.813324,393.408234 331.774292,393.232910 331.686768,393.212708  z"
    />
    <path
      fill="#7FA6D5"
      opacity="1.000000"
      stroke="none"
      d=" M344.945801,386.655792   C345.000000,387.444458 345.000000,387.888885 345.000000,388.666687   C343.568420,389.189453 342.136871,389.378937 340.698334,389.569305   C340.790680,385.348175 341.438751,384.852203 344.945801,386.655792  z"
    />
    <path
      fill="#7EA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M362.780273,392.107605   C362.899628,392.322357 362.713989,392.583099 362.223755,392.890045   C362.103271,392.674622 362.288635,392.413727 362.780273,392.107605  z"
    />
    <path
      fill="#EED16D"
      opacity="1.000000"
      stroke="none"
      d=" M362.216125,196.716309   C360.335815,192.848953 361.608215,190.263947 364.896271,188.661209   C367.929718,187.182617 370.529968,188.280121 372.147552,191.020905   C373.785461,193.796036 373.318207,196.556320 370.578552,198.462524   C367.499451,200.604889 364.663757,200.260712 362.216125,196.716309  z"
    />
    <path
      fill="#A1C2E0"
      opacity="1.000000"
      stroke="none"
      d=" M361.111542,286.693268   C361.203033,282.301117 363.783173,279.900055 367.262238,280.330078   C369.341766,280.587097 371.919861,283.207825 372.785156,285.363586   C374.022491,288.446289 371.621613,290.692657 368.666290,291.568176   C364.720551,292.737091 362.455200,290.599335 361.111542,286.693268  z"
    />
    <path
      fill="#5D8FC6"
      opacity="1.000000"
      stroke="none"
      d=" M372.913757,240.767471   C370.807861,242.723282 368.903687,244.972885 366.571167,245.581909   C365.334473,245.904816 362.443451,243.659668 361.950989,242.064056   C361.397278,240.269913 362.157196,237.467148 363.380859,235.924011   C364.311066,234.750916 367.485687,233.909454 368.551697,234.609863   C370.455383,235.860641 371.521240,238.386566 372.913757,240.767471  z"
    />
    <path
      fill="#EE9A84"
      opacity="1.000000"
      stroke="none"
      d=" M364.950989,215.421722   C365.479187,219.073456 364.211670,221.602921 361.048676,222.292465   C359.397369,222.652435 356.674835,222.164261 355.796783,221.017426   C354.590546,219.441895 353.989655,216.722290 354.430237,214.789383   C354.761932,213.334152 357.354584,211.176788 358.556763,211.400055   C360.807220,211.817963 362.779114,213.735779 364.950989,215.421722  z"
    />
    <path
      fill="#977896"
      opacity="1.000000"
      stroke="none"
      d=" M353.925781,262.205322   C354.922668,258.504303 357.248413,256.239288 360.482727,257.434998   C362.431061,258.155304 364.747192,261.065491 364.741302,262.985046   C364.735535,264.878479 362.320435,267.905121 360.417877,268.419067   C356.219910,269.553162 354.082672,266.806396 353.925781,262.205322  z"
    />
    <path
      fill="#E0F3FC"
      opacity="1.000000"
      stroke="none"
      d=" M372.389862,259.994995   C370.765259,259.809235 369.588806,259.624115 367.974030,259.369995   C371.554810,256.310150 394.956146,256.182983 398.528992,259.995636   C389.965332,259.995636 381.401672,259.995636 372.389862,259.994995  z"
    />
    <path
      fill="#E1F5FE"
      opacity="1.000000"
      stroke="none"
      d=" M401.692749,188.050201   C403.405457,188.293381 404.658661,188.536880 405.911896,188.780396   C405.852966,189.289581 405.794067,189.798752 405.735138,190.307938   C395.903778,190.307938 386.072418,190.307938 376.241028,190.307938   C376.222443,189.782593 376.203857,189.257263 376.185272,188.731918   C384.454742,187.234116 392.893860,188.435394 401.692749,188.050201  z"
    />
    <path
      fill="#E1F5FD"
      opacity="1.000000"
      stroke="none"
      d=" M394.619202,213.998260   C385.640747,213.999512 377.118011,213.999512 367.980408,213.999512   C370.647217,210.723892 391.602142,209.870071 398.843994,212.474121   C397.008026,213.215942 396.041473,213.606476 394.619202,213.998260  z"
    />
    <path
      fill="#E1F5FD"
      opacity="1.000000"
      stroke="none"
      d=" M388.018219,234.050415   C394.220367,234.152863 399.927368,234.255219 405.634369,234.357590   C405.598633,235.041000 405.562866,235.724426 405.527100,236.407837   C395.800659,236.407837 386.074219,236.407837 376.347778,236.407837   C376.329681,235.756439 376.311584,235.105026 376.293488,234.453629   C380.036682,234.319199 383.779877,234.184784 388.018219,234.050415  z"
    />
    <path
      fill="#F0FCFD"
      opacity="1.000000"
      stroke="none"
      d=" M406.021698,283.011047   C396.240387,283.018860 386.433228,283.018860 376.626099,283.018860   C376.593536,282.443024 376.560974,281.867188 376.528412,281.291351   C378.023468,281.166107 379.517944,280.941040 381.013641,280.932770   C387.824615,280.895142 394.637421,280.843018 401.445892,280.979675   C402.917725,281.009216 404.374298,281.796783 405.929871,282.643311   C406.021851,283.051453 405.995880,283.003265 406.021698,283.011047  z"
    />
    <path
      fill="#F0FCFD"
      opacity="1.000000"
      stroke="none"
      d=" M371.486389,261.959534   C379.074554,261.957764 386.217316,261.957764 393.360107,261.957764   C393.350891,262.456329 393.341705,262.954895 393.332489,263.453461   C385.126740,263.453461 376.920990,263.453461 368.715210,263.453461   C368.667480,263.173615 368.619751,262.893738 368.572021,262.613892   C369.395020,262.396362 370.217987,262.178864 371.486389,261.959534  z"
    />
    <path
      fill="#F0FCFD"
      opacity="1.000000"
      stroke="none"
      d=" M400.952057,194.644928   C392.617035,194.868118 384.618652,194.868118 376.620270,194.868118   C376.579712,194.369781 376.539154,193.871429 376.498566,193.373093   C377.964752,193.234299 379.429932,192.988998 380.897247,192.975693   C386.369873,192.926041 391.845947,192.858521 397.314301,193.017654   C398.651581,193.056580 399.964539,193.931290 400.952057,194.644928  z"
    />
    <path
      fill="#F0FCFD"
      opacity="1.000000"
      stroke="none"
      d=" M373.283722,215.966568   C380.283905,215.966446 386.818726,215.966446 393.353577,215.966446   C393.355591,216.423050 393.357605,216.879639 393.359650,217.336243   C385.145477,217.336243 376.931335,217.336243 368.717194,217.336243   C368.656586,217.037628 368.596008,216.738998 368.535431,216.440384   C369.963074,216.282486 371.390747,216.124588 373.283722,215.966568  z"
    />
    <path
      fill="#F0FCFD"
      opacity="1.000000"
      stroke="none"
      d=" M399.383118,238.969299   C400.019958,239.619934 400.231476,240.256516 400.443024,240.893112   C392.496002,240.893112 384.548981,240.893112 376.601990,240.893112   C376.598785,240.247162 376.595612,239.601227 376.592407,238.955276   C384.047546,238.955276 391.502655,238.955276 399.383118,238.969299  z"
    />
    <path
      fill="#F0FCFD"
      opacity="1.000000"
      stroke="none"
      d=" M377.712494,286.951843   C377.621857,286.256195 377.940430,285.077911 378.275116,285.073303   C385.884277,284.968994 393.495209,284.993011 401.135162,285.697693   C393.567352,287.785034 385.798828,286.684723 377.712494,286.951843  z"
    />
    <path
      fill="#F0FCFD"
      opacity="1.000000"
      stroke="none"
      d=" M396.916992,289.270538   C396.908051,290.153748 396.526611,291.516968 396.178223,291.508575   C389.658081,291.351562 383.141876,291.031769 376.624847,290.746063   C376.605316,290.201385 376.585815,289.656708 376.566284,289.112030   C383.230804,289.112030 389.895325,289.112030 396.916992,289.270538  z"
    />
    <path
      fill="#F0FCFD"
      opacity="1.000000"
      stroke="none"
      d=" M384.745728,268.079102   C379.026031,268.079346 373.771057,268.079346 368.516083,268.079346   C368.540436,267.549713 368.564789,267.020081 368.589142,266.490448   C375.505707,266.490448 382.422241,266.490448 389.338776,266.490448   C389.396454,266.865753 389.454102,267.241089 389.511749,267.616394   C388.077972,267.770538 386.644226,267.924713 384.745728,268.079102  z"
    />
    <path
      fill="#F0FCFD"
      opacity="1.000000"
      stroke="none"
      d=" M384.099304,197.002838   C388.816986,197.002838 393.056427,197.002838 397.295837,197.002838   C397.308838,197.446625 397.321838,197.890411 397.334839,198.334198   C390.451508,198.334198 383.568176,198.334198 376.684845,198.334198   C376.638123,198.023926 376.591400,197.713638 376.544678,197.403366   C378.903473,197.269852 381.262238,197.136337 384.099304,197.002838  z"
    />
    <path
      fill="#F0FCFD"
      opacity="1.000000"
      stroke="none"
      d=" M389.384766,221.043457   C382.488678,221.451126 375.600555,221.451126 368.712402,221.451126   C368.706696,221.179352 368.700958,220.907578 368.695251,220.635803   C375.594391,220.635803 382.493561,220.635803 389.384766,221.043457  z"
    />
    <path
      fill="#F0FCFD"
      opacity="1.000000"
      stroke="none"
      d=" M381.270874,245.076294   C379.405487,244.969315 378.002350,244.862442 376.599182,244.755569   C376.612366,244.389481 376.625549,244.023407 376.638733,243.657318   C383.459930,243.657318 390.281158,243.657318 397.102356,243.657318   C397.112885,244.130341 397.123413,244.603363 397.133942,245.076385   C392.000366,245.076385 386.866760,245.076385 381.270874,245.076294  z"
    />
    <path
      fill="#77B6D8"
      opacity="1.000000"
      stroke="none"
      d=" M239.004639,370.571686   C235.779129,372.123657 232.555511,373.247314 229.164734,374.687012   C228.444443,374.198151 227.492996,373.435486 227.402435,372.581543   C226.787537,366.783569 223.388702,364.190308 217.945724,362.733185   C212.309540,361.224396 209.240219,355.446228 210.079834,349.413757   C210.235733,348.293640 211.032547,346.906708 211.955002,346.377197   C212.548370,346.036652 213.958939,346.952301 214.912613,347.471375   C215.465973,347.772552 216.013580,348.326202 216.267502,348.897827   C218.551712,354.039886 222.903992,355.638000 228.073746,356.623535   C236.574493,358.244080 238.966736,361.527191 239.004639,370.571686  z"
    />
    <path
      fill="#7FA6D6"
      opacity="1.000000"
      stroke="none"
      d=" M364.668823,369.046875   C364.848389,370.179108 364.696777,371.358215 364.272583,372.768677   C364.112579,371.697937 364.225128,370.395844 364.668823,369.046875  z"
    />
    <path
      fill="#F39D85"
      opacity="1.000000"
      stroke="none"
      d=" M562.100586,310.475220   C561.930908,309.099121 562.075989,307.972412 562.514648,306.264862   C563.455994,304.029358 564.103821,302.374695 564.922485,300.283752   C559.327942,300.706360 558.867920,296.615448 557.864258,292.999512   C557.770630,292.182434 557.677002,291.365326 557.438232,289.814819   C557.192749,286.588806 557.092468,284.096222 557.203918,281.284149   C561.514709,280.320465 565.613770,279.676270 569.575684,279.053619   C570.161377,282.654388 570.627136,285.517761 571.023254,287.953003   C572.675842,287.128204 574.286255,286.324463 575.896729,285.520691   C575.874634,287.344452 576.620972,289.997894 575.699829,290.850983   C571.287048,294.937866 572.886353,299.637085 573.762573,304.695496   C573.511597,306.861603 573.060059,308.657227 572.381042,310.704956   C568.875000,312.241577 565.579529,314.232117 562.100586,310.475220  z"
    />
    <path
      fill="#2F3B4E"
      opacity="1.000000"
      stroke="none"
      d=" M576.036133,285.177795   C574.286255,286.324463 572.675842,287.128204 571.023254,287.953003   C570.627136,285.517761 570.161377,282.654388 569.575684,279.053619   C565.613770,279.676270 561.514709,280.320465 556.975708,281.017090   C555.581604,275.529541 556.968445,273.368042 562.287903,272.401764   C568.737915,271.230042 574.394409,272.162170 577.767212,278.664337   C577.236633,280.721191 576.706116,282.778015 576.036133,285.177795  z"
    />
    <path
      fill="#A0E1F1"
      opacity="1.000000"
      stroke="none"
      d=" M577.830261,278.242432   C574.394409,272.162170 568.737915,271.230042 562.287903,272.401764   C556.968445,273.368042 555.581604,275.529541 556.763916,281.336609   C557.092468,284.096222 557.192749,286.588806 557.286560,289.541351   C552.189819,286.632904 551.276855,282.547058 555.030151,278.573822   C554.154419,277.532654 553.251709,276.459442 552.348633,275.385284   C551.365112,270.340393 569.394775,265.208801 577.500427,270.625519   C577.630920,273.015289 577.762146,275.417908 577.830261,278.242432  z"
    />
    <path
      fill="#A0E1F1"
      opacity="1.000000"
      stroke="none"
      d=" M557.525757,293.006104   C558.867920,296.615448 559.327942,300.706360 564.922485,300.283752   C564.103821,302.374695 563.455994,304.029358 562.564026,305.921906   C560.706665,306.582794 559.093445,307.005768 557.242798,307.681122   C554.579956,308.663025 552.154541,309.392578 549.337646,310.136169   C550.299438,308.805542 551.423096,306.878510 553.053101,306.235779   C556.595032,304.839233 557.431030,302.949524 556.398376,299.295349   C555.869751,297.424835 556.875122,295.120819 557.525757,293.006104  z"
    />
    <path
      fill="#A0E1F1"
      opacity="1.000000"
      stroke="none"
      d=" M548.016174,310.006744   C546.704651,312.415558 545.147156,314.509094 543.346191,316.816528   C542.018921,315.871887 540.935059,314.713348 539.470703,313.148071   C542.749695,311.782410 545.259949,310.736908 548.016174,310.006744  z"
    />
    <path
      fill="#A0E1F1"
      opacity="1.000000"
      stroke="none"
      d=" M586.018372,257.494995   C589.155823,257.178802 592.309204,257.259552 595.747192,257.634521   C592.672241,260.908722 588.474976,260.893250 586.018372,257.494995  z"
    />
    <path
      fill="#A0E1F1"
      opacity="1.000000"
      stroke="none"
      d=" M602.018494,257.489288   C604.755981,257.169403 607.509338,257.249725 610.631348,257.572144   C611.000000,258.542450 611.000000,259.270660 611.000000,259.998871   C608.074463,259.027893 604.192200,262.123352 602.018494,257.489288  z"
    />
    <path
      fill="#A0E1F1"
      opacity="1.000000"
      stroke="none"
      d=" M542.528687,319.015381   C542.474304,321.170197 542.030579,323.339020 541.350281,325.785583   C539.982605,323.503845 538.191956,320.848236 542.528687,319.015381  z"
    />
    <path
      fill="#9FE1F1"
      opacity="1.000000"
      stroke="none"
      d=" M611.312744,259.864014   C611.000000,259.270660 611.000000,258.542450 611.000000,257.451721   C612.065918,257.066132 613.131836,257.043030 614.595215,257.065826   C613.870239,257.984192 612.747864,258.856689 611.312744,259.864014  z"
    />
    <path
      fill="#A0E1F1"
      opacity="1.000000"
      stroke="none"
      d=" M540.705444,328.226379   C540.817810,328.877197 540.672363,329.738434 540.280029,330.820862   C540.171326,330.173645 540.309509,329.305237 540.705444,328.226379  z"
    />
    <path
      fill="#2F3B4E"
      opacity="1.000000"
      stroke="none"
      d=" M592.245178,237.240631   C588.624023,234.327896 585.281311,231.158096 581.415039,227.626984   C578.893860,226.298508 576.896301,225.331360 574.788818,223.975769   C574.442505,222.617599 574.079285,221.659317 573.990662,220.676300   C573.469482,214.894455 573.012207,209.106873 572.550659,203.529144   C567.512512,203.529144 563.414856,203.529144 558.778320,203.529144   C559.789978,210.216629 557.424988,217.290054 564.537231,221.740875   C565.049011,222.061142 564.332825,224.343491 563.829529,225.748978   C561.973206,226.385895 560.474854,226.987396 558.976562,227.588928   C558.237976,227.821274 557.499451,228.053604 556.382080,228.365021   C555.438049,219.701645 554.503113,210.961502 554.448425,202.215851   C554.416443,197.112366 556.162109,192.349533 562.289368,190.964294   C569.389648,189.359055 576.785034,191.562729 580.093872,196.784836   C581.772766,199.434464 582.868164,202.446838 584.429626,205.179642   C586.234558,208.338547 587.928040,211.653046 590.256348,214.403595   C596.952087,222.313568 597.631470,227.658981 592.245178,237.240631  z"
    />
    <path
      fill="#2F3B4E"
      opacity="1.000000"
      stroke="none"
      d=" M472.864929,304.919220   C471.550903,305.230713 470.236847,305.542206 468.585663,305.873535   C466.343964,302.377808 462.988220,289.995697 462.784210,285.731079   C462.400208,277.701996 464.971405,274.503143 472.740173,273.344513   C479.817596,272.289032 485.867889,275.748810 487.112579,282.501312   C487.999298,287.311890 490.180023,290.607880 493.960968,293.485962   C500.324249,298.329742 500.624786,301.254730 496.477142,308.415344   C496.028137,309.190552 496.221649,310.337921 496.056793,311.701843   C493.587555,310.322571 491.178650,308.554047 488.440186,306.651306   C486.632812,305.475433 485.155060,304.433777 483.195923,302.976074   C481.544586,299.449097 478.990936,296.070923 479.528137,293.289825   C480.338745,289.093597 479.173401,286.873993 476.002014,284.515076   C475.047668,283.632355 474.060669,282.557007 473.251862,282.677521   C470.701782,283.057526 468.218536,283.885986 465.140198,284.689453   C465.766205,288.650269 466.425720,292.823334 467.119934,297.354309   C468.327332,298.772064 469.429077,300.626617 470.686462,300.738922   C474.101776,301.043976 473.192291,303.000824 472.864929,304.919220  z"
    />
    <path
      fill="#A0E1F1"
      opacity="1.000000"
      stroke="none"
      d=" M441.434021,255.000977   C438.022583,253.991577 435.056152,253.007996 431.000000,251.663086   C431.000000,229.268555 431.000000,205.559402 431.000000,181.425430   C456.443054,181.333740 481.885895,181.681519 507.329254,181.990067   C513.984070,182.070786 513.994507,182.014816 513.997986,188.651047   C514.004883,201.978073 513.910522,215.306351 514.093445,228.630859   C514.121887,230.702576 515.474915,232.734558 516.065247,234.827255   C516.502930,236.378815 516.556763,238.042786 517.034851,239.577805   C517.659546,241.583542 519.084167,243.487564 519.170471,245.478485   C519.295837,248.365585 518.531860,251.291275 518.075806,254.567474   C515.314514,254.947662 512.624512,254.960876 509.490051,254.941223   C507.781708,248.784088 506.933441,242.535278 505.144714,236.568359   C503.089172,229.711365 496.539917,229.291763 490.205414,227.707779   C488.071259,226.918655 486.542023,226.411407 484.823120,225.545197   C484.097687,220.285538 482.163452,215.336884 486.687958,210.931137   C487.779083,209.868591 487.115112,207.003616 487.376984,204.561462   C488.685669,199.778458 490.596710,194.409592 484.501343,192.957062   C479.647949,191.800507 473.959320,192.169403 469.111847,193.533096   C464.412567,194.855087 464.169678,200.001938 467.893311,203.485168   C468.714874,209.999207 466.631989,217.103058 474.507050,221.112427   C474.039398,222.929306 473.521484,224.941498 472.621002,226.964874   C470.156250,227.619400 468.074036,228.262726 465.991821,228.906052   C456.616943,230.901016 454.091431,234.181488 452.080048,246.910370   C451.799042,248.688614 451.412292,250.450165 450.682434,252.655090   C449.861145,253.704697 449.431885,254.318634 449.002625,254.932571   C446.628113,254.963989 444.253571,254.995392 441.434021,255.000977  z"
    />
    <path
      fill="#405068"
      opacity="1.000000"
      stroke="none"
      d=" M478.968658,254.984924   C476.607452,255.038956 474.246216,255.092987 471.423584,254.602051   C471.373932,246.271484 471.785706,238.485916 472.537415,230.838379   C476.125580,234.323868 479.521179,233.056137 482.929688,231.683289   C481.607513,239.707779 480.288086,247.346344 478.968658,254.984924  z"
    />
    <path
      fill="#D6E4EB"
      opacity="1.000000"
      stroke="none"
      d=" M479.342499,254.986313   C480.288086,247.346344 481.607513,239.707779 483.062836,231.342133   C483.803406,229.044769 484.408081,227.474472 485.012756,225.904175   C486.542023,226.411407 488.071259,226.918655 489.804138,227.704575   C487.379608,236.528610 484.790710,245.086624 482.045380,253.594162   C481.836365,254.241760 480.518677,254.531586 479.342499,254.986313  z"
    />
    <path
      fill="#D6E4EB"
      opacity="1.000000"
      stroke="none"
      d=" M472.197510,230.700333   C471.785706,238.485916 471.373932,246.271484 470.986816,254.524445   C470.013977,253.935684 468.373993,253.011993 468.124573,251.801712   C466.649658,244.645050 464.384766,237.458862 467.329468,230.110397   C467.418610,229.887985 466.873474,229.411377 466.307922,228.979660   C468.074036,228.262726 470.156250,227.619400 472.612122,227.297241   C472.722992,228.645721 472.460266,229.673019 472.197510,230.700333  z"
    />
    <path
      fill="#A0E1F1"
      opacity="1.000000"
      stroke="none"
      d=" M449.328918,254.930054   C449.431885,254.318634 449.861145,253.704697 450.593811,253.047852   C450.483246,253.645813 450.069214,254.286682 449.328918,254.930054  z"
    />
    <path
      fill="#405068"
      opacity="1.000000"
      stroke="none"
      d=" M565.060913,255.024109   C563.727112,255.037140 562.393372,255.050156 560.675049,254.500427   C560.252014,246.665253 559.066406,239.255768 562.967041,232.744965   C566.201660,236.939407 568.919800,232.658768 571.734009,233.028961   C569.432617,240.640030 567.246765,247.832077 565.060913,255.024109  z"
    />
    <path
      fill="#D6E4EB"
      opacity="1.000000"
      stroke="none"
      d=" M565.431519,255.020203   C567.246765,247.832077 569.432617,240.640030 571.843018,232.765839   C573.011353,229.510529 573.955078,226.937378 574.898804,224.364227   C576.896301,225.331360 578.893860,226.298508 581.089783,227.536560   C577.206909,235.617081 573.174927,243.453186 568.999756,251.212296   C568.231384,252.640335 566.882874,253.756302 565.431519,255.020203  z"
    />
    <path
      fill="#D6E4EB"
      opacity="1.000000"
      stroke="none"
      d=" M562.859253,232.441193   C559.066406,239.255768 560.252014,246.665253 560.287720,254.394836   C559.208679,252.916412 557.188416,250.962357 557.225769,249.048508   C557.360352,242.162704 558.189453,235.290466 558.866333,228.001007   C560.474854,226.987396 561.973206,226.385895 563.969482,226.037842   C563.931396,228.341263 563.395325,230.391235 562.859253,232.441193  z"
    />
    <path
      fill="#A0E1F1"
      opacity="1.000000"
      stroke="none"
      d=" M521.519287,181.105347   C521.930664,202.019653 521.955505,223.031281 521.946960,244.507324   C521.276733,243.726028 520.092102,242.483475 520.084778,241.234039   C519.971985,221.907852 520.000427,202.580719 520.063477,183.254013   C520.065735,182.569077 520.760681,181.886398 521.519287,181.105347  z"
    />
    <path
      fill="#EE9A84"
      opacity="1.000000"
      stroke="none"
      d=" M476.050903,284.869720   C479.173401,286.873993 480.338745,289.093597 479.528137,293.289825   C478.990936,296.070923 481.544586,299.449097 482.896973,302.903809   C482.077271,305.936523 481.075226,308.625458 479.950317,311.652527   C477.001068,312.173340 474.174713,312.356018 471.128296,312.265259   C471.514526,309.870819 472.120789,307.749817 472.795990,305.274017   C473.192291,303.000824 474.101776,301.043976 470.686462,300.738922   C469.429077,300.626617 468.327332,298.772064 467.480652,297.360901   C468.898590,297.353790 470.175232,297.445740 471.050018,298.086395   C474.585968,300.676025 476.284424,298.754608 477.996918,295.524597   C472.364990,292.743561 476.632355,288.454224 476.050903,284.869720  z"
    />
    <path
      fill="#7A9CBF"
      opacity="1.000000"
      stroke="none"
      d=" M226.575012,422.708679   C226.942184,417.462433 227.763214,412.241119 228.474289,407.004852   C228.661758,405.624390 228.509567,404.197815 228.367828,402.447479   C229.321365,401.976288 230.420410,401.850006 231.714203,401.701385   C231.714203,408.622375 231.714203,415.217010 231.714203,422.430786   C230.110229,422.531647 228.548981,422.629822 226.575012,422.708679  z"
    />
    <path
      fill="#665970"
      opacity="1.000000"
      stroke="none"
      d=" M186.832825,351.215332   C185.250763,347.790497 183.806152,344.714294 182.361526,341.638092   C182.764694,341.453766 183.167862,341.269440 183.571030,341.085114   C186.122070,346.309845 188.673126,351.534576 191.224182,356.759308   C190.903442,356.937225 190.582718,357.115143 190.261993,357.293030   C189.164749,355.383362 188.067505,353.473663 186.832825,351.215332  z"
    />
    <path
      fill="#665970"
      opacity="1.000000"
      stroke="none"
      d=" M192.013214,360.732422   C192.399643,360.366180 193.206497,360.262756 193.283218,360.453308   C193.676544,361.430237 193.881927,362.482849 193.511368,363.733612   C193.039856,362.866028 192.568344,361.998413 192.013214,360.732422  z"
    />
    <path
      fill="#665970"
      opacity="1.000000"
      stroke="none"
      d=" M191.750000,358.250000   C191.699997,358.533325 191.400009,358.566681 191.100006,358.600006   C191.233322,358.399994 191.366653,358.199982 191.750000,358.250000  z"
    />
    <path
      fill="#5F524B"
      opacity="1.000000"
      stroke="none"
      d=" M151.605499,415.587982   C151.924286,415.307465 152.243073,415.026947 152.561859,414.746429   C152.632675,415.121582 152.703506,415.496735 152.335541,415.879883   C151.896759,415.887848 151.605484,415.587982 151.605499,415.587982  z"
    />
    <path
      fill="#5F524B"
      opacity="1.000000"
      stroke="none"
      d=" M151.027603,417.028503   C150.957764,416.530670 151.058899,416.201538 151.382751,415.730164   C151.605484,415.587982 151.896759,415.887848 152.043610,416.036621   C152.099854,416.509705 152.009247,416.834015 151.738373,417.337036   C151.558121,417.515747 151.198578,417.197205 151.027603,417.028503  z"
    />
    <path
      fill="#EE9A84"
      opacity="1.000000"
      stroke="none"
      d=" M562.967041,232.744965   C563.395325,230.391235 563.931396,228.341263 564.327515,226.002441   C564.332825,224.343491 565.049011,222.061142 564.537231,221.740875   C557.424988,217.290054 559.789978,210.216629 558.778320,203.529144   C563.414856,203.529144 567.512512,203.529144 572.550659,203.529144   C573.012207,209.106873 573.469482,214.894455 573.990662,220.676300   C574.079285,221.659317 574.442505,222.617599 574.788818,223.975769   C573.955078,226.937378 573.011353,229.510529 571.958618,232.346802   C568.919800,232.658768 566.201660,236.939407 562.967041,232.744965  z"
    />
    <path
      fill="#F39D85"
      opacity="1.000000"
      stroke="none"
      d=" M476.002014,284.515076   C476.632355,288.454224 472.364990,292.743561 477.996918,295.524597   C476.284424,298.754608 474.585968,300.676025 471.050018,298.086395   C470.175232,297.445740 468.898590,297.353790 467.445984,297.003052   C466.425720,292.823334 465.766205,288.650269 465.140198,284.689453   C468.218536,283.885986 470.701782,283.057526 473.251862,282.677521   C474.060669,282.557007 475.047668,283.632355 476.002014,284.515076  z"
    />
    <path
      fill="#F49F88"
      opacity="1.000000"
      stroke="none"
      d=" M472.537415,230.838379   C472.460266,229.673019 472.722992,228.645721 472.994629,227.286057   C473.521484,224.941498 474.039398,222.929306 474.507050,221.112427   C466.631989,217.103058 468.714874,209.999207 468.232513,203.380920   C472.745270,203.523285 476.947052,204.220917 481.592133,204.992157   C481.721161,205.733429 481.949829,207.047440 482.058746,207.673157   C483.902649,206.713654 485.580444,205.840591 487.258270,204.967514   C487.115112,207.003616 487.779083,209.868591 486.687958,210.931137   C482.163452,215.336884 484.097687,220.285538 484.823120,225.545197   C484.408081,227.474472 483.803406,229.044769 483.065582,230.956223   C479.521179,233.056137 476.125580,234.323868 472.537415,230.838379  z"
    />
    <path
      fill="#2F3B4E"
      opacity="1.000000"
      stroke="none"
      d=" M487.376984,204.561462   C485.580444,205.840591 483.902649,206.713654 482.058746,207.673157   C481.949829,207.047440 481.721161,205.733429 481.592133,204.992157   C476.947052,204.220917 472.745270,203.523285 468.204285,202.929901   C464.169678,200.001938 464.412567,194.855087 469.111847,193.533096   C473.959320,192.169403 479.647949,191.800507 484.501343,192.957062   C490.596710,194.409592 488.685669,199.778458 487.376984,204.561462  z"
    />
  </svg>
);
export const BiCheck = ({ customClass }) => (
  <svg
    stroke="currentColor"
    className={customClass}
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 24 24"
  >
    <path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path>
  </svg>
);
export const Stethoscope = ({ customClass }) => (
  <svg
    version="1.1"
    id="Capa_1"
    x="0px"
    y="0px"
    viewBox="0 0 480.007 480.007"
    className={customClass}
  >
    <g>
      <g>
        <path d="M479.426,267.581c-3.547-24.574-22.852-43.879-47.426-47.426v-14.544c0-40.128-30.504-72.8-68-72.8    c-36.416,0-66.904,31.68-68,70.624h0.464l-0.464,0.08v157.656c0,50.4-37.68,91.328-84,91.328s-84-40.984-84-91.328v-13.656    c11.6,0,24-8.408,24-32v-20.12c51.344-13.128,88-57.216,88-107.2v-16.68h-16l-0.336-104.12    c-0.116-19.273-13.946-35.729-32.912-39.16c-4.091-12.533-17.568-19.377-30.102-15.285c-12.533,4.091-19.377,17.568-15.285,30.102    c4.091,12.533,17.568,19.377,30.102,15.285c6.711-2.191,12.108-7.24,14.741-13.79c10.249,2.916,17.349,12.24,17.432,22.896    L208,171.515h-16v16.912c-0.638,27.827-19.294,52.009-46.048,59.688c-14.315,4.542-29.685,4.542-44,0    C75.229,240.41,56.615,216.232,56,188.427v-16.912H32v-104c0.046-10.813,7.318-20.261,17.76-23.072    c4.869,12.395,18.864,18.495,31.259,13.626S99.514,39.204,94.645,26.81S75.78,8.315,63.386,13.184    c-6.716,2.639-11.898,8.146-14.122,15.011C30.091,31.471,16.053,48.064,16,67.515v104H0v16.64c0,50.04,36.68,94.144,88,107.24    v20.12c0,23.592,12.4,32,24,32v13.656c0,59.2,44.856,107.328,100,107.328s100-48.184,100-107.328V203.899    c0.8-30.36,24.144-55.064,52-55.064c28.672,0,52,25.472,52,56.8v14.52c-30.611,4.418-51.844,32.815-47.426,63.426    s32.815,51.844,63.426,47.426S483.844,298.191,479.426,267.581z M168,43.515c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8    S172.418,43.515,168,43.515z M72,27.515c4.418,0,8,3.582,8,8s-3.582,8-8,8s-8-3.582-8-8S67.582,27.515,72,27.515z M16,188.155    v-0.64h24v0.912c0.6,34.771,23.733,65.116,57.104,74.904c17.487,5.537,36.257,5.537,53.744,0    c33.387-9.775,56.541-40.121,57.152-74.904v-0.912h16v0.64c0,44.504-34.304,83.664-81.6,93.136    c-11.106,2.224-22.482,2.782-33.752,1.656c-3.71-0.36-7.398-0.918-11.048-1.672C50.304,271.819,16,232.659,16,188.155z     M112,331.515c-7.2,0-8-11.2-8-16v-16.976c0.64,0.08,1.296,0.112,1.944,0.176c0.8,0.088,1.6,0.152,2.4,0.224    c3.784,0.336,7.6,0.56,11.448,0.568h0.4c3.84,0,7.648-0.232,11.408-0.568c0.8-0.072,1.648-0.136,2.472-0.224    c0.632-0.072,1.288-0.096,1.92-0.176v16.976c0,4.8-0.8,16-8,16H112z M424,315.515c-22.091,0-40-17.909-40-40    c0-22.091,17.909-40,40-40c22.091,0,40,17.909,40,40C463.974,297.596,446.08,315.489,424,315.515z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M424,251.515c-13.255,0-24,10.745-24,24s10.745,24,24,24s24-10.745,24-24S437.255,251.515,424,251.515z M424,283.515    c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8S428.418,283.515,424,283.515z" />
      </g>
    </g>
  </svg>
);
export const BsBellFill = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    stroke-width="0"
    viewBox="0 0 16 16"
    className={customClass}
  >
    <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zm.995-14.901a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901z"></path>
  </svg>
);

export const BsBell = ({ customClass, id = '', gtmTagVariable = '' }) => (
  <i className={`flaticon-notification ${customClass} ${gtmTagVariable} `} id={id} />
);

export const GiVote = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    stroke-width="0"
    viewBox="0 0 512 512"
    className={customClass}
  >
    <path d="M494 21.621c-14.947 8.43-29.566 17.581-43.67 29.227l7.318 38.547C471.923 93.66 483.583 95.26 494 95.36v-73.74zm-98.982 24.512c-15.283-.085-32.48 2.596-53.832 6.834l-.22.043-.22.033c-14.77 2.177-40.794 12.065-66.465 38.867l44.27 11.766c.972-1.493 5.936-9.004 6.88-10.555 5.124 3.123 10.248 6.244 15.372 9.365-12.475 20.475-26.742 35.556-43.934 54.522-2.123 4.718.977 8.199 4.36 10.14 5.22 2.931 14.1 3.09 16.437 2.102 23.932-15.768 40.819-35.928 55.963-56.271l5.469.964c11.501 2.031 26.47 1.058 38.707-2.853 11.098-3.548 19.272-9.357 22.662-15.688L432.54 53.65c-12.044-5.214-24.039-7.442-37.523-7.517zM227.932 98.717l-29.436 115.986 9.643.297H311.27l.9-.209 6.804-27.092c-8.86 1.9-18.296-.217-26.557-4.855-5.188-2.913-10.024-7.24-12.621-13.434-7.797-19.938 15.857-37.297 28.724-52.75l-80.59-17.943zM69.562 201l-23 46h418.875l-23-46H334.195l-3.517 14H352v18H160v-18h19.852l3.552-14H69.563zM41 265v222h430V265H41zm14 14h402v194H55V279zm18 18v118.238l34.502-74.994 73.36 31.762 66.652-45.84 37.513 57.273 50.11-4.595 31.3-39.332L439 394.627V297H73zm169.543 54.43l-90.63 62.33 27.01 41.24h95.606l19.666-24.71-51.652-78.86zm-126.045 12.326L74.521 455h82.885l-30.193-46.098 36.144-24.857-46.859-20.29zm253.065.732L297.533 455h140.54l.927-1.166v-36.602l-69.438-52.744zm-49.944 33.854l-23.426 2.148 9.805 14.969 13.621-17.117z"></path>
  </svg>
);

export const BsSortDown = ({ customClass }) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 16 16"
      className={customClass}
    >
      <path d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293V2.5zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"></path>
    </svg>
  );
};
export const AiOutlineClockCircle = ({ customClass, gtmTagVariable = '' }) => (
  <i className={`flaticon-clock ${customClass} ${gtmTagVariable}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   stroke-width="0"
  //   viewBox="0 0 1024 1024"
  //   className={`${customClass} ${gtmTagVariable}`}
  // >
  //   <path
  //     className={gtmTagVariable}
  //     d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
  //   ></path>
  //   <path
  //     className={gtmTagVariable}
  //     d="M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
  //   ></path>
  // </svg>
);
export const AiOutlineUserDelete = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    stroke-width="0"
    viewBox="0 0 1024 1024"
    className={customClass}
  >
    <path d="M678.3 655.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 518 759.6 444.7 759.6 362c0-137-110.8-248-247.5-248S264.7 225 264.7 362c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 901.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 641.2 432.2 610 512.2 610c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 534c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 362c0-45.9 17.9-89.1 50.3-121.6S466.3 190 512.2 190s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 362c0 45.9-17.9 89.1-50.3 121.6C601.1 516.1 558 534 512.2 534zM880 772H640c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"></path>
  </svg>
);
export const BiUserCheck = ({ customClass }) => (
  <i className={`flaticon-add-friend ${customClass}`} />
);

export const AiOutlineArrowUp = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    stroke-width="0"
    viewBox="0 0 1024 1024"
    className={customClass}
  >
    <path d="M868 545.5L536.1 163a31.96 31.96 0 0 0-48.3 0L156 545.5a7.97 7.97 0 0 0 6 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z"></path>
  </svg>
);
export const DraggableIcon = ({ customClass }) => (
  <i className={`flaticon-drag ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="none"
  //   stroke-width="0"
  //   viewBox="0 0 15 15"
  //   className={customClass}
  // >
  //   <path
  //     fillRule="evenodd"
  //     clip-rule="evenodd"
  //     d="M5.5 4.625C6.12132 4.625 6.625 4.12132 6.625 3.5C6.625 2.87868 6.12132 2.375 5.5 2.375C4.87868 2.375 4.375 2.87868 4.375 3.5C4.375 4.12132 4.87868 4.625 5.5 4.625ZM9.5 4.625C10.1213 4.625 10.625 4.12132 10.625 3.5C10.625 2.87868 10.1213 2.375 9.5 2.375C8.87868 2.375 8.375 2.87868 8.375 3.5C8.375 4.12132 8.87868 4.625 9.5 4.625ZM10.625 7.5C10.625 8.12132 10.1213 8.625 9.5 8.625C8.87868 8.625 8.375 8.12132 8.375 7.5C8.375 6.87868 8.87868 6.375 9.5 6.375C10.1213 6.375 10.625 6.87868 10.625 7.5ZM5.5 8.625C6.12132 8.625 6.625 8.12132 6.625 7.5C6.625 6.87868 6.12132 6.375 5.5 6.375C4.87868 6.375 4.375 6.87868 4.375 7.5C4.375 8.12132 4.87868 8.625 5.5 8.625ZM10.625 11.5C10.625 12.1213 10.1213 12.625 9.5 12.625C8.87868 12.625 8.375 12.1213 8.375 11.5C8.375 10.8787 8.87868 10.375 9.5 10.375C10.1213 10.375 10.625 10.8787 10.625 11.5ZM5.5 12.625C6.12132 12.625 6.625 12.1213 6.625 11.5C6.625 10.8787 6.12132 10.375 5.5 10.375C4.87868 10.375 4.375 10.8787 4.375 11.5C4.375 12.1213 4.87868 12.625 5.5 12.625Z"
  //     fill="currentColor"
  //   ></path>
  // </svg>
);
export const DoctubeSupport = ({ customClass }) => (
  <svg
    id="Group_54"
    data-name="Group 54"
    xmlns="http://www.w3.org/2000/svg"
    width="106.921"
    height="151.394"
    viewBox="0 0 106.921 151.394"
    className={customClass}
  >
    <g id="Group_38" data-name="Group 38" transform="translate(77.352 87.89)">
      <path
        id="Path_392"
        data-name="Path 392"
        d="M132.327,243.69l1.886,12.227H110.934l-.868-2.72Z"
        transform="translate(-106.13 -192.721)"
        fill="#e06a58"
      />
      <path
        id="Path_393"
        data-name="Path 393"
        d="M105.036,189.09l4.39-10.54s11.909,5.595,15.837,12.5c4.2,7.386,9.343,46.658,9.343,46.658s-21.025,4.843-24.89,2.786S105.036,189.09,105.036,189.09Z"
        transform="translate(-105.036 -178.55)"
        fill="#f2ae30"
      />
    </g>
    <path
      id="Path_394"
      data-name="Path 394"
      d="M50.1,128.971c-3.075-1.127-6.33-2.113-9.624-1.862s-6.659,2-7.778,4.89c-.8,2.05-.43,4.468-1.69,6.314-1.2,1.768-3.6,2.5-5.837,2.653s-4.507-.141-6.737.149c-6.886.915-11.8,8.4-9.538,14.522.9,2.441,2.746,4.773,2.324,7.316-.446,2.723-3.3,4.515-4.476,7.042-1.557,3.365.305,7.441,3.38,9.734s7.073,3.153,10.954,3.732c5.344.8,10.861,1.174,16.142.047s10.328-3.912,13.059-8.263c1.213-1.925,1.948-4.1,3.357-5.908,2.911-3.732,8.067-5.18,12.128-7.825,4.437-2.9,7.692-8.552,5.078-12.973-2.52-4.249-9.077-5.2-11.706-9.382-1.088-1.729-1.346-3.787-2.05-5.673C56.364,131.593,54.642,130.638,50.1,128.971Z"
      transform="translate(-6.179 -79.461)"
      fill="#0a2240"
    />
    <g id="Group_39" data-name="Group 39" transform="translate(38.033 55.011)">
      <path
        id="Path_395"
        data-name="Path 395"
        d="M78.588,183.149a4.616,4.616,0,0,0,2.958,1.956,4.433,4.433,0,0,0,3.318-1.768,33.677,33.677,0,0,0,8.568-16.432c-1.1-.626-2.167-1.228-3.13-1.792a4.752,4.752,0,0,1-1.948-2.144,4.119,4.119,0,0,1-.29-2.019,57.7,57.7,0,0,1,3.247-15.133c-9.812-2.214-19.069-4.843-24.389-9.288-.649,2.739-1.416,8.1-3.052,13.411-1.745,5.626-4.468,11.189-9.084,13.583A97.352,97.352,0,0,1,78.588,183.149Z"
        transform="translate(-54.786 -136.53)"
        fill="#f9a07b"
      />
      <path
        id="Path_396"
        data-name="Path 396"
        d="M90.59,160.961a4.105,4.105,0,0,0,.29,2.019c-5.806,7.042-18.787-2.16-24.483-13.028,1.635-5.313,2.4-10.673,3.052-13.411,5.313,4.444,14.577,7.081,24.389,9.288A57.634,57.634,0,0,0,90.59,160.961Z"
        transform="translate(-57.312 -136.532)"
        fill="#e06a58"
      />
    </g>
    <g id="Group_40" data-name="Group 40" transform="translate(17.798 79.056)">
      <path
        id="Path_397"
        data-name="Path 397"
        d="M34.794,239.6s-1.1-11.377-1.948-17.715c-2.316-17-5.4-35.187-3.122-38.959,4.46-7.347,14.89-12.339,20.062-14.483,1.776-.736,2.934-1.135,3.02-1.182,6.487,11.064,19.687,20.5,24.671,20.078,1.385-.11,5.493-1.541,8.208-15.211,1.056.6,2.113,1.158,3.161,1.7,5.156,2.684,9.992,4.9,11.385,8.349,3.678,9.084,7.285,31.987,6.487,40.132-.6,6.162-4.556,16.861-4.556,16.861Z"
        transform="translate(-28.925 -167.26)"
        fill="#ffc73c"
      />
      <path
        id="Path_398"
        data-name="Path 398"
        d="M49.884,252.388s-1.1-11.377-1.948-17.715c3.685,3.889,9.061-12.543,11.44-7.731,6.136,12.383,17.658,25.432,17.658,25.432Z"
        transform="translate(-33.061 -180.049)"
        fill="#fb3"
      />
      <path
        id="Path_399"
        data-name="Path 399"
        d="M94.646,173.825c-.837,6.08-3.318,14.272-10.532,16.432-9.749,2.919-23.857-15.3-28.529-21.815,1.776-.736,2.934-1.135,3.02-1.182,6.487,11.064,19.687,20.5,24.671,20.078,1.385-.11,5.493-1.541,8.208-15.211C92.542,172.722,93.6,173.277,94.646,173.825Z"
        transform="translate(-34.725 -167.26)"
        fill="#fce172"
      />
    </g>
    <g id="Group_49" data-name="Group 49" transform="translate(34.034 0)">
      <g id="Group_41" data-name="Group 41" transform="translate(46.993 39.992)">
        <ellipse
          id="Ellipse_20"
          data-name="Ellipse 20"
          cx="13.607"
          cy="8.975"
          rx="13.607"
          ry="8.975"
          transform="translate(0 26.754) rotate(-79.444)"
          fill="#56c4f9"
        />
      </g>
      <path
        id="Path_400"
        data-name="Path 400"
        d="M130,101.536c-.908,6.432-3.779,13.521-7.965,21.353-1.471-6.416-2.41-14.233-3.709-22.05-1.322-7.832-3-15.665-5.923-22.065a38.309,38.309,0,0,0-2.144-4.022,14.277,14.277,0,0,1,5.149.462,17.25,17.25,0,0,1,7.042,3.842,24.692,24.692,0,0,1,6.862,11.213A25.163,25.163,0,0,1,130,101.536Z"
        transform="translate(-62.853 -68.067)"
        fill="#0b2d50"
      />
      <g id="Group_42" data-name="Group 42" transform="translate(6.965 3.445)">
        <path
          id="Path_401"
          data-name="Path 401"
          d="M113.841,107.3c-.047,1.268-.133,2.559-.25,3.842-1.784,20.813-10.524,35.093-23.9,35.093-18.881,0-31.118-21.173-31.118-41.916,0-20.461,12.535-35.273,27.206-33.56,8.458.97,14.64,3.779,19.029,7.9a25.937,25.937,0,0,1,6.432,9.812,42.9,42.9,0,0,1,2.59,14.131c0,.016.016.031.016.047C113.912,104.166,113.9,105.715,113.841,107.3Z"
          transform="translate(-58.576 -70.628)"
          fill="#f9a07b"
        />
        <path
          id="Path_402"
          data-name="Path 402"
          d="M116.245,111.511a20.918,20.918,0,0,0-2.543-5.735,59.415,59.415,0,0,1-36.987,5.939c-2.394,2-4.734,3.959-7.089,5.923.047-9.468.18-15.876,3.873-20.461,3.466-4.3,9.249-5.923,14.726-6.627a68.116,68.116,0,0,1,18.583.117,18.806,18.806,0,0,1,6.847,2.027,42.9,42.9,0,0,1,2.59,14.131c0,.016.016.031.016.047C116.315,108.373,116.3,109.923,116.245,111.511Z"
          transform="translate(-60.98 -74.835)"
          fill="#e06a58"
        />
      </g>
      <path
        id="Path_403"
        data-name="Path 403"
        d="M115.008,93.531a34.88,34.88,0,0,1-9.483,5.477c-10.375,4.186-23.857,5.571-34.366,5.063-5.164,11.346-7.253,15.414-8.576,25.313-5.047-4.734-9.155-13.4-10.375-20.219a46.245,46.245,0,0,1,.806-20.594,30.8,30.8,0,0,1,15.712-18.9,29.529,29.529,0,0,1,3.38-1.565c6.659-2.574,14.163-2.34,20.993-.25a25,25,0,0,1,9.5,5.524c5.329,4.812,8.623,11.33,10.751,16.213C114.022,91.09,114.562,92.444,115.008,93.531Z"
        transform="translate(-50.055 -66.227)"
        fill="#0b2d50"
      />
      <path
        id="Path_404"
        data-name="Path 404"
        d="M122.014,99.695a31.856,31.856,0,0,0-1.98-6.612,22.78,22.78,0,0,0-1.862-3.5,19.179,19.179,0,0,0-9.992-8.145,36.767,36.767,0,0,0-3.756-4.5,28.983,28.983,0,0,0-16.173-8.529,30.726,30.726,0,0,0-14.695,1.252,29.533,29.533,0,0,1,3.38-1.565c6.659-2.574,14.163-2.34,20.993-.25a25,25,0,0,1,9.5,5.524,17.25,17.25,0,0,1,7.042,3.842,24.692,24.692,0,0,1,6.862,11.213A25.277,25.277,0,0,1,122.014,99.695Z"
        transform="translate(-54.87 -66.225)"
        fill="#225570"
      />
      <g id="Group_45" data-name="Group 45" transform="translate(27.121 44.179)">
        <g id="Group_43" data-name="Group 43">
          <path
            id="Path_405"
            data-name="Path 405"
            d="M84.336,124.739A13.245,13.245,0,0,1,96.527,123.7"
            transform="translate(-84.336 -122.687)"
            fill="none"
            stroke="#0b2d50"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="2"
          />
          <path
            id="Path_406"
            data-name="Path 406"
            d="M114.876,124.641c2.989-2.23,7.418-2.457,9.726,0"
            transform="translate(-90.98 -122.729)"
            fill="none"
            stroke="#0b2d50"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="2"
          />
          <path
            id="Path_407"
            data-name="Path 407"
            d="M110.1,139.67a14.322,14.322,0,0,1-.61,6.651"
            transform="translate(-89.807 -126.381)"
            fill="none"
            stroke="#cc454e"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="2"
          />
          <ellipse
            id="Ellipse_21"
            data-name="Ellipse 21"
            cx="1.44"
            cy="2.269"
            rx="1.44"
            ry="2.269"
            transform="translate(7.058 9.814)"
            fill="#262d40"
          />
          <ellipse
            id="Ellipse_22"
            data-name="Ellipse 22"
            cx="1.44"
            cy="2.269"
            rx="1.44"
            ry="2.269"
            transform="translate(25.876 8.758)"
            fill="#262d40"
          />
        </g>
        <g id="Group_44" data-name="Group 44" transform="translate(6.811 19.947)">
          <path
            id="Path_408"
            data-name="Path 408"
            d="M104.735,151.263a11.06,11.06,0,0,1-.822,1.291,8.936,8.936,0,0,1-4.249,3.31h-.008a5.548,5.548,0,0,1-2.731.18c-2.942-.524-3.717-3.239-3.858-5.329a11.188,11.188,0,0,1-.023-1.127,10.665,10.665,0,0,1,.11-1.408C97.841,150.762,104.735,151.263,104.735,151.263Z"
            transform="translate(-93.04 -148.18)"
            fill="#cc454e"
          />
          <path
            id="Path_409"
            data-name="Path 409"
            d="M104.736,151.263a11.06,11.06,0,0,1-.822,1.291,32.325,32.325,0,0,1-10.868-2.966,10.667,10.667,0,0,1,.11-1.408C97.842,150.762,104.736,151.263,104.736,151.263Z"
            transform="translate(-93.042 -148.18)"
            fill="#fff"
          />
          <path
            id="Path_410"
            data-name="Path 410"
            d="M99.664,156.559a5.548,5.548,0,0,1-2.731.18c-2.942-.524-3.717-3.239-3.858-5.329a8.012,8.012,0,0,1,6.588,5.149Z"
            transform="translate(-93.048 -148.883)"
            fill="#e8729b"
          />
        </g>
      </g>
      <g id="Group_48" data-name="Group 48" transform="translate(0 3.25)">
        <path
          id="Path_411"
          data-name="Path 411"
          d="M64.885,109.769a54.09,54.09,0,0,1,3.9-19.452A27.954,27.954,0,0,1,94.329,72.594a27.439,27.439,0,0,1,19.734,7.715s-3.951-6.972-11.745-8.975c-5.117-1.315-12.84-1.526-19.037.994-6.385,2.59-14.342,9.781-17.222,17.378s-4.272,19.429-4.272,19.429Z"
          transform="translate(-52.309 -70.378)"
          fill="#3d86e0"
        />
        <g id="Group_46" data-name="Group 46" transform="translate(0 35.303)">
          <ellipse
            id="Ellipse_23"
            data-name="Ellipse 23"
            cx="9.46"
            cy="14.334"
            rx="9.46"
            ry="14.334"
            transform="translate(0 1.956) rotate(-5.935)"
            fill="#56c4f9"
          />
          <ellipse
            id="Ellipse_24"
            data-name="Ellipse 24"
            cx="6.142"
            cy="10.806"
            rx="6.142"
            ry="10.806"
            transform="translate(0.696 6.502) rotate(-8.546)"
            fill="#3d86e0"
          />
        </g>
        <g id="Group_47" data-name="Group 47" transform="translate(16.785 62.465)">
          <ellipse
            id="Ellipse_25"
            data-name="Ellipse 25"
            cx="5.039"
            cy="3.138"
            rx="5.039"
            ry="3.138"
            transform="translate(20.274 7.355)"
            fill="#3a92c9"
          />
          <path
            id="Path_412"
            data-name="Path 412"
            d="M71.126,150.21A30.444,30.444,0,0,0,91.4,160.7"
            transform="translate(-71.126 -150.21)"
            fill="none"
            stroke="#3a92c9"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="2"
          />
        </g>
      </g>
    </g>
    <g id="Group_53" data-name="Group 53" transform="translate(10.469 85.081)">
      <g id="Group_52" data-name="Group 52" transform="translate(0)">
        <g id="Group_51" data-name="Group 51" transform="translate(4.02 42.754)">
          <g id="Group_50" data-name="Group 50">
            <path
              id="Path_413"
              data-name="Path 413"
              d="M24.7,234.806l26.525-5.2"
              transform="translate(-24.696 -229.602)"
              fill="#f9a07b"
            />
            <path
              id="Path_414"
              data-name="Path 414"
              d="M27.927,252.852,24.7,234.8l26.525-5.2c0-.008.723,23.245.723,23.245Z"
              transform="translate(-24.696 -229.6)"
              fill="#e06a58"
            />
          </g>
        </g>
        <path
          id="Path_415"
          data-name="Path 415"
          d="M47.123,191.478c-1.925-5.422-8.975-16.518-8.975-16.518s-10.759,4.476-14.577,12.073c-6.463,12.864-3.177,49.8-3.177,49.8,8.709,3.646,26.189,3.7,33.63,2.653C54.024,239.482,50.98,202.315,47.123,191.478Z"
          transform="translate(-19.558 -174.96)"
          fill="#ffc73c"
        />
      </g>
      <path
        id="Path_416"
        data-name="Path 416"
        d="M56.536,198.97a239.235,239.235,0,0,1,5.008,39.976"
        transform="translate(-27.602 -180.183)"
        fill="none"
        stroke="#f2ae30"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="1"
      />
    </g>
  </svg>
);

export const WhatHappensIcon = ({ customClass }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={customClass}
    width="96"
    height="94"
    viewBox="0 0 96 94"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_104"
          data-name="Rectangle 104"
          width="96"
          height="94"
          transform="translate(7 -0.469)"
          fill="none"
        />
      </clipPath>
      <clipPath id="clip-path-2">
        <rect
          id="Rectangle_97"
          data-name="Rectangle 97"
          width="91.491"
          height="81.927"
          fill="#e8b61f"
        />
      </clipPath>
    </defs>
    <g id="Group_185" data-name="Group 185" transform="translate(-7 0.469)">
      <g id="Group_184" data-name="Group 184" clip-path="url(#clip-path)">
        <path
          id="Path_534"
          data-name="Path 534"
          d="M56.061,54.895C54.29,61.13,59.7,67.809,57.744,73.987c-1.016,3.2-3.833,5.5-6.758,7.157s-6.118,2.881-8.773,4.942a14.08,14.08,0,0,0-5.127,7.525,10.427,10.427,0,0,0,1.658,8.808c2.041,2.639,5.315,3.928,8.238,5.537,5.28,2.906,9.742,7.128,15.007,10.063s11.961,4.443,17.238,1.532c5.326-2.938,7.569-9.351,8.879-15.291.759-3.44,1.432-7.082,3.692-9.784,1.674-2,4.041-3.262,6.309-4.55q4.287-2.435,8.363-5.219c3.76-2.568,7.47-5.456,9.75-9.4s2.848-9.17.32-12.957c-1.059-1.587-2.621-2.9-3.177-4.721-.473-1.551-.138-3.214-.064-4.833a12.17,12.17,0,0,0-2.433-8.1,8.983,8.983,0,0,0-7.548-3.464c-3.433.283-6.221,2.737-9.017,4.75s-6.416,3.727-9.579,2.362c-16.225-7-26.595-.711-28.659,6.553"
          transform="translate(-22.309 -37.462)"
          fill="#f15a29"
        />
        <g id="Group_167" data-name="Group 167" transform="translate(10.313 5.287)" opacity="0.9">
          <g id="Group_166" data-name="Group 166">
            <g id="Group_165" data-name="Group 165" clip-path="url(#clip-path-2)">
              <path
                id="Path_535"
                data-name="Path 535"
                d="M65.322,58.545a22.529,22.529,0,0,1-7.6,2.708L46.134,63.872c-3.572.807-7.522,1.873-9.441,4.992-2.831,4.6.07,11.668-3.854,15.382a36.151,36.151,0,0,1-3.243,2.24,8.219,8.219,0,0,0,1.248,13.886c5.4,2.733,12.917-.763,17.529,3.153,2.066,1.755,2.9,4.587,3.07,7.292s-.2,5.423-.04,8.129c.168,2.888,1.179,6.045,3.726,7.418,3.2,1.727,7.22-.19,9.778-2.778s4.456-5.889,7.5-7.878c2.619-1.71,5.8-2.26,8.871-2.86q4.513-.883,8.973-2.013c2.826-.717,5.713-1.547,8.01-3.344,3.651-2.857,5.168-7.622,6.157-12.151.546-2.5,1.036-5.127,2.592-7.162a20.779,20.779,0,0,1,3.524-3.229,20.135,20.135,0,0,0,6.673-8.91c1.179-3.571.728-7.833-1.813-10.605-2.332-2.544-5.912-3.45-8.848-5.263-3.231-1.994-5.628-5.055-8.374-7.677-3.887-3.712-8.733-6.656-14.071-7.283A15.576,15.576,0,0,0,71.38,49.319c-2.733,2.764-2.535,6.9-6.059,9.226"
                transform="translate(-26.339 -45.097)"
                fill="#e8b61f"
              />
            </g>
          </g>
        </g>
        <path
          id="Path_538"
          data-name="Path 538"
          d="M123.861,91.166a21.048,21.048,0,0,1,6.047,1.482,14.439,14.439,0,0,1,4.506,2.906,10.966,10.966,0,0,1,2.682,4.111,11.165,11.165,0,0,1,.579,5.069,8.163,8.163,0,0,1-1.115,3.486,11.992,11.992,0,0,1-2.158,2.608,17.106,17.106,0,0,1-2.644,1.978q-1.395.843-2.6,1.546a16.073,16.073,0,0,0-2.03,1.373,2.186,2.186,0,0,0-.9,1.446l-.181,1.747a.759.759,0,0,1-.833.677l-8.548-.884a.759.759,0,0,1-.677-.832l.356-3.442a3.916,3.916,0,0,1,.769-1.954,9.962,9.962,0,0,1,1.613-1.692q.954-.8,2.02-1.563a25.5,25.5,0,0,0,2.025-1.606,10.186,10.186,0,0,0,1.623-1.793,4.494,4.494,0,0,0,.789-2.155,4.742,4.742,0,0,0-.1-1.578,3.817,3.817,0,0,0-.626-1.386,3.89,3.89,0,0,0-1.128-1.031,3.756,3.756,0,0,0-1.6-.514,3.9,3.9,0,0,0-2,.229,3.2,3.2,0,0,0-1.28,1,4.392,4.392,0,0,0-.724,1.522,11.352,11.352,0,0,0-.331,1.8q-.042.4-.082.79v.008a.768.768,0,0,1-.835.7l-9.34-.966a.76.76,0,0,1-.68-.755v-.434a10.267,10.267,0,0,1,.057-1.113,11.023,11.023,0,0,1,1.742-5.048,11.778,11.778,0,0,1,3.754-3.576,15.627,15.627,0,0,1,5.343-1.96,22.907,22.907,0,0,1,6.512-.2"
          transform="translate(-64.352 -67.514)"
          fill="#fff"
        />
        <path
          id="Path_539"
          data-name="Path 539"
          d="M136.448,180.523l-8.657-.895a.759.759,0,0,1-.677-.833l.825-7.981a.759.759,0,0,1,.833-.677l8.657.895a.759.759,0,0,1,.677.833l-.825,7.981a.759.759,0,0,1-.833.677"
          transform="translate(-76.812 -115.233)"
          fill="#fff"
        />
        <path
          id="Path_540"
          data-name="Path 540"
          d="M123.3,118.32c-.11,0-.221-.006-.332-.017l-8.548-.884a3.211,3.211,0,0,1-2.889-3.2,3.271,3.271,0,0,1,.017-.334l.356-3.441a6.384,6.384,0,0,1,.324-1.453l.749.263a5.583,5.583,0,0,0-.284,1.271l-.356,3.442a2.461,2.461,0,0,0-.013.252,2.419,2.419,0,0,0,2.177,2.411l8.548.884a2.428,2.428,0,0,0,.251.013h.063l.019.793Zm8.577-7.684-.446-.656a19.124,19.124,0,0,0,2.1-1.656,13.61,13.61,0,0,0,2.113-2.437l.656.446a14.418,14.418,0,0,1-2.236,2.58,19.973,19.973,0,0,1-2.188,1.724m-22.63-7.23-4.355-.45a3.209,3.209,0,0,1-1.74-.734l.511-.608a2.416,2.416,0,0,0,1.311.553l4.356.45Zm-3.5-12.338-.609-.509a14.463,14.463,0,0,1,3.6-3.079A18.158,18.158,0,0,1,114.91,85.2a25.443,25.443,0,0,1,7.161-.23l-.08.79a24.634,24.634,0,0,0-6.937.221,17.374,17.374,0,0,0-5.907,2.174,13.668,13.668,0,0,0-3.4,2.91"
          transform="translate(-62.358 -63.774)"
          fill="#fff"
        />
        <path
          id="Path_541"
          data-name="Path 541"
          d="M132.785,182.985a3.218,3.218,0,0,1-.331-.017l-8.658-.9a3.211,3.211,0,0,1-2.889-3.2,3.244,3.244,0,0,1,.017-.333l.054-.524.789.081-.054.524a2.423,2.423,0,0,0,2.163,2.662l8.658.9a2.41,2.41,0,0,0,.25.013l.037.794Zm3.735-8.048-.789-.082.292-2.821a2.424,2.424,0,0,0-.331-1.5l.68-.409a3.214,3.214,0,0,1,.44,1.988Z"
          transform="translate(-73.07 -115.23)"
          fill="#fff"
        />
        <path
          id="Path_542"
          data-name="Path 542"
          d="M195.69,164.572a.176.176,0,0,1-.126-.052.178.178,0,0,1,0-.252l18.37-18.369a.178.178,0,0,1,.252.252l-18.37,18.37a.177.177,0,0,1-.126.052"
          transform="translate(-118.072 -100.582)"
          fill="#f15a29"
        />
        <path
          id="Path_543"
          data-name="Path 543"
          d="M208.579,95.989a.176.176,0,0,1-.126-.052.178.178,0,0,1,0-.252l18.639-18.639a.178.178,0,0,1,.252.252L208.7,95.937a.177.177,0,0,1-.126.052"
          transform="translate(-125.847 -59.05)"
          fill="#f15a29"
        />
        <path
          id="Path_544"
          data-name="Path 544"
          d="M66.3,89.581a.176.176,0,0,1-.126-.052.178.178,0,0,1,0-.252l18.5-18.5a.178.178,0,0,1,.252.252l-18.5,18.5a.177.177,0,0,1-.126.052"
          transform="translate(-40.022 -55.266)"
          fill="#f15a29"
        />
        <path
          id="Path_545"
          data-name="Path 545"
          d="M32.89,183.1a.176.176,0,0,1-.126-.052.178.178,0,0,1,0-.252l13.323-13.323a.178.178,0,1,1,.252.252L33.015,183.046a.177.177,0,0,1-.126.052"
          transform="translate(-19.87 -114.802)"
          fill="#f15a29"
        />
        <path
          id="Path_546"
          data-name="Path 546"
          d="M89.7,189.7a.177.177,0,0,1-.126-.052.178.178,0,0,1,0-.252l2.624-2.624a.178.178,0,1,1,.252.252l-2.625,2.624a.176.176,0,0,1-.126.052"
          transform="translate(-54.138 -125.235)"
          fill="#f15a29"
        />
        <path
          id="Path_547"
          data-name="Path 547"
          d="M161.265,232.226a.176.176,0,0,1-.126-.052.178.178,0,0,1,0-.252l11.237-11.237a.178.178,0,0,1,.252.252L161.39,232.174a.177.177,0,0,1-.126.052"
          transform="translate(-97.307 -145.694)"
          fill="#f15a29"
        />
        <path
          id="Path_548"
          data-name="Path 548"
          d="M191.281,80.971a.178.178,0,0,1-.126-.3l5.316-5.315a.178.178,0,0,1,.252.252l-5.316,5.315a.176.176,0,0,1-.126.052"
          transform="translate(-115.413 -58.028)"
          fill="#f15a29"
        />
        <path
          id="Path_549"
          data-name="Path 549"
          d="M55.1,128.959a.177.177,0,0,1-.126-.052.178.178,0,0,1,0-.252l18.37-18.37a.178.178,0,0,1,.252.252l-18.37,18.37a.176.176,0,0,1-.126.052"
          transform="translate(-33.27 -79.1)"
          fill="#fff"
        />
        <path
          id="Path_550"
          data-name="Path 550"
          d="M41.538,197.4a.176.176,0,0,1-.126-.052.178.178,0,0,1,0-.252l18.639-18.639a.178.178,0,1,1,.252.252l-18.64,18.64a.177.177,0,0,1-.126.052"
          transform="translate(-25.086 -120.222)"
          fill="#fff"
        />
        <path
          id="Path_551"
          data-name="Path 551"
          d="M184.159,203.881a.176.176,0,0,1-.126-.052.178.178,0,0,1,0-.252l18.5-18.5a.178.178,0,1,1,.252.252l-18.5,18.5a.176.176,0,0,1-.126.052"
          transform="translate(-111.117 -124.213)"
          fill="#fff"
        />
        <path
          id="Path_552"
          data-name="Path 552"
          d="M230.625,113.059a.176.176,0,0,1-.126-.052.178.178,0,0,1,0-.252l13.323-13.323a.178.178,0,0,1,.252.252L230.75,113.007a.177.177,0,0,1-.126.052"
          transform="translate(-139.146 -72.554)"
          fill="#fff"
        />
        <path
          id="Path_553"
          data-name="Path 553"
          d="M200.778,112.026a.177.177,0,0,1-.126-.052.178.178,0,0,1,0-.252l2.624-2.624a.178.178,0,1,1,.252.252l-2.624,2.624a.176.176,0,0,1-.126.052"
          transform="translate(-121.142 -78.384)"
          fill="#fff"
        />
        <path
          id="Path_554"
          data-name="Path 554"
          d="M107.507,65.016a.176.176,0,0,1-.126-.052.178.178,0,0,1,0-.252l11.237-11.237a.178.178,0,0,1,.252.252L107.632,64.964a.177.177,0,0,1-.126.052"
          transform="translate(-64.879 -44.831)"
          fill="#fff"
        />
        <path
          id="Path_555"
          data-name="Path 555"
          d="M92.414,219.351a.176.176,0,0,1-.126-.052.178.178,0,0,1,0-.252l5.315-5.316a.178.178,0,0,1,.252.252L92.539,219.3a.177.177,0,0,1-.126.052"
          transform="translate(-55.775 -141.5)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);
export const BsWhatsapp = ({ customClass }) => (
  <i className={`flaticon-whatsapp ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   stroke-width="0"
  //   viewBox="0 0 16 16"
  //   className={customClass}
  // >
  //   <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
  // </svg>
);

export const FaLinkedinIn = ({ customClass }) => (
  <i className={`flaticon-linkedin ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   stroke-width="0"
  //   viewBox="0 0 448 512"
  //   className={customClass}
  // >
  //   <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path>
  // </svg>
);

export const GrFacebookOption = ({ customClass }) => (
  <i className={`flaticon-facebook-app-symbol ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   stroke-width="0"
  //   viewBox="0 0 24 24"
  //   className={customClass}
  // >
  //   <path
  //     fillRule="evenodd"
  //     d="M9.94474914,22 L9.94474914,13.1657526 L7,13.1657526 L7,9.48481614 L9.94474914,9.48481614 L9.94474914,6.54006699 C9.94474914,3.49740494 11.8713513,2 14.5856738,2 C15.8857805,2 17.0033128,2.09717672 17.3287076,2.13987558 L17.3287076,5.32020466 L15.4462767,5.32094085 C13.9702212,5.32094085 13.6256856,6.02252733 13.6256856,7.05171716 L13.6256856,9.48481614 L17.306622,9.48481614 L16.5704347,13.1657526 L13.6256856,13.1657526 L13.6845806,22"
  //   ></path>
  // </svg>
);

export const BsThreeDots = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    stroke-width="0"
    viewBox="0 0 16 16"
    className={customClass}
  >
    <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"></path>
  </svg>
);

export const IoIosArrowBack = ({ customClass }) => (
  <i className={`flaticon-left-chevron  ${customClass}`}></i>
);

export const SiSimpleanalytics = ({ customClass }) => (
  <i className={`flaticon-graph-bar ${customClass}`}></i>
);

export const RiPlayListAddFill = ({ customClass }) => (
  <i className={`flaticon-add-to-playlist ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   stroke-width="0"
  //   viewBox="0 0 24 24"
  //   className={customClass}
  // >
  //   <g>
  //     <path fill="none" d="M0 0h24v24H0z"></path>
  //     <path d="M2 18h10v2H2v-2zm0-7h20v2H2v-2zm0-7h20v2H2V4zm16 14v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3z"></path>
  //   </g>
  // </svg>
);

export const IoCloudUpload = ({ customClass }) => (
  <i className={`flaticon-cloud-upload ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   stroke-width="0"
  //   viewBox="0 0 512 512"
  //   className={customClass}
  // >
  //   <path d="M473.66 210c-14-10.38-31.2-18-49.36-22.11a16.11 16.11 0 01-12.19-12.22c-7.8-34.75-24.59-64.55-49.27-87.13C334.15 62.25 296.21 47.79 256 47.79c-35.35 0-68 11.08-94.37 32.05a150.07 150.07 0 00-42.06 53 16 16 0 01-11.31 8.87c-26.75 5.4-50.9 16.87-69.34 33.12C13.46 197.33 0 227.24 0 261.39c0 34.52 14.49 66 40.79 88.76 25.12 21.69 58.94 33.64 95.21 33.64h104V230.42l-36.69 36.69a16 16 0 01-23.16-.56c-5.8-6.37-5.24-16.3.85-22.39l63.69-63.68a16 16 0 0122.62 0L331 244.14c6.28 6.29 6.64 16.6.39 22.91a16 16 0 01-22.68.06L272 230.42v153.37h124c31.34 0 59.91-8.8 80.45-24.77 23.26-18.1 35.55-44 35.55-74.83 0-29.94-13.26-55.61-38.34-74.19zM240 448.21a16 16 0 1032 0v-64.42h-32z"></path>
  // </svg>
);

export const FaGraduationCap = ({ customClass }) => (
  <i
    className={`flaticon-black-graduation-cap-tool-of-university-student-for-head ${customClass}`}
  ></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   stroke-width="0"
  //   viewBox="0 0 640 512"
  //   className={customClass}
  // >
  //   <path d="M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"></path>
  // </svg>
);

export const FaUserEdit = ({ customClass }) => (
  <i
    className={`flaticon-black-graduation-cap-tool-of-university-student-for-head ${customClass}`}
  ></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   stroke-width="0"
  //   viewBox="0 0 640 512"
  //   className={customClass}
  // >
  //   <path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"></path>
  // </svg>
);

export const FaClinicMedical = ({ customClass }) => (
  <i className={`flaticon-hospital ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   stroke-width="0"
  //   viewBox="0 0 576 512"
  //   className={customClass}
  // >
  //   <path d="M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"></path>
  // </svg>
);

export const IoIosAddCircle = ({ customClass }) => (
  <i className={`flaticon-add-button ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   stroke-width="0"
  //   viewBox="0 0 512 512"
  //   className={customClass}
  // >
  //   <path d="M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm90.5 224H272v74.5c0 8.8-7.2 16-16 16-4.4 0-8.4-1.8-11.3-4.7-2.9-2.9-4.7-6.9-4.7-11.3V272h-74.5c-4.4 0-8.4-1.8-11.3-4.7-2.9-2.9-4.7-6.9-4.7-11.3 0-8.8 7.2-16 16-16H240v-74.5c0-8.8 7.2-16 16-16s16 7.2 16 16V240h74.5c8.8 0 16 7.2 16 16s-7.2 16-16 16z"></path>
  // </svg>
);

export const IoIosArrowForward = ({ customClass }) => (
  <i className={`flaticon-chevron ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   stroke-width="0"
  //   viewBox="0 0 512 512"
  //   className={customClass}
  // >
  //   <path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"></path>
  // </svg>
);

export const SlUserFollowing = ({ customClass }) => (
  <i className={`flaticon-add-friend ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   stroke-width="0"
  //   viewBox="0 0 1024 1024"
  //   className={customClass}
  // >
  //   <path d="M63.504 959.76l.002-64.942c0-25.44 19.103-33.424 26.72-36.944l281.04-132.624c20.143-9.248 34.047-28.32 36.752-50.32 2.72-22-6.16-43.84-23.457-57.712-66.48-53.376-97.456-170.704-97.456-233.185v-159.92c0-66.864 116.4-159.856 224.128-159.856 108.672 0 223.936 91.536 223.936 159.856v159.92c0 61.552-25.6 179.312-94.256 233.376a63.99 63.99 0 0 0-23.967 57.808c2.624 22.16 16.591 41.313 36.847 50.624l162.24 77.248 38.144-54.064-173.664-81.344c88.656-69.776 118.656-206.849 118.656-283.665v-159.92C799.169 118.176 652.545.241 511.233.241S223.105 118.177 223.105 224.096v159.92c0 69.872 31.888 211.248 121.392 283.088L63.457 799.76S-.495 828.256-.495 863.728v96.032c0 35.344 28.64 63.968 63.951 63.968h639.712l-52-63.984zm948.706-236.253c-13.904-10.912-34.032-8.432-44.912 5.473L830.45 937.684l-85.056-85.073c-12.496-12.496-32.768-12.496-45.264 0s-12.496 32.752 0 45.248l113.136 113.136c12.496 12.496 32.752 12.496 45.248 0 3.04-3.024 5.312-6.544 6.88-10.288l152.304-232.304c10.88-13.904 8.432-34.016-5.488-44.896z"></path>
  // </svg>
);

export const FaPlay = ({ customClass }) => (
  <i className={`flaticon-play-1 ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   stroke-width="0"
  //   viewBox="0 0 448 512"
  //   className={customClass}
  // >
  //   <path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path>
  // </svg>
);

export const ClockLogo = ({ customClass }) => (
  <i className={`flaticon-clock ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   stroke-width="0"
  //   viewBox="0 0 16 16"
  //   className={customClass}
  // >
  //   <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"></path>
  //   <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"></path>
  //   <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"></path>
  // </svg>
);
export const AchievementColor = ({ customClass }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.422"
    height="14.695"
    viewBox="0 0 12.422 14.695"
    className={customClass}
  >
    <g id="medal" transform="translate(-39.592)">
      <path
        id="Path_1"
        data-name="Path 1"
        d="M42.8,221.248l-3.209,6.046,2.914-.269,1.411,2.565,3.209-6.046Z"
        transform="translate(0 -214.895)"
        fill="#355fd3"
      />
      <g id="Group_1" data-name="Group 1" transform="translate(42.243 6.353)">
        <path
          id="Path_2"
          data-name="Path 2"
          d="M132.846,261.028a.41.41,0,0,0-.193-.525l-.185-.1a.395.395,0,0,1,.38-.692l.522.277a.329.329,0,0,0,.447-.139l.013-.025a.311.311,0,0,0-.12-.439l-1.561-.828a.411.411,0,0,1-.195-.525.4.4,0,0,1,.544-.182l1.448.769a.333.333,0,0,0,.449-.138l.008-.021,0,0a.347.347,0,0,0-.143-.472l-.812-.431a.411.411,0,0,1-.193-.527.4.4,0,0,1,.544-.182l.9.476a.335.335,0,0,0,.455-.154l0,0,0,0a.335.335,0,0,0-.127-.463l-.968-.514a.41.41,0,0,1-.193-.524.4.4,0,0,1,.544-.182l2.388,1.268-3.209,6.046-.884-1.608A.376.376,0,0,0,132.846,261.028Z"
          transform="translate(-131.92 -254.446)"
          fill="#fff"
          opacity="0.097"
        />
        <path
          id="Path_3"
          data-name="Path 3"
          d="M214.125,221.248l3.209,6.046-2.914-.269-1.411,2.565-3.209-6.046Z"
          transform="translate(-207.564 -221.248)"
          fill="#355fd3"
        />
      </g>
      <path
        id="Path_4"
        data-name="Path 4"
        d="M213.773,261.043a.41.41,0,0,1,.193-.525l.185-.1a.395.395,0,0,0-.38-.692l-.522.277a.329.329,0,0,1-.447-.139l-.013-.025a.311.311,0,0,1,.12-.439l1.562-.829a.411.411,0,0,0,.195-.525.4.4,0,0,0-.544-.182l-1.448.769a.333.333,0,0,1-.449-.138l-.008-.021,0,0a.347.347,0,0,1,.143-.472l.812-.431a.411.411,0,0,0,.193-.527.4.4,0,0,0-.544-.182l-.9.477a.335.335,0,0,1-.455-.154l0,0,0,0a.335.335,0,0,1,.127-.463l.968-.514a.41.41,0,0,0,.193-.524.4.4,0,0,0-.544-.182l-2.388,1.268,3.209,6.046.884-1.608A.382.382,0,0,1,213.773,261.043Z"
        transform="translate(-165.336 -248.109)"
        fill="#fff"
        opacity="0.096"
      />
      <circle
        id="Ellipse_1"
        data-name="Ellipse 1"
        cx="5.362"
        cy="5.362"
        r="5.362"
        transform="translate(40.441 0)"
        fill="#ffcc5b"
      />
      <path
        id="Path_5"
        data-name="Path 5"
        d="M75.762,18.361h-3.4a.483.483,0,0,1-.481-.481l0-.033v-.007a.5.5,0,0,1,.5-.507h2.355a.6.6,0,0,0,.606-.544.576.576,0,0,0-.573-.6H72.283a.486.486,0,0,1-.477-.507v-.015a.486.486,0,0,1,.477-.507h2.611a.594.594,0,0,0,.6-.54.574.574,0,0,0-.573-.6H73.011a5.362,5.362,0,0,0,0,9.918h2.427a.594.594,0,0,0,.6-.54.573.573,0,0,0-.573-.6H72.707a.571.571,0,0,1-.571-.6.593.593,0,0,1,.6-.541H73.81a.572.572,0,0,0-.017-1.144H72.17a.477.477,0,0,1-.477-.481v-.04a.452.452,0,0,1,.452-.481h3.584a.6.6,0,0,0,.606-.54A.574.574,0,0,0,75.762,18.361Z"
        transform="translate(-29.232 -13.614)"
        fill="#fdbc4b"
      />
      <path
        id="Path_6"
        data-name="Path 6"
        d="M126.412,61.095a3.827,3.827,0,1,1,3.828-3.827A3.832,3.832,0,0,1,126.412,61.095Z"
        transform="translate(-80.609 -51.905)"
        fill="#ffdb70"
      />
      <path
        id="Path_7"
        data-name="Path 7"
        d="M231.937,57.641a3.829,3.829,0,0,0-3.608-3.817h-.357a.454.454,0,0,0-.459.412.438.438,0,0,0,.437.459h2.106a.436.436,0,0,1,.435.459.453.453,0,0,1-.46.413h-.816a.436.436,0,0,0,.012.872h1.238a.364.364,0,0,1,.364.367v.03a.344.344,0,0,1-.345.367h-2.733a.454.454,0,0,0-.462.412.438.438,0,0,0,.437.459h2.591a.368.368,0,0,1,.367.367l0,.025v.006a.383.383,0,0,1-.384.386h-1.8a.455.455,0,0,0-.462.414.439.439,0,0,0,.437.459h1.9a.37.37,0,0,1,.364.386v.011a.37.37,0,0,1-.364.386h-1.991a.454.454,0,0,0-.459.412.438.438,0,0,0,.437.459h.525A3.834,3.834,0,0,0,231.937,57.641Z"
        transform="translate(-182.307 -52.278)"
        fill="#fff"
        opacity="0.2"
      />
      <path
        id="Path_8"
        data-name="Path 8"
        d="M159.792,91.553H157.93l-.576-1.771a.247.247,0,0,0-.47,0l-.575,1.771h-1.862A.247.247,0,0,0,154.3,92l1.506,1.094-.575,1.771a.247.247,0,0,0,.38.276l1.506-1.094,1.506,1.094a.247.247,0,0,0,.38-.276l-.575-1.771L159.937,92A.247.247,0,0,0,159.792,91.553Z"
        transform="translate(-111.317 -87.039)"
        fill="#ec9922"
      />
    </g>
  </svg>
);
export const ReelIcon = ({ customClass }) => (
  <i className={`flaticon-video ${customClass}`}></i>
  // <svg
  //   id="Layer_3"
  //   height="512"
  //   viewBox="0 0 22 22"
  //   width="512"
  //   data-name="Layer 3"
  //   className={customClass}
  // >
  //   <g>
  //     <path
  //       fillRule="evenodd"
  //       fill="currentColor"
  //       d="m-.0132 8v9a5.0018 5.0018 0 0 0 5 5h12a5.0018 5.0018 0 0 0 5-5v-9zm14.49 6.87-6 3.38a.9472.9472 0 0 1 -.49.13 1.0145 1.0145 0 0 1 -1-1v-6.76a1.0039 1.0039 0 0 1 1.49-.87l6 3.38a.9971.9971 0 0 1 0 1.74z"
  //     ></path>
  //     <path
  //       fillRule="evenodd"
  //       fill="currentColor"
  //       d="m6.0968 6h-6.11v-1a4.9909 4.9909 0 0 1 2.27-4.19l1.19 1.62z"
  //     ></path>
  //     <path
  //       fillRule="evenodd"
  //       fill="currentColor"
  //       d="m15.1068 6h-6.52l-2.96-4-1.44-1.93a4.2509 4.2509 0 0 1 .8-.07h5.72l1.46 2z"
  //     ></path>
  //     <path
  //       fillRule="evenodd"
  //       fill="currentColor"
  //       d="m21.9868 5v1h-4.4l-2.95-4-1.47-2h3.82a5.0018 5.0018 0 0 1 5 5z"
  //     ></path>
  //   </g>
  // </svg>
);

export const Dt_Icon1 = ({ customClass }) => (
  <svg
    id="Capa_1"
    enableBackground="new 0 0 512 512"
    height="512"
    viewBox="0 0 512 512"
    width="512"
    className={customClass}
  >
    <g>
      <g>
        <path
          clip-rule="evenodd"
          d="m262.804 475.433c6.156 5.04 9.22 7.781 12.313 7.898 3.063-.118 6.156-2.859 12.313-7.898l162.33-166.222c48.013-51.37 48.013-135.453 0-186.852-43.624-46.684-115.26-36.309-160.711 8.399l-8.542 8.4c-4.949 4.863-5.891 4.863-10.958-.118l-8.395-8.282c-45.362-44.738-117.087-55.083-160.711-8.399-48.013 51.399-48.013 135.482 0 186.852l19.47 19.953z"
          fill="#fd8087"
          fillRule="evenodd"
        />
      </g>
      <g>
        <path
          clip-rule="evenodd"
          d="m309.05 114.402c23.358 33.893 36.908 74.151 36.908 117.328 0 4.715-.177 9.372-.501 13.97-2.592 38.343-15.906 74.004-37.173 104.449-9.367 13.41-20.266 25.817-32.519 37.017-13.078 11.966-27.659 22.517-43.477 31.388-5.42 3.036-10.987 5.894-16.701 8.547l47.218 48.334c6.156 5.04 9.22 7.781 12.313 7.898 3.063-.118 6.156-2.859 12.313-7.898l49.662-50.869 112.667-115.355c37.939-40.583 45.892-101.619 23.889-150.778-5.862-13.056-13.815-25.287-23.889-36.074-6.628-7.073-13.903-12.85-21.621-17.388-25.155-14.765-55.112-16.445-83.389-7.781-12.401 3.802-24.507 9.638-35.7 17.212z"
          fill="#fe636e"
          fillRule="evenodd"
        />
      </g>
      <g>
        <path
          d="m322.983 291.213c-.046 0-.092-.001-.137-.001-2.771-.049-5.303-1.58-6.637-4.01l-39.938-72.817-29.736 51.983c-1.348 2.356-3.831 3.832-6.544 3.889-2.733.05-5.257-1.314-6.701-3.611l-18.471-29.366-13.939 23.164c-1.397 2.323-3.909 3.743-6.619 3.743h-48.278c-4.267 0-7.726-3.461-7.726-7.73s3.459-7.73 7.726-7.73h43.911l18.16-30.179c1.384-2.299 3.86-3.717 6.543-3.743.026-.001.051-.001.076-.001 2.654 0 5.124 1.363 6.539 3.613l18.302 29.097 30.193-52.781c1.377-2.407 3.937-3.89 6.705-3.89.024 0 .046 0 .07.001 2.795.025 5.359 1.559 6.704 4.011l40.071 73.061 20.216-33.953c1.393-2.34 3.915-3.774 6.638-3.774h64.39c4.267 0 7.726 3.461 7.726 7.73s-3.459 7.73-7.726 7.73h-59.999l-24.882 41.79c-1.395 2.342-3.918 3.774-6.637 3.774z"
          fill="#f8f2f0"
        />
      </g>
      <g>
        <path
          clip-rule="evenodd"
          d="m428.139 171.843c46.187 0 83.861-37.695 83.861-83.936 0-46.212-37.674-83.907-83.861-83.907-46.216 0-83.89 37.695-83.89 83.907 0 46.241 37.674 83.936 83.89 83.936z"
          fill="#f8f2f0"
          fillRule="evenodd"
        />
      </g>
      <g>
        <path
          clip-rule="evenodd"
          d="m398.065 9.541c29.485 13.027 50.045 42.499 50.045 76.804 0 .53 0 1.061-.029 1.562-.177 9.755-2.003 19.098-5.243 27.733-8.365 22.517-26.157 40.465-48.543 49.071 10.339 4.598 21.797 7.132 33.845 7.132 16.76 0 32.401-4.922 45.509-13.41 23.093-14.972 38.351-40.966 38.351-70.526 0-46.33-37.556-83.907-83.861-83.907-10.604 0-20.736 1.945-30.074 5.541z"
          fill="#d6dcea"
          fillRule="evenodd"
        />
      </g>
      <path
        d="m458.655 80.176h-22.79v-22.802c0-4.269-3.459-7.73-7.726-7.73s-7.726 3.461-7.726 7.73v22.803h-22.79c-4.267 0-7.726 3.461-7.726 7.73s3.459 7.73 7.726 7.73h22.79v22.803c0 4.269 3.459 7.73 7.726 7.73s7.726-3.461 7.726-7.73v-22.804h22.79c4.267 0 7.726-3.461 7.726-7.73s-3.458-7.73-7.726-7.73z"
        fill="#fd8087"
      />
      <g>
        <path
          clip-rule="evenodd"
          d="m71.548 347.849-17.202 55.82 17.202 59.15 79.236 21.573 64.272 17.477c37.497 11.671 54.051 5.01 88.544-6.071l126.395-40.553c36.289-11.641 30.87-61.567-22.239-44.503l-70.664 13.822-11.547 2.269c-17.143 3.33-19.5 4.715-36.79 2.034l-56.467-10.315-10.251-1.886c-23.152-7.397-14.139-38.402 6.068-35.337 13.667 1.739 31.989 4.214 47.659 5.835.324.029.648.059.943.088 30.251 3.065 42.387-19.54 31.577-37.105-4.094-6.69-11.547-12.673-22.593-16.18l-42.564-7.81c-27.6-5.069-47.218 1.238-90.046 8.282l-24.124 3.979z"
          fill="#fed1a3"
          fillRule="evenodd"
        />
      </g>
      <g>
        <path
          clip-rule="evenodd"
          d="m0 337.858v136.013c0 1.709 1.797 3.095 3.977 3.095h63.566c2.209 0 4.006-1.385 4.006-3.095v-11.052-114.97-9.991c0-1.709-1.797-3.095-4.006-3.095h-63.566c-2.18.001-3.977 1.386-3.977 3.095z"
          fill="#99e6fc"
          fillRule="evenodd"
        />
      </g>
      <g>
        <path
          clip-rule="evenodd"
          d="m0 452.975v20.896c0 1.709 1.797 3.095 3.977 3.095h63.566c2.209 0 4.006-1.385 4.006-3.095v-11.052-9.844c0 1.68-1.797 3.095-4.006 3.095h-63.566c-2.18 0-3.977-1.415-3.977-3.095z"
          fill="#62dbfb"
          fillRule="evenodd"
        />
      </g>
      <g>
        <path
          clip-rule="evenodd"
          d="m71.548 452.975v9.844l79.236 21.573 64.272 17.477c37.497 11.671 54.051 5.01 88.544-6.071l126.395-40.553c20.472-6.543 27.659-25.287 20.531-37.341-3.505 6.955-10.368 13.203-20.531 16.445l-126.395 40.553c-34.493 11.052-51.047 17.742-88.544 6.071l-64.272-17.477-79.236-21.603z"
          fill="#ffbc85"
          fillRule="evenodd"
        />
      </g>
      <g>
        <path
          clip-rule="evenodd"
          d="m228.105 360.434c-16.024-2.417-25.008 16.534-16.525 28.175 3.387-5.04 9.22-8.37 16.525-7.28 13.667 1.739 31.989 4.214 47.659 5.835l.943.088c28.837 2.918 41.209-17.447 32.961-34.571-2.268 4.362-6.068 8.105-11.311 10.61-5.597 2.682-12.872 3.949-21.65 3.065l-.943-.088c-15.67-1.62-33.991-4.096-47.659-5.834z"
          fill="#ffbc85"
          fillRule="evenodd"
        />
      </g>
    </g>
  </svg>
);

export const Dt_Icon2 = ({ customClass }) => (
  <svg height="512" viewBox="0 0 64 64" width="512" className={customClass}>
    <g id="Flat">
      <g id="Stroke_copy_2" data-name="Stroke copy 2">
        <path
          d="m9 21h46a4 4 0 0 1 4 4v30a0 0 0 0 1 0 0h-54a0 0 0 0 1 0 0v-30a4 4 0 0 1 4-4z"
          fill="#84d2f4"
        />
        <path d="m59 47v8h-54v-30a4 4 0 0 1 4-4h44v20a6 6 0 0 0 6 6z" fill="#57b7eb" />
        <path d="m38 53v2h-12v-2h-23v4a4 4 0 0 0 4 4h50a4 4 0 0 0 4-4v-4z" fill="#e9f1f2" />
        <path d="m61 57a4 4 0 0 1 -4 4h-50a4 4 0 0 1 -4-4v-4h4a4 4 0 0 0 4 4z" fill="#d0d8da" />
        <g fill="#656b76">
          <circle cx="50" cy="57" r="1" />
          <circle cx="54" cy="57" r="1" />
          <circle cx="10" cy="57" r="1" />
          <circle cx="14" cy="57" r="1" />
        </g>
        <path
          d="m36 9a1 1 0 0 1 -1-1 3 3 0 0 0 -6 0 1 1 0 0 1 -2 0 5 5 0 0 1 10 0 1 1 0 0 1 -1 1z"
          fill="#fcbc04"
        />
        <path d="m15 10h34v39h-34z" fill="#e9f1f2" />
        <path d="m23 10h17v4h-17z" fill="#d0d8da" />
        <path d="m49 39v10h-34v-39h5v1a28.005 28.005 0 0 0 28 28z" fill="#d0d8da" />
        <path d="m24 7h16v6h-16z" fill="#f9e109" />
        <circle cx="32" cy="26" fill="#84d2f4" r="9" />
        <path d="m37 24h-3v-3h-4v3h-3v4h3v3h4v-3h3z" fill="#f9e109" />
        <path d="m40 10v3h-16v-6h2a3 3 0 0 0 3 3z" fill="#fcbc04" />
        <path
          d="m33.41 34.89a9.358 9.358 0 0 1 -1.41.11 8.993 8.993 0 0 1 -8.78-10.97 27.938 27.938 0 0 0 10.19 10.86z"
          fill="#57b7eb"
        />
        <path d="m37 26v2h-3v3h-4v-3h-3v-4h3v-3h2v3a2.006 2.006 0 0 0 2 2z" fill="#fcbc04" />
        <path d="m43 40h-14a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2z" fill="#f9e109" />
        <path d="m36 44h-14a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2z" fill="#fcbc04" />
        <path d="m43 44h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2z" fill="#fcbc04" />
        <path
          d="m44 39a1 1 0 0 1 -1 1h-14a1 1 0 0 1 0-2h11.58a26.868 26.868 0 0 0 3.37.71.929.929 0 0 1 .05.29z"
          fill="#fcbc04"
        />
      </g>
    </g>
  </svg>
);

export const Dt_Icon3 = ({ customClass }) => (
  <svg
    id="Capa_1"
    enableBackground="new 0 0 512 512"
    height="512"
    viewBox="0 0 512 512"
    width="512"
    className={customClass}
  >
    <g>
      <g>
        <path
          d="m432.91 308.882c-4.143 0-7.5-3.357-7.5-7.5v-168.041c0-7.341-5.972-13.313-13.312-13.313h-53.57c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h53.57c15.611 0 28.312 12.701 28.312 28.313v168.041c0 4.142-3.357 7.5-7.5 7.5z"
          fill="#bfbfbf"
        />
      </g>
      <g>
        <path
          d="m79.09 308.882c-4.143 0-7.5-3.357-7.5-7.5v-168.041c0-15.612 12.701-28.313 28.312-28.313h53.57c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5h-53.57c-7.341 0-13.312 5.973-13.312 13.313v168.041c0 4.142-3.358 7.5-7.5 7.5z"
          fill="#bfbfbf"
        />
      </g>
      <g>
        <g>
          <path
            d="m0 502v-41.208c0-16.133 11.565-29.946 27.447-32.782l30.83-5.505h41.626l30.83 5.505c15.882 2.836 27.447 16.649 27.447 32.782v41.208c0 5.523-4.477 10-10 10h-138.18c-5.523 0-10-4.477-10-10z"
            fill="#528fd8"
          />
        </g>
        <g>
          <path
            d="m130.732 428.009-8.988-1.605c5.841 6.038 9.378 14.24 9.378 23.157v62.439h17.057c5.523 0 10-4.477 10-10v-41.208c0-16.134-11.565-29.947-27.447-32.783z"
            fill="#0573ce"
          />
        </g>
        <g>
          <path
            d="m99.902 422.504-15.931 22.303c-2.393 3.35-7.372 3.35-9.765 0l-15.931-22.303v-29.138h41.626v29.138z"
            fill="#f6a96c"
          />
        </g>
        <g>
          <path
            d="m120.715 364.228c0 22.989-18.637 41.626-41.626 41.626s-41.626-18.637-41.626-41.626v-31.22h83.252z"
            fill="#fed2a4"
          />
        </g>
        <g>
          <path
            d="m120.715 333.008c0-22.718-18.2-41.186-40.814-41.618-23.336-.446-42.438 19.1-42.438 42.44v13.747c31.748 0 51.389-8.475 58.923-12.497 1.859-.993 4.176-.376 5.271 1.426 2.62 4.311 8.424 11.072 19.058 11.072z"
            fill="#5a5a5a"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="m353.821 502v-41.208c0-16.133 11.565-29.946 27.447-32.782l30.83-5.505h41.626l30.83 5.505c15.881 2.835 27.446 16.648 27.446 32.782v41.208c0 5.523-4.477 10-10 10h-138.179c-5.523 0-10-4.477-10-10z"
            fill="#bbec6c"
          />
        </g>
        <g>
          <path
            d="m484.553 428.009-8.988-1.605c5.841 6.038 9.378 14.24 9.378 23.157v62.439h17.057c5.523 0 10-4.477 10-10v-41.208c0-16.134-11.565-29.947-27.447-32.783z"
            fill="#a2e62e"
          />
        </g>
        <g>
          <path
            d="m453.724 422.504-15.931 22.303c-2.393 3.35-7.372 3.35-9.765 0l-15.931-22.303v-29.138h41.626v29.138z"
            fill="#f6a96c"
          />
        </g>
        <g>
          <path
            d="m474.537 364.228c0 22.989-18.637 41.626-41.626 41.626s-41.626-18.637-41.626-41.626v-31.22h83.252z"
            fill="#fed2a4"
          />
        </g>
        <g>
          <path
            d="m474.537 333.008c0-22.718-18.199-41.186-40.814-41.618-23.336-.446-42.438 19.1-42.438 42.44v13.747c31.748 0 51.389-8.475 58.923-12.497 1.859-.993 4.176-.376 5.271 1.426 2.62 4.311 8.424 11.072 19.058 11.072z"
            fill="#5a5a5a"
          />
        </g>
      </g>
      <g>
        <path
          d="m298.198 256 6.101-18.302c5.302-15.905 14.486-30.293 26.948-41.508 22.888-20.597 37.281-50.448 37.281-83.663-.001-62.147-50.381-112.527-112.528-112.527s-112.527 50.38-112.527 112.527c0 33.215 14.393 63.066 37.281 83.663 12.462 11.215 21.647 25.603 26.949 41.508l6.099 18.302z"
          fill="#ffe177"
        />
      </g>
      <g>
        <path
          d="m299.221 8.606c17.898 21.661 28.652 49.441 28.652 79.734 0 69.179-56.081 125.26-125.26 125.26-2.312 0-4.608-.068-6.889-.191 5.069 7.475 9.1 15.656 11.978 24.29l6.1 18.302h84.396l6.1-18.302c5.302-15.905 14.486-30.293 26.949-41.508 22.888-20.597 37.281-50.447 37.281-83.663-.001-46.833-28.613-86.978-69.307-103.922z"
          fill="#ffd15b"
        />
      </g>
      <g>
        <path
          d="m284.841 338.142h-58.026c-5.264 0-9.743-3.834-10.556-9.035l-6.22-39.807h91.577l-6.22 39.807c-.812 5.201-5.291 9.035-10.555 9.035z"
          fill="#5a5a5a"
        />
      </g>
      <g>
        <path
          d="m280.249 289.301-6.22 39.806c-.813 5.201-5.292 9.035-10.556 9.035h21.368c5.264 0 9.743-3.834 10.556-9.035l6.22-39.806z"
          fill="#444"
        />
      </g>
      <g>
        <g>
          <path
            d="m309.073 289.301h-106.146c-4.598 0-8.325-3.727-8.325-8.325v-16.65c0-4.598 3.727-8.325 8.325-8.325h106.146c4.598 0 8.325 3.727 8.325 8.325v16.65c0 4.597-3.727 8.325-8.325 8.325z"
            fill="#cecece"
          />
        </g>
        <g>
          <path
            d="m309.073 256h-31.22c4.598 0 8.325 3.727 8.325 8.325v16.65c0 4.598-3.727 8.325-8.325 8.325h31.22c4.598 0 8.325-3.727 8.325-8.325v-16.65c0-4.598-3.727-8.325-8.325-8.325z"
            fill="#bfbfbf"
          />
        </g>
      </g>
      <g fill="#ffc344">
        <path d="m272.456 143.011c-4.143 0-7.5 3.357-7.5 7.5v105.489h15v-105.489c0-4.143-3.357-7.5-7.5-7.5z" />
        <path d="m239.2 143.011c-4.143 0-7.5 3.357-7.5 7.5v105.489h15v-105.489c0-4.143-3.357-7.5-7.5-7.5z" />
      </g>
      <g>
        <g>
          <path
            d="m322.43 118.631v-12.206c0-3.076-2.241-5.694-5.28-6.169l-9.753-1.524c-2.188-.342-4.061-1.806-4.843-3.879-.367-.971-.763-1.928-1.187-2.87-.91-2.019-.624-4.377.682-6.166l5.818-7.973c1.813-2.485 1.547-5.92-.629-8.096l-8.631-8.631c-2.175-2.175-5.611-2.442-8.096-.629l-7.973 5.818c-1.789 1.305-4.147 1.592-6.166.682-.941-.424-1.898-.82-2.87-1.187-2.072-.782-3.537-2.655-3.879-4.843l-1.524-9.753c-.475-3.039-3.093-5.28-6.169-5.28h-12.206c-3.076 0-5.694 2.241-6.169 5.28l-1.524 9.753c-.342 2.188-1.806 4.061-3.879 4.843-.971.367-1.928.763-2.87 1.187-2.019.91-4.377.624-6.166-.682l-7.973-5.818c-2.485-1.813-5.92-1.547-8.096.629l-8.631 8.631c-2.175 2.175-2.442 5.611-.629 8.096l5.818 7.973c1.305 1.789 1.592 4.147.682 6.166-.424.941-.82 1.898-1.187 2.87-.782 2.072-2.655 3.537-4.843 3.879l-9.753 1.524c-3.039.475-5.28 3.093-5.28 6.169v12.206c0 3.076 2.241 5.694 5.28 6.169l9.753 1.524c2.188.342 4.061 1.806 4.843 3.879.367.971.763 1.928 1.187 2.87.91 2.019.624 4.377-.682 6.166l-5.818 7.973c-1.813 2.485-1.547 5.92.629 8.096l8.631 8.631c2.175 2.175 5.611 2.442 8.096.629l7.973-5.818c1.789-1.305 4.147-1.592 6.166-.682.941.424 1.898.82 2.87 1.187 2.072.782 3.537 2.655 3.879 4.843l1.524 9.753c.475 3.039 3.093 5.28 6.169 5.28h12.206c3.076 0 5.694-2.241 6.169-5.28l1.524-9.753c.342-2.188 1.806-4.061 3.879-4.843.971-.367 1.928-.763 2.87-1.187 2.019-.91 4.377-.624 6.166.682l7.973 5.818c2.485 1.813 5.92 1.547 8.096-.629l8.631-8.631c2.175-2.175 2.442-5.611.629-8.096l-5.818-7.973c-1.305-1.789-1.592-4.147-.682-6.166.424-.941.82-1.898 1.187-2.87.782-2.072 2.655-3.537 4.843-3.879l9.753-1.524c3.039-.475 5.28-3.093 5.28-6.169zm-66.602 10.547c-9.196 0-16.65-7.455-16.65-16.65s7.455-16.65 16.65-16.65c9.196 0 16.65 7.455 16.65 16.65s-7.454 16.65-16.65 16.65z"
            fill="#528fd8"
          />
        </g>
        <g>
          <path
            d="m317.15 100.255-9.753-1.524c-2.188-.342-4.061-1.806-4.843-3.878-.367-.971-.763-1.928-1.187-2.87-.91-2.019-.624-4.377.682-6.166l5.818-7.973c1.813-2.485 1.547-5.92-.629-8.096l-8.631-8.631c-1.214-1.214-2.821-1.81-4.436-1.805.775 4.443 1.202 9.006 1.202 13.671 0 43.68-35.41 79.089-79.089 79.089-4.665 0-9.228-.427-13.671-1.202-.005 1.615.591 3.222 1.805 4.436l8.631 8.631c2.175 2.175 5.611 2.442 8.096.629l7.973-5.818c1.789-1.305 4.147-1.592 6.166-.682.941.425 1.898.82 2.87 1.187 2.072.782 3.537 2.655 3.879 4.843l1.524 9.753c.475 3.039 3.093 5.28 6.169 5.28h12.206c3.076 0 5.694-2.241 6.169-5.28l1.524-9.753c.342-2.188 1.806-4.061 3.879-4.843.971-.367 1.928-.762 2.87-1.187 2.019-.91 4.377-.623 6.166.682l7.973 5.818c2.485 1.813 5.92 1.546 8.096-.629l8.631-8.631c2.175-2.175 2.442-5.611.629-8.096l-5.818-7.973c-1.305-1.789-1.592-4.147-.682-6.166.424-.941.82-1.898 1.187-2.87.782-2.072 2.655-3.537 4.843-3.878l9.753-1.524c3.039-.475 5.28-3.093 5.28-6.169v-12.206c-.002-3.076-2.243-5.694-5.282-6.169z"
            fill="#0573ce"
          />
        </g>
      </g>
      <g fill="#0067c5">
        <path d="m123.536 470.735c-4.143 0-7.5 3.357-7.5 7.5v33.765h15v-33.765c0-4.142-3.357-7.5-7.5-7.5z" />
        <path d="m34.643 470.735c-4.143 0-7.5 3.357-7.5 7.5v33.765h15v-33.765c0-4.142-3.358-7.5-7.5-7.5z" />
      </g>
      <g fill="#8bc727">
        <path d="m477.357 470.735c-4.143 0-7.5 3.357-7.5 7.5v33.765h15v-33.765c0-4.142-3.357-7.5-7.5-7.5z" />
        <path d="m388.464 470.735c-4.143 0-7.5 3.357-7.5 7.5v33.765h15v-33.765c0-4.142-3.358-7.5-7.5-7.5z" />
      </g>
    </g>
  </svg>
);

export const Dt_BgGraph = ({ customClass }) => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    height="512"
    width="512"
    className={customClass}
  >
    <g>
      <g>
        <g>
          <g>
            <polygon
              fill="#CAEBFC"
              points="222.8,346.7 277.6,346.7 305.3,298 277.6,249.3 222.2,249.3 194.8,297.4 196.6,298.5       223.4,251.4 276.4,251.4 302.9,298 276.4,344.6 222.8,344.6     "
            />
          </g>
          <g>
            <g>
              <path
                fill="#CAEBFC"
                d="M298.3,298.2c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C300.9,292.3,298.3,294.9,298.3,298.2z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M189.9,298.2c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C192.5,292.3,189.9,294.9,189.9,298.2z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M271.1,250.4c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.7,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C273.7,244.5,271.1,247.2,271.1,250.4z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M271.1,345.5c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C273.7,339.6,271.1,342.2,271.1,345.5z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M217.1,250.4c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.7,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C219.7,244.5,217.1,247.2,217.1,250.4z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M217.1,345.5c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C219.7,339.6,217.1,342.2,217.1,345.5z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <polygon
              fill="#CAEBFC"
              points="115.4,155.7 142.2,108.6 195.2,108.6 222,155.7 223.8,154.7 196.4,106.5 141,106.5 113.6,154.7           "
            />
          </g>
          <g>
            <g>
              <path
                fill="#CAEBFC"
                d="M217.1,155.4c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C219.7,149.5,217.1,152.1,217.1,155.4z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M108.7,155.4c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C111.3,149.5,108.7,152.1,108.7,155.4z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M189.9,107.7c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C192.5,101.8,189.9,104.4,189.9,107.7z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M189.9,202.7c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C192.5,196.8,189.9,199.5,189.9,202.7z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M135.9,107.7c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C138.5,101.8,135.9,104.4,135.9,107.7z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M135.9,202.7c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C138.5,196.8,135.9,199.5,135.9,202.7z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <polygon fill="#CAEBFC" points="140.8,108 142.6,106.9 115.5,59.3 113.7,60.3     " />
          </g>
          <g>
            <g>
              <path
                fill="#CAEBFC"
                d="M108.7,59.9c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C111.3,54,108.7,56.6,108.7,59.9z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <polygon fill="#CAEBFC" points="465.6,298.9 467.4,297.9 440.3,250.2 438.5,251.3     " />
          </g>
          <g>
            <g>
              <path
                fill="#CAEBFC"
                d="M460.7,298.6c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C463.3,292.7,460.7,295.3,460.7,298.6z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M433.5,250.9c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C436.1,245,433.5,247.6,433.5,250.9z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <polygon fill="#CAEBFC" points="59.6,250.8 61.4,249.7 34.3,202 32.5,203.1     " />
          </g>
          <g>
            <g>
              <path
                fill="#CAEBFC"
                d="M54.7,250.4c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C57.3,244.5,54.7,247.2,54.7,250.4z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M27.5,202.7c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C30.1,196.8,27.5,199.4,27.5,202.7z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <polygon fill="#CAEBFC" points="303.1,108 305,106.9 277.9,59.3 276,60.3     " />
          </g>
          <g>
            <g>
              <path
                fill="#CAEBFC"
                d="M298.2,107.6c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C300.8,101.7,298.2,104.4,298.2,107.6z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M271,59.9c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C273.6,54,271,56.6,271,59.9z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <polygon fill="#CAEBFC" points="277.8,60.2 304.9,12.6 303.1,11.5 276,59.2     " />
          </g>
          <g>
            <g>
              <path
                fill="#CAEBFC"
                d="M309.9,12.2c0,3.3-2.6,5.9-5.8,5.9c-3.2,0-5.8-2.6-5.8-5.9c0-3.3,2.6-5.9,5.8-5.9       C307.3,6.3,309.9,8.9,309.9,12.2z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <polygon fill="#CAEBFC" points="440.2,156.1 467.3,108.5 465.5,107.4 438.4,155.1     " />
          </g>
          <g>
            <g>
              <path
                fill="#CAEBFC"
                d="M445.1,155.8c0,3.3-2.6,5.9-5.8,5.9c-3.2,0-5.8-2.6-5.8-5.9c0-3.3,2.6-5.9,5.8-5.9       C442.5,149.9,445.1,152.5,445.1,155.8z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M472.3,108.1c0,3.3-2.6,5.9-5.8,5.9c-3.2,0-5.8-2.6-5.8-5.9c0-3.3,2.6-5.9,5.8-5.9       C469.7,102.2,472.3,104.8,472.3,108.1z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <polygon
              fill="#CAEBFC"
              points="304,299.4 358.8,299.4 386.5,250.7 358.8,201.9 304,201.9 304,204.1 357.6,204.1 384.1,250.7       357.6,297.3 304,297.3     "
            />
          </g>
          <g>
            <g>
              <path
                fill="#CAEBFC"
                d="M379.4,250.9c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C382.1,244.9,379.4,247.6,379.4,250.9z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M352.3,203.1c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C354.9,197.2,352.3,199.9,352.3,203.1z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M352.3,298.2c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C354.9,292.3,352.3,294.9,352.3,298.2z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M298.2,203.1c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C300.9,197.2,298.2,199.9,298.2,203.1z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <polygon
              fill="#CAEBFC"
              points="277.9,251.1 305.3,202.9 277.6,154.2 222.2,154.2 194.8,202.4 196.6,203.5 223.4,156.3       276.4,156.3 302.9,202.9 276.1,250.1     "
            />
          </g>
          <g>
            <g>
              <path
                fill="#CAEBFC"
                d="M271.1,155.4c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C273.7,149.5,271.1,152.1,271.1,155.4z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <polygon
              fill="#CAEBFC"
              points="384.4,155.7 386.2,154.6 358.8,106.5 304,106.5 304,108.6 357.6,108.6     "
            />
          </g>
          <g>
            <g>
              <path
                fill="#CAEBFC"
                d="M352.3,107.6c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C354.9,101.7,352.3,104.4,352.3,107.6z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <polygon
              fill="#CAEBFC"
              points="60.4,346.7 115.3,346.7 143,298 115.3,249.3 59.8,249.3 32.4,297.4 34.2,298.5 61,251.4       114,251.4 140.5,298 114,344.6 60.4,344.6     "
            />
          </g>
          <g>
            <g>
              <path
                fill="#CAEBFC"
                d="M135.9,298.2c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C138.5,292.3,135.9,294.9,135.9,298.2z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M27.5,298.2c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C30.1,292.3,27.5,294.9,27.5,298.2z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M108.7,250.4c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.7,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C111.3,244.5,108.7,247.2,108.7,250.4z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M108.7,345.5c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C111.3,339.6,108.7,342.2,108.7,345.5z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M54.7,345.5c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C57.3,339.6,54.7,342.2,54.7,345.5z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <polygon
              fill="#CAEBFC"
              points="465.6,203.9 467.4,202.8 440,154.6 384.6,154.6 357.2,202.8 359,203.9 385.8,156.7 438.8,156.7           "
            />
          </g>
          <g>
            <rect x="385.2" y="249.9" fill="#CAEBFC" width="54.2" height="2.1" />
          </g>
          <g>
            <g>
              <path
                fill="#CAEBFC"
                d="M472.3,203.5c0,3.3-2.6,5.9-5.8,5.9c-3.2,0-5.8-2.6-5.8-5.9c0-3.3,2.6-5.9,5.8-5.9       C469.7,197.6,472.3,200.3,472.3,203.5z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M391.1,155.8c0,3.3-2.6,5.9-5.8,5.9c-3.2,0-5.8-2.7-5.8-5.9c0-3.3,2.6-5.9,5.8-5.9       C388.5,149.9,391.1,152.5,391.1,155.8z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <polygon
              fill="#CAEBFC"
              points="115.4,250.8 142.2,203.6 195.2,203.6 222,250.8 223.8,249.7 196.4,201.5 141,201.5 113.6,249.7           "
            />
          </g>
        </g>
        <g>
          <g>
            <polygon
              fill="#CAEBFC"
              points="196.8,488.9 224.2,440.7 196.5,392 141.1,392 113.7,440.2 115.5,441.3 142.3,394.1 195.3,394.1       221.8,440.7 195,487.9     "
            />
          </g>
          <g>
            <g>
              <path
                fill="#CAEBFC"
                d="M217.1,440.9c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C219.7,435,217.1,437.7,217.1,440.9z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M108.7,440.9c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C111.4,435,108.7,437.7,108.7,440.9z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M189.9,393.2c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C192.6,387.3,189.9,389.9,189.9,393.2z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M189.9,488.3c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C192.6,482.4,189.9,485,189.9,488.3z"
              />
            </g>
            <g>
              <path
                fill="#CAEBFC"
                d="M135.9,393.2c0,3.3,2.6,5.9,5.8,5.9c3.2,0,5.8-2.6,5.8-5.9c0-3.3-2.6-5.9-5.8-5.9       C138.5,387.3,135.9,389.9,135.9,393.2z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <polygon fill="#CAEBFC" points="140.7,393.9 142.5,392.8 115.4,345.2 113.6,346.2     " />
          </g>
          <g>
            <polygon
              fill="#CAEBFC"
              points="196.7,393.9 224.1,345.7 196.4,297 141.6,297 141.6,299.1 195.2,299.1 221.7,345.7 194.9,392.8           "
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Dt_linkSentIcon = ({ customClass }) => (
  <svg height="512" viewBox="0 0 110 110" width="512" className={customClass}>
    <g id="_19._Login" data-name="19. Login">
      <path
        d="m105 55a50 50 0 0 1 -21 40.73c-26.38-12.31-59-.73-59-.73a50 50 0 1 1 80-40z"
        fill="#e7efff"
      />
      <circle cx="4" cy="16" fill="#00c99f" r="3" />
      <circle cx="96.91" cy="4" fill="#ffa100" r="3" />
      <circle cx="106" cy="93" fill="#00c99f" r="3" />
      <circle cx="8" cy="106" fill="#ff4d69" r="3" />
      <path
        d="m91 33v56.68a50.5 50.5 0 0 1 -7 6c-31.49-14.68-59-.68-59-.68a48.79 48.79 0 0 1 -6-5.31v-56.69a15 15 0 0 1 15-15h42a15 15 0 0 1 15 15z"
        fill="#4e6aff"
      />
      <path d="m84 32v63.73a50 50 0 0 1 -59-.73v-63a8 8 0 0 1 8-8h43a8 8 0 0 1 8 8z" fill="#fff" />
      <path
        d="m65.88 33h-21.76a4 4 0 0 1 -3.88-3l-2.24-9h34l-2.24 9a4 4 0 0 1 -3.88 3z"
        fill="#4e6aff"
      />
      <path d="m56 28h-10a2 2 0 0 1 0-4h10a2 2 0 0 1 0 4z" fill="#323fd4" />
      <circle cx="64" cy="26" fill="#323fd4" r="2" />
      <path
        d="m17 41h2a0 0 0 0 1 0 0v8a0 0 0 0 1 0 0h-2a2 2 0 0 1 -2-2v-4a2 2 0 0 1 2-2z"
        fill="#323fd4"
      />
      <path
        d="m17 53h2a0 0 0 0 1 0 0v10a0 0 0 0 1 0 0h-2a2 2 0 0 1 -2-2v-6a2 2 0 0 1 2-2z"
        fill="#323fd4"
      />
      <circle cx="91" cy="28" fill="#00c99f" r="15" />
      <path
        d="m87.59 33.91-5-5a2 2 0 0 1 2.82-2.82l3.59 3.58 7.59-7.58a2 2 0 0 1 2.82 2.82l-9 9a2 2 0 0 1 -2.82 0z"
        fill="#fff"
      />
      <path
        d="m64 60a3 3 0 0 1 -3-3v-6a6 6 0 0 0 -12 0v6a3 3 0 0 1 -6 0v-6a12 12 0 0 1 24 0v6a3 3 0 0 1 -3 3z"
        fill="#4e6aff"
      />
      <rect fill="#ffa100" height="28" rx="5" width="34" x="38" y="55" />
      <path d="m55 74a2 2 0 0 1 -2-2v-7a2 2 0 0 1 4 0v7a2 2 0 0 1 -2 2z" fill="#fff" />
      <path d="m68 98h-26a5 5 0 0 1 0-10h26a5 5 0 0 1 0 10z" fill="#4e6aff" />
      <g fill="#fff">
        <circle cx="43" cy="93" r="2" />
        <circle cx="51" cy="93" r="2" />
        <circle cx="59" cy="93" r="2" />
        <circle cx="67" cy="93" r="2" />
      </g>
    </g>
  </svg>
);
export const GoalsIcon = ({ customClass }) => (
  <svg
    id="Group_398"
    className={customClass}
    data-name="Group 398"
    xmlns="http://www.w3.org/2000/svg"
    width="46.071"
    height="46.071"
    viewBox="0 0 46.071 46.071"
  >
    <path
      id="Path_1495"
      data-name="Path 1495"
      d="M183.71,175.14a7.29,7.29,0,1,0,5.727,5.727l-4.285,4.285a4.049,4.049,0,0,1-5.727-5.727Z"
      transform="translate(-159.253 -159.253)"
    />
    <path
      id="Path_1496"
      data-name="Path 1496"
      d="M44.01,13.515l-2.9,2.9a4.056,4.056,0,0,1-.972.719,18.085,18.085,0,1,1-11.2-11.2,4.051,4.051,0,0,1,.717-.973l2.9-2.9A23.04,23.04,0,1,0,44.01,13.515"
      transform="translate(0 -0.001)"
    />
    <path
      id="Path_1497"
      data-name="Path 1497"
      d="M106.12,88.928l-.246-2.916a15.387,15.387,0,1,0,8.889,8.889l-2.916-.246-2.14,2.14a9.989,9.989,0,1,1-5.726-5.726Z"
      transform="translate(-77.352 -77.352)"
    />
    <path
      id="Path_1498"
      data-name="Path 1498"
      d="M250.485,15.55l.393,4.657L241.4,29.689A1.35,1.35,0,1,0,243.3,31.6l9.483-9.483,4.657.393c.038,0,.076,0,.114,0a1.35,1.35,0,0,0,.954-.4l5.726-5.727a1.349,1.349,0,0,0-.841-2.3l-4.146-.35L258.9,9.6a1.35,1.35,0,0,0-2.3-.841l-5.726,5.727a1.35,1.35,0,0,0-.391,1.068"
      transform="translate(-219.314 -7.607)"
    />
  </svg>
);
export const AchivementTrophy = ({ customClass }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={customClass}
    width="18.775"
    height="40.23"
    viewBox="0 0 18.775 40.23"
  >
    <path
      id="path1600"
      d="M4.762,308.086v2.682a.671.671,0,0,0,.668.674H6.1v4.692H5.43a.67.67,0,0,0-.668.668v3.355a.67.67,0,0,0,.668.668H22.869a.67.67,0,0,0,.668-.668V316.8a.67.67,0,0,0-.668-.668h-.674v-4.692h.674a.67.67,0,0,0,.668-.674v-2.682a.67.67,0,0,0-.668-.668H21.527V305.4a.67.67,0,0,0-.673-.668h-1.5l-2.114-7.575,2.618,1.458a.671.671,0,0,0,.949-.84L18.331,291.6l4.89-3.057a.671.671,0,0,0-.208-1.222l-5.726-1.273-2.539-5.079a.669.669,0,0,0-1.2,0l-2.541,5.079-5.724,1.273a.671.671,0,0,0-.21,1.222L9.968,291.6l-2.475,6.183a.671.671,0,0,0,.949.84l2.618-1.455-2.114,7.572h-1.5a.671.671,0,0,0-.674.668v2.016H5.4a.674.674,0,0,0-.636.668Zm9.39-25.321,2.082,4.165a.67.67,0,0,0,.452.357l4.438.985-3.976,2.484a.671.671,0,0,0-.268.815l1.983,4.961-4.389-2.441a.671.671,0,0,0-.651,0L9.44,296.531l1.979-4.961a.671.671,0,0,0-.268-.815l-3.976-2.484,4.438-.985a.67.67,0,0,0,.457-.357Zm0,12.678,1.438.8,2.37,8.492H10.339l2.369-8.489ZM8.114,306.077H20.186v1.341H8.114ZM6.1,308.759H22.195V310.1H6.1Zm1.342,2.683H20.854v4.692H7.446ZM6.1,317.476H22.195v2.009H6.1Z"
      transform="translate(-4.762 -280.596)"
    />
  </svg>
);

export const BiSave = ({ customClass }) => (
  <i className={`flaticon-save ${customClass}`}></i>
  // <svg
  //   stroke="currentColor"
  //   fill="currentColor"
  //   stroke-width="0"
  //   viewBox="0 0 24 24"
  //   // height="1em"
  //   // width="1em"
  //   // xmlns="http://www.w3.org/2000/svg"
  //   className={customClass}
  // >
  //   <path d="M5 21h14a2 2 0 0 0 2-2V8a1 1 0 0 0-.29-.71l-4-4A1 1 0 0 0 16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2zm10-2H9v-5h6zM13 7h-2V5h2zM5 5h2v4h8V5h.59L19 8.41V19h-2v-5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v5H5z"></path>
  // </svg>
);
export const FiWifiOff = ({ customClass }) => (
  <svg
    stroke="currentColor"
    className={customClass}
    fill="none"
    stroke-width="2"
    viewBox="0 0 24 24"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <line x1="1" y1="1" x2="23" y2="23"></line>
    <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path>
    <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path>
    <path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path>
    <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path>
    <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
    <line x1="12" y1="20" x2="12.01" y2="20"></line>
  </svg>
);
export const FiWifi = ({ customClass }) => (
  <svg
    stroke="currentColor"
    fill="none"
    className={customClass}
    stroke-width="2"
    viewBox="0 0 24 24"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M5 12.55a11 11 0 0 1 14.08 0"></path>
    <path d="M1.42 9a16 16 0 0 1 21.16 0"></path>
    <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
    <line x1="12" y1="20" x2="12.01" y2="20"></line>
  </svg>
);

export const DateTimeCalendar = ({ customClass }) => (
  <i className={`flaticon-calendar-1 ${customClass}`}></i>
);

export const MdOutlineVideoLibrary = ({ customClass }) => {
  return <i className={`flaticon-playlist ${customClass}`}></i>;
};

export const DoctorIcon = ({ customClass }) => {
  return (
    // <i className={`flaticon-speaker ${customClass}`}></i>
    <svg enableBackground="new 0 0 64 64" viewBox="0 0 64 64" className={customClass}>
      <g id="grid" />
      <g id="Layer_2">
        <path d="m32 31c6.6 0 12-6.1 12-13.5s-5.4-13.5-12-13.5-12 6.1-12 13.5 5.4 13.5 12 13.5zm0-25c5.5 0 10 5.2 10 11.5s-4.5 11.5-10 11.5-10-5.2-10-11.5 4.5-11.5 10-11.5zm12.7 29.4c-.3-.2-4.2-1.6-7.8-2.1-.2 0-.5 0-.7.2l-4.2 3.2-4.2-3.2c-.1-.1-.2-.1-.3-.2-.1 0-.3 0-.4 0-3.5.5-7.1 1.7-7.8 2.1-14.1 5.9-14.3 21.4-14.3 21.6 0 .6.4 1 1 1h52c.6 0 1-.4 1-1 0-.2-.2-15.7-14.3-21.6zm-.7 8.6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm-34.5 3.1c2.1-4.3 5.3-7.4 9.5-9.4v4.5c-3.9.7-5 5.3-5 7.9 0 .6.4 1 1 1h2c.6 0 1-.4 1-1s-.4-1-1-1h-.9c.2-1.7 1-5 3.9-5s3.7 3.3 3.9 5h-.9c-.6 0-1 .4-1 1s.4 1 1 1h2c.6 0 1-.4 1-1 0-2.6-1.1-7.2-5-7.9v-5.3c1.8-.7 3.8-1.2 5.9-1.4l4.1 3.1v17.4h-23.9c.1-1.7.6-5.2 2.4-8.9zm23.5 8.9v-17.5l4.1-3.1c2.2.3 4.2.8 5.9 1.5v5.3c-1.7.4-3 2-3 3.9 0 2.2 1.8 4 4 4s4-1.8 4-4c0-1.9-1.3-3.4-3-3.9v-4.5c10.1 4.8 11.7 15 12 18.3z" />
      </g>
    </svg>
  );
};

export const AgendaIcon = ({ customClass }) => {
  return <i className={`flaticon-checklist ${customClass}`}></i>;
};

export const LunchBreakIcon = ({ customClass }) => {
  return (
    <svg
      id="Capa_1"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
      className={customClass}
    >
      <g>
        <path d="m448.082 403.338h13.524c27.788 0 50.395-22.606 50.395-50.395s-22.606-50.395-50.395-50.395h-8.783v-26.46c0-4.143-3.357-7.5-7.5-7.5h-26.571c4.866-18.052 7.337-36.686 7.337-55.537 0-54.785-20.758-106.842-58.449-146.582-2.852-3.007-7.599-3.131-10.603-.28-3.006 2.851-3.131 7.598-.28 10.603 35.036 36.941 54.332 85.332 54.332 136.26 0 18.892-2.666 37.546-7.915 55.537h-34.431c6.356-17.776 9.584-36.406 9.584-55.537 0-91.137-74.145-165.282-165.281-165.282s-165.283 74.146-165.283 165.282c0 18.365 3 36.421 8.917 53.665 1.345 3.92 5.615 6.008 9.527 4.66 3.918-1.344 6.005-5.609 4.66-9.527-5.378-15.675-8.104-32.093-8.104-48.798 0-82.866 67.416-150.282 150.282-150.282 82.865 0 150.281 67.416 150.281 150.282 0 19.218-3.574 37.875-10.614 55.537h-137.686c-4.143 0-7.5 3.357-7.5 7.5v87.135c-51.412-1.906-98.823-30.314-124.704-75.117-2.072-3.587-6.66-4.814-10.246-2.742-3.586 2.071-4.814 6.659-2.742 10.246 28.67 49.63 80.682 80.771 137.807 82.633.559 11.601 3.193 22.666 7.538 32.833-.713.008-1.43.019-2.134.019-109.202 0-198.045-88.842-198.045-198.044s88.843-198.044 198.045-198.044c44.858 0 87.161 14.624 122.335 42.291 3.254 2.561 7.971 1.998 10.531-1.258 2.562-3.256 1.998-7.971-1.258-10.531-37.843-29.767-83.353-45.502-131.608-45.502-117.474 0-213.045 95.572-213.045 213.044s95.571 213.044 213.045 213.044c3.274 0 6.641-.087 10.049-.249 7.458 11.4 17.277 21.121 28.761 28.459h-50.927c-4.927 0-9.425 2.495-12.034 6.675-2.608 4.18-2.874 9.317-.71 13.741l.295.604c10.894 22.273 33.954 36.666 58.748 36.666h72.592c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-72.592c-18.896 0-36.484-10.846-44.99-27.686h255.874c-8.508 16.84-26.096 27.686-44.991 27.686h-63.313c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h63.313c24.795 0 47.855-14.393 58.755-36.677l.287-.59c2.165-4.426 1.9-9.563-.708-13.743-2.608-4.181-7.107-6.676-12.035-6.676h-50.926c18.471-11.801 32.637-29.764 39.589-50.968zm13.523-85.789c19.517 0 35.395 15.878 35.395 35.395s-15.878 35.395-35.395 35.395h-9.921c.748-4.811 1.138-9.738 1.138-14.755v-56.034h8.783zm-104.505 136.757h-53.851c-44.511 0-80.723-36.212-80.723-80.723v-89.994h215.296v89.994c0 44.511-36.212 80.723-80.722 80.723z" />
        <path d="m213.045 104.085c4.143 0 7.5-3.357 7.5-7.5v-10.602c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v10.603c0 4.142 3.357 7.499 7.5 7.499z" />
        <path d="m300.703 136.001 7.497-7.497c2.929-2.93 2.929-7.678 0-10.607-2.93-2.928-7.678-2.928-10.607 0l-7.497 7.497c-2.929 2.93-2.929 7.678 0 10.607 1.465 1.464 3.385 2.196 5.304 2.196s3.838-.732 5.303-2.196z" />
        <path d="m340.114 220.552c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-10.603c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5z" />
        <path d="m117.89 308.208c2.931 2.929 7.678 2.928 10.607 0l7.497-7.497c2.929-2.93 2.929-7.678 0-10.607-2.93-2.928-7.678-2.928-10.607 0l-7.497 7.497c-2.929 2.929-2.929 7.677 0 10.607z" />
        <path d="m96.578 220.552c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-10.602c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5z" />
        <path d="m125.387 136.001c1.465 1.464 3.385 2.196 5.304 2.196s3.839-.732 5.304-2.196c2.929-2.93 2.929-7.678 0-10.607l-7.497-7.497c-2.93-2.928-7.678-2.928-10.607 0-2.929 2.93-2.929 7.678 0 10.607z" />
        <path d="m205.545 216.136c0 3.141 1.957 5.949 4.904 7.036.848.312 1.725.464 2.594.464 2.152 0 4.251-.928 5.705-2.629l27.103-31.729c2.689-3.149 2.317-7.884-.832-10.574-3.15-2.688-7.885-2.316-10.574.832l-13.899 16.272v-50.648c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v70.976z" />
      </g>
    </svg>
  );
};
export const UpVoteIcon = ({ className }) => {
  return <i className={`flaticon-up-arrow-1 ${customClass}`}></i>;
};
export const ReceiveCertificate = () => {
  return (
    <svg
      id="_016---Certificate"
      data-name="016---Certificate"
      xmlns="http://www.w3.org/2000/svg"
      width="38.476"
      height="34.089"
      viewBox="0 0 38.476 34.089"
    >
      <path
        id="Shape"
        fill="#f3d55b"
        d="M38.084.391A1.3,1.3,0,0,0,37.149,0H1.327A1.3,1.3,0,0,0,.391.391,1.3,1.3,0,0,0,0,1.327V29.188a1.3,1.3,0,0,0,.391.935,1.3,1.3,0,0,0,.935.391H36.486a1.99,1.99,0,0,0,1.99-1.99V1.327a1.3,1.3,0,0,0-.391-.935Z"
        transform="translate(0 0)"
      />
      <path
        id="Shape-2"
        data-name="Shape"
        fill="#f0c419"
        d="M56.317,1.525v27.2a1.985,1.985,0,0,1-.584,1.406L53,27.4V3.515L55.925.59A1.3,1.3,0,0,1,56.317,1.525Z"
        transform="translate(-17.841 -0.199)"
      />
      <path
        id="Shape-3"
        data-name="Shape"
        fill="#f0c419"
        d="M3.317,3.515V27.4L.391,30.322A1.3,1.3,0,0,1,0,29.387V1.525A1.3,1.3,0,0,1,.391.59Z"
        transform="translate(0 -0.199)"
      />
      <path
        id="Shape-4"
        data-name="Shape"
        fill="#f29c1f"
        d="M38.091,43.733a1.986,1.986,0,0,1-1.406.584H1.525a1.3,1.3,0,0,1-.935-.391L3.515,41H35.357Z"
        transform="translate(-0.199 -13.802)"
      />
      <path
        id="Rectangle-path"
        fill="#ecf0f1"
        d="M5,5H36.842V28.881H5Z"
        transform="translate(-1.683 -1.683)"
      />
      <path
        id="Shape-5"
        data-name="Shape"
        fill="#fff"
        d="M36.842,5S5,5,5,28.881V5Z"
        transform="translate(-1.683 -1.683)"
      />
      <path
        id="Shape-6"
        data-name="Shape"
        fill="#bdc3c7"
        d="M30.951,11.327H21.663a.663.663,0,0,1,0-1.327h9.287a.663.663,0,0,1,0,1.327Z"
        transform="translate(-7.069 -3.366)"
      />
      <path
        id="Shape-7"
        data-name="Shape"
        fill="#95a5a5"
        d="M20.951,33.327H11.663a.663.663,0,0,1,0-1.327h9.287a.663.663,0,1,1,0,1.327Z"
        transform="translate(-3.703 -10.772)"
      />
      <path
        id="Shape-8"
        data-name="Shape"
        fill="#bdc3c7"
        d="M31.931,16.327H18.663a.663.663,0,0,1,0-1.327H31.931a.663.663,0,1,1,0,1.327Z"
        transform="translate(-6.059 -5.049)"
      />
      <path
        id="Shape-9"
        data-name="Shape"
        fill="#ff5364"
        d="M35,37.4v8.611a.663.663,0,0,0,.962.6l1.725-.869a.675.675,0,0,1,.6,0l1.725.869a.663.663,0,0,0,.962-.6V37.4Z"
        transform="translate(-11.782 -12.59)"
      />
      <path
        id="Shape-10"
        data-name="Shape"
        fill="#95a5a5"
        d="M20.951,26.97a9.442,9.442,0,0,1-4.636-1.217,9.331,9.331,0,0,1-4.651,1.217.663.663,0,0,1,0-1.327,8.041,8.041,0,0,0,3.442-.757,3.15,3.15,0,0,1-1.217-2.179c0-.4.174-1.708,2.419-1.708s2.419,1.307,2.419,1.708a3.157,3.157,0,0,1-1.217,2.183,8.067,8.067,0,0,0,3.441.753.663.663,0,0,1,0,1.327Zm-4.644-4.644c-.5,0-1.093.1-1.093.381s.3.848,1.087,1.455c.706-.54,1.1-1.1,1.1-1.455C17.4,22.426,16.811,22.327,16.307,22.327Z"
        transform="translate(-3.703 -7.069)"
      />
      <path
        id="Shape-11"
        data-name="Shape"
        fill="#fb7b76"
        d="M42.6,27.3c0,.765-1.428,1.239-1.7,1.9-.286.689.377,2.033-.142,2.552s-1.863-.144-2.551.141c-.665.276-1.14,1.7-1.9,1.7s-1.239-1.428-1.9-1.7c-.689-.286-2.033.377-2.552-.142s.144-1.863-.141-2.551c-.276-.665-1.7-1.14-1.7-1.9s1.428-1.239,1.7-1.9c.286-.689-.377-2.033.142-2.552s1.863.144,2.551-.141c.663-.276,1.14-1.7,1.9-1.7s1.239,1.428,1.9,1.7c.689.286,2.033-.377,2.552.142s-.144,1.863.141,2.551C41.176,26.063,42.6,26.537,42.6,27.3Z"
        transform="translate(-10.099 -7.069)"
      />
      <ellipse
        id="Oval"
        fill="#df4d60"
        cx="2.594"
        cy="2.223"
        rx="2.594"
        ry="2.223"
        transform="translate(23.654 17.785)"
      />
    </svg>
  );
};
export const CameraImage = () => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 121.91 135.01"
    >
      <path
        className="cls-1"
        fill="#30569f"
        d="M90.07,100.13a2,2,0,0,0,2-2V86.58a2,2,0,0,0-4,0V98.13a2,2,0,0,0,2,2Z"
        transform="translate(0 0)"
      />
      <path
        className="cls-1"
        fill="#30569f"
        d="M102.53,135a2,2,0,0,0,2-2,2,2,0,0,0-.06-.47l-7.3-30.28a2,2,0,0,0-3.9.94l7.3,30.29A2,2,0,0,0,102.53,135Z"
        transform="translate(0 0)"
      />
      <path
        className="cls-1"
        fill="#30569f"
        d="M77.61,135a2,2,0,0,0,2-1.53l7.31-30.29a2,2,0,0,0-3.9-.94l-7.31,30.29A2,2,0,0,0,77.15,135a1.83,1.83,0,0,0,.47,0Z"
        transform="translate(0 0)"
      />
      <path
        className="cls-2"
        fill="#75cff9"
        d="M33.31,83.85a2,2,0,0,0,2-2V55.18a2,2,0,1,0-4,0V81.84a2,2,0,0,0,2,2Z"
        transform="translate(0 0)"
      />
      <path
        className="cls-1"
        fill="#30569f"
        d="M78.49,45.53,82.9,40a1.86,1.86,0,0,1,1.45-.7H95.79a1.88,1.88,0,0,1,1.46.7l4.41,5.51h8.6v33H72.05a2.16,2.16,0,0,1-2.15-2.16V47.69a2.16,2.16,0,0,1,2.15-2.16Z"
        transform="translate(0 0)"
      />
      <path
        className="cls-3"
        fill="#26447e"
        d="M72.05,73.55h38.2v5H72.05a2.16,2.16,0,0,1-2.15-2.16h0v-5a2.16,2.16,0,0,0,2.15,2.16Z"
        transform="translate(0 0)"
      />
      <circle className="cls-4" fill="#5392f9" cx="90.07" cy="62.05" r="10.25" />
      <path
        className="cls-5"
        fill="#ddebfd"
        d="M90.07,74.31A12.26,12.26,0,1,0,77.82,62.05,12.25,12.25,0,0,0,90.07,74.31Zm0-20.5a8.24,8.24,0,1,1-8.24,8.24A8.24,8.24,0,0,1,90.07,53.81Z"
        transform="translate(0 0)"
      />
      <path
        className="cls-2"
        fill="#75cff9"
        d="M119.92,78.57h-9.83a2,2,0,0,1-2-2V47.52a2,2,0,0,1,2-2h9.83a2,2,0,0,1,2,2V76.58A2,2,0,0,1,119.92,78.57Z"
        transform="translate(0 0)"
      />
      <path
        className="cls-6"
        fill="#5fa7ee"
        d="M110.09,73.55h9.83a2,2,0,0,0,2-2v5a2,2,0,0,1-2,2h-9.83a2,2,0,0,1-2-2h0v-5A2,2,0,0,0,110.09,73.55Z"
        transform="translate(0 0)"
      />
      <path
        className="cls-7"
        fill="#bed9fd"
        d="M84,86.58H96.16a.75.75,0,0,0,.75-.74V78.57H83.24v7.27A.75.75,0,0,0,84,86.58Z"
        transform="translate(0 0)"
      />
      <path
        className="cls-2"
        fill="#75cff9"
        d="M17.76,0H48.85a2.22,2.22,0,0,1,1.92,1.11L66.31,28a2.2,2.2,0,0,1,0,2.22L50.77,57.17a2.21,2.21,0,0,1-1.92,1.11H17.76a2.21,2.21,0,0,1-1.92-1.11L.3,30.25A2.2,2.2,0,0,1,.3,28L15.84,1.11A2.22,2.22,0,0,1,17.76,0Z"
        transform="translate(0 0)"
      />
      <path
        className="cls-6"
        fill="#5fa7ee"
        d="M.3,28l2.78-4.82a2.31,2.31,0,0,0,.28,1.37L19,51.71A2.23,2.23,0,0,0,21,52.83H52.29a2.34,2.34,0,0,0,1.2-.36l-2.72,4.7a2.21,2.21,0,0,1-1.92,1.11H17.76a2.22,2.22,0,0,1-1.92-1.11L.3,30.25A2.2,2.2,0,0,1,.3,28Z"
        transform="translate(0 0)"
      />
      <path
        className="cls-6"
        fill="#5fa7ee"
        d="M.3,28l.52-.9h29L15.32,2l.52-.9A2.22,2.22,0,0,1,17.76,0h1L33.3,25.13,47.82,0h1a2.21,2.21,0,0,1,1.92,1.11l.52.9L36.79,27.13h29l.52.9a2.25,2.25,0,0,1,0,2.22l-.52.9h-29L51.29,56.28l-.52.9a2.21,2.21,0,0,1-1.92,1.11h-1L33.31,33.16,18.8,58.28h-1a2.21,2.21,0,0,1-1.92-1.11l-.52-.9L29.83,31.14H.81l-.51-.9A2.2,2.2,0,0,1,.3,28Z"
        transform="translate(0 0)"
      />
      <circle className="cls-8" fill="#f4daa7" cx="33.31" cy="29.14" r="8.03" />
      <path
        className="cls-1"
        fill="#30569f"
        d="M38.24,81.65v52.29A1.06,1.06,0,0,1,37.17,135H29.44a1.06,1.06,0,0,1-1.07-1.07h0V81.65a1.07,1.07,0,0,1,1.07-1.08h7.73A1.07,1.07,0,0,1,38.24,81.65Z"
        transform="translate(0 0)"
      />
      <path
        className="cls-2"
        fill="#75cff9"
        d="M79.39,107.32h21.37a2.56,2.56,0,0,0,2.55-2.56v-4.08a2.55,2.55,0,0,0-2.55-2.55H79.39a2.56,2.56,0,0,0-2.56,2.55v4.08A2.56,2.56,0,0,0,79.39,107.32Z"
        transform="translate(0 0)"
      />
      <path
        className="cls-6"
        fill="#5fa7ee"
        d="M79.39,98.13h6.83a2.56,2.56,0,0,0-2.56,2.55v4.08a2.56,2.56,0,0,0,2.56,2.56H79.39a2.56,2.56,0,0,1-2.56-2.56v-4.08A2.56,2.56,0,0,1,79.39,98.13Z"
        transform="translate(0 0)"
      />
    </svg>
  );
};
